if (!window.__rojoOsAssetLoaded) {
  window.__rojoOsAssetLoaded = true;

  // TEMPORARY CAMPAIGN (2026-09) — module-level (outside initRojoOS, so
  // it survives across multiple initRojoOS(root) calls within one page
  // load) countdown interval id. A Shopify theme-editor section reload
  // replaces the whole [data-rojo-os] subtree and calls initRojoOS again
  // on a fresh root; without this, the previous interval would keep
  // ticking forever against the old, now-detached DOM. Cleared and
  // restarted fresh on every initRojoOS() call — see
  // startRojoPromoCountdown() below.
  let rojoPromoCountdownInterval = null;

  function initRojoOS(root) {
    if (!root || root.dataset.initialized === 'true') return;
    // Halloween entry defers the existing OS initialization until OPEN FILE.
    if (window.__rojoHalloweenEntry?.(root, () => initRojoOS(root))) return;
    root.dataset.initialized = 'true';
    // Optional Halloween decoration must never block the original OS or signup.
    try { window.__rojoHalloweenSMS?.(root); } catch (_) { /* Keep the core OS usable. */ }

    function initRojoProductImageFit() {
      if (root.dataset.rojoImageFitInitialized === 'true') return;
      root.dataset.rojoImageFitInitialized = 'true';

  const images = Array.from(root.querySelectorAll('.rojo-product-card__image'));
  const alphaThreshold = 8;
  const safePaddingRatio = 0.035;

  async function trimTransparentCanvas(image) {
    if (!image || image.dataset.rojoTrimmed === 'true') return;
    image.dataset.rojoTrimmed = 'true';

    const source = image.currentSrc || image.src;
    if (!source) return;

    try {
      const response = await fetch(source, { mode: 'cors', credentials: 'omit' });
      if (!response.ok) return;

      const blob = await response.blob();
      const bitmap = await createImageBitmap(blob);
      const width = bitmap.width;
      const height = bitmap.height;
      if (!width || !height) {
        bitmap.close();
        return;
      }

      const scanCanvas = document.createElement('canvas');
      scanCanvas.width = width;
      scanCanvas.height = height;
      const scanContext = scanCanvas.getContext('2d', { willReadFrequently: true });
      if (!scanContext) {
        bitmap.close();
        return;
      }

      scanContext.clearRect(0, 0, width, height);
      scanContext.drawImage(bitmap, 0, 0);
      const pixels = scanContext.getImageData(0, 0, width, height).data;

      let minX = width;
      let minY = height;
      let maxX = -1;
      let maxY = -1;

      for (let y = 0; y < height; y += 1) {
        const row = y * width * 4;
        for (let x = 0; x < width; x += 1) {
          if (pixels[row + (x * 4) + 3] > alphaThreshold) {
            if (x < minX) minX = x;
            if (x > maxX) maxX = x;
            if (y < minY) minY = y;
            if (y > maxY) maxY = y;
          }
        }
      }

      if (maxX < minX || maxY < minY) {
        bitmap.close();
        return;
      }

      const visibleWidth = maxX - minX + 1;
      const visibleHeight = maxY - minY + 1;
      const transparentAreaRatio = 1 - ((visibleWidth * visibleHeight) / (width * height));

      /* Leave regular photos and already-tight images untouched. */
      if (transparentAreaRatio < 0.12) {
        bitmap.close();
        return;
      }

      const padding = Math.max(10, Math.round(Math.max(visibleWidth, visibleHeight) * safePaddingRatio));
      const cropX = Math.max(0, minX - padding);
      const cropY = Math.max(0, minY - padding);
      const cropRight = Math.min(width, maxX + padding + 1);
      const cropBottom = Math.min(height, maxY + padding + 1);
      const cropWidth = cropRight - cropX;
      const cropHeight = cropBottom - cropY;

      const outputCanvas = document.createElement('canvas');
      outputCanvas.width = cropWidth;
      outputCanvas.height = cropHeight;
      const outputContext = outputCanvas.getContext('2d');
      if (!outputContext) {
        bitmap.close();
        return;
      }

      outputContext.clearRect(0, 0, cropWidth, cropHeight);
      outputContext.drawImage(
        bitmap,
        cropX, cropY, cropWidth, cropHeight,
        0, 0, cropWidth, cropHeight
      );
      bitmap.close();

      const trimmedBlob = await new Promise((resolve) => outputCanvas.toBlob(resolve, 'image/png'));
      if (!trimmedBlob) return;

      const objectUrl = URL.createObjectURL(trimmedBlob);
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = objectUrl;
      image.style.objectPosition = 'center center';
      image.addEventListener('load', () => URL.revokeObjectURL(objectUrl), { once: true });
    } catch (error) {
      /* Keep Shopify's original image if browser/CORS processing is unavailable. */
    }
  }

  images.forEach((image) => {
    if (image.complete && image.naturalWidth) trimTransparentCanvas(image);
    else image.addEventListener('load', () => trimTransparentCanvas(image), { once: true });
  });
    }

    function initTdomRadio() {
      if (root.dataset.tdomRadioInitialized === 'true') return;
      root.dataset.tdomRadioInitialized = 'true';

  const audio = root.querySelector('[data-tdom-audio]');
  const radio = root.querySelector('[data-tdom-radio]');
  const wrap = root.querySelector('[data-tdom-radio-wrap]');
  const playButton = root.querySelector('[data-tdom-play]');
  const prevButton = root.querySelector('[data-tdom-prev]');
  const nextButton = root.querySelector('[data-tdom-next]');
  const setlist = root.querySelector('[data-tdom-setlist]');
  const setlistToggle = root.querySelector('[data-tdom-setlist-toggle]');
  const channelLabel = root.querySelector('[data-tdom-channel]');
  const tickerArtistEls = Array.from(root.querySelectorAll('[data-tdom-ticker-artist]'));
  const trackButtons = Array.from(root.querySelectorAll('[data-tdom-track-select]'));

  if (!audio || !radio || !wrap || !playButton || !trackButtons.length) return;

  // 7-track upgrade (2026-07-28) — track data is read straight off the
  // setlist's own rendered buttons (src/artist come from Liquid via data
  // attributes) rather than kept in a separate JSON blob, so there's one
  // source of truth for both the visible list and playback.
  const tdomTracks = trackButtons.map((button, index) => ({
    index,
    src: button.dataset.tdomTrackSrc || '',
    artist: button.dataset.tdomTrackArtist || '',
  }));

  const savedTrackIndexRaw = Number.parseInt(window.localStorage.getItem('tdomRadioTrackIndex'), 10);
  let currentTrackIndex = Number.isInteger(savedTrackIndexRaw) && savedTrackIndexRaw >= 0 && savedTrackIndexRaw < tdomTracks.length
    ? savedTrackIndexRaw
    : 0;
  const initialSavedTime = window.localStorage.getItem('tdomRadioTime');

  wrap.classList.add('tdom-ready');

  function updateSetlistHighlight() {
    trackButtons.forEach((button, index) => {
      button.classList.toggle('is-current', index === currentTrackIndex);
    });
  }

  // Loads a track by index — always used for every track change, including
  // the very first load on page open, so the ticker/channel-label/setlist
  // highlight can never drift out of sync with whatever audio.src actually
  // points at. options.resumeTime (only ever passed on the initial load)
  // restores a saved mid-track position; every other track change starts
  // fresh at 0, which is what "picking a different song" should do.
  function loadTrack(index, options) {
    const opts = options || {};
    const track = tdomTracks[index];
    if (!track) return;

    currentTrackIndex = index;
    window.localStorage.setItem('tdomRadioTrackIndex', String(currentTrackIndex));

    audio.src = track.src;

    if (channelLabel) {
      channelLabel.textContent = 'TDOM RADIO // CH.' + String(index + 1).padStart(3, '0');
    }
    tickerArtistEls.forEach((el) => {
      el.textContent = 'ROJO ERA VOL. 1 — FEAT. ' + track.artist;
    });
    updateSetlistHighlight();

    if (opts.resumeTime) {
      const parsedTime = Number.parseFloat(opts.resumeTime);
      if (Number.isFinite(parsedTime)) {
        audio.addEventListener('loadedmetadata', () => { audio.currentTime = parsedTime; }, { once: true });
      }
    }

    if (opts.autoplay) audio.play().catch(() => {});
  }

  function playNext() {
    loadTrack((currentTrackIndex + 1) % tdomTracks.length, { autoplay: !audio.paused });
  }

  // Reached only via the 'ended' event below -- by definition the track WAS
  // just playing (that's the only way it can end), but the browser marks
  // the element paused as a side effect of reaching the end, so playNext()'s
  // own !audio.paused check (correct for the manual next/prev/setlist-tap
  // paths, where audio.paused still reflects pre-tap state) is always wrong
  // here and was silently swallowing the auto-resume. Always autoplay
  // instead of reusing that check.
  function playNextAfterTrackEnded() {
    loadTrack((currentTrackIndex + 1) % tdomTracks.length, { autoplay: true });
  }

  function playPrev() {
    loadTrack((currentTrackIndex - 1 + tdomTracks.length) % tdomTracks.length, { autoplay: !audio.paused });
  }

  function openTdomSetlist() {
    if (!setlist || !setlistToggle) return;
    setlist.hidden = false;
    setlistToggle.setAttribute('aria-expanded', 'true');
  }

  function closeTdomSetlist() {
    if (!setlist || !setlistToggle) return;
    setlist.hidden = true;
    setlistToggle.setAttribute('aria-expanded', 'false');
  }

  loadTrack(currentTrackIndex, { resumeTime: initialSavedTime });

  audio.addEventListener('timeupdate', () => {
    window.localStorage.setItem('tdomRadioTime', String(audio.currentTime));
  });

  // Continuous radio behavior — a finished track always rolls into the
  // next one and keeps playing, wrapping from #7 back to #1.
  audio.addEventListener('ended', playNextAfterTrackEnded);

  audio.addEventListener('play', () => {
    playButton.textContent = '❚❚';
    radio.classList.add('tdom-playing');
    window.localStorage.setItem('tdomRadioPlaying', 'true');
  });

  audio.addEventListener('pause', () => {
    playButton.textContent = '▶';
    radio.classList.remove('tdom-playing');
    window.localStorage.setItem('tdomRadioPlaying', 'false');
  });

  playButton.addEventListener('click', () => {
    if (audio.paused) audio.play().catch(() => {});
    else audio.pause();
  });

  prevButton?.addEventListener('click', playPrev);
  nextButton?.addEventListener('click', playNext);

  setlistToggle?.addEventListener('click', () => {
    if (setlist?.hidden) openTdomSetlist();
    else closeTdomSetlist();
  });

  trackButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
      loadTrack(index, { autoplay: !audio.paused });
      closeTdomSetlist();
    });
  });

  document.addEventListener('click', (event) => {
    if (!setlist || setlist.hidden) return;
    if (event.target.closest('[data-tdom-setlist-toggle], [data-tdom-setlist]')) return;
    closeTdomSetlist();
  });

  window.addEventListener('beforeunload', () => {
    window.localStorage.setItem('tdomRadioTime', String(audio.currentTime));
  });
    }

    initRojoProductImageFit();
    initTdomRadio();

  document.body.classList.add('rojo-os-page-locked');

  const rojoSectionHost = root.closest('.shopify-section');
  const rojoMainContent = root.closest('#MainContent');

  if (rojoSectionHost && rojoMainContent) {
    Array.from(rojoMainContent.children).forEach((child) => {
      if (child === rojoSectionHost || child.contains(root)) return;
      child.hidden = true;
      child.dataset.rojoOsHiddenSection = 'true';
    });
  }

  const canvas = root.querySelector('[data-rojo-canvas]');
  const enter = root.querySelector('[data-rojo-enter]');
  const worldButton = root.querySelector('[data-rojo-world]');
  const menu = root.querySelector('[data-rojo-menu]');
  const fallback = root.querySelector('[data-rojo-fallback]');
  const boot = root.querySelector('[data-rojo-boot]');
  const bootFill = root.querySelector('[data-rojo-boot-fill]');
  const bootPercent = root.querySelector('[data-rojo-boot-percent]');
  const apps = root.querySelector('[data-rojo-apps]');
  const appPanels = Array.from(root.querySelectorAll('[data-rojo-app]'));
  const shopApp = root.querySelector('[data-rojo-app="shop"]');
  const shopButton = root.querySelector('[data-rojo-open="shop"]');
  const rojomiesApp = root.querySelector('[data-rojo-app="rojomies"]');
  const rojomiesButton = root.querySelector('[data-rojo-open="rojomies"]');
  const rojomiesForm = root.querySelector('[data-rojo-rojomies-form]');
  const rojomiesFormView = root.querySelector('[data-rojo-rojomies-form-view]');
  const rojomiesSuccessView = root.querySelector('[data-rojo-rojomies-success]');
  const rojomiesSubmitButton = root.querySelector('[data-rojo-rojomies-submit]');
  const rojomiesSubmitLabel = root.querySelector('[data-rojo-rojomies-submit-label]');
  const rojomiesErrorBlock = root.querySelector('[data-rojo-rojomies-error]');
  const rojomiesTryAgainButton = root.querySelector('[data-rojo-rojomies-try-again]');
  const rojomiesPhoneInput = root.querySelector('[data-rojo-rojomies-phone]');
  const rojomiesPhoneLabel = root.querySelector('[data-rojo-rojomies-phone-label]');
  const rojomiesCountrySelect = root.querySelector('[data-rojo-rojomies-country]');
  const rojomiesConsentCheckbox = root.querySelector('[data-rojo-rojomies-consent]');
  const rojomiesHoneypot = root.querySelector('[data-rojo-rojomies-honeypot]');
  // TEMPORARY CAMPAIGN (2026-09, round 9) — compact validation. The row
  // wrapping the consent checkbox doubles as the no-layout-shift consent-
  // error target (see setRojomiesConsentError() below).
  const rojomiesConsentRow = root.querySelector('.rojo-rojomies-consent');
  // TEMPORARY CAMPAIGN (2026-09) — promo countdown + fail-safe closed
  // state element refs. Everything above this line (rojomies* refs) is
  // unrelated/unchanged; these are additive only.
  const promoCountdown = root.querySelector('[data-rojo-promo-countdown]');
  const promoDaysEl = root.querySelector('[data-rojo-promo-days]');
  const promoHoursEl = root.querySelector('[data-rojo-promo-hours]');
  const promoMinutesEl = root.querySelector('[data-rojo-promo-minutes]');
  const promoSecondsEl = root.querySelector('[data-rojo-promo-seconds]');
  const promoDropInfo = root.querySelector('[data-rojo-promo-drop]');
  const promoClosedState = root.querySelector('[data-rojo-promo-closed]');
  const contactApp = root.querySelector('[data-rojo-app="contact"]');
  const contactButton = root.querySelector('[data-rojo-open="contact"]');
  const contactForm = root.querySelector('[data-rojo-contact-form]');
  const contactFormView = root.querySelector('[data-rojo-contact-form-view]');
  const contactSuccessView = root.querySelector('[data-rojo-contact-success]');
  const contactSubmitButton = root.querySelector('[data-rojo-contact-submit]');
  const contactSubmitLabel = root.querySelector('[data-rojo-contact-submit-label]');
  const contactErrorBlock = root.querySelector('[data-rojo-contact-error]');
  const contactSendAnotherButton = root.querySelector('[data-rojo-contact-send-another]');
  const conceptApp = root.querySelector('[data-rojo-app="concept"]');
  const conceptShell = root.querySelector('[data-rojo-concept-shell]');
  const conceptButton = root.querySelector('[data-rojo-open="concept"]');
  const conceptPages = Array.from(root.querySelectorAll('[data-rojo-concept-page]'));
  const conceptPagePrev = root.querySelector('[data-rojo-concept-page-prev]');
  const conceptPageNext = root.querySelector('[data-rojo-concept-page-next]');
  const conceptPageLabel = root.querySelector('[data-rojo-concept-page-label]');
  const conceptTiles = Array.from(root.querySelectorAll('[data-rojo-concept-tile]'));
  const conceptPreviews = Array.from(root.querySelectorAll('[data-rojo-concept-preview]'));
  const conceptFullViews = Array.from(root.querySelectorAll('[data-rojo-concept-full]'));
  const conceptPreviewCloseButtons = Array.from(root.querySelectorAll('[data-rojo-concept-preview-close]'));
  const conceptOpenProjectButtons = Array.from(root.querySelectorAll('[data-rojo-concept-open-project]'));
  const conceptFullCloseButtons = Array.from(root.querySelectorAll('[data-rojo-concept-full-close]'));
  const galleryTriggers = Array.from(root.querySelectorAll('[data-rojo-gallery-trigger]'));
  const videoLinks = Array.from(root.querySelectorAll('.rojo-concept-video-link'));
  const lightbox = root.querySelector('[data-rojo-lightbox]');
  const lightboxBackdrop = root.querySelector('[data-rojo-lightbox-backdrop]');
  const lightboxImage = root.querySelector('[data-rojo-lightbox-image]');
  const lightboxClose = root.querySelector('[data-rojo-lightbox-close]');
  const lightboxPrev = root.querySelector('[data-rojo-lightbox-prev]');
  const lightboxNext = root.querySelector('[data-rojo-lightbox-next]');
  const lightboxCounter = root.querySelector('[data-rojo-lightbox-counter]');
  const videoViewer = root.querySelector('[data-rojo-video-viewer]');
  const videoBackdrop = root.querySelector('[data-rojo-video-backdrop]');
  const videoClose = root.querySelector('[data-rojo-video-close]');
  const videoMedia = root.querySelector('[data-rojo-video-media]');
  // Secret ROJO-Tavo-only reward popup — cloned from the lightbox/video-
  // viewer shell pattern above, own namespace, registers with the same
  // shared overlay registry (activeOverlayContainer/activeOverlayCloser).
  const secretRewardPopup = root.querySelector('[data-rojo-secret-reward-popup]');
  const secretRewardBackdrop = root.querySelector('[data-rojo-secret-reward-backdrop]');
  const secretRewardClose = root.querySelector('[data-rojo-secret-reward-close]');
  const secretRewardCard = root.querySelector('[data-rojo-secret-reward-card]');
  const conceptCartButton = root.querySelector('[data-rojo-concept-cart]');
  const conceptCartCount = root.querySelector('[data-rojo-concept-cart-count]');
  const productViewport = root.querySelector('[data-rojo-product-viewport]');
  const allProductCards = Array.from(root.querySelectorAll('[data-rojo-product-card]'));
  let productCards = allProductCards.slice();
  const productPrev = root.querySelector('[data-rojo-product-prev]');
  const productNext = root.querySelector('[data-rojo-product-next]');
  const cartButton = root.querySelector('[data-rojo-cart]');
  const cartCount = root.querySelector('[data-rojo-cart-count]');
  const cartDrawer = root.querySelector('[data-rojo-cart-drawer]');
  const cartCloseButton = root.querySelector('[data-rojo-cart-close]');
  const cartAddItemsButton = root.querySelector('[data-rojo-cart-add-items]');
  const cartItems = root.querySelector('[data-rojo-cart-items]');
  const cartSubtotal = root.querySelector('[data-rojo-cart-subtotal]');
  const cartCheckoutButton = root.querySelector('[data-rojo-cart-checkout]');
  const cartShippingProgress = root.querySelector('[data-rojo-cart-shipping-progress]');
  const cartShippingStatus = root.querySelector('[data-rojo-cart-shipping-status]');
  const cartShippingFill = root.querySelector('[data-rojo-cart-shipping-fill]');
  const cartShippingCurrent = root.querySelector('[data-rojo-cart-shipping-current]');
  const cartShippingSecondary = root.querySelector('[data-rojo-cart-shipping-secondary]');
  const cartBundleUpsell = root.querySelector('[data-rojo-cart-bundle-upsell]');
  const cartBundleUpsellButton = root.querySelector('[data-rojo-cart-bundle-upsell-add]');
  const cartBundleUpsellStatus = root.querySelector('[data-rojo-cart-bundle-upsell-status]');
  const collectionToggle = root.querySelector('[data-rojo-collection-toggle]');
  const collectionLabel = root.querySelector('[data-rojo-collection-label]');
  const collectionMenu = root.querySelector('[data-rojo-collection-menu]');
  const collectionOptions = Array.from(root.querySelectorAll('[data-rojo-collection-option]'));
  const categoryEmpty = root.querySelector('[data-rojo-category-empty]');

  const rojoRunApp = root.querySelector('[data-rojo-app="rojo-run"]');
  const rojoRunButton = root.querySelector('[data-rojo-open="rojo-run"]');
  const rojoRunShell = root.querySelector('[data-rojo-run-shell]');
  // ROJO RUN — Environmental Art, Background Layer 2 (Mountains) (2026-07-25):
  // canvas-based (same proven-stable technique as hills/midground), not a
  // DOM sprite — see rojoRunBakeParallaxCanvases() below. Uses onload/
  // onerror as the PRIMARY load signal (not decode()) — the clouds attempt
  // relied on decode() as primary and never rendered on real device with no
  // clear cause found; onload/onerror is the longer-established, more
  // conservative browser API. onerror re-triggers a bake without ever
  // marking "ready" (rather than clouds' approach of quietly marking
  // "ready" on any settled promise, success or failure) so the bake
  // function safely falls back to the original procedural ridge if the
  // image never loads — mountains can never end up rendering nothing,
  // unlike clouds' all-or-nothing draw.
  const rojoRunMountainsImage = new Image();
  let rojoRunMountainsImageReady = false;
  rojoRunMountainsImage.onload = () => { rojoRunMountainsImageReady = true; rojoRunBakeParallaxCanvases(); };
  rojoRunMountainsImage.onerror = () => { rojoRunBakeParallaxCanvases(); };
  rojoRunMountainsImage.src = rojoRunShell?.dataset.rojoRunMountainsSrc || '';
  // ROJO RUN — round (2026-07-25, owner: "the sky background is the last
  // thing to render in"): the sky is a plain CSS background-image on an
  // element inside .rojo-run-playing, which stays display:none until the
  // player reaches the countdown/playing state — browsers commonly defer
  // fetching a hidden element's background-image until it's actually laid
  // out, unlike every other art asset here (all loaded via an early JS
  // Image() object). This is a pure cache-warming preload: same URL as the
  // CSS background-image, fetched immediately at script startup regardless
  // of visibility, so by the time .rojo-run-playing is shown the browser
  // already has it cached and it paints instantly. No onload/ready-gating
  // needed — nothing draws conditionally on this, the actual sky rendering
  // (CSS background-image) is completely unchanged.
  const rojoRunSkyPreloadImage = new Image();
  rojoRunSkyPreloadImage.src = rojoRunShell?.dataset.rojoRunSkySrc || '';
  // ROJO OS — bug fix (2026-08-01, owner: "the cross logo is the last
  // thing to load up" on the ROJO RUN title screen): same root cause and
  // same fix as the sky preload immediately above — .rojo-run-tdom-mark's
  // background-image (rojo-run-health-pickup.png, reused from the health
  // pickup art) sits on the title screen, which is display:none until
  // ROJO RUN is opened, so the browser was deferring the fetch until then.
  // The gameplay health-pickup sprites reuse this same file too, but
  // those aren't built until a run actually starts (rojoRunBuildHealthPickupSprites(),
  // called from resetRojoRunPlayerPhysics()) — well after the title
  // screen already needed to paint it, so they never warmed the cache in
  // time. Pure cache-warming preload, same as the sky: no onload/ready-
  // gating needed, the actual logo rendering (CSS background-image) is
  // completely unchanged.
  const rojoRunTdomMarkPreloadImage = new Image();
  rojoRunTdomMarkPreloadImage.src = rojoRunShell?.dataset.rojoRunHealthPickupSrc || '';
  // ROJO RUN — Environmental Art Phase B (2026-07-26): terrain material
  // texture, drawn via ctx.createPattern() in place of the flat #356B30
  // fill — same "load once, gate with a ready flag, safe solid-color
  // fallback if it never loads" pattern already proven for mountains.
  // Terrain GEOMETRY (segment startX/endX/groundY/slopes) is never touched
  // by this — only what fillStyle paints into that already-locked shape.
  const rojoRunTerrainTextureImage = new Image();
  let rojoRunTerrainTextureReady = false;
  rojoRunTerrainTextureImage.onload = () => { rojoRunTerrainTextureReady = true; };
  rojoRunTerrainTextureImage.onerror = () => {};
  rojoRunTerrainTextureImage.src = rojoRunShell?.dataset.rojoRunTerrainFillSrc || '';
  // ROJO RUN — Environmental Art Phase B: how many world units one texture
  // tile spans (both axes, source art is square) — tunable, first-pass
  // value chosen relative to the player's own 60-unit width so the texture
  // reads as fine ground detail rather than giant blown-up blobs.
  const ROJO_RUN_TERRAIN_TEXTURE_WORLD_SIZE = 400;
  // ROJO RUN — ROJO Tavo sprite integration, Phase 1 (2026-07-31): both
  // sheets preloaded here, same onload/onerror-ready-flag pattern already
  // proven for mountains/terrain above — onerror never marks ready and
  // never throws, so a failed load safely falls back to the graybox rect
  // at the actual draw site instead of crashing. The jump sheet is only
  // preloaded this phase — nothing reads rojoRunPlayerJumpImage yet, that
  // wiring is a later animation phase.
  const rojoRunPlayerRunImage = new Image();
  let rojoRunPlayerRunImageReady = false;
  rojoRunPlayerRunImage.onload = () => { rojoRunPlayerRunImageReady = true; };
  rojoRunPlayerRunImage.onerror = () => {};
  rojoRunPlayerRunImage.src = rojoRunShell?.dataset.rojoRunPlayerRunSrc || '';
  const rojoRunPlayerJumpImage = new Image();
  let rojoRunPlayerJumpImageReady = false;
  rojoRunPlayerJumpImage.onload = () => { rojoRunPlayerJumpImageReady = true; };
  rojoRunPlayerJumpImage.onerror = () => {};
  rojoRunPlayerJumpImage.src = rojoRunShell?.dataset.rojoRunPlayerJumpSrc || '';
  // ROJO RUN — round 4 (2026-07-25): how far down the mountains artwork is
  // shifted within its own canvas, as a fraction of canvas height — see the
  // drawImage() call in rojoRunBakeParallaxCanvases() below.
  // ROJO RUN — round 5 (2026-07-25): owner sent a mockup screenshot marking
  // where the peak should sit, roughly 28% down the arena — 0.35 put the
  // peak at ~45.5% (base 10.5% + 35), too low/at ground level per the
  // owner's real-device screenshot. Recalculated backward from the marked
  // target: (28% - 10.5% base peak) = 17.5%.
  const ROJO_RUN_MOUNTAINS_VERTICAL_OFFSET_FRACTION = 0.175;
  // ROJO RUN — Phase 9 item 6 follow-up 2 (2026-07-25): Pulse Zone texture
  // art moved to a static DOM sprite (same as every other Phase 9 item) —
  // the always-visible-structure redesign from the previous round made the
  // per-frame canvas draw call every frame instead of ~40-60% of the time,
  // reintroducing the exact shake/twitch already fixed for containers. See
  // rojoRunBuildPulseZoneSprites()/rojoRunStartPulseZoneGlowAnimations().
  // The canvas-preload machinery this used last round (Image()/decode()/
  // warm-up canvas) is no longer needed — a plain <img src> handles its own
  // loading, same as every other DOM sprite this phase.
  // ROJO RUN — Phase 9 round 9 (2026-07-23): paint containers are plain
  // positioned <img> elements inside this layer, built once and scrolled
  // via a single GPU-driven WAAPI transform — the same "bake once, scroll
  // via transform" architecture already proven for the terrain tiles and
  // parallax layers, replacing the earlier per-frame ctx.drawImage()
  // approach (rounds 3/5/8) that redrew every container from scratch every
  // frame. See rojoRunBuildContainerLayer()/rojoRunStartContainerLayerAnimation().
  const rojoRunContainerLayer = root.querySelector('[data-rojo-run-container-layer]');
  const rojoRunContainerScaler = root.querySelector('[data-rojo-run-container-scaler]');
  const rojoRunContainerTrack = root.querySelector('[data-rojo-run-container-track]');
  const rojoRunContainerElements = {};
  let rojoRunContainerLayerAnimation = null;
  // ROJO OS — bug fix (2026-08-06): separate world-anchored layer for
  // checkpoint pillars, Signal Fractures, Pulse Zones, and the finish
  // marker — structurally identical to the container layer above (same
  // scaler/track/scroll-position technique) but never elevated above
  // .rojo-run-canvas, so these stay behind Tavo while paint containers/
  // health pickups (still on rojoRunContainerTrack) stay in front. See
  // rojoRunStartWorldObjectLayerAnimation() and rojo-os.css.
  const rojoRunWorldObjectScaler = root.querySelector('[data-rojo-run-world-object-scaler]');
  const rojoRunWorldObjectTrack = root.querySelector('[data-rojo-run-world-object-track]');
  let rojoRunWorldObjectLayerAnimation = null;
  // ROJO RUN — Phase 9 (2026-07-23): health pickups reuse this exact same
  // container track/scaler/scroll-animation infrastructure — they're just
  // 2 more static-position sprites that need to scroll in perfect lockstep
  // with the world, which this track already does correctly on both
  // platforms. See rojoRunBuildHealthPickupSprites().
  const rojoRunHealthPickupElements = {};
  // ROJO RUN — Phase 9 item 3 round 2 (2026-07-24): checkpoint pillars
  // rebuilt to reuse the exact same container-track DOM/WAAPI architecture
  // as containers/health pickups — the original "lightweight canvas sprite"
  // approach (only 3 checkpoints, assumed cheap) turned out to still show
  // the same per-frame redraw/lookup shake the container had before its own
  // rebuild, at a smaller scale. See rojoRunBuildCheckpointPillarSprites().
  const rojoRunLaunchFill = root.querySelector('[data-rojo-run-launch-fill]');
  const rojoRunLaunch = root.querySelector('[data-rojo-run-launch]');
  const rojoRunRotate = root.querySelector('[data-rojo-run-rotate]');
  const rojoRunLandscape = root.querySelector('[data-rojo-run-landscape]');
  // ROJO RUN — Phase 6B: mission-briefing screen, same query-once pattern
  // as every other panel ref in this file. Character-select was removed
  // (2026-07-30) when the game became ROJO-Tavo-only — the intro screen's
  // own START RUN button now goes straight into the countdown.
  const rojoRunIntro = root.querySelector('[data-rojo-run-intro]');
  const rojoRunIntroEnter = root.querySelector('[data-rojo-run-intro-enter]');
  const rojoRunCountdownOverlay = root.querySelector('[data-rojo-run-countdown-overlay]');
  const rojoRunCountdownNumber = root.querySelector('[data-rojo-run-countdown-number]');
  // ROJO RUN — Phase 6C: pause button (built inert in Phase 6A) becomes
  // real, plus the pause overlay's menu and restart-confirm controls.
  const rojoRunPauseButton = root.querySelector('[data-rojo-run-pause]');
  const rojoRunPauseOverlay = root.querySelector('[data-rojo-run-pause-overlay]');
  const rojoRunPauseResumeButton = root.querySelector('[data-rojo-run-pause-resume]');
  const rojoRunPauseRestartButton = root.querySelector('[data-rojo-run-pause-restart]');
  const rojoRunPauseExitButton = root.querySelector('[data-rojo-run-pause-exit]');
  const rojoRunPauseConfirmYes = root.querySelector('[data-rojo-run-pause-confirm-yes]');
  const rojoRunPauseConfirmCancel = root.querySelector('[data-rojo-run-pause-confirm-cancel]');
  const rojoRunPlaying = root.querySelector('[data-rojo-run-playing]');
  const rojoRunArenaFrame = root.querySelector('[data-rojo-run-arena-frame]');
  const rojoRunCanvas = root.querySelector('[data-rojo-run-canvas]');
  const rojoRunJumpButton = root.querySelector('[data-rojo-run-jump]');
  const rojoRunLandscapeEnter = root.querySelector('[data-rojo-run-landscape-enter]');
  const rojoRunTileWorldViewport = root.querySelector('[data-rojo-run-tile-world-viewport]');
  const rojoRunTileWorldScaler = root.querySelector('[data-rojo-run-tile-world-scaler]');
  const rojoRunSwellCanvas = root.querySelector('[data-rojo-run-swell-canvas]');
  // ROJO RUN — Phase 8B: static markup, grabbed once (unlike the tile
  // canvases above, these are never created/destroyed at runtime).
  const rojoRunParallaxTrackElements = Array.from(root.querySelectorAll('[data-rojo-run-parallax-track]'));
  // ROJO RUN — Phase 8B (2026-07-23): these carry the tint filter directly
  // (not the tracks above, which only ever carry the WAAPI scroll transform)
  // — kept on separate elements so the CSS transition on filter never
  // interacts with the transform-based infinite scroll loop.
  const rojoRunParallaxSky = root.querySelector('[data-rojo-run-parallax-sky]');
  const rojoRunParallaxLayerElements = Array.from(root.querySelectorAll('[data-rojo-run-parallax-layer]'));
  const rojoRunParallaxCanvasElements = Array.from(root.querySelectorAll('[data-rojo-run-parallax-canvas]'));
  // ROJO RUN — Phase 4B: 3 plain graybox health-cross indicators, matching
  // the existing visual language (no icon art — that's spec Phase 9
  // territory). Array order matches DOM order, used directly by index in
  // rojoRunSetHealth().
  const rojoRunHealthHud = Array.from(root.querySelectorAll('[data-rojo-run-health-cross]'));
  // ROJO RUN — Phase 4E: temporary graybox course-progress bar/percent and
  // paint-container counter. Same query-once-at-load pattern as every other
  // element ref in this file.
  const rojoRunProgressFill = root.querySelector('[data-rojo-run-progress-fill]');
  const rojoRunProgressPercent = root.querySelector('[data-rojo-run-progress-percent]');
  const rojoRunContainerCounter = root.querySelector('[data-rojo-run-container-counter]');
  // ROJO RUN — Phase 6A: score readout and paint meter, same query-once
  // pattern as the progress bar above.
  const rojoRunScoreValue = root.querySelector('[data-rojo-run-score-value]');
  const rojoRunPaintFill = root.querySelector('[data-rojo-run-paint-fill]');
  const rojoRunCheckpointMessage = root.querySelector('[data-rojo-run-checkpoint-message]');
  const rojoRunGameOverMessage = root.querySelector('[data-rojo-run-gameover-message]');
  // ROJO RUN — Phase 6D: real Game Over screen buttons, plus the shared
  // damage-flash overlay (triggered on any damage event).
  const rojoRunGameOverRestartButton = root.querySelector('[data-rojo-run-gameover-restart]');
  const rojoRunGameOverExitButton = root.querySelector('[data-rojo-run-gameover-exit]');
  const rojoRunDamageFlash = root.querySelector('[data-rojo-run-damage-flash]');
  const rojoRunLevelCompleteMessage = root.querySelector('[data-rojo-run-levelcomplete-message]');
  // ROJO RUN — Phase 6E: real results screen fields + buttons.
  const rojoRunResultsContainersCount = root.querySelector('[data-rojo-run-results-containers-count]');
  const rojoRunResultsContainersPoints = root.querySelector('[data-rojo-run-results-containers-points]');
  const rojoRunResultsCheckpointsCount = root.querySelector('[data-rojo-run-results-checkpoints-count]');
  const rojoRunResultsCheckpointsPoints = root.querySelector('[data-rojo-run-results-checkpoints-points]');
  const rojoRunResultsPickupsCount = root.querySelector('[data-rojo-run-results-pickups-count]');
  const rojoRunResultsPickupsPoints = root.querySelector('[data-rojo-run-results-pickups-points]');
  const rojoRunResultsSectionsCount = root.querySelector('[data-rojo-run-results-sections-count]');
  const rojoRunResultsSectionsPoints = root.querySelector('[data-rojo-run-results-sections-points]');
  const rojoRunResultsNoDamageCount = root.querySelector('[data-rojo-run-results-nodamage-count]');
  const rojoRunResultsNoDamagePoints = root.querySelector('[data-rojo-run-results-nodamage-points]');
  const rojoRunResultsAllContainersCount = root.querySelector('[data-rojo-run-results-allcontainers-count]');
  const rojoRunResultsAllContainersPoints = root.querySelector('[data-rojo-run-results-allcontainers-points]');
  const rojoRunResultsTotal = root.querySelector('[data-rojo-run-results-total]');
  const rojoRunResultsSecretTrigger = root.querySelector('[data-rojo-run-results-secret-trigger]');
  const rojoRunResultsReplayButton = root.querySelector('[data-rojo-run-results-replay]');
  const rojoRunResultsExitButton = root.querySelector('[data-rojo-run-results-exit]');
  let rojoRunCheckpointMessageHideTimer = null;
  const tdomRadioWrap = root.querySelector('[data-tdom-radio-wrap]');
  let rojoRunActive = false;
  let rojoRunLaunchTimer = null;
  // ROJO RUN — the game is ROJO-Tavo-only (2026-07-30, Normal Tavo removed).
  // Kept as a named constant, not a hardcoded literal, since results.character
  // and the secret-reward-unlock gating downstream both still read it.
  const rojoRunSelectedCharacter = 'rojo';

  // ROJO RUN — Phase 7: save/progression. localStorage is the only
  // persistence mechanism available here (no backend/account system this
  // theme section can reach) — standard, no new dependency, survives
  // refresh and closing/reopening the browser on the same device. Wrapped
  // in try/catch since Safari private-browsing and similar can throw on
  // access; failing silently just means progress isn't saved this session,
  // never a hard error.
  const ROJO_RUN_SAVE_KEY = 'rojoRunSave';

  function rojoRunLoadSave() {
    try {
      const raw = window.localStorage.getItem(ROJO_RUN_SAVE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return null;
      return parsed;
    } catch (err) {
      return null;
    }
  }

  function rojoRunWriteSave() {
    try {
      window.localStorage.setItem(ROJO_RUN_SAVE_KEY, JSON.stringify(rojoRunSave));
    } catch (err) {
      // best-effort only — see comment above.
    }
  }

  const ROJO_RUN_SAVE_DEFAULTS = {
    highScore: 0,
    bestContainers: 0,
    noDamageEver: false
  };

  let rojoRunSave = Object.assign({}, ROJO_RUN_SAVE_DEFAULTS, rojoRunLoadSave() || {});
  // ROJO RUN — Phase 6B: countdown state. The arena/loop is already built
  // and painted by the time this becomes true (see enterRojoRunPlaying) —
  // this flag's only job is (1) blocking JUMP/keyboard input while the
  // frozen countdown is showing and (2) letting orientation/visibility/
  // teardown handlers know a countdown timer needs cancelling.
  let rojoRunCountdownActive = false;
  let rojoRunCountdownTimer = null;
  let rojoRunCountdownStepIndex = 0;
  // ROJO RUN — Phase 6C: true only while the player-initiated pause menu
  // is open. Distinct from rojoRunLoopPaused (which is also true during
  // the countdown freeze and during ordinary backgrounding) — this flag
  // is specifically what tells the visibility-change handler NOT to
  // auto-resume gameplay out from under the player on foreground return.
  let rojoRunPauseActive = false;
  const ROJO_RUN_STEP_MS = 1000 / 60;
  const ROJO_RUN_STEP_SECONDS = ROJO_RUN_STEP_MS / 1000;
  const ROJO_RUN_MAX_FRAME_MS = 100;
  const ROJO_RUN_VIRTUAL_WIDTH = 1920;
  const ROJO_RUN_VIRTUAL_HEIGHT = 1080;
  let rojoRunLoopId = null;
  let rojoRunLoopRunning = false;
  let rojoRunLoopPaused = false;
  let rojoRunAccumulatorMs = 0;
  let rojoRunLastFrameTime = 0;
  const rojoRunActiveJumpKeys = new Set();
  let rojoRunActiveJumpPointerId = null;
  let rojoRunJumpHeld = false;
  let rojoRunJumpPressQueued = false;
  let rojoRunJumpReleaseQueued = false;
  let rojoRunJumpPressStart = 0;
  let rojoRunJumpLastHoldDuration = 0;
  let rojoRunSuspended = false;
  let rojoRunSuspendedState = null;

  // ROJO RUN — Phase 3A graybox movement foundation. No hazards, collectibles,
  // health, scoring, camera effects, final art, or audio yet.
  // ROJO RUN — Phase 4E course-difficulty revision: base speed raised from
  // 520 to 650 (+25%, owner decision 2026-07-21) for a faster, less-boring
  // pace. Every existing Signal Fracture width below was scaled by the same
  // 650/520 ratio to preserve the exact tap-jump-vs-held-jump clearance
  // margin at the new speed — see each fracture's own comment for the math.
  // ROJO RUN — the game is ROJO-Tavo-only (2026-07-30, Normal Tavo removed).
  // This was originally ROJO Tavo's own +20% speed boost over Normal Tavo's
  // 650 (verified safe: jump-arc air-time is speed-independent, so only
  // horizontal range grows — tap 410->492, held 514->616 at +20% — checked
  // against all 33 Signal Fractures and 26 Pulse Zones with hundreds of
  // units of clearance everywhere). Owner then asked for a gentler +15%
  // instead (650 * 1.15 = 747.5, rounded to 748) — since +15% is a smaller
  // increase than the already-validated +20%, it needs no re-checking: less
  // extra jump range can only ever be safer, never riskier.
  const ROJO_RUN_ROJO_SPEED = 748;
  // ROJO_RUN_BASE_SPEED stays a plain, un-prefixed, reassignable (let) name
  // — every existing reference throughout this file (world-distance
  // advancement, mobile tile-animation duration, Pulse Zone cycle-phase
  // math, Terrain Swell phase math) keeps working completely unchanged.
  // Reassigned once per run inside rojoRunArmCountdown() below purely for
  // defensive consistency — its value never actually changes run to run
  // now that there's only one character/speed.
  let ROJO_RUN_BASE_SPEED = ROJO_RUN_ROJO_SPEED;
  const ROJO_RUN_JUMP_BUFFER_SECONDS = 0.12;
  const ROJO_RUN_COYOTE_SECONDS = 0.09;
  const ROJO_RUN_JUMP_HOLD_SECONDS = 0.18;
  const ROJO_RUN_GRAVITY = 2600;
  const ROJO_RUN_JUMP_VELOCITY = 820;
  const ROJO_RUN_JUMP_HOLD_GRAVITY_SCALE = 0.5;
  const ROJO_RUN_GROUND_Y = ROJO_RUN_VIRTUAL_HEIGHT * 0.70;
  const ROJO_RUN_PLAYER_SCREEN_X = ROJO_RUN_VIRTUAL_WIDTH * 0.07;
  const ROJO_RUN_PLAYER_WIDTH = 60;
  const ROJO_RUN_PLAYER_HEIGHT = 90;

  // ROJO RUN — Phase 3B: graybox terrain foundation established here
  // (flat/slope segment format, swept collision, coyote time, fall
  // detection). The specific test course originally authored in this phase
  // has since been superseded — see Phase 4A below.
  const ROJO_RUN_DEATH_PLANE_Y = ROJO_RUN_VIRTUAL_HEIGHT + 200;
  const ROJO_RUN_PLAYER_PROBE_SCREEN_X = ROJO_RUN_PLAYER_SCREEN_X + ROJO_RUN_PLAYER_WIDTH / 2;
  // ROJO RUN — ROJO Tavo sprite integration, Phase 1 (2026-07-31): static
  // size/anchor calibration only. Purely visual — none of these feed into
  // collision, which stays keyed to ROJO_RUN_PLAYER_WIDTH/HEIGHT above,
  // unchanged. SOURCE_SIZE is one 320x320 cell of the 4x4 sprite sheet;
  // DRAW_SIZE is the on-screen render size (~165-170 virtual units tall
  // once the sheet's own internal padding is accounted for); PIVOT_X is
  // the horizontal pixel (within the 320-wide source cell) to center over
  // the collision box; RUN_FRAME_1_FOOT_Y is the source-pixel row where
  // Run Frame 1's lowest shoe pixel sits, used to align the sprite's feet
  // with rojoRunPlayerFootY.
  const ROJO_RUN_PLAYER_SPRITE_SOURCE_SIZE = 320;
  const ROJO_RUN_PLAYER_SPRITE_DRAW_SIZE = 240;
  const ROJO_RUN_PLAYER_SPRITE_PIVOT_X = 160;
  const ROJO_RUN_RUN_FRAME_1_FOOT_Y = 294;

  // ROJO RUN — ROJO Tavo sprite integration, Phase 2 (run cycle, 2026-07-31):
  // grounded-only run-cycle timing. Isolated in named constants, per spec,
  // so the cadence can be tuned later without touching the animation logic.
  //
  // Phase 2 follow-up 2 (2026-07-31): two earlier attempts (playing all 16
  // sheet frames in order, then only the 8 front-facing frames) both still
  // read as unnatural/glitchy. The full 16-frame sheet is four discrete
  // 4-frame blocks (front/back/front/back), not one continuous turn --
  // playing them back to back always produces a hard instant cut at each
  // block boundary regardless of which frames are shown, since no frame in
  // the sheet is an actual in-between pose. This round restores all 16
  // frames in original sheet order (owner confirmed the back showing is
  // fine) and instead targets the cut itself: the render block below
  // cross-fades the last frame of each block into the first frame of the
  // next (see rojoRunRenderFrame()'s player-draw block for the blend
  // logic), softening the snap into a dissolve. ROJO_RUN_RUN_FRAME_COUNT
  // still derives from this list's length, so every other constant/
  // formula that reads it (ROJO_RUN_RUN_CYCLE_SECONDS, the playback-step
  // modulo below) stays correct automatically regardless of which/how many
  // frames are listed. Separately, the owner also reported the run
  // looking too fast -- ROJO_RUN_RUN_FRAME_DURATION_SECONDS is doubled
  // (0.05s -> 0.1s, 20fps -> 10fps character animation) as a direct test
  // of that, folded into this same round rather than a separate cycle.
  // ROJO RUN — Phase 2 follow-up 7 (2026-07-31): each of the 4 facing-
  // direction blocks' own FIRST frame (sheet frames 1/5/9/13) is now
  // skipped, so a flip lands one frame further into the new block instead
  // of on its opening pose -- testing whether cutting straight into
  // already-established motion reads as less abrupt than landing on a
  // "just-turned" first pose. FRAME_COUNT/CYCLE_SECONDS below still derive
  // automatically from this array's new (shorter, 12-entry) length, and
  // each block is now 3 playback steps instead of 4 (see the updated
  // block-boundary check in rojoRunRenderFrame()'s player-draw block).
  const ROJO_RUN_RUN_PLAYBACK_FRAME_INDICES = [1, 2, 3, 5, 6, 7, 9, 10, 11, 13, 14, 15];
  const ROJO_RUN_RUN_FRAME_COUNT = ROJO_RUN_RUN_PLAYBACK_FRAME_INDICES.length;
  const ROJO_RUN_RUN_FRAME_DURATION_SECONDS = 0.1;
  const ROJO_RUN_RUN_CYCLE_SECONDS = ROJO_RUN_RUN_FRAME_COUNT * ROJO_RUN_RUN_FRAME_DURATION_SECONDS;
  // ROJO RUN — Phase 2 follow-up 5 (2026-07-31): the crossfade used to
  // blend across a frame's ENTIRE display duration -- by the moment right
  // before every cut, the outgoing (full alpha) and incoming (~full
  // alpha by then) frames were both nearly fully visible at once, read as
  // a constant double-image/extra-limb "shapeshifting" effect the whole
  // time the character ran, not just at cuts. Confining the blend to a
  // short tail window at the end of each frame's slot (this fraction of
  // ROJO_RUN_RUN_FRAME_DURATION_SECONDS) means most of a frame's display
  // time shows one single, crisp pose with zero blending; only the
  // trailing tail briefly cross-fades into the next pose. First-pass
  // value, easy to retune from feedback like every other timing constant.
  const ROJO_RUN_RUN_BLEND_TAIL_FRACTION = 0.2;

  // ROJO RUN — Phase 4A: Level 01, Section 1 (real course data, per
  // docs/ROJO_RUN_LOCKED_SPEC_v2.md Section 10.1). Replaces the Phase
  // 3B/3C/3D graybox validation course entirely. No Signal Fractures, Pulse
  // Zones, Terrain Swells, or route splits — none belong in Section 1.
  // Checkpoint 1 only; Checkpoints 2–3 are added in Phase 4B/4C.
  const ROJO_RUN_CHECKPOINTS = [
    { id: 1, worldX: 24900 },
    { id: 2, worldX: 57400 },
    { id: 3, worldX: 95600 }
  ];
  let rojoRunLatestCheckpointX = 0;

  // ROJO RUN — Phase 9 item 3 (2026-07-24): checkpoint pillar decorative
  // art size, purely visual — never touches ROJO_RUN_CHECKPOINTS' worldX
  // (gameplay-authoritative trigger position) or the existing stripe drawn
  // separately below. Source art is 1536x1024. Round 2 (2026-07-24, owner
  // feedback "thinner and a little less tall"): width reduced further than
  // height, intentionally departing from the source's exact 1.5:1 aspect —
  // first-pass tuning numbers, one-constant-at-a-time to adjust further.
  const ROJO_RUN_CHECKPOINT_PILLAR_DRAW_HEIGHT = 540;
  const ROJO_RUN_CHECKPOINT_PILLAR_DRAW_WIDTH = 720;
  // ROJO RUN — Phase 9 item 3 fix (2026-07-24): the source art's actual
  // visible pillar base sits at Y=928 of its 1024-tall canvas (the rest is
  // transparent glow-falloff margin) — not the image's raw bottom edge.
  // Ground-aligning the whole image's bottom edge left the visible pillar
  // hovering above the ground line. This fraction anchors the VISIBLE base
  // to groundY instead, letting the transparent margin extend past it.
  const ROJO_RUN_CHECKPOINT_PILLAR_CONTENT_BOTTOM_FRACTION = 928 / 1024;
  // ROJO RUN — Phase 9 item 3 round 2 (2026-07-24): owner reported the
  // fraction-based fix above still read as "a bit hovered" on real device.
  // Added on top of that fix as a further deliberate downward nudge so the
  // base plants into the ground rather than sitting exactly flush (a flush
  // edge can still read as floating due to the art's own soft falloff).
  const ROJO_RUN_CHECKPOINT_PILLAR_GROUND_EMBED = 24;

  // ROJO RUN — Phase 9 item 4 (2026-07-24): finish gateway decorative art —
  // built directly with the DOM-sprite-on-the-shared-track architecture
  // from the start (see rojoRunBuildFinishMarkerSprite() below), applying
  // the same fix already learned twice this phase (containers, then
  // checkpoints): no per-frame canvas redraw, no per-frame terrain lookup.
  // Purely visual — never touches ROJO_RUN_FINISH_X (the gameplay-
  // authoritative finish-line trigger) or the existing stripe drawn
  // separately below.
  //
  // Round 2 (2026-07-24): owner replaced the source art with a new,
  // differently-oriented image — 1536x1024 (landscape), the exact inverse
  // aspect ratio of round 1's 1024x1536 (portrait) source. Width/height
  // swapped (900/600 instead of 600/900) to match the new image's own
  // aspect exactly without stretching, while preserving the identical
  // total footprint area/scale already shipped in round 1 (600*900 ==
  // 900*600) — same visual size, just reoriented to fit the new art.
  const ROJO_RUN_FINISH_MARKER_DRAW_WIDTH = 900;
  const ROJO_RUN_FINISH_MARKER_DRAW_HEIGHT = 600; // 900 * (1024/1536), exact aspect ratio
  // Measured directly from the new source PNG (pixel alpha-bounds scan):
  // this art is framed much more tightly than round 1's — the gateway's
  // visible base sits at ~93% down the canvas (not 85% like before), so
  // the fraction is recalibrated to match this specific image. Ground-embed
  // below is unchanged — still the same proactive nudge already approved.
  const ROJO_RUN_FINISH_MARKER_CONTENT_BOTTOM_FRACTION = 0.93;
  // Same lesson already learned for the checkpoint pillar: the fraction
  // alone still read as slightly hovering on real device, so a further
  // deliberate downward nudge is included proactively here instead of
  // waiting for a second round of the same feedback.
  const ROJO_RUN_FINISH_MARKER_GROUND_EMBED = 30;

  // Simple graybox paint-container markers — position and contact-collection
  // only. No scoring, magnetism, glow, dissolve polish, or HUD update; those
  // belong to Phase 5/6/9. heightAboveGround elevates a container above the
  // local terrain surface (0 = ground level, collectible by contact alone).
  const ROJO_RUN_CONTAINER_RADIUS = 18;
  // ROJO RUN — Phase 9 (2026-07-23): visual draw size only, independent of
  // the collision radius above (still 18, still drives hit detection and
  // the collision-circle center point — untouched). Purely how big the art
  // is drawn, centered on that same unchanged center point.
  const ROJO_RUN_CONTAINER_VISUAL_SIZE = 105;
  // ROJO RUN — ROJO Tavo sprite integration follow-up (2026-07-31): once
  // the placeholder rectangle was replaced with the real 240x240 sprite,
  // the player's visible silhouette (arms/legs at full stride) reaches
  // measurably further than the still-original 60x90 collision box
  // (ROJO_RUN_PLAYER_WIDTH/HEIGHT, untouched) -- a container could look
  // clearly touched and still not register. Measured directly from the
  // actual art (pixel-alpha scan across all 16 run frames): the widest
  // limb reach is ~83 units from the sprite's own center (vs. the box's
  // 30), and standing head-height is ~166 units above the feet (vs. the
  // box's 90-units-above-feet ceiling). These two constants widen ONLY
  // the container-pickup reach check in rojoRunCheckContainerCollisions()
  // below to close that gap -- the collision box itself, hazard/damage
  // detection, and health-pickup collision are all untouched. First-pass
  // values bridging most of the measured gap (not the full visual extent,
  // which would trivialize collection) -- easy to retune from real-device
  // feedback like every other numeric constant in this file.
  const ROJO_RUN_CONTAINER_PICKUP_REACH_X_BONUS = 50;
  const ROJO_RUN_CONTAINER_PICKUP_REACH_Y_BONUS = 20;
  // ROJO RUN — Phase 4E course-difficulty revision Step B2 (2026-07-21):
  // doubled from 10 to 20 (all sections 40->80 total, owner decision). The
  // 10 new containers use height variety (short-jump/held-jump mixed with
  // ground-level) instead of clustering at ground level, per the owner's
  // original "reduce ground-level, add variety" request. Every new position
  // was checked against every Signal Fracture and Pulse Zone in this section
  // and confirmed clear of both. Renumbered 1-20 in strict world-X order.
  const ROJO_RUN_SECTION1_CONTAINERS = [
    { id: 1,  worldX: 1800,  heightAboveGround: 45 },   // elevated 2026-07-21 (height rebalance) from 0
    { id: 2,  worldX: 3800,  heightAboveGround: 90 },
    { id: 3,  worldX: 4200,  heightAboveGround: 90 },   // NEW Step B2
    { id: 4,  worldX: 4400,  heightAboveGround: 90 },
    { id: 5,  worldX: 6000,  heightAboveGround: 0 },
    { id: 6,  worldX: 6300,  heightAboveGround: 60 },   // elevated 2026-07-21 (height rebalance) from 0
    { id: 7,  worldX: 7050,  heightAboveGround: 0 },    // NEW Step B2
    { id: 8,  worldX: 8200,  heightAboveGround: 60 },   // NEW Step B2
    { id: 9,  worldX: 9400,  heightAboveGround: 45 },   // elevated 2026-07-21 (height rebalance) from 0
    { id: 10, worldX: 9700,  heightAboveGround: 0 },
    { id: 11, worldX: 10000, heightAboveGround: 70 },   // elevated 2026-07-21 (height rebalance) from 0
    { id: 12, worldX: 10950, heightAboveGround: 0 },    // NEW Step B2
    { id: 13, worldX: 12100, heightAboveGround: 90 },   // NEW Step B2
    { id: 14, worldX: 14800, heightAboveGround: 0 },    // NEW Step B2
    { id: 15, worldX: 17300, heightAboveGround: 60 },   // elevated 2026-07-21 (height rebalance) from 0
    { id: 16, worldX: 18300, heightAboveGround: 0 },
    { id: 17, worldX: 20450, heightAboveGround: 70 },   // NEW Step B2
    { id: 18, worldX: 23150, heightAboveGround: 0 },    // NEW Step B2
    { id: 19, worldX: 24300, heightAboveGround: 60 },   // NEW Step B2
    { id: 20, worldX: 26700, heightAboveGround: 90 }    // NEW Step B2, = 25% milestone X
  ];
  let rojoRunCollectedContainers = new Set();

  // Inert graybox position markers only — no transformation authority,
  // slowdown cinematic, score event, healing, or interaction. Milestone tied
  // to Container 20's position (updated 2026-07-21 from Container 10, per
  // the 40->80 container expansion) per Section 8.1.
  const ROJO_RUN_MILESTONE_25_X = 26700;
  // ROJO RUN — Phase 5F: Health Pickup 1 (formerly 21900) removed entirely,
  // owner-directed — it never had collision code (locked non-functional
  // since Phase 4B) and looked like a real pickup without being one. Course
  // now has 2 real health pickups (2 and 3); max score is 12,250.

  const ROJO_RUN_LEVEL1_SECTION1_TERRAIN = [
    { startX: 0,     endX: 2600,  groundY: ROJO_RUN_GROUND_Y },                                                                                       // flat opening, Container 1
    { startX: 2600,  endX: 2880,  groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 280, tap-clearable) — Step B1b, Section 1's density-increase pass
    { startX: 2880,  endX: 5500,  groundY: ROJO_RUN_GROUND_Y },                                                                                       // landing + arc zone
    { startX: 5500,  endX: 5850,  groundY: null, isSlope: true, slopeFrom: ROJO_RUN_GROUND_Y, slopeTo: ROJO_RUN_GROUND_Y - 40 },                       // small ridge up
    { startX: 5850,  endX: 6450,  groundY: ROJO_RUN_GROUND_Y - 40 },                                                                                   // small ridge crest
    { startX: 6450,  endX: 6800,  groundY: null, isSlope: true, slopeFrom: ROJO_RUN_GROUND_Y - 40, slopeTo: ROJO_RUN_GROUND_Y },                       // small ridge down
    { startX: 6800,  endX: 7400,  groundY: ROJO_RUN_GROUND_Y },                                                                                        // recovery space
    { startX: 7400,  endX: 7700,  groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 300, tap-clearable) — Step B1b
    { startX: 7700,  endX: 8800,  groundY: ROJO_RUN_GROUND_Y },                                                                                        // landing, recovery
    { startX: 8800,  endX: 9200,  groundY: null, isSlope: true, slopeFrom: ROJO_RUN_GROUND_Y, slopeTo: ROJO_RUN_GROUND_Y - 70 },                       // taller ridge up
    { startX: 9200,  endX: 10200, groundY: ROJO_RUN_GROUND_Y - 70 },                                                                                   // taller ridge crest
    { startX: 10200, endX: 10600, groundY: null, isSlope: true, slopeFrom: ROJO_RUN_GROUND_Y - 70, slopeTo: ROJO_RUN_GROUND_Y },                       // taller ridge down
    { startX: 10600, endX: 11300, groundY: ROJO_RUN_GROUND_Y },                                                                                        // buffer flat
    { startX: 11300, endX: 11620, groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 320, tap-clearable) — Step B1b
    { startX: 11620, endX: 12600, groundY: ROJO_RUN_GROUND_Y },                                                                                        // landing, buffer flat
    { startX: 12600, endX: 13050, groundY: null, isSlope: true, slopeFrom: ROJO_RUN_GROUND_Y, slopeTo: ROJO_RUN_GROUND_Y - 110 },                      // held-jump tutorial ridge up (tallest rise in Section 1)
    { startX: 13050, endX: 14050, groundY: ROJO_RUN_GROUND_Y - 110 },                                                                                  // held-jump tutorial ridge crest — no containers
    { startX: 14050, endX: 14500, groundY: null, isSlope: true, slopeFrom: ROJO_RUN_GROUND_Y - 110, slopeTo: ROJO_RUN_GROUND_Y },                      // held-jump tutorial ridge down
    { startX: 14500, endX: 15150, groundY: ROJO_RUN_GROUND_Y },                                                                                        // buffer flat
    { startX: 15150, endX: 15450, groundY: ROJO_RUN_GROUND_Y },                                                                                        // Pulse Zone footprint (id 9, worldX 15300) — Step B1, placed right after the held-jump tutorial so the section's first reactive hazard follows the jump-timing skill just taught
    { startX: 15450, endX: 15900, groundY: ROJO_RUN_GROUND_Y },                                                                                        // buffer flat
    { startX: 15900, endX: 16200, groundY: ROJO_RUN_GROUND_Y },                                                                                        // NEW 2026-07-21 Pulse Zone footprint (id 18, worldX 15900) — Step B1b
    { startX: 16200, endX: 16500, groundY: ROJO_RUN_GROUND_Y },                                                                                        // buffer flat
    { startX: 16500, endX: 16900, groundY: null, isSlope: true, slopeFrom: ROJO_RUN_GROUND_Y, slopeTo: ROJO_RUN_GROUND_Y - 50 },                       // wide hill up
    { startX: 16900, endX: 18500, groundY: ROJO_RUN_GROUND_Y - 50 },                                                                                   // wide hill crest
    { startX: 18500, endX: 18900, groundY: null, isSlope: true, slopeFrom: ROJO_RUN_GROUND_Y - 50, slopeTo: ROJO_RUN_GROUND_Y },                       // wide hill down
    { startX: 18900, endX: 19600, groundY: ROJO_RUN_GROUND_Y },                                                                                        // recovery
    { startX: 19600, endX: 19900, groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 300, tap-clearable) — Step B1b
    { startX: 19900, endX: 21050, groundY: ROJO_RUN_GROUND_Y },                                                                                        // landing, approach to health marker
    { startX: 21050, endX: 21350, groundY: ROJO_RUN_GROUND_Y },                                                                                        // NEW 2026-07-21 Pulse Zone footprint (id 19, worldX 21200) — Step B1b
    { startX: 21350, endX: 22600, groundY: ROJO_RUN_GROUND_Y },                                                                                        // flat approach (formerly "Health marker (21900)" — Health Pickup 1 removed in Phase 5F)
    { startX: 22600, endX: 22920, groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 320, tap-clearable) — Step B1b
    { startX: 22920, endX: 23450, groundY: ROJO_RUN_GROUND_Y },                                                                                        // landing, recovery
    { startX: 23450, endX: 23750, groundY: ROJO_RUN_GROUND_Y },                                                                                        // NEW 2026-07-21 Pulse Zone footprint (id 20, worldX 23600) — Step B1b
    { startX: 23750, endX: 24900, groundY: ROJO_RUN_GROUND_Y },                                                                                        // approach, Checkpoint 1
    { startX: 24900, endX: 25800, groundY: ROJO_RUN_GROUND_Y },                                                                                        // safe continuation past Checkpoint 1
    { startX: 25800, endX: 26140, groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 340, tap-clearable) — Step B1b
    { startX: 26140, endX: 27400, groundY: ROJO_RUN_GROUND_Y }                                                                                         // landing, safe tail
  ];

  // ROJO RUN — Phase 4B: Level 01, Section 2 (per docs/ROJO_RUN_LOCKED_SPEC_v2.md
  // Section 10.2). The spec gives no world-X coordinates for Section 2 (same
  // as Section 1) — these are invented from the 520 units/sec run speed and
  // the spec's own 60-65 sec target length (62.5 sec / 32,500 units chosen,
  // the middle of that band). Section 1 ends at 27,400, so Section 2 runs
  // 27,400 -> 59,900. Introduces two hazard mechanics that don't exist
  // anywhere else in the file yet: Signal Fractures (a real terrain "pit" —
  // the shape already existed dormant in the flat/slope segment format,
  // never actually used until now) and ROJO Pulse Zones (a stateless,
  // time-based hazard overlay — see ROJO_RUN_PULSE_ZONES below). Route split
  // (spec step 9) is deliberately NOT a literal fork — the "upper route" is
  // a single elevated bonus container (18) reachable only by a held jump,
  // with zero penalty for missing it, per the owner's explicit decision to
  // avoid the class of new-mechanic real-device risk that caused repeated
  // problems earlier in this project.
  // ROJO RUN — Step B2 (2026-07-21): doubled from 10 to 20, renumbered
  // 21-40 in strict world-X order — see Section 1's array for the full
  // rationale (height variety, every position checked against every
  // hazard in this section).
  const ROJO_RUN_SECTION2_CONTAINERS = [
    { id: 21, worldX: 29800, heightAboveGround: 45 },   // elevated 2026-07-21 (height rebalance) from 0
    { id: 22, worldX: 30600, heightAboveGround: 0 },
    { id: 23, worldX: 31100, heightAboveGround: 60 },
    { id: 24, worldX: 31650, heightAboveGround: 60 },   // elevated 2026-07-21 (height rebalance) from 0
    { id: 25, worldX: 31800, heightAboveGround: 0 },    // NEW Step B2
    { id: 26, worldX: 32900, heightAboveGround: 60 },   // NEW Step B2
    { id: 27, worldX: 33900, heightAboveGround: 0 },    // NEW Step B2
    { id: 28, worldX: 34900, heightAboveGround: 70 },   // shifted 2026-07-21 from 35220 — was 80 units from Pulse Zone 1 (35300), inside its 150-unit danger radius; now 400 units clear before the zone, still requires a jump to collect (elevated 70)
    { id: 29, worldX: 36000, heightAboveGround: 70 },   // NEW Step B2
    { id: 30, worldX: 36700, heightAboveGround: 0 },    // NEW Step B2
    { id: 31, worldX: 37800, heightAboveGround: 90 },   // NEW Step B2
    { id: 32, worldX: 39300, heightAboveGround: 0 },
    { id: 33, worldX: 40100, heightAboveGround: 70 },   // elevated 2026-07-21 (height rebalance) from 0
    { id: 34, worldX: 41400, heightAboveGround: 0 },    // NEW Step B2
    { id: 35, worldX: 42600, heightAboveGround: 150 },  // route-split bonus — requires a deliberate held jump (tap-jump peaks ~129px, held jump peaks ~193px)
    { id: 36, worldX: 43800, heightAboveGround: 60 },   // NEW Step B2
    { id: 37, worldX: 45100, heightAboveGround: 45 },   // elevated 2026-07-21 (height rebalance) from 0
    { id: 38, worldX: 47300, heightAboveGround: 0 },
    { id: 39, worldX: 52700, heightAboveGround: 0 },    // NEW Step B2
    { id: 40, worldX: 54600, heightAboveGround: 90 }    // NEW Step B2, = 50% milestone X
  ];

  const ROJO_RUN_MILESTONE_50_X = 54600;
  const ROJO_RUN_HEALTH_PICKUP_2_X = 52300;

  const ROJO_RUN_LEVEL1_SECTION2_TERRAIN = [
    { startX: 27400, endX: 28200, groundY: ROJO_RUN_GROUND_Y },                                                                                       // recovery
    { startX: 28200, endX: 28500, groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 300, tap-clearable) — course-difficulty revision Step B1
    { startX: 28500, endX: 31200, groundY: ROJO_RUN_GROUND_Y },                                                                                       // landing + Containers 11-12
    { startX: 31200, endX: 31475, groundY: null, isSlope: false },                                                                                    // Signal Fracture 1 (width 275, re-tuned 2026-07-21 from 220 for the 650 speed — 220 * 650/520)
    { startX: 31475, endX: 32200, groundY: ROJO_RUN_GROUND_Y },                                                                                       // landing, recovery
    { startX: 32200, endX: 32520, groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 320, tap-clearable) — Step B1b
    { startX: 32520, endX: 33300, groundY: ROJO_RUN_GROUND_Y },                                                                                       // landing, recovery
    { startX: 33300, endX: 33600, groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 300, tap-clearable) — Step B1b
    { startX: 33600, endX: 34200, groundY: ROJO_RUN_GROUND_Y },                                                                                       // landing, approach
    { startX: 34200, endX: 36400, groundY: ROJO_RUN_GROUND_Y },                                                                                       // ROJO Pulse Zone 1 footprint + approach, Container 15
    { startX: 36400, endX: 37050, groundY: ROJO_RUN_GROUND_Y },                                                                                       // recovery
    { startX: 37050, endX: 37350, groundY: ROJO_RUN_GROUND_Y },                                                                                       // NEW 2026-07-21 Pulse Zone footprint (id 10, worldX 37200) — Step B1
    { startX: 37350, endX: 38400, groundY: ROJO_RUN_GROUND_Y },                                                                                       // recovery
    { startX: 38400, endX: 38850, groundY: null, isSlope: true, slopeFrom: ROJO_RUN_GROUND_Y, slopeTo: ROJO_RUN_GROUND_Y - 140 },                      // tall ridge up
    { startX: 38850, endX: 40650, groundY: ROJO_RUN_GROUND_Y - 140 },                                                                                  // tall ridge crest, Containers 16-17
    { startX: 40650, endX: 41100, groundY: null, isSlope: true, slopeFrom: ROJO_RUN_GROUND_Y - 140, slopeTo: ROJO_RUN_GROUND_Y },                      // tall ridge down
    { startX: 41100, endX: 41800, groundY: ROJO_RUN_GROUND_Y },                                                                                       // route-split zone approach (single path; Container 18 elevated bonus)
    { startX: 41800, endX: 42150, groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 350, tap-clearable) — Step B1b, ground-level pit under the elevated Container 18 bonus arc, no conflict since the container is collision-checked independent of ground state
    { startX: 42150, endX: 43200, groundY: ROJO_RUN_GROUND_Y },                                                                                       // landing, past Container 18
    { startX: 43200, endX: 43500, groundY: ROJO_RUN_GROUND_Y },                                                                                       // NEW 2026-07-21 Pulse Zone footprint (id 21, worldX 43350) — Step B1b
    { startX: 43500, endX: 44100, groundY: ROJO_RUN_GROUND_Y },                                                                                       // recovery
    { startX: 44100, endX: 44450, groundY: ROJO_RUN_GROUND_Y },                                                                                       // reconnect
    { startX: 44450, endX: 44750, groundY: ROJO_RUN_GROUND_Y },                                                                                       // NEW 2026-07-21 Pulse Zone footprint (id 11, worldX 44600) — Step B1
    { startX: 44750, endX: 46100, groundY: ROJO_RUN_GROUND_Y },                                                                                       // Container 19
    { startX: 46100, endX: 46500, groundY: null, isSlope: true, slopeFrom: ROJO_RUN_GROUND_Y, slopeTo: ROJO_RUN_GROUND_Y - 90 },                       // final hill up
    { startX: 46500, endX: 48100, groundY: ROJO_RUN_GROUND_Y - 90 },                                                                                   // final hill crest, Container 20 (= 50% milestone X)
    { startX: 48100, endX: 48500, groundY: null, isSlope: true, slopeFrom: ROJO_RUN_GROUND_Y - 90, slopeTo: ROJO_RUN_GROUND_Y },                       // final hill down
    { startX: 48500, endX: 49500, groundY: ROJO_RUN_GROUND_Y },                                                                                       // recovery
    { startX: 49500, endX: 49820, groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 320, tap-clearable) — Step B1
    { startX: 49820, endX: 50750, groundY: ROJO_RUN_GROUND_Y },                                                                                       // landing + recovery
    { startX: 50750, endX: 51050, groundY: ROJO_RUN_GROUND_Y },                                                                                       // NEW 2026-07-21 Pulse Zone footprint (id 22, worldX 50900) — Step B1b
    { startX: 51050, endX: 51500, groundY: ROJO_RUN_GROUND_Y },                                                                                       // recovery
    { startX: 51500, endX: 53400, groundY: ROJO_RUN_GROUND_Y },                                                                                       // Health Pickup 2, approach
    { startX: 53400, endX: 53740, groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 340, tap-clearable) — Step B1
    { startX: 53740, endX: 55600, groundY: ROJO_RUN_GROUND_Y },                                                                                       // recovery
    { startX: 55600, endX: 55960, groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 360, tap-clearable) — Step B1
    { startX: 55960, endX: 58200, groundY: ROJO_RUN_GROUND_Y },                                                                                       // approach, Checkpoint 2
    { startX: 58200, endX: 58540, groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 340, tap-clearable) — Step B1b, placed after Checkpoint 2 with clear buffer both sides
    { startX: 58540, endX: 59900, groundY: ROJO_RUN_GROUND_Y }                                                                                        // landing, safe tail
  ];

  // ROJO RUN — Phase 4C: Level 01, Section 3 (per docs/ROJO_RUN_LOCKED_SPEC_v2.md
  // Section 10.3). Section 2 ends at 59,900; target 70-75 sec (72.5 sec /
  // 37,700 units chosen, the middle of that band), so Section 3 runs
  // 59,900 -> 97,600. Reuses every mechanic from Phase 4B (Signal Fracture,
  // Pulse Zone, health system) with no new collision code. The one genuinely
  // new piece is the Terrain Swell (see its own repositioning comment
  // below) — everything else here is just more content in the established
  // pattern. Route split (spec step 8) again deliberately NOT a literal
  // fork, same owner-confirmed reasoning as Section 2's Container 18: the
  // "upper route" bonus (Container 28) is gated by skillfully clearing a
  // short Signal Fracture (jumping across it and landing near an elevated
  // pickup on the far side) instead of a separate branching path. "Paired
  // Pulse sequence" (spec step 5) interpreted as two separate
  // ROJO_RUN_PULSE_ZONES entries close together, per owner decision.
  // ROJO RUN — Step B2 (2026-07-21): doubled from 10 to 20, renumbered
  // 41-60 in strict world-X order — see Section 1's array for the full
  // rationale.
  const ROJO_RUN_SECTION3_CONTAINERS = [
    { id: 41, worldX: 61050, heightAboveGround: 0 },    // NEW Step B2
    { id: 42, worldX: 61450, heightAboveGround: 45 },   // elevated 2026-07-21 (height rebalance) from 0
    { id: 43, worldX: 61850, heightAboveGround: 0 },
    { id: 44, worldX: 63200, heightAboveGround: 60 },   // NEW Step B2
    { id: 45, worldX: 64500, heightAboveGround: 60 },   // elevated 2026-07-21 (height rebalance) from 0
    { id: 46, worldX: 65400, heightAboveGround: 0 },
    { id: 47, worldX: 66800, heightAboveGround: 0 },    // NEW Step B2
    { id: 48, worldX: 67900, heightAboveGround: 90 },   // NEW Step B2
    { id: 49, worldX: 69150, heightAboveGround: 70 },   // elevated 2026-07-21 (height rebalance) from 0
    { id: 50, worldX: 71300, heightAboveGround: 0 },    // NEW Step B2
    { id: 51, worldX: 72450, heightAboveGround: 55 },  // Terrain Swell footprint — 55 sits safely above the swell's 40px max rise
    { id: 52, worldX: 74350, heightAboveGround: 70 },   // NEW Step B2
    { id: 53, worldX: 75200, heightAboveGround: 45 },   // elevated 2026-07-21 (height rebalance) from 0
    { id: 54, worldX: 76550, heightAboveGround: 45 },  // route-split bonus — past the short Signal Fracture, requires clearing the gap and landing the jump on the far side
    { id: 55, worldX: 78300, heightAboveGround: 0 },   // shifted 2026-07-21 from 78600 — see Section 3 terrain comment near worldX 78300 for the fracture/Pulse-Zone spacing fix this was part of
    { id: 56, worldX: 79200, heightAboveGround: 0 },    // NEW Step B2
    { id: 57, worldX: 80750, heightAboveGround: 60 },   // NEW Step B2
    { id: 58, worldX: 82800, heightAboveGround: 0 },    // NEW Step B2
    { id: 59, worldX: 86900, heightAboveGround: 60 },   // elevated 2026-07-21 (height rebalance) from 0
    { id: 60, worldX: 92200, heightAboveGround: 90 }    // NEW Step B2, = 75% milestone X
  ];

  const ROJO_RUN_MILESTONE_75_X = 92200;
  const ROJO_RUN_HEALTH_PICKUP_3_X = 92600;

  const ROJO_RUN_LEVEL1_SECTION3_TERRAIN = [
    { startX: 59900, endX: 60450, groundY: ROJO_RUN_GROUND_Y },                                                                                       // recovery
    { startX: 60450, endX: 60750, groundY: ROJO_RUN_GROUND_Y },                                                                                       // NEW 2026-07-21 Pulse Zone footprint (id 12, worldX 60600) — Step B1
    { startX: 60750, endX: 61400, groundY: ROJO_RUN_GROUND_Y },                                                                                       // recovery
    { startX: 61400, endX: 61900, groundY: null, isSlope: true, slopeFrom: ROJO_RUN_GROUND_Y, slopeTo: ROJO_RUN_GROUND_Y + 70 },                       // downhill — first downhill in the game, Containers 21-22
    { startX: 61900, endX: 62400, groundY: ROJO_RUN_GROUND_Y + 70 },                                                                                   // recovery/approach
    { startX: 62400, endX: 62700, groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 300, tap-clearable) — Step B1
    { startX: 62700, endX: 63900, groundY: ROJO_RUN_GROUND_Y + 70 },                                                                                   // landing/approach
    { startX: 63900, endX: 64275, groundY: null, isSlope: false },                                                                                    // wider Signal Fracture (width 375, re-tuned 2026-07-21 from 300 for the 650 speed — 300 * 650/520)
    { startX: 64275, endX: 66200, groundY: ROJO_RUN_GROUND_Y + 70 },                                                                                   // landing, Containers 23-24
    { startX: 66200, endX: 66500, groundY: null, isSlope: true, slopeFrom: ROJO_RUN_GROUND_Y + 70, slopeTo: ROJO_RUN_GROUND_Y },                       // back to baseline
    { startX: 66500, endX: 67150, groundY: ROJO_RUN_GROUND_Y },                                                                                       // recovery
    { startX: 67150, endX: 67450, groundY: ROJO_RUN_GROUND_Y },                                                                                       // NEW 2026-07-21 Pulse Zone footprint (id 13, worldX 67300) — Step B1
    { startX: 67450, endX: 68500, groundY: ROJO_RUN_GROUND_Y },                                                                                       // recovery
    { startX: 68500, endX: 70200, groundY: ROJO_RUN_GROUND_Y },                                                                                       // paired Pulse Zones (68800, 69500) + Container 25
    { startX: 70200, endX: 70700, groundY: ROJO_RUN_GROUND_Y },                                                                                       // recovery
    { startX: 70700, endX: 71000, groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 300, tap-clearable) — Step B1b
    { startX: 71000, endX: 71700, groundY: ROJO_RUN_GROUND_Y },                                                                                       // landing, approach to Swell
    { startX: 71700, endX: 73200, groundY: ROJO_RUN_GROUND_Y },                                                                                       // Terrain Swell footprint (repositioned here), Container 26 — no new hazards placed inside a Swell footprint
    { startX: 73200, endX: 73700, groundY: ROJO_RUN_GROUND_Y },                                                                                       // recovery
    { startX: 73700, endX: 74020, groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 320, tap-clearable) — Step B1b
    { startX: 74020, endX: 74700, groundY: ROJO_RUN_GROUND_Y },                                                                                       // landing, recovery
    { startX: 74700, endX: 75300, groundY: null, isSlope: true, slopeFrom: ROJO_RUN_GROUND_Y, slopeTo: ROJO_RUN_GROUND_Y - 130 },                      // climb, Container 27 near top
    { startX: 75300, endX: 76300, groundY: ROJO_RUN_GROUND_Y - 130 },                                                                                  // crest, approach
    { startX: 76300, endX: 76525, groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 225) — Step B1, implements the short fracture this segment's design comment always described but that was never actually built as real terrain (only 4 real fracture segments existed in the file before this step); gates Container 28's route-split bonus as originally intended
    { startX: 76525, endX: 77300, groundY: ROJO_RUN_GROUND_Y - 130 },                                                                                  // landing, Container 28
    { startX: 77300, endX: 77600, groundY: null, isSlope: true, slopeFrom: ROJO_RUN_GROUND_Y - 130, slopeTo: ROJO_RUN_GROUND_Y },                      // back to baseline (routes reconnect)
    { startX: 77600, endX: 77650, groundY: ROJO_RUN_GROUND_Y },                                                                                       // recovery
    { startX: 77650, endX: 77970, groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 320, tap-clearable) — Step B1
    { startX: 77970, endX: 78300, groundY: ROJO_RUN_GROUND_Y },                                                                                       // landing, Container 29 — shifted 2026-07-21 from 78600 (owner feedback: real-device test found the Pulse Zone below only 80 units past this fracture's landing, unfair; both this container and the zone moved to open real clearance)
    { startX: 78300, endX: 78650, groundY: ROJO_RUN_GROUND_Y },                                                                                       // buffer
    { startX: 78650, endX: 78950, groundY: ROJO_RUN_GROUND_Y },                                                                                       // Pulse Zone footprint (id 23, worldX 78800) — shifted 2026-07-21 from 78200, now 680 units clear of the fracture landing instead of 80
    { startX: 78950, endX: 79600, groundY: ROJO_RUN_GROUND_Y },                                                                                       // recovery
    { startX: 79600, endX: 80150, groundY: ROJO_RUN_GROUND_Y },                                                                                       // recovery
    { startX: 80150, endX: 80450, groundY: ROJO_RUN_GROUND_Y },                                                                                       // NEW 2026-07-21 Pulse Zone footprint (id 14, worldX 80300) — Step B1
    { startX: 80450, endX: 81100, groundY: ROJO_RUN_GROUND_Y },                                                                                       // recovery
    { startX: 81100, endX: 81600, groundY: null, isSlope: true, slopeFrom: ROJO_RUN_GROUND_Y, slopeTo: ROJO_RUN_GROUND_Y - 90 },                       // ridge
    { startX: 81600, endX: 82200, groundY: ROJO_RUN_GROUND_Y - 90 },                                                                                   // safe area
    { startX: 82200, endX: 82500, groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 300, tap-clearable) — Step B1b
    { startX: 82500, endX: 83100, groundY: ROJO_RUN_GROUND_Y - 90 },                                                                                   // landing, safe area
    { startX: 83100, endX: 83400, groundY: null, isSlope: true, slopeFrom: ROJO_RUN_GROUND_Y - 90, slopeTo: ROJO_RUN_GROUND_Y },                       // back to baseline
    { startX: 83400, endX: 85400, groundY: ROJO_RUN_GROUND_Y },                                                                                       // single Pulse Zone (84400)
    { startX: 85400, endX: 86000, groundY: null, isSlope: true, slopeFrom: ROJO_RUN_GROUND_Y, slopeTo: ROJO_RUN_GROUND_Y - 140 },                      // uphill
    { startX: 86000, endX: 87800, groundY: ROJO_RUN_GROUND_Y - 140 },                                                                                  // crest, Container 30 (= 75% milestone X)
    { startX: 87800, endX: 88100, groundY: null, isSlope: true, slopeFrom: ROJO_RUN_GROUND_Y - 140, slopeTo: ROJO_RUN_GROUND_Y },                      // back to baseline
    { startX: 88100, endX: 89000, groundY: ROJO_RUN_GROUND_Y },                                                                                       // recovery
    { startX: 89000, endX: 89380, groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 380, tap-clearable) — Step B1
    { startX: 89380, endX: 90600, groundY: ROJO_RUN_GROUND_Y },                                                                                       // landing, recovery
    { startX: 90600, endX: 93200, groundY: ROJO_RUN_GROUND_Y },                                                                                       // Health Pickup 3, approach
    { startX: 93200, endX: 93540, groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 340, tap-clearable) — Step B1b
    { startX: 93540, endX: 94850, groundY: ROJO_RUN_GROUND_Y },                                                                                       // landing, approach
    { startX: 94850, endX: 95150, groundY: ROJO_RUN_GROUND_Y },                                                                                       // NEW 2026-07-21 Pulse Zone footprint (id 24, worldX 95000) — Step B1b
    { startX: 95150, endX: 97600, groundY: ROJO_RUN_GROUND_Y }                                                                                        // approach, Checkpoint 3, safe tail
  ];

  // ROJO RUN — Phase 4D: Level 01, Section 4 (per docs/ROJO_RUN_LOCKED_SPEC_v2.md
  // Section 10.4) — the final section of Level 01. Section 3 ends at 97,600;
  // target 80-90 sec (85 sec / 44,200 units chosen, the middle of that
  // band), so Section 4 runs 97,600 -> 141,800. Reuses every mechanic
  // already built and proven (Signal Fracture, Pulse Zone, Terrain Swell,
  // health system) — no new collision code. Two new pieces: a second
  // Terrain Swell placement (the swell system below was generalized to an
  // array of footprints to support this) and invisible safe anchors (spec
  // Section 10.5), added here only — not retrofitted into the already-locked
  // Sections 2-3, per owner decision. Route split (spec step 9) again a
  // single continuous path, not a literal fork: a Pulse Zone (matching
  // "lower/safer route") followed by a short Signal Fracture gating bonus
  // Container 36 (matching "upper route"), same reasoning as Sections 2-3.
  // Section 4 has no additional checkpoint (it ends at Finish, not a
  // checkpoint) and per spec's own health-pickup rule ("before each major
  // checkpoint, place one optional health pickup") there is no Health
  // Pickup 4 — Section 4 simply has none. The 100% milestone and the Finish
  // marker itself stay inert/position-only, matching every milestone so
  // far — no victory cinematic, results screen, or completion logic; those
  // are explicitly later-phase systems per the spec's own sequencing
  // (Section 21, Phase 5+).
  // ROJO RUN — Step B2 (2026-07-21): doubled from 10 to 20, renumbered
  // 61-80 in strict world-X order — see Section 1's array for the full
  // rationale. No new containers placed in the hazard-free victory runway
  // (138600-141800) — Container 80 stays the level's last collectible
  // before that closing stretch, unchanged in position.
  const ROJO_RUN_SECTION4_CONTAINERS = [
    { id: 61, worldX: 98500,  heightAboveGround: 45 },  // elevated 2026-07-21 (height rebalance) from 0
    { id: 62, worldX: 100400, heightAboveGround: 0 },
    { id: 63, worldX: 102550, heightAboveGround: 0 },   // NEW Step B2
    { id: 64, worldX: 103650, heightAboveGround: 55 },  // second Terrain Swell footprint — 55 sits safely above the swell's 40px max rise
    { id: 65, worldX: 105950, heightAboveGround: 60 },  // NEW Step B2
    { id: 66, worldX: 107300, heightAboveGround: 60 },  // elevated 2026-07-21 (height rebalance) from 0
    { id: 67, worldX: 109050, heightAboveGround: 0 },   // NEW Step B2
    { id: 68, worldX: 110200, heightAboveGround: 70 },  // NEW Step B2
    { id: 69, worldX: 111350, heightAboveGround: 70 },  // elevated 2026-07-21 (height rebalance) from 0
    { id: 70, worldX: 112950, heightAboveGround: 0 },   // NEW Step B2
    { id: 71, worldX: 114150, heightAboveGround: 90 },  // NEW Step B2
    { id: 72, worldX: 116230, heightAboveGround: 45 },  // route-split bonus — past the short Signal Fracture, same pattern as Section 2/3's Container 18/28
    { id: 73, worldX: 118200, heightAboveGround: 0 },   // NEW Step B2
    { id: 74, worldX: 119680, heightAboveGround: 45 },  // elevated 2026-07-21 (height rebalance) from 0
    { id: 75, worldX: 121000, heightAboveGround: 60 },  // NEW Step B2
    { id: 76, worldX: 122150, heightAboveGround: 0 },   // NEW Step B2
    { id: 77, worldX: 128400, heightAboveGround: 60 },  // elevated 2026-07-21 (height rebalance) from 0
    { id: 78, worldX: 130600, heightAboveGround: 90 },  // NEW Step B2
    { id: 79, worldX: 132850, heightAboveGround: 0 },   // shifted 2026-07-21 from 132520 (owner-requested removal of the old "containers-on-zones" convention) — was sitting exactly on the final Pulse Zone (132520); now 330 units clear after it, well outside its 150-unit danger radius
    { id: 80, worldX: 137220, heightAboveGround: 0 }    // = 100% milestone X (unchanged position — highest world-X container, no new container placed after it)
  ];

  const ROJO_RUN_MILESTONE_100_X = 137220;
  const ROJO_RUN_FINISH_X = 140800;

  // ROJO RUN — Phase 5C: named section boundaries, matching the terrain
  // arrays' own Section 1-4 split exactly (start-of-array world-X values,
  // finish end capped at ROJO_RUN_FINISH_X rather than the terrain array's
  // literal end so the hazard-free victory runway is never counted as part
  // of Section 4 for evaluation purposes). Consumed by Phase 5E's
  // clean-section bonus evaluation below.
  const ROJO_RUN_SECTION_BOUNDARIES = [
    { section: 1, startX: 0,     endX: 27400 },
    { section: 2, startX: 27400, endX: 59900 },
    { section: 3, startX: 59900, endX: 97600 },
    { section: 4, startX: 97600, endX: ROJO_RUN_FINISH_X }
  ];

  // ROJO RUN — Phase 5E: which section a given world-X position falls
  // inside, for attributing damage to the correct clean-section flag.
  function rojoRunSectionIndexAt(worldX) {
    for (let i = 0; i < ROJO_RUN_SECTION_BOUNDARIES.length; i++) {
      if (worldX < ROJO_RUN_SECTION_BOUNDARIES[i].endX) return i;
    }
    return ROJO_RUN_SECTION_BOUNDARIES.length - 1;
  }

  // ROJO RUN — Phase 4D: invisible safe respawn anchors (spec Section 10.5).
  // Same crossing-detection mechanism the visible ROJO_RUN_CHECKPOINTS
  // array already uses (updates rojoRunLatestCheckpointX, only ever
  // advances, never regresses) — just no visual marker drawn. Placed after
  // the medium fracture, after the paired Pulse sequence, after route
  // reconnection, and before the final obstacle chain, per spec.
  const ROJO_RUN_SAFE_ANCHORS = [
    { worldX: 106750 }, // shifted 2026-07-21 from 106680 — matches the medium Signal Fracture's new landing point after its 280->350 re-tune
    { worldX: 112680 },
    { worldX: 116680 },
    { worldX: 122680 }
  ];

  const ROJO_RUN_LEVEL1_SECTION4_TERRAIN = [
    { startX: 97600,  endX: 99400,  groundY: ROJO_RUN_GROUND_Y },                                                                                      // opening, Container 31
    { startX: 99400,  endX: 99800,  groundY: null, isSlope: true, slopeFrom: ROJO_RUN_GROUND_Y, slopeTo: ROJO_RUN_GROUND_Y - 70 },                      // small ridge up
    { startX: 99800,  endX: 101000, groundY: ROJO_RUN_GROUND_Y - 70 },                                                                                  // small ridge crest, Container 32
    { startX: 101000, endX: 101400, groundY: null, isSlope: true, slopeFrom: ROJO_RUN_GROUND_Y - 70, slopeTo: ROJO_RUN_GROUND_Y },                      // small ridge down
    { startX: 101400, endX: 101900, groundY: ROJO_RUN_GROUND_Y },                                                                                       // recovery
    { startX: 101900, endX: 102200, groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 300, tap-clearable) — Step B1
    { startX: 102200, endX: 102900, groundY: ROJO_RUN_GROUND_Y },                                                                                       // landing, approach
    { startX: 102900, endX: 104400, groundY: ROJO_RUN_GROUND_Y },                                                                                       // second Terrain Swell footprint, Container 33 — no new hazards placed inside a Swell footprint
    { startX: 104400, endX: 105200, groundY: ROJO_RUN_GROUND_Y },                                                                                       // safe area
    { startX: 105200, endX: 105520, groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 320, tap-clearable) — Step B1b
    { startX: 105520, endX: 106400, groundY: ROJO_RUN_GROUND_Y },                                                                                       // landing, safe area
    { startX: 106400, endX: 106750, groundY: null, isSlope: false },                                                                                    // medium Signal Fracture (width 350, re-tuned 2026-07-21 from 280 for the 650 speed — 280 * 650/520)
    { startX: 106750, endX: 108680, groundY: ROJO_RUN_GROUND_Y },                                                                                       // landing, Container 34 — invisible anchor
    { startX: 108680, endX: 109500, groundY: ROJO_RUN_GROUND_Y },                                                                                       // recovery
    { startX: 109500, endX: 109800, groundY: ROJO_RUN_GROUND_Y },                                                                                       // NEW 2026-07-21 Pulse Zone footprint (id 15, worldX 109500) — Step B1
    { startX: 109800, endX: 110680, groundY: ROJO_RUN_GROUND_Y },                                                                                       // recovery
    { startX: 110680, endX: 112680, groundY: ROJO_RUN_GROUND_Y },                                                                                       // paired Pulse Zones (111000, 111700), Container 35 — invisible anchor at end
    { startX: 112680, endX: 113300, groundY: ROJO_RUN_GROUND_Y },                                                                                       // recovery
    { startX: 113300, endX: 113680, groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 380, tap-clearable) — Step B1
    { startX: 113680, endX: 114680, groundY: ROJO_RUN_GROUND_Y },                                                                                       // landing, recovery
    { startX: 114680, endX: 115900, groundY: ROJO_RUN_GROUND_Y },                                                                                       // route-split gauntlet: Pulse Zone (115200), approach
    { startX: 115900, endX: 116125, groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 225) — Step B1, implements the short fracture this segment's design comment always described but that was never actually built as real terrain (only 4 real fracture segments existed in the file before this step); gates Container 36's route-split bonus as originally intended
    { startX: 116125, endX: 116680, groundY: ROJO_RUN_GROUND_Y },                                                                                       // landing, Container 36 — invisible anchor at end
    { startX: 116680, endX: 117400, groundY: ROJO_RUN_GROUND_Y },                                                                                       // routes reconnect + recovery
    { startX: 117400, endX: 117820, groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 420, HELD-JUMP REQUIRED — exceeds the 650-speed tap-jump range of ~410, second held-jump-only gap in the level after the existing 425-wide one) — Step B1
    { startX: 117820, endX: 118680, groundY: ROJO_RUN_GROUND_Y },                                                                                       // landing, recovery
    { startX: 118680, endX: 119100, groundY: ROJO_RUN_GROUND_Y },                                                                                       // approach
    { startX: 119100, endX: 119400, groundY: ROJO_RUN_GROUND_Y },                                                                                       // NEW 2026-07-21 Pulse Zone footprint (id 16, worldX 119100) — Step B1
    { startX: 119400, endX: 120680, groundY: ROJO_RUN_GROUND_Y },                                                                                       // Container 37
    { startX: 120680, endX: 121350, groundY: ROJO_RUN_GROUND_Y },                                                                                       // recovery — invisible anchor at end
    { startX: 121350, endX: 121650, groundY: ROJO_RUN_GROUND_Y },                                                                                       // NEW 2026-07-21 Pulse Zone footprint (id 17, worldX 121500) — Step B1
    { startX: 121650, endX: 122680, groundY: ROJO_RUN_GROUND_Y },                                                                                       // recovery
    { startX: 122680, endX: 123280, groundY: null, isSlope: true, slopeFrom: ROJO_RUN_GROUND_Y, slopeTo: ROJO_RUN_GROUND_Y - 140 },                     // final chain: ridge up
    { startX: 123280, endX: 124100, groundY: ROJO_RUN_GROUND_Y - 140 },                                                                                 // safe area
    { startX: 124100, endX: 124450, groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 350, tap-clearable) — Step B1b
    { startX: 124450, endX: 125280, groundY: ROJO_RUN_GROUND_Y - 140 },                                                                                 // landing, safe area
    { startX: 125280, endX: 125680, groundY: null, isSlope: true, slopeFrom: ROJO_RUN_GROUND_Y - 140, slopeTo: ROJO_RUN_GROUND_Y },                     // ridge down
    { startX: 125680, endX: 126500, groundY: ROJO_RUN_GROUND_Y },                                                                                       // buffer/approach
    { startX: 126500, endX: 126800, groundY: null, isSlope: false },                                                                                    // NEW 2026-07-21 Signal Fracture (width 300, tap-clearable) — Step B1b
    { startX: 126800, endX: 127680, groundY: ROJO_RUN_GROUND_Y },                                                                                       // landing, approach
    { startX: 127680, endX: 128105, groundY: null, isSlope: false },                                                                                    // widest Signal Fracture (width 425, re-tuned 2026-07-21 from 340 for the 650 speed — 340 * 650/520)
    { startX: 128105, endX: 129500, groundY: ROJO_RUN_GROUND_Y },                                                                                       // safe area, Container 38
    { startX: 129500, endX: 129800, groundY: ROJO_RUN_GROUND_Y },                                                                                       // NEW 2026-07-21 Pulse Zone footprint (id 25, worldX 129650) — Step B1b
    { startX: 129800, endX: 131520, groundY: ROJO_RUN_GROUND_Y },                                                                                       // safe area
    { startX: 131520, endX: 133520, groundY: ROJO_RUN_GROUND_Y },                                                                                       // final Pulse Zone, Container 39
    { startX: 133520, endX: 134150, groundY: ROJO_RUN_GROUND_Y },                                                                                       // recovery
    { startX: 134150, endX: 134450, groundY: ROJO_RUN_GROUND_Y },                                                                                       // NEW 2026-07-21 Pulse Zone footprint (id 26, worldX 134300) — Step B1b
    { startX: 134450, endX: 135520, groundY: ROJO_RUN_GROUND_Y },                                                                                       // recovery
    { startX: 135520, endX: 136220, groundY: null, isSlope: true, slopeFrom: ROJO_RUN_GROUND_Y, slopeTo: ROJO_RUN_GROUND_Y - 160 },                     // final hill up — tallest rise in the level
    { startX: 136220, endX: 138220, groundY: ROJO_RUN_GROUND_Y - 160 },                                                                                 // crest, Container 40 (= 100% milestone X)
    { startX: 138220, endX: 138600, groundY: null, isSlope: true, slopeFrom: ROJO_RUN_GROUND_Y - 160, slopeTo: ROJO_RUN_GROUND_Y },                     // back to baseline
    { startX: 138600, endX: 141800, groundY: ROJO_RUN_GROUND_Y }                                                                                        // hazard-free victory runway, white TDOM finish marker, safe tail
  ];

  const ROJO_RUN_LEVEL1_TERRAIN = ROJO_RUN_LEVEL1_SECTION1_TERRAIN.concat(ROJO_RUN_LEVEL1_SECTION2_TERRAIN, ROJO_RUN_LEVEL1_SECTION3_TERRAIN, ROJO_RUN_LEVEL1_SECTION4_TERRAIN);
  const ROJO_RUN_ALL_CONTAINERS = ROJO_RUN_SECTION1_CONTAINERS.concat(ROJO_RUN_SECTION2_CONTAINERS, ROJO_RUN_SECTION3_CONTAINERS, ROJO_RUN_SECTION4_CONTAINERS);

  // ROJO RUN — Phase 4B: ROJO Pulse Zones. Stateless by design — no
  // accumulator, no reset-path wiring needed, since world position is
  // always an exact function of elapsed time at ROJO_RUN_BASE_SPEED: cycle
  // phase is computed live as (worldTimeSeconds % cycleSeconds). Spec
  // Section 12 gives a "0.95 / 0.45 / 0.65" timing triplet for Section 2,
  // unlabeled in the spec — interpreted here as telegraph/active/reset.
  // Real-device testing found the original telegraph/active/reset ratio let
  // a player walk straight through untouched most of the time (only ~22% of
  // the cycle was actually dangerous). Per the owner's explicit "mostly
  // dangerous" balance decision: telegraphSeconds kept at the spec-derived
  // 0.95 unchanged, activeSeconds extended well past the spec's original
  // 0.45 so the danger window is the majority of the cycle, and the safe
  // reset gap shrunk to a brief 0.2s rather than eliminated outright. Since
  // the collision check below is purely "are you grounded" (not
  // timing-precise), jumping at any point always avoids it regardless of
  // these numbers — only the "do nothing" outcome changes.
  // ROJO RUN — Phase 4C: Section 3 adds three more zones — the "paired
  // sequence" (spec step 5, two entries close together) and a single zone
  // later in the section (step 12). Spec Section 12 gives "Section 3 pair:
  // 0.80 / 0.45 / 0.35" (telegraph/active/reset, same unlabeled-triplet
  // reading as Section 2's). Rebalanced the same "mostly dangerous"
  // direction as Section 2's zone, for consistency: telegraph kept at the
  // spec-derived 0.80 unchanged, active extended to 1.3 (well past the
  // spec's 0.45), reset shrunk to a brief 0.15 — active is ~58% of the
  // cycle, matching Section 2's zone's ~57% ratio.
  // ROJO RUN — Phase 4D: Section 4 adds four more zones — the paired
  // sequence (step 8), the single "lower route" zone inside the route-split
  // gauntlet (step 9), and the final zone (step 13's final chain). Spec
  // Section 12 gives "Section 4 pair: 0.68 / 0.45 / 0.25" for the paired
  // zones (and, per established convention, the gauntlet's single zone
  // reuses the same Section 4 timing) — rebalanced the same "mostly
  // dangerous" direction as every prior section's zones: telegraph kept at
  // the spec-derived 0.68 unchanged, active extended to 1.1, reset shrunk
  // to 0.12 (~58% active ratio, matching Sections 2-3). The final zone uses
  // its own slightly more generous telegraph (0.75s, comfortably above
  // spec's "final warning: at least 0.65 sec" floor for the level's last
  // hazard) with the same 1.1 active window.
  const ROJO_RUN_PULSE_ZONES = [
    { id: 1, worldX: 35300,  halfWidth: 150, cycleSeconds: 2.65, telegraphSeconds: 0.95, activeSeconds: 1.5 },
    { id: 2, worldX: 68800,  halfWidth: 150, cycleSeconds: 2.25, telegraphSeconds: 0.80, activeSeconds: 1.3 },
    { id: 3, worldX: 69500,  halfWidth: 150, cycleSeconds: 2.25, telegraphSeconds: 0.80, activeSeconds: 1.3 },
    { id: 4, worldX: 84400,  halfWidth: 150, cycleSeconds: 2.25, telegraphSeconds: 0.80, activeSeconds: 1.3 },
    { id: 5, worldX: 111000, halfWidth: 150, cycleSeconds: 1.90, telegraphSeconds: 0.68, activeSeconds: 1.1 },
    { id: 6, worldX: 111700, halfWidth: 150, cycleSeconds: 1.90, telegraphSeconds: 0.68, activeSeconds: 1.1 },
    { id: 7, worldX: 115200, halfWidth: 150, cycleSeconds: 1.90, telegraphSeconds: 0.68, activeSeconds: 1.1 },
    { id: 8, worldX: 132520, halfWidth: 150, cycleSeconds: 2.00, telegraphSeconds: 0.75, activeSeconds: 1.1 },
    // ROJO RUN — Phase 4E course-difficulty revision Step B1 (2026-07-21):
    // 9 new zones. Section 1's id 9 uses deliberately gentler timing (mostly
    // SAFE rather than "mostly dangerous" — danger is only ~21% of the
    // cycle) appropriate for a first introduction in the easiest section.
    // ids 10-17 reuse each destination section's own already-established
    // telegraph/active/cycle tuning for consistency with that section's
    // existing zones, same halfWidth as every other zone in the file.
    { id: 9,  worldX: 15300,  halfWidth: 150, cycleSeconds: 2.80, telegraphSeconds: 1.00, activeSeconds: 0.6 },
    { id: 10, worldX: 37200,  halfWidth: 150, cycleSeconds: 2.65, telegraphSeconds: 0.95, activeSeconds: 1.5 },
    { id: 11, worldX: 44600,  halfWidth: 150, cycleSeconds: 2.65, telegraphSeconds: 0.95, activeSeconds: 1.5 },
    { id: 12, worldX: 60600,  halfWidth: 150, cycleSeconds: 2.25, telegraphSeconds: 0.80, activeSeconds: 1.3 },
    { id: 13, worldX: 67300,  halfWidth: 150, cycleSeconds: 2.25, telegraphSeconds: 0.80, activeSeconds: 1.3 },
    { id: 14, worldX: 80300,  halfWidth: 150, cycleSeconds: 2.25, telegraphSeconds: 0.80, activeSeconds: 1.3 },
    { id: 15, worldX: 109500, halfWidth: 150, cycleSeconds: 1.90, telegraphSeconds: 0.68, activeSeconds: 1.1 },
    { id: 16, worldX: 119100, halfWidth: 150, cycleSeconds: 1.90, telegraphSeconds: 0.68, activeSeconds: 1.1 },
    { id: 17, worldX: 121500, halfWidth: 150, cycleSeconds: 1.90, telegraphSeconds: 0.68, activeSeconds: 1.1 },
    // ROJO RUN — Phase 4E course-difficulty revision Step B1b (2026-07-21):
    // owner-requested density increase on top of Step B1. Section 1's ids
    // 18-20 use the same gentle "mostly safe" timing as id 9 (danger only
    // ~21% of the cycle), consistent with Section 1's still-easier-per-hazard
    // identity even though its hazard count now matches the later sections.
    // ids 21-26 reuse each destination section's own established timing.
    { id: 18, worldX: 15900,  halfWidth: 150, cycleSeconds: 2.80, telegraphSeconds: 1.00, activeSeconds: 0.6 },
    { id: 19, worldX: 21200,  halfWidth: 150, cycleSeconds: 2.80, telegraphSeconds: 1.00, activeSeconds: 0.6 },
    { id: 20, worldX: 23600,  halfWidth: 150, cycleSeconds: 2.80, telegraphSeconds: 1.00, activeSeconds: 0.6 },
    { id: 21, worldX: 43350,  halfWidth: 150, cycleSeconds: 2.65, telegraphSeconds: 0.95, activeSeconds: 1.5 },
    { id: 22, worldX: 50900,  halfWidth: 150, cycleSeconds: 2.65, telegraphSeconds: 0.95, activeSeconds: 1.5 },
    { id: 23, worldX: 78800,  halfWidth: 150, cycleSeconds: 2.25, telegraphSeconds: 0.80, activeSeconds: 1.3 },   // shifted 2026-07-21 from 78200 — owner real-device feedback: only 80 units of clearance after the 77650-77970 fracture's landing, unfair. Now 680 units clear.
    { id: 24, worldX: 95000,  halfWidth: 150, cycleSeconds: 2.25, telegraphSeconds: 0.80, activeSeconds: 1.3 },
    { id: 25, worldX: 129650, halfWidth: 150, cycleSeconds: 1.90, telegraphSeconds: 0.68, activeSeconds: 1.1 },
    { id: 26, worldX: 134300, halfWidth: 150, cycleSeconds: 1.90, telegraphSeconds: 0.68, activeSeconds: 1.1 }
  ];

  // ROJO RUN — Phase 4B: first real health/damage system. Simulation-time
  // countdowns, decremented only in rojoRunSimulationStep — same pattern as
  // the existing jump-buffer/coyote timers, so pause/resume needs no
  // special-case code. Pulse Zone contact: -1 health + brief invincibility +
  // visual-only hit reaction, respawn only at 0 health (owner-confirmed).
  // Signal Fracture fall: always -1 health and always respawns (a fall is
  // categorically different from a standing hit, per spec Section 5.3) —
  // ignores invincibility entirely. 0-health respawn restores to 3 crosses,
  // a graybox stand-in for the not-yet-built Game Over/Retry flow (spec
  // Section 20 also restores 3 crosses there).
  const ROJO_RUN_MAX_HEALTH = 3;
  const ROJO_RUN_INVINCIBILITY_SECONDS = 1.5;
  const ROJO_RUN_HIT_REACTION_SECONDS = 0.25;
  let rojoRunPlayerHealth = ROJO_RUN_MAX_HEALTH;
  let rojoRunInvincibleRemaining = 0;
  let rojoRunHitReactionRemaining = 0;
  let rojoRunHealthPickup2Collected = false;
  let rojoRunHealthPickup3Collected = false; // ROJO RUN — Phase 4C
  // ROJO RUN — Phase 5A: authoritative current-run damage tracking. Neither
  // is consumed by anything yet (no scoring exists) — that's explicitly
  // Phase 5D/5E's job. Updated only inside the two real damage functions
  // below (never guessed at a distance), reset only on a genuine fresh run
  // in resetRojoRunPlayer() — must survive checkpoint respawn, same
  // persistence rule as collected containers and checkpoint progress,
  // since taking a hit and respawning still means the run wasn't clean.
  let rojoRunDamageTakenThisRun = 0;
  let rojoRunNoDamageThisRun = true;
  // ROJO RUN — Phase 5B: authoritative Game Over state. Replaces the old
  // free-full-heal-on-zero-health respawn — death now actually freezes
  // gameplay (guarded at the top of rojoRunSimulationStep) instead of
  // silently continuing. No visual presentation yet — that's Phase 6D.
  // Cleared only by resetRojoRunPlayer() (a genuine fresh run — currently
  // reached by exiting to ROJO OS and re-entering ROJO RUN, until Phase 6C
  // builds a real in-game restart).
  let rojoRunGameOver = false;
  // ROJO RUN — Phase 5D: authoritative score. +50 per container, +250 per
  // checkpoint, +500 per health pickup — all three award points inside the
  // exact same already-once-only-guarded blocks that record the collection
  // itself (container Set membership, the checkpoint "only ever advances"
  // check, the pickup-collected flags), so duplicate scoring is structurally
  // impossible, not just prevented by a separate check. Persists across
  // checkpoint respawn — only resetRojoRunPlayer() (a genuine fresh run)
  // clears it, same rule as containers/checkpoint progress/health pickups.
  // No HUD display yet — that's Phase 6A scope.
  let rojoRunScore = 0;
  // ROJO RUN — Phase 5E: authoritative milestone-crossing state (25/50/75/
  // 100%, tied to Containers 20/40/60/80 via the existing MILESTONE_X
  // constants). No score value of its own — reserved for Phase 8's world-
  // transformation hooks — except the 100% crossing, which also gates the
  // no-damage bonus below since it's the last checkpoint before the
  // finish-line runway. Cleared only on a genuine fresh run.
  let rojoRunMilestone25Reached = false;
  let rojoRunMilestone50Reached = false;
  let rojoRunMilestone75Reached = false;
  let rojoRunMilestone100Reached = false;
  // ROJO RUN — Phase 8A: world transformation (green-to-red), tied to the
  // milestone flags above. rojoRunWorldTintTargetIndex (0-4) is set the
  // instant a milestone is reached — mobile's CSS transition and desktop's
  // eased per-frame interpolation (rojoRunWorldTintCurrentIndex, updated
  // in rojoRunSimulationStep) both animate toward it smoothly rather than
  // snapping. Mobile never redraws/rebakes any tile — the existing baked
  // canvases are only ever tinted via a CSS filter on the already-locked
  // Phase 4A tile-world-viewport, never touched at the pixel level.
  let rojoRunWorldTintTargetIndex = 0;
  let rojoRunWorldTintCurrentIndex = 0;
  const ROJO_RUN_WORLD_TINT_TRANSITION_SECONDS = 1.0;
  // Keyframes: hue-rotate angle (green -> red, derived from the real
  // terrain fill color #356B30's actual hue, ~115deg) and a saturate
  // boost so higher milestones read as more vivid/dominant, not just
  // hue-shifted. Angles are front-loaded (not linear) so the 50%/75%
  // states already read as a clear warm/red shift rather than lingering
  // in yellow — confirmed against the real terrain and checkpoint
  // (#274F29) colors before choosing these values.
  // ROJO RUN — bug fix (2026-07-23): retuned to be front-loaded. The old
  // table only reached -75deg by the 50% mark, shifting terrain's ~115deg
  // green hue to ~40deg — orange/brown, not red. Owner: "by 40 container
  // pickup the world should be visiably getting red. instead its
  // brownish... by 60ish it should be a powerful red and by 70-80 it
  // should be undeinably a red world." New values reach ~15deg (clearly
  // red-orange) by 50%, ~3deg (near-pure red) by 75%, and ~357deg (deep
  // saturated red) by 100% — saturation ramps faster too, since a
  // desaturated orange-red is what reads as "brown," not just the hue
  // alone. Shared by both the ground and all 4 background layers (see
  // rojoRunGetWorldTintFilter()), so this one table keeps everything
  // synchronized exactly as already established.
  const ROJO_RUN_WORLD_TINT_KEYFRAMES = [
    { angle: 0,    saturate: 1.0 },
    { angle: -70,  saturate: 1.2 },
    { angle: -100, saturate: 1.35 },
    { angle: -112, saturate: 1.45 },
    { angle: -118, saturate: 1.5 }
  ];

  // ROJO RUN — Phase 9 perf fix (2026-07-24): keyframe interpolation
  // extracted out of rojoRunGetWorldTintFilter() so rojoRunGetTerrainTintColor()
  // below can reuse the exact same angle/saturate math instead of duplicating
  // it — both must always agree, since the ground and background layers
  // stay synchronized only if they're derived from identical values.
  function rojoRunGetWorldTintAngleSaturate(fractionalIndex) {
    const clamped = Math.max(0, Math.min(4, fractionalIndex));
    const lowerIndex = Math.floor(clamped);
    const upperIndex = Math.min(4, lowerIndex + 1);
    const t = clamped - lowerIndex;
    const lower = ROJO_RUN_WORLD_TINT_KEYFRAMES[lowerIndex];
    const upper = ROJO_RUN_WORLD_TINT_KEYFRAMES[upperIndex];
    return {
      angle: lower.angle + (upper.angle - lower.angle) * t,
      saturate: lower.saturate + (upper.saturate - lower.saturate) * t
    };
  }

  function rojoRunGetWorldTintFilter(fractionalIndex) {
    const { angle, saturate } = rojoRunGetWorldTintAngleSaturate(fractionalIndex);
    if (angle === 0 && saturate === 1) return 'none';
    return `hue-rotate(${angle}deg) saturate(${saturate})`;
  }

  // ROJO RUN — Phase 9 perf fix (2026-07-24): the terrain's own base fill
  // color, as plain RGB numbers (same value as the '#356B30' literal used
  // for ctx.fillStyle) so the matrices below can operate on it directly.
  const ROJO_RUN_TERRAIN_BASE_RGB = { r: 0x35, g: 0x6B, b: 0x30 };

  // ROJO RUN — Phase 9 perf fix (2026-07-24): replicates the W3C Filter
  // Effects Module Level 1 hue-rotate()/saturate() matrices — the exact
  // formulas browsers use internally for ctx.filter — applied directly to
  // the terrain's single base color, instead of running a full per-pixel
  // canvas filter over the entire terrain fill every frame. Confirmed via a
  // clean diagnostic (2026-07-24, owner: "it works" with ctx.filter forced
  // to 'none') that this active filter — pre-existing Phase 8A/8B code,
  // unrelated to anything built for Phase 9's containers or health pickup —
  // was the real cause of a severe desktop freeze starting at the first
  // container collection (the filter goes from a cheap 'none' fast path to
  // a permanently-active hue-rotate/saturate state at that exact moment,
  // and never returns to 'none' for the rest of the run). Terrain is solid
  // color fills only (no texture — confirmed via code read), so this
  // produces the mathematically identical locked look — same keyframes,
  // same interpolation — at a tiny fraction of the cost: one matrix
  // multiply on one color per frame, not a per-pixel shader pass over the
  // whole canvas.
  function rojoRunGetTerrainTintColor(fractionalIndex) {
    const { angle, saturate } = rojoRunGetWorldTintAngleSaturate(fractionalIndex);
    const r0 = ROJO_RUN_TERRAIN_BASE_RGB.r;
    const g0 = ROJO_RUN_TERRAIN_BASE_RGB.g;
    const b0 = ROJO_RUN_TERRAIN_BASE_RGB.b;

    if (angle === 0 && saturate === 1) {
      return `rgb(${r0}, ${g0}, ${b0})`;
    }

    const hueRad = angle * (Math.PI / 180);
    const cosA = Math.cos(hueRad);
    const sinA = Math.sin(hueRad);

    // W3C Filter Effects Module Level 1 — hue-rotate() matrix.
    const r1 = (0.213 + cosA * 0.787 - sinA * 0.213) * r0 + (0.715 - cosA * 0.715 - sinA * 0.715) * g0 + (0.072 - cosA * 0.072 + sinA * 0.928) * b0;
    const g1 = (0.213 - cosA * 0.213 + sinA * 0.143) * r0 + (0.715 + cosA * 0.285 + sinA * 0.140) * g0 + (0.072 - cosA * 0.072 - sinA * 0.283) * b0;
    const b1 = (0.213 - cosA * 0.213 - sinA * 0.787) * r0 + (0.715 - cosA * 0.715 + sinA * 0.715) * g0 + (0.072 + cosA * 0.928 + sinA * 0.072) * b0;

    // W3C Filter Effects Module Level 1 — saturate() matrix.
    const r2 = (0.213 + 0.787 * saturate) * r1 + (0.715 - 0.715 * saturate) * g1 + (0.072 - 0.072 * saturate) * b1;
    const g2 = (0.213 - 0.213 * saturate) * r1 + (0.715 + 0.285 * saturate) * g1 + (0.072 - 0.072 * saturate) * b1;
    const b2 = (0.213 - 0.213 * saturate) * r1 + (0.715 - 0.715 * saturate) * g1 + (0.072 + 0.928 * saturate) * b1;

    const clampChannel = (v) => Math.max(0, Math.min(255, Math.round(v)));
    return `rgb(${clampChannel(r2)}, ${clampChannel(g2)}, ${clampChannel(b2)})`;
  }

  // ROJO RUN — Environmental Art Phase B (2026-07-26): desktop-only tinted
  // terrain texture. Mobile gets tinting for free (the existing world-tint
  // CSS filter already covers the baked texture, same as it always covered
  // the flat color) but desktop draws terrain live every frame with a
  // computed RGB fillStyle instead — deliberately NOT ctx.filter, per the
  // Phase 9 perf fix above (a full-canvas filter here already caused a real
  // freeze once). A texture can't be "computed" as a single RGB string the
  // way a solid color can, so this re-tints a small OFFSCREEN 1024x1024
  // copy of the source texture once per frame (via ctx.globalCompositeOperation
  // = 'multiply', a cheap per-draw blend mode, not a full secondary filter
  // pass) and reuses that tinted copy as the live pattern source — the
  // re-tint cost is fixed (one small canvas), completely independent of how
  // many terrain segments are actually on screen. Skips the re-tint work
  // entirely on any frame where the tint hasn't actually changed.
  let rojoRunTerrainTintCanvas = null;
  let rojoRunTerrainTintCanvasLastColor = null;
  function rojoRunGetTintedTerrainPattern(ctx, tintColor) {
    if (!rojoRunTerrainTintCanvas) {
      rojoRunTerrainTintCanvas = document.createElement('canvas');
      rojoRunTerrainTintCanvas.width = rojoRunTerrainTextureImage.naturalWidth;
      rojoRunTerrainTintCanvas.height = rojoRunTerrainTextureImage.naturalHeight;
    }
    if (tintColor !== rojoRunTerrainTintCanvasLastColor) {
      const tintCtx = rojoRunTerrainTintCanvas.getContext('2d');
      const w = rojoRunTerrainTintCanvas.width;
      const h = rojoRunTerrainTintCanvas.height;
      tintCtx.globalCompositeOperation = 'source-over';
      tintCtx.drawImage(rojoRunTerrainTextureImage, 0, 0, w, h);
      // ROJO OS — bug fix (2026-08-06, owner: desktop terrain never turns
      // red as containers are collected, stays plain green). Root cause:
      // 'multiply' blend can only ever DARKEN a channel toward the base
      // texture's own value, never brighten it — mathematically incapable
      // of producing a visible red shift on this green-dominant texture,
      // regardless of how red tintColor itself computes. 'color' genuinely
      // shifts hue/saturation while preserving the backdrop's own
      // luminosity/shading detail — matches every other tinted layer in
      // this codebase (all of which use a real CSS hue-rotate/saturate
      // filter, just not available here per the perf-fix comment above).
      tintCtx.globalCompositeOperation = 'color';
      tintCtx.fillStyle = tintColor;
      tintCtx.fillRect(0, 0, w, h);
      tintCtx.globalCompositeOperation = 'source-over';
      rojoRunTerrainTintCanvasLastColor = tintColor;
    }
    return ctx.createPattern(rojoRunTerrainTintCanvas, 'repeat');
  }

  // ROJO RUN — Phase 8B (2026-07-23): applies one filter string to every
  // mobile-visible tinted element at once (ground + all 4 background
  // layers) — the single choke point that keeps them synchronized, since
  // they always receive the exact same computed value in the same call.
  function rojoRunApplyWorldTintFilter(filterValue) {
    if (rojoRunTileWorldViewport) rojoRunTileWorldViewport.style.filter = filterValue;
    // ROJO OS — bug fix (2026-07-26): the Terrain Swell's dedicated mobile
    // canvas (see .rojo-run-swell-canvas) is tinted the same way as the
    // tile viewport above — a real CSS filter set directly on it here, not
    // ctx.filter inside its own draw calls (which didn't reliably apply on
    // real device with a pattern fillStyle). Harmless on desktop too; the
    // swell never draws onto this element there.
    if (rojoRunSwellCanvas) rojoRunSwellCanvas.style.filter = filterValue;
    if (rojoRunParallaxSky) rojoRunParallaxSky.style.filter = filterValue;
    rojoRunParallaxLayerElements.forEach((layerEl) => { layerEl.style.filter = filterValue; });
  }

  // ROJO RUN — Phase 8B (2026-07-23): called once per container collected
  // (see rojoRunCheckContainerCollisions), with a continuous fractional
  // index (0-4) proportional to collectedContainers/80 — no longer tied to
  // the 4 discrete Phase 5E position milestones. Sets the target both
  // desktop (rojoRunWorldTintCurrentIndex eases toward this every
  // simulation frame, unchanged mechanism) and mobile (writes the filter
  // directly; the elements' own CSS transition:filter still provides the
  // smooth animation between the old and new value — same native easing as
  // before, just re-targeted far more often with much smaller steps).
  function rojoRunSetWorldTintIndex(index) {
    rojoRunWorldTintTargetIndex = index;
    rojoRunApplyWorldTintFilter(rojoRunGetWorldTintFilter(index));
  }

  // ROJO RUN — Phase 8B (2026-07-23): a genuine fresh run must snap back to
  // 0 instantly, not fade over the usual 1s transition. Temporarily
  // suspends each element's transition, applies the reset, forces a
  // synchronous reflow so the browser can't coalesce/animate the change,
  // then restores the transition for normal per-container updates again.
  function rojoRunResetWorldTintInstant() {
    rojoRunWorldTintTargetIndex = 0;
    rojoRunWorldTintCurrentIndex = 0;
    const tintedElements = [rojoRunTileWorldViewport, rojoRunSwellCanvas, rojoRunParallaxSky, ...rojoRunParallaxLayerElements].filter(Boolean);
    tintedElements.forEach((el) => { el.style.transition = 'none'; });
    rojoRunApplyWorldTintFilter('none');
    if (tintedElements[0]) void tintedElements[0].offsetHeight;
    tintedElements.forEach((el) => { el.style.transition = ''; });
  }
  // ROJO RUN — Phase 5E: per-section damage flags for the four clean-section
  // bonuses (+500 each). Index matches ROJO_RUN_SECTION_BOUNDARIES (0 =
  // Section 1). rojoRunSectionDamaged is set true the moment any damage
  // lands while the player's world position is inside that section (see
  // rojoRunSectionIndexAt, used by both damage functions below) — evaluated
  // and scored once per section, the moment the player's world position
  // crosses that section's endX, via rojoRunSectionBonusEvaluated (monotonic
  // guard, same "only ever advances" pattern as checkpoints). Both arrays
  // reset only on a genuine fresh run.
  let rojoRunSectionDamaged = [false, false, false, false];
  let rojoRunSectionBonusEvaluated = [false, false, false, false];
  // ROJO RUN — Phase 5F: authoritative Level 01 completion state, same
  // guarded-flag shape as rojoRunGameOver. rojoRunFinalResults is built once
  // by rojoRunTriggerLevelComplete() (below) and left in place for Phase 6E
  // to read — never mutated afterward. Cleared only on a genuine fresh run.
  let rojoRunLevelComplete = false;
  let rojoRunFinalResults = null;

  // ROJO RUN — Phase 4A iOS fix, pre-rendered canvas-tile compositor: real
  // iPhone Safari would not reliably paint DOM-element terrain (rectangles,
  // slopes, clip-path polygons) moving inside a transformed layer — neither
  // as one giant ~29,400px track nor as 16 smaller chunked DOM containers.
  // This replaces every DOM terrain visual with 16 fixed-size 2048x1080
  // <canvas> tiles. Terrain, containers, checkpoint, milestone, and health
  // marker are drawn onto each tile's 2D context exactly ONCE at build time,
  // using the same ctx.fillRect/ctx.arc technique the (already working)
  // desktop canvas path already uses — never DOM elements, never
  // clip-path — and are then moved purely via per-tile CSS transforms
  // (Web Animations API), with no redraw during gameplay. Gated entirely by
  // rojoRunHasCoarsePointer() — desktop's canvas/accumulator path is
  // completely unaffected.
  const ROJO_RUN_TILE_LOGICAL_WIDTH = 2048;
  const ROJO_RUN_TILE_LOGICAL_HEIGHT = 1080;
  // ROJO RUN — Phase 4A iOS fix, memory-safety correction: 16 tiles at full
  // 2048x1080 backing resolution risked exceeding iOS Safari's per-page
  // canvas memory budget. Each terrain canvas's CSS display size stays
  // 2048x1080 (its world-space footprint is unchanged), but its backing
  // store is rasterized at a quarter of the pixel count — see the
  // ctx.setTransform(0.5, ...) in rojoRunBuildTileWorld, which lets all
  // drawing code keep using the original logical 2048x1080 coordinates
  // unmodified; only the canvas's own width/height attributes change.
  const ROJO_RUN_TILE_BACKING_WIDTH = 1024;
  const ROJO_RUN_TILE_BACKING_HEIGHT = 540;
  const ROJO_RUN_TILE_WORLD_MIN_X = -2048;
  // ROJO RUN — Phase 4C: Section 3 extends terrain to world-X 97,600, past
  // the prior 61,440 limit (Phase 4B). Mechanical parameter change only,
  // same as Phase 4B's own expansion — the tile-building loop is purely
  // count-driven. Flagged risk, now more pressing than Phase 4B's own
  // flagged risk: total tile count has grown from 16 (Phase 4A) to 31
  // (Phase 4B) to 49 here — needs dedicated real-device memory testing
  // (crashes/context loss/reloads), watched especially closely this time
  // given the cumulative growth.
  // ROJO RUN — Phase 4D: Section 4 (the final section of Level 01) extends
  // terrain to world-X 141,800. Same mechanical count-driven expansion as
  // every prior section. Tile count has now grown 16 (4A) -> 31 (4B) -> 49
  // (4C) -> 71 (4D) — this is the largest jump yet and the most important
  // thing to verify on real device before this phase can be considered
  // locked, same category of risk as every prior expansion but now at its
  // highest cumulative level for all of Level 01.
  const ROJO_RUN_TILE_WORLD_MAX_X = 143360;
  const ROJO_RUN_TILE_COUNT = 71; // (143360 - (-2048)) / 2048
  let rojoRunTilesBuilt = false;
  let rojoRunContainerLayerBuilt = false;
  let rojoRunTileCanvasElements = [];
  let rojoRunTileAnimations = [];
  // ROJO RUN — Phase 8B: parallax layer animations. Deliberately separate
  // from rojoRunTileAnimations above (never merged into it) — that array's
  // pause/resume is gated to coarse-pointer devices only (a locked Phase 4A
  // iOS fix), while parallax must pause/resume identically on both mobile
  // and desktop. worldUnitsPerLoop is a function of ROJO_RUN_BASE_SPEED, not
  // a fixed duration, so ROJO Tavo's speed boost scrolls parallax faster
  // too, matching every other speed-derived value in this file.
  let rojoRunParallaxAnimations = [];
  // ROJO RUN — clouds added (2026-07-23): 20000, slower than mountains'
  // 9000 — clouds read as more distant/high than any terrain feature.
  const ROJO_RUN_PARALLAX_LOOP_UNITS = { mountains: 9000, hills: 3600, midground: 1500, clouds: 20000 };
  let rojoRunMobileRunStartTimestamp = 0;
  let rojoRunMobileWorldStartOffset = 0;
  let rojoRunMobilePausedTotalMs = 0;
  let rojoRunMobilePauseStartedAt = null;

  // ROJO RUN — Phase 3C: graybox Terrain Swell mechanic (functions below
  // unchanged and fully reusable). Its active world-X range was parked far
  // outside any authored course content through Phase 4A/4B (Sections 1-2
  // have no Terrain Swell), since rojoRunGetSwellSurfaceY() checks this
  // range unconditionally before falling back to static terrain, and
  // leaving it at a real-content position too early would have silently
  // overridden ground that wasn't meant to have a swell.
  // ROJO RUN — Phase 4C: repositioned to its real Section 3 location — same
  // 1500-unit footprint size as the old parked position, so the existing
  // spatial-profile math (Math.sin(Math.PI * u) ** 2) needs no retuning.
  // ROJO RUN — Phase 4D: generalized from a single start/end pair to an
  // array of footprints, since Section 4 places a second swell (spec step
  // 4). Both footprints share the exact same cycle/rise/adhesion constants
  // below — the spec gives no distinct timing per instance — only their
  // world-X position differs. Every function that reads
  // ROJO_RUN_SWELL_START_X/END_X was updated to loop over this array
  // instead; the per-footprint math itself (spatial profile, temporal
  // amplitude, drop-away trigger) is completely unchanged from Phase 4C.
  const ROJO_RUN_SWELL_FOOTPRINTS = [
    { startX: 71700,  endX: 73200 },
    { startX: 102900, endX: 104400 }
  ];
  const ROJO_RUN_SWELL_CYCLE_SECONDS = 2.4;
  const ROJO_RUN_SWELL_TELEGRAPH_SECONDS = 2.0;
  const ROJO_RUN_SWELL_RISE_HEIGHT = 40;
  const ROJO_RUN_SWELL_MAX_ADHESION_SPEED = 90;

  let rojoRunCanvasContext = null;
  let rojoRunSwellCanvasContext = null;
  let rojoRunPlayerWorldDistance = 0;
  // ROJO OS — bug fix (2026-08-06, owner: desktop terrain shakes + doesn't
  // line up with the checkpoint pillar). Root cause: rojoRunLoopTick() is a
  // fixed-timestep accumulator with NO render interpolation — some
  // rendered frames get 0 simulation steps, others get 2 (real display
  // timing is never exactly 60.000Hz), so rojoRunPlayerWorldDistance jumps
  // in whole ~12.5px increments at uneven times. Math.round()-based pixel
  // snapping alone can't fix this — it only removes sub-pixel noise WITHIN
  // one frame, not whole-pixel noise BETWEEN frames. Fix: standard fixed-
  // timestep-with-render-interpolation (see rojoRunLoopTick/
  // rojoRunWorldToScreenXRender below) — blends between the last two
  // simulation snapshots using the leftover accumulator fraction, so
  // rendering tracks real elapsed time smoothly while the authoritative
  // rojoRunPlayerWorldDistance (physics/collision/hazards/checkpoints)
  // stays completely untouched, still stepped exactly as before. Also
  // narrows the gap to the checkpoint pillar (WAAPI/compositor-clocked,
  // already smooth) since terrain now tracks real time far more closely
  // too — though the two remain genuinely different clocks (main-thread
  // rAF vs. compositor), so perfect pixel-sync isn't guaranteed.
  let rojoRunPlayerWorldDistanceAtLastStep = 0;
  let rojoRunPlayerWorldDistanceRender = 0;
  let rojoRunPlayerFootY = ROJO_RUN_GROUND_Y;
  let rojoRunPlayerVelocityY = 0;
  let rojoRunPlayerGrounded = true;
  // ROJO RUN — ROJO Tavo sprite integration, Phase 2 (run cycle): grounded-
  // only, simulation-time run-animation clock. Advances only while
  // rojoRunPlayerGrounded, wraps at ROJO_RUN_RUN_CYCLE_SECONDS, resets to 0
  // on every full player-state reset (see resetRojoRunPlayerPhysics()).
  let rojoRunRunAnimationElapsedSeconds = 0;
  let rojoRunJumpBufferRemaining = 0;
  let rojoRunCoyoteRemaining = 0;
  let rojoRunJumpHoldRemaining = 0;
  let rojoRunSwellElapsedSeconds = 0;
  let rojoRunSwellDropTriggeredThisCycle = false;

  let activeConceptPage = 0;
  let bootValue = 0;
  const bootInterval = window.setInterval(() => {
    const increment = bootValue < 68 ? 4 : bootValue < 91 ? 2 : 1;
    bootValue = Math.min(100, bootValue + increment);

    if (bootFill) bootFill.style.width = `${bootValue}%`;
    if (bootPercent) bootPercent.textContent = `${bootValue}%`;

    if (bootValue >= 100) {
      window.clearInterval(bootInterval);
      window.setTimeout(() => {
        boot?.classList.add('is-complete');
        // TEMPORARY CAMPAIGN (2026-09) — no ENTER ROJO MUNDO button is
        // shown in this build (see rojo-os.css), so the visitor arrives
        // directly at the promo takeover once INITIALIZING finishes.
        // This synthetic click fires the exact same handler a real tap
        // would (enter.addEventListener('click', ...) below), reusing
        // its existing is-entering -> showHome() sequence and timing
        // completely unchanged — same pattern proven in the approved V5
        // reference build. INITIALIZING's own progress/timing/fade above
        // this block is untouched.
        enter?.click();
      }, 220);
    }
  }, 82);

  const textureData = 'data:image/png;base64,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';

  function pulseWorld() {
    worldButton.classList.remove('is-pulsing');
    void worldButton.offsetWidth;
    worldButton.classList.add('is-pulsing');
    window.setTimeout(() => worldButton.classList.remove('is-pulsing'), 360);
  }

  let appTransitionTimer = null;
  let appTransitionLocked = false;
  // ROJO OS — bug fix (2026-07-26, owner: "tap a page and go back to the
  // homepage back and forth really fast. the site crashes"): showHome()'s
  // re-entrancy guard only bails while appTransitionLocked AND is-app is
  // not yet present — but each openX() function's transition is actually a
  // two-stage chain (an outer setTimeout, then a nested double
  // requestAnimationFrame + a SECOND setTimeout before appTransitionLocked
  // finally clears). is-app gets added ~260ms in, well before the lock
  // clears ~260ms after that — so a fast tap on Home during that window
  // passes showHome()'s guard and runs concurrently with the still-in-flight
  // open. Both write the same shared appTransitionTimer variable, so
  // whichever finishes last clobbers the other's pending timer id — leaving
  // either a stray callback that resurrects a panel showHome() just closed
  // (a "dead" panel stealing taps), or a permanently stuck
  // appTransitionLocked with nothing left scheduled to clear it (every nav
  // tap silently no-ops forever). Both read as "the site crashes" to a user.
  // Fix: a monotonically-increasing token, captured by each transition at
  // the moment it starts. Every deferred callback (each setTimeout/rAF
  // continuation) checks its own captured token against the current one
  // before touching any shared state — a callback from a transition that's
  // since been superseded becomes a harmless no-op instead of corrupting
  // state. This doesn't change any intentional timing/choreography for a
  // normal single tap — only makes overlapping/rapid taps safe.
  let appTransitionToken = 0;

  function finishAppTransition() {
    appTransitionLocked = false;
    root.classList.remove('is-app-transition');
  }

  function deactivateAllApps() {
    appPanels.forEach((appPanel) => {
      appPanel.classList.remove('is-active');
      appPanel.setAttribute('aria-hidden', 'true');
    });
    stopRojoRun();
    stopProductAngleAutoplay();
  }

  function renderConceptPage(requestedPage = activeConceptPage) {
    if (!conceptPages.length) return;

    activeConceptPage = Math.max(0, Math.min(requestedPage, conceptPages.length - 1));

    conceptPages.forEach((page, index) => {
      const isActive = index === activeConceptPage;
      page.hidden = !isActive;
      page.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    if (conceptPageLabel) {
      const current = String(activeConceptPage + 1).padStart(2, '0');
      const total = String(conceptPages.length).padStart(2, '0');
      conceptPageLabel.textContent = `PAGE ${current} / ${total}`;
    }

    if (conceptPagePrev) conceptPagePrev.disabled = activeConceptPage === 0;
    if (conceptPageNext) conceptPageNext.disabled = activeConceptPage === conceptPages.length - 1;
  }

  function resetConceptViews() {
    conceptShell?.classList.remove('is-preview-open');

    conceptPreviews.forEach((preview) => {
      preview.hidden = true;
      preview.setAttribute('aria-hidden', 'true');
    });

    conceptFullViews.forEach((fullView) => {
      fullView.hidden = true;
      fullView.setAttribute('aria-hidden', 'true');
    });

    closeAllConceptOverlays();
  }

  // Shared overlay infrastructure — gallery lightbox + video viewer (Full Project only).
  let activeOverlayContainer = null;
  let activeOverlayCloser = null;
  let scrollLockTarget = null;
  let scrollLockValue = 0;
  let scrollLockHadOverflow = false;
  let scrollLockPrevOverflow = '';
  let scrollLockHadPointerEvents = false;
  let scrollLockPrevPointerEvents = '';
  let lightboxCloseTimer = null;
  // ROJO OS — bug fix (2026-08-01, owner: "the x button and left and right
  // button appear first then a second later the images pop up"): pending
  // safety-net timer for openGalleryLightbox()'s load-gated reveal below.
  let lightboxRevealTimer = null;
  let videoViewerCloseTimer = null;

  function lockUnderlyingScroll(target) {
    scrollLockTarget = target || null;
    if (!target) return;
    scrollLockValue = target.scrollTop;
    scrollLockHadOverflow = target.style.overflow !== '';
    scrollLockPrevOverflow = target.style.overflow;
    scrollLockHadPointerEvents = target.style.pointerEvents !== '';
    scrollLockPrevPointerEvents = target.style.pointerEvents;
    target.style.overflow = 'hidden';
    target.style.pointerEvents = 'none';
  }

  function restoreUnderlyingScroll() {
    if (scrollLockTarget) {
      if (scrollLockHadOverflow) {
        scrollLockTarget.style.overflow = scrollLockPrevOverflow;
      } else {
        scrollLockTarget.style.removeProperty('overflow');
      }
      if (scrollLockHadPointerEvents) {
        scrollLockTarget.style.pointerEvents = scrollLockPrevPointerEvents;
      } else {
        scrollLockTarget.style.removeProperty('pointer-events');
      }
      scrollLockTarget.scrollTop = scrollLockValue;
    }
    scrollLockTarget = null;
  }

  function trapOverlayFocus(event, container) {
    if (event.key !== 'Tab' || !container) return;
    const focusable = Array.from(container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'))
      .filter((el) => !el.disabled && el.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function handleOverlayKeydown(event) {
    if (!activeOverlayContainer) return;
    if (event.key === 'Escape') {
      activeOverlayCloser?.();
      return;
    }
    if (event.key === 'Tab') {
      trapOverlayFocus(event, activeOverlayContainer);
      return;
    }
    if (activeOverlayContainer === lightbox) {
      if (event.key === 'ArrowLeft') stepGallery(-1);
      if (event.key === 'ArrowRight') stepGallery(1);
    }
  }

  document.addEventListener('keydown', handleOverlayKeydown);

  // GALLERY LIGHTBOX
  let galleryList = [];
  let galleryIndex = 0;
  let galleryReturnFocus = null;
  let lightboxSwipeActive = false;
  let lightboxSwipeStartX = 0;
  let lightboxSwipePointerId = null;

  function getLargestSrcsetUrl(img) {
    if (!img?.srcset) return img?.currentSrc || img?.src || '';
    const candidates = img.srcset.split(',').map((entry) => entry.trim().split(' '));
    candidates.sort((a, b) => Number.parseInt(a[1], 10) - Number.parseInt(b[1], 10));
    return candidates[candidates.length - 1][0];
  }

  function preloadAdjacentGalleryImages() {
    const total = galleryList.length;
    if (total < 2) return;
    [(galleryIndex + 1) % total, (galleryIndex - 1 + total) % total].forEach((idx) => {
      const img = galleryList[idx].querySelector('img');
      if (img) new Image().src = getLargestSrcsetUrl(img);
    });
  }

  function renderGalleryImage() {
    const trigger = galleryList[galleryIndex];
    const img = trigger?.querySelector('img');
    if (!img || !lightboxImage) return;
    lightboxImage.src = getLargestSrcsetUrl(img);
    lightboxImage.alt = img.alt || '';
    if (lightboxCounter) lightboxCounter.textContent = galleryList.length > 1 ? `${galleryIndex + 1} / ${galleryList.length}` : '';
    const multi = galleryList.length > 1;
    if (lightboxPrev) lightboxPrev.hidden = !multi;
    if (lightboxNext) lightboxNext.hidden = !multi;
    preloadAdjacentGalleryImages();
  }

  function stepGallery(direction) {
    if (galleryList.length < 2) return;
    galleryIndex = (galleryIndex + direction + galleryList.length) % galleryList.length;
    renderGalleryImage();
  }

  function openGalleryLightbox(trigger) {
    if (!lightbox || !trigger) return;
    window.clearTimeout(lightboxCloseTimer);
    window.clearTimeout(lightboxRevealTimer);

    // ROJO OS — bug fix (2026-08-01): BTS photos now also use
    // data-rojo-gallery-trigger (see the BTS grid markup) — this closest()
    // scoping is what keeps swipe-navigation self-contained to whichever
    // grid was actually tapped (main gallery vs. this project's own BTS
    // photos), same as it was already self-contained per-project before.
    const gallery = trigger.closest('.rojo-concept-gallery, .rojo-concept-bts-grid');
    galleryList = gallery ? Array.from(gallery.querySelectorAll('[data-rojo-gallery-trigger]')) : [trigger];
    galleryIndex = Math.max(0, galleryList.indexOf(trigger));
    galleryReturnFocus = trigger;
    renderGalleryImage();

    lockUnderlyingScroll(trigger.closest('.rojo-concept-view__body'));

    lightbox.hidden = false;
    lightbox.setAttribute('aria-hidden', 'false');
    activeOverlayContainer = lightbox;
    activeOverlayCloser = closeGalleryLightbox;

    // ROJO OS — bug fix (2026-08-01, owner: "the x button and left and
    // right button appear first then a second later the images pop up"):
    // the whole lightbox (backdrop/buttons/image) already fades in as one
    // unit via the .is-active CSS transition -- the real cause was that
    // renderGalleryImage() had just set a brand-new lightboxImage.src, so
    // the image area was still empty for a moment after that fade-in
    // completed, while the buttons (plain CSS, no network fetch) already
    // had real pixels to show. Fix: don't reveal at all until the image
    // has actually finished loading, so everything appears together.
    // Falls back to a short timeout if 'load'/'error' never fire, so a
    // slow connection doesn't make the tap feel unresponsive; guarded on
    // aria-hidden so a late-firing reveal can never pop the lightbox back
    // open after the visitor already closed it.
    const revealLightbox = () => {
      window.clearTimeout(lightboxRevealTimer);
      if (lightbox.getAttribute('aria-hidden') === 'true') return;
      lightbox.classList.add('is-active');
      lightboxClose?.focus({ preventScroll: true });
    };

    if (lightboxImage && !lightboxImage.complete) {
      lightboxImage.addEventListener('load', revealLightbox, { once: true });
      lightboxImage.addEventListener('error', revealLightbox, { once: true });
      lightboxRevealTimer = window.setTimeout(revealLightbox, 900);
    } else {
      window.requestAnimationFrame(revealLightbox);
    }
  }

  function closeGalleryLightbox() {
    if (!lightbox || lightbox.hidden) return;
    lightbox.classList.remove('is-active');
    lightbox.setAttribute('aria-hidden', 'true');

    window.clearTimeout(lightboxCloseTimer);
    lightboxCloseTimer = window.setTimeout(() => {
      if (lightbox.classList.contains('is-active')) return;
      lightbox.hidden = true;
      if (lightboxImage) lightboxImage.removeAttribute('src');
    }, 220);

    restoreUnderlyingScroll();
    activeOverlayContainer = null;
    activeOverlayCloser = null;
    galleryReturnFocus?.focus({ preventScroll: true });
    galleryReturnFocus = null;
  }

  function endLightboxSwipe() {
    if (lightboxSwipePointerId !== null && lightboxImage?.releasePointerCapture) {
      try { lightboxImage.releasePointerCapture(lightboxSwipePointerId); } catch (error) {}
    }
    lightboxSwipeActive = false;
    lightboxSwipePointerId = null;
  }

  lightboxBackdrop?.addEventListener('click', closeGalleryLightbox);
  lightboxClose?.addEventListener('click', closeGalleryLightbox);
  lightboxPrev?.addEventListener('click', () => stepGallery(-1));
  lightboxNext?.addEventListener('click', () => stepGallery(1));

  galleryTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => openGalleryLightbox(trigger));
  });

  lightboxImage?.addEventListener('pointerdown', (event) => {
    if (event.pointerType === 'mouse') return;
    lightboxSwipeActive = true;
    lightboxSwipeStartX = event.clientX;
    lightboxSwipePointerId = event.pointerId;
    lightboxImage.setPointerCapture?.(event.pointerId);
  });

  lightboxImage?.addEventListener('pointerup', (event) => {
    if (!lightboxSwipeActive) return;
    const delta = event.clientX - lightboxSwipeStartX;
    endLightboxSwipe();
    if (Math.abs(delta) > 40) stepGallery(delta < 0 ? 1 : -1);
  });

  lightboxImage?.addEventListener('pointercancel', endLightboxSwipe);
  lightboxImage?.addEventListener('lostpointercapture', endLightboxSwipe);

  // VIDEO VIEWER
  let videoReturnFocus = null;

  function parseVideoEmbed(url) {
    let parsed;
    try {
      parsed = new URL(url, window.location.href);
    } catch (error) {
      parsed = null;
    }

    if (parsed) {
      const host = parsed.hostname.replace(/^www\./, '');

      if (host === 'youtu.be') {
        const id = parsed.pathname.split('/').filter(Boolean)[0];
        if (id) return { type: 'youtube', embedUrl: `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0` };
      }

      if (host === 'youtube.com' || host === 'm.youtube.com') {
        const videoId = parsed.searchParams.get('v');
        if (videoId) return { type: 'youtube', embedUrl: `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0` };

        const segments = parsed.pathname.split('/').filter(Boolean);
        const afterKeyword = (keyword) => {
          const index = segments.indexOf(keyword);
          return index !== -1 ? segments[index + 1] : null;
        };
        const embedId = afterKeyword('embed') || afterKeyword('shorts');
        if (embedId) return { type: 'youtube', embedUrl: `https://www.youtube-nocookie.com/embed/${embedId}?autoplay=1&rel=0` };
      }

      if (host === 'vimeo.com' || host === 'player.vimeo.com') {
        const id = parsed.pathname.split('/').filter(Boolean).find((segment) => /^\d+$/.test(segment));
        if (id) return { type: 'vimeo', embedUrl: `https://player.vimeo.com/video/${id}?autoplay=1` };
      }
    }

    return { type: 'file', embedUrl: url };
  }

  function buildVideoIframe(embedUrl) {
    const iframe = document.createElement('iframe');
    iframe.src = embedUrl;
    iframe.title = 'Project video player';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    iframe.allowFullscreen = true;
    iframe.setAttribute('frameborder', '0');
    return iframe;
  }

  function openVideoViewer(url, trigger) {
    if (!videoViewer || !videoMedia || !url) return;
    window.clearTimeout(videoViewerCloseTimer);

    const { type, embedUrl } = parseVideoEmbed(url);

    videoMedia.replaceChildren();

    if (type === 'file') {
      const video = document.createElement('video');
      video.src = embedUrl;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      videoMedia.appendChild(video);
    } else {
      videoMedia.appendChild(buildVideoIframe(embedUrl));
    }

    videoReturnFocus = trigger || null;
    lockUnderlyingScroll(trigger?.closest('.rojo-concept-view__body'));

    videoViewer.hidden = false;
    videoViewer.setAttribute('aria-hidden', 'false');
    activeOverlayContainer = videoViewer;
    activeOverlayCloser = closeVideoViewer;

    window.requestAnimationFrame(() => {
      videoViewer.classList.add('is-active');
      videoClose?.focus({ preventScroll: true });
    });
  }

  function closeVideoViewer() {
    if (!videoViewer || videoViewer.hidden) return;
    videoViewer.classList.remove('is-active');
    videoViewer.setAttribute('aria-hidden', 'true');

    const nativeVideo = videoMedia?.querySelector('video');
    if (nativeVideo) {
      nativeVideo.pause();
      nativeVideo.removeAttribute('src');
      nativeVideo.load();
    }
    videoMedia?.replaceChildren();

    window.clearTimeout(videoViewerCloseTimer);
    videoViewerCloseTimer = window.setTimeout(() => {
      if (videoViewer.classList.contains('is-active')) return;
      videoViewer.hidden = true;
    }, 220);

    restoreUnderlyingScroll();
    activeOverlayContainer = null;
    activeOverlayCloser = null;
    videoReturnFocus?.focus({ preventScroll: true });
    videoReturnFocus = null;
  }

  videoBackdrop?.addEventListener('click', closeVideoViewer);
  videoClose?.addEventListener('click', closeVideoViewer);

  videoLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      openVideoViewer(link.href, link);
    });
  });

  function closeAllConceptOverlays() {
    closeGalleryLightbox();
    closeVideoViewer();
  }

  // SECRET REWARD POPUP — same hidden/.is-active/close-timer shell mechanics
  // as the lightbox/video-viewer above, own state, registers with the same
  // shared activeOverlayContainer/activeOverlayCloser registry so Escape-
  // to-close and Tab focus-trapping work identically with zero new logic.
  let secretRewardCloseTimer = null;
  let secretRewardReturnFocus = null;

  function openSecretRewardPopup(trigger) {
    if (!secretRewardPopup) return;
    window.clearTimeout(secretRewardCloseTimer);

    secretRewardReturnFocus = trigger || null;
    lockUnderlyingScroll(trigger?.closest('.rojo-run-console-panel'));

    secretRewardPopup.hidden = false;
    secretRewardPopup.setAttribute('aria-hidden', 'false');
    activeOverlayContainer = secretRewardPopup;
    activeOverlayCloser = closeSecretRewardPopup;

    window.requestAnimationFrame(() => {
      secretRewardPopup.classList.add('is-active');
      secretRewardClose?.focus({ preventScroll: true });
    });
  }

  function closeSecretRewardPopup() {
    if (!secretRewardPopup || secretRewardPopup.hidden) return;
    secretRewardPopup.classList.remove('is-active');
    secretRewardPopup.setAttribute('aria-hidden', 'true');

    window.clearTimeout(secretRewardCloseTimer);
    secretRewardCloseTimer = window.setTimeout(() => {
      if (secretRewardPopup.classList.contains('is-active')) return;
      secretRewardPopup.hidden = true;
      secretRewardCard?.classList.remove('is-flipped');
    }, 220);

    restoreUnderlyingScroll();
    activeOverlayContainer = null;
    activeOverlayCloser = null;
    secretRewardReturnFocus?.focus({ preventScroll: true });
    secretRewardReturnFocus = null;
  }

  // Card flip — owner-directed (2026-07-27): tap the card anywhere to flip
  // it, tap again to flip back, no dedicated button either direction (the
  // original back-face close/flip button was removed entirely — it was
  // also the cause of a "ghost X" rendering behind the popup's own close
  // button on real iOS Safari). Guarded exactly like Shop's own carousel
  // cards (event.target.closest('button, select, input')) so the
  // quantity/size/Add to Cart controls — now on the front, where this
  // listener also lives — never accidentally trigger a flip.
  function toggleSecretRewardCardFlip(event) {
    if (event.target.closest('button, select, input')) return;
    secretRewardCard?.classList.toggle('is-flipped');
  }

  rojoRunResultsSecretTrigger?.addEventListener('click', () => openSecretRewardPopup(rojoRunResultsSecretTrigger));
  secretRewardBackdrop?.addEventListener('click', closeSecretRewardPopup);
  secretRewardClose?.addEventListener('click', closeSecretRewardPopup);

  if (secretRewardCard) {
    const secretRewardVariantSelect = secretRewardCard.querySelector('[data-rojo-variant-select]');
    const secretRewardQtyInput = secretRewardCard.querySelector('[data-rojo-qty]');
    const secretRewardQtyMinus = secretRewardCard.querySelector('[data-rojo-qty-minus]');
    const secretRewardQtyPlus = secretRewardCard.querySelector('[data-rojo-qty-plus]');
    const secretRewardAddButton = secretRewardCard.querySelector('[data-rojo-add-cart]');
    const secretRewardPrice = secretRewardCard.querySelector('[data-rojo-focus-price]');

    secretRewardCard.addEventListener('click', toggleSecretRewardCardFlip);

    secretRewardQtyMinus?.addEventListener('click', (event) => {
      event.stopPropagation();
      if (!secretRewardQtyInput) return;
      secretRewardQtyInput.value = String(clampQuantity(Number(secretRewardQtyInput.value) - 1));
    });

    secretRewardQtyPlus?.addEventListener('click', (event) => {
      event.stopPropagation();
      if (!secretRewardQtyInput) return;
      secretRewardQtyInput.value = String(clampQuantity(Number(secretRewardQtyInput.value) + 1));
    });

    secretRewardQtyInput?.addEventListener('change', () => {
      secretRewardQtyInput.value = String(clampQuantity(secretRewardQtyInput.value));
    });

    secretRewardVariantSelect?.addEventListener('change', () => {
      const selected = secretRewardVariantSelect.options[secretRewardVariantSelect.selectedIndex];
      if (secretRewardPrice && selected?.dataset.price) secretRewardPrice.textContent = selected.dataset.price;
    });

    secretRewardAddButton?.addEventListener('click', (event) => {
      event.stopPropagation();
      addCardToCart(secretRewardCard);
    });
  }

  const shopifySection = root.closest('.shopify-section') || root.closest('[id^="shopify-section-"]');

  function handleRojoSectionUnload(event) {
    if (!shopifySection || event.target !== shopifySection) return;

    document.removeEventListener('keydown', handleOverlayKeydown);
    document.removeEventListener('shopify:section:unload', handleRojoSectionUnload);

    removeRojoRunMediaListener(rojoRunLandscapeQuery, updateRojoRunOrientation);
    removeRojoRunMediaListener(rojoRunCoarsePointerQuery, updateRojoRunOrientation);
    removeRojoRunMediaListener(rojoRunShortHeightQuery, updateRojoRunOrientation);
    window.removeEventListener('resize', updateRojoRunOrientation);
    window.visualViewport?.removeEventListener('resize', updateRojoRunOrientation);
    document.removeEventListener('visibilitychange', handleRojoRunVisibilityChange);
    document.removeEventListener('keydown', handleRojoRunKeydown);
    document.removeEventListener('keyup', handleRojoRunKeyup);
    window.clearTimeout(rojoRunLaunchTimer);
    stopRojoRun();
    stopProductAngleAutoplay();

    closeAllConceptOverlays();
    closeSecretRewardPopup();

    window.clearTimeout(lightboxCloseTimer);
    window.clearTimeout(videoViewerCloseTimer);
    window.clearTimeout(secretRewardCloseTimer);
    lightboxCloseTimer = null;
    videoViewerCloseTimer = null;
    secretRewardCloseTimer = null;

    restoreUnderlyingScroll();

    if (lightbox) {
      lightbox.classList.remove('is-active');
      lightbox.hidden = true;
    }

    if (videoViewer) {
      videoViewer.classList.remove('is-active');
      videoViewer.hidden = true;
    }

    if (secretRewardPopup) {
      secretRewardPopup.classList.remove('is-active');
      secretRewardPopup.hidden = true;
    }

    if (lightboxImage) lightboxImage.removeAttribute('src');
    videoMedia?.replaceChildren();
  }

  document.addEventListener('shopify:section:unload', handleRojoSectionUnload);

  // CONCEPTS — cart shortcut (reuses the Shop cart's own drawer/state; see openCartDrawer()/refreshCartCount()).
  let cartDrawerOrigin = 'shop';

  conceptCartButton?.addEventListener('click', () => {
    openCartDrawer('concepts');
  });

  function showHome() {
    if (appTransitionLocked && !root.classList.contains('is-app')) return;

    window.clearTimeout(appTransitionTimer);
    if (focusCard) closeProductFocus(focusCard);
    closeCartDrawer();
    closeCollectionMenu();

    if (!root.classList.contains('is-app')) {
      // TEMPORARY CAMPAIGN (2026-09, round 3) — final, freshest read of
      // the visible viewport height, taken and LOCKED right before the
      // promo becomes visible (is-home below), so the first visible frame
      // already uses the settled geometry rather than a pre-load reading
      // that a chrome-settling resize later corrects. See
      // updateRojoPromoVisibleHeight()/lockRojoPromoVisibleHeight() near
      // the end of this file — after this call, further resize events
      // are ignored unless the viewport WIDTH actually changes (a real
      // rotation/window resize), so mobile browser chrome showing/hiding
      // afterward can never visibly reposition the revealed promo.
      lockRojoPromoVisibleHeight();
      root.classList.remove('is-entering', 'is-app-transition');
      root.classList.add('is-home', 'is-settling');
      rojoGlobeDebugLog('is-home added t=' + Math.round(performance.now() - rojoGlobeDebugEnterClickAt) + 'ms');
      menu.setAttribute('aria-hidden', 'false');
      // Deferred one frame so pulseWorld()'s forced synchronous reflow
      // doesn't happen in the same script tick as the class change above.
      window.requestAnimationFrame(pulseWorld);
      // is-settling only drives the decorative rojo-world-glow-settle /
      // rojo-world-breathe-settle animations (see rojo-os.css) for a few
      // seconds after a fresh ENTER — cleared afterward so they never
      // linger or replay on later returns to the homepage from an app.
      // (The CSS is also guarded with :not(.is-app) so opening an app
      // during this window is never blocked by this class either way.)
      window.setTimeout(() => root.classList.remove('is-settling'), 5000);
      appTransitionLocked = false;
      return;
    }

    appTransitionLocked = true;
    const myTransitionToken = ++appTransitionToken;
    root.classList.add('is-app-transition');
    deactivateAllApps();
    resetConceptViews();

    appTransitionTimer = window.setTimeout(() => {
      if (myTransitionToken !== appTransitionToken) return;
      root.classList.remove('is-entering', 'is-app', 'is-app-transition');
      root.classList.add('is-home');
      menu.setAttribute('aria-hidden', 'false');
      if (apps) apps.hidden = true;
      appTransitionLocked = false;
      pulseWorld();
    }, 260);
  }

  function openShop({ fromApp = false } = {}) {
    if (
      appTransitionLocked ||
      !root.classList.contains('is-home') ||
      (root.classList.contains('is-app') && !fromApp) ||
      !apps ||
      !shopApp
    ) return;

    window.clearTimeout(appTransitionTimer);
    appTransitionLocked = true;
    const myTransitionToken = ++appTransitionToken;

    deactivateAllApps();
    resetConceptViews();

    // Two-beat open, mirroring showHome()'s close rhythm: beat 1 closes the
    // homepage on its own (only the menu visibly changes — the globe and
    // the app panel stay exactly where/as they are); beat 2, after a
    // matching pause, reveals the app (globe snaps to its in-app position
    // and the panel appears together). Applied identically in openConcept()
    // and openRojoRun() below.
    root.classList.add('is-app-transition');
    menu.setAttribute('aria-hidden', 'true');

    appTransitionTimer = window.setTimeout(() => {
      if (myTransitionToken !== appTransitionToken) return;
      root.classList.add('is-app');
      apps.hidden = false;
      shopApp.setAttribute('aria-hidden', 'false');

      renderProductBrowser();
      syncActiveProductAngle();

      // Two nested rAFs, not one: apps.hidden = false above just gave the
      // Shop subtree (up to 250 product cards) real layout for the first
      // time this run. A single rAF can still fire before the browser has
      // painted that freshly-unhidden "before" state, so the transition to
      // .is-active has no clean starting frame to animate from and the
      // reveal snaps instead of fading. Waiting a second rAF guarantees one
      // full paint of the "before" state has happened first.
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          if (myTransitionToken !== appTransitionToken) return;
          shopApp.classList.add('is-active');
          appTransitionTimer = window.setTimeout(() => {
            if (myTransitionToken !== appTransitionToken) return;
            finishAppTransition();
          }, 260);
        });
      });
    }, 260);
  }

  function openConcept() {
    if (
      appTransitionLocked ||
      !root.classList.contains('is-home') ||
      root.classList.contains('is-app') ||
      !apps ||
      !conceptApp
    ) return;

    window.clearTimeout(appTransitionTimer);
    appTransitionLocked = true;
    const myTransitionToken = ++appTransitionToken;

    deactivateAllApps();
    resetConceptViews();

    // Two-beat open — see openShop() for the full explanation.
    root.classList.add('is-app-transition');
    menu.setAttribute('aria-hidden', 'true');

    appTransitionTimer = window.setTimeout(() => {
      if (myTransitionToken !== appTransitionToken) return;
      root.classList.add('is-app');
      apps.hidden = false;
      conceptApp.setAttribute('aria-hidden', 'false');
      renderConceptPage(0);

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          if (myTransitionToken !== appTransitionToken) return;
          conceptApp.classList.add('is-active');
          appTransitionTimer = window.setTimeout(() => {
            if (myTransitionToken !== appTransitionToken) return;
            finishAppTransition();
          }, 260);
        });
      });
    }, 260);
  }

  // ROJO OS — ROJOMIES CLUB application (2026-07-28, Phase 1 native-form
  // revision). This panel's Omnisend integration has now gone through
  // native embed (broke Shop/ROJO RUN/Contact touch interaction) ->
  // hand-built form + identify/tracking snippet (data never actually
  // reached Omnisend) -> official Embedded Form App Block (broke the
  // same touch interaction a third time). Full history is in the plan
  // file. This revision is a fully hand-built form again — Phase 1 only,
  // visual/interaction testing with zero Omnisend connection (see
  // submitRojomiesForm() below). resetRojomiesForm() (defined below,
  // alongside the rest of the ROJOMIES form logic) is called on every
  // open, same rule as openContact()'s own resetContactForm() call, so a
  // stale test-success/error state from a previous visit never lingers.
  // Same two-beat open choreography as openShop()/openConcept()/
  // openContact() above/below, no changes to that shared pattern.
  function openRojomies() {
    if (
      appTransitionLocked ||
      !root.classList.contains('is-home') ||
      root.classList.contains('is-app') ||
      !apps ||
      !rojomiesApp
    ) return;

    window.clearTimeout(appTransitionTimer);
    appTransitionLocked = true;
    const myTransitionToken = ++appTransitionToken;

    deactivateAllApps();
    resetRojomiesForm();

    // Two-beat open — see openShop() for the full explanation.
    root.classList.add('is-app-transition');
    menu.setAttribute('aria-hidden', 'true');

    appTransitionTimer = window.setTimeout(() => {
      if (myTransitionToken !== appTransitionToken) return;
      root.classList.add('is-app');
      apps.hidden = false;
      rojomiesApp.setAttribute('aria-hidden', 'false');

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          if (myTransitionToken !== appTransitionToken) return;
          rojomiesApp.classList.add('is-active');
          appTransitionTimer = window.setTimeout(() => {
            if (myTransitionToken !== appTransitionToken) return;
            finishAppTransition();
          }, 260);
        });
      });
    }, 260);
  }

  // ROJO OS — ROJOMIES CLUB Phase 2B native form (2026-07-29). Client-side
  // validation (phone/consent/honeypot) is unchanged from Phase 1. On a
  // valid submission, this now POSTs to the deployed rojo-os-rojomies-
  // signup Cloudflare Worker — the Worker owns all Omnisend contact
  // lookup/create/update/tagging logic and the API key entirely; nothing
  // in this file ever references window.omnisend, an Omnisend endpoint,
  // or any secret. Full Worker source/history is in the plan file and at
  // ROJO_OS_ROJOMIES_WORKER\worker.js.
  // International SMS test (2026-08-18): replaces the old US-only digit
  // check. No country dropdown and no per-country parsing — a bare 10/11-
  // digit US number is still accepted for backward compatibility, and any
  // other country requires an explicit leading '+' (or '00') so a number is
  // never silently guessed into the wrong country. Returns full E.164
  // (leading '+'), unlike the old helper's bare-digits return, since the
  // Worker now expects an already-normalized identifier (see
  // submitRojomiesForm() below).
  function rojoNormalizePhoneToE164(rawValue) {
    if (typeof rawValue !== 'string') return null;

    const trimmed = rawValue.trim();
    if (!trimmed) return null;

    const plusCount = (trimmed.match(/\+/g) || []).length;
    if (plusCount > 1 || (plusCount === 1 && trimmed.charAt(0) !== '+')) return null;

    const hasLeadingPlus = trimmed.charAt(0) === '+';
    const strippedFormatting = trimmed.replace(/[\s().-]/g, '');
    const hasZeroZeroPrefix = !hasLeadingPlus && /^00\d/.test(strippedFormatting);

    if (hasLeadingPlus || hasZeroZeroPrefix) {
      const digits = hasLeadingPlus ? strippedFormatting.slice(1) : strippedFormatting.slice(2);
      if (!/^[1-9]\d{6,14}$/.test(digits)) return null;
      return `+${digits}`;
    }

    // No explicit international marker — US legacy shorthand only. Never
    // guess a bare digit-only number belongs to some other country.
    const digitsOnly = trimmed.replace(/\D/g, '');
    if (digitsOnly.length === 10) return `+1${digitsOnly}`;
    if (digitsOnly.length === 11 && digitsOnly.charAt(0) === '1') return `+${digitsOnly}`;

    return null;
  }

  // Country/calling-code selector (2026-08-18) — progressive enhancement
  // over the manual "+countrycode" behavior above, which stays completely
  // untouched and is still what runs whenever this enhancement can't
  // initialize (library blocked/failed to load, no supported countries,
  // etc.). rojomiesEnhancedPhoneMode only ever flips to true after the
  // country <select> has real, populated options — never on a guess.
  let rojomiesEnhancedPhoneMode = false;
  let rojomiesCountryOptionCodes = [];

  // Standard regional-indicator-symbol technique: each flag emoji is just
  // two Unicode regional indicator letters, offset from 'A'/'a' by the same
  // fixed amount as their Latin letter. No image/SVG/font asset involved —
  // if a given code point pair doesn't render as a flag on some platform,
  // the two letters still display, which is an acceptable fallback per the
  // international-SMS-selector spec (section 12).
  function rojoCountryCodeToFlagEmoji(countryCode) {
    if (typeof countryCode !== 'string' || countryCode.length !== 2) return '';
    const codePoints = countryCode
      .toUpperCase()
      .split('')
      .map((char) => 127397 + char.charCodeAt(0));
    return String.fromCodePoint(...codePoints);
  }

  function rojoGetCountryDisplayName(countryCode, displayNames) {
    if (displayNames) {
      try {
        const name = displayNames.of(countryCode);
        if (name && name !== countryCode) return name;
      } catch (err) {
        // Falls through to the ISO code below.
      }
    }
    return countryCode;
  }

  // Reads the supported-country list straight from the library itself
  // (getCountries()/getCountryCallingCode()) rather than a hand-maintained
  // table, so the selector can never drift out of sync with what the parser
  // actually supports. Returns null on any failure — the caller treats that
  // exactly like "library unavailable" and leaves the manual fallback in
  // place.
  function rojoBuildRojomiesCountryOptions() {
    const lib = window.libphonenumber;
    if (!lib || typeof lib.getCountries !== 'function' || typeof lib.getCountryCallingCode !== 'function') {
      return null;
    }

    let countries;
    try {
      countries = lib.getCountries();
    } catch (err) {
      return null;
    }
    if (!Array.isArray(countries) || !countries.length) return null;

    let displayNames = null;
    if (typeof Intl !== 'undefined' && typeof Intl.DisplayNames === 'function') {
      try {
        displayNames = new Intl.DisplayNames(['en'], { type: 'region' });
      } catch (err) {
        displayNames = null;
      }
    }

    const options = [];
    countries.forEach((countryCode) => {
      let callingCode;
      try {
        callingCode = lib.getCountryCallingCode(countryCode);
      } catch (err) {
        return;
      }
      if (!callingCode) return;

      const displayName = rojoGetCountryDisplayName(countryCode, displayNames);
      const flag = rojoCountryCodeToFlagEmoji(countryCode);
      const label = `${flag ? flag + ' ' : ''}+${callingCode} ${displayName}`.trim();

      options.push({ countryCode, displayName, label });
    });

    if (!options.length) return null;

    options.sort((a, b) => a.displayName.localeCompare(b.displayName));
    return options;
  }

  // Hotfix (2026-08-18): initial ROJOMIES phone-country selection is always
  // US, independent of Shopify Markets/localization — this selector only
  // interprets a typed phone number and was never meant to reflect
  // storefront country detection. Using localization.country here produced
  // an incorrect Afghanistan default whenever that didn't resolve to a real
  // visitor country. Falls back to the first available option only in the
  // unexpected case where the library doesn't support 'US' at all.
  function rojoDetermineRojomiesDefaultCountry(options) {
    const isSupported = (code) => options.some((opt) => opt.countryCode === code);
    if (isSupported('US')) return 'US';
    return options[0] ? options[0].countryCode : null;
  }

  // Called once during setup. Leaves the select hidden (and the manual
  // fallback fully in charge) unless every step below succeeds.
  // US phone placeholder micro-fix (2026-08-18): presentation only, no
  // effect on the actual input value or on E.164 normalization — the
  // placeholder is just a hint that a US number needs its area code.
  function updateRojomiesPhonePlaceholder() {
    if (!rojomiesPhoneInput) return;
    rojomiesPhoneInput.placeholder = rojomiesCountrySelect?.value === 'US' ? '(555) 555-5555' : 'PHONE NUMBER';
  }

  function initRojomiesCountrySelector() {
    if (!rojomiesCountrySelect) return;

    const options = rojoBuildRojomiesCountryOptions();
    if (!options) return;

    const defaultCountry = rojoDetermineRojomiesDefaultCountry(options);
    if (!defaultCountry) return;

    rojomiesCountrySelect.innerHTML = '';
    options.forEach((opt) => {
      const optionEl = document.createElement('option');
      optionEl.value = opt.countryCode;
      optionEl.textContent = opt.label;
      // .selected only affects the CURRENT live value — form.reset() restores
      // whichever option has .defaultSelected true (an entirely separate
      // property), which every dynamically-created option here otherwise
      // defaults to false on, leaving the browser to reset back to the
      // first option in the (alphabetically-sorted) list. Both must be set.
      const isDefaultCountry = opt.countryCode === defaultCountry;
      optionEl.defaultSelected = isDefaultCountry;
      optionEl.selected = isDefaultCountry;
      rojomiesCountrySelect.appendChild(optionEl);
    });

    // Explicit final step, not solely reliant on the per-option properties
    // above — setting .value after every option exists is the authoritative
    // way to establish the current initial selection.
    rojomiesCountrySelect.value = defaultCountry;

    rojomiesCountryOptionCodes = options.map((opt) => opt.countryCode);
    rojomiesCountrySelect.hidden = false;
    rojomiesEnhancedPhoneMode = true;

    if (rojomiesPhoneLabel) rojomiesPhoneLabel.textContent = 'PHONE NUMBER';
    updateRojomiesPhonePlaceholder();

    // Changing country never submits, never makes a network request, and
    // never touches Shopify Markets/currency/localization — it only tells
    // the parser which country to interpret the typed digits as. Clears a
    // stale error left over from a previous failed attempt, if any.
    rojomiesCountrySelect.addEventListener('change', () => {
      if (rojomiesErrorBlock && !rojomiesErrorBlock.hidden) setRojomiesFormState('idle');
      // TEMPORARY CAMPAIGN (2026-09, round 9) — the phone-validation
      // context changed (different country = different parsing rules), so
      // any compact phone error is no longer meaningful; restore the
      // normal label. Consent state is unrelated and left untouched.
      clearRojomiesPhoneCompactError();
      updateRojomiesPhonePlaceholder();
    });
  }

  initRojomiesCountrySelector();

  function rojoParseWithLibphonenumber(value, defaultCountry) {
    const lib = window.libphonenumber;
    if (!value || !lib || typeof lib.parsePhoneNumberFromString !== 'function') return null;

    try {
      return defaultCountry
        ? lib.parsePhoneNumberFromString(value, defaultCountry)
        : lib.parsePhoneNumberFromString(value);
    } catch (err) {
      return null;
    }
  }

  // The single entry point submitRojomiesForm() calls. Enhanced mode parses
  // the typed national number using the selected country (or, for an
  // explicit '+...' paste, as an already-international number outright —
  // never double-prepends a calling code); if that doesn't resolve to a
  // possible number, the proven manual rojoNormalizePhoneToE164() fallback
  // still gets a chance before giving up, exactly as it always has.
  function rojoResolveRojomiesPhoneE164() {
    const rawValue = rojomiesPhoneInput?.value || '';

    if (rojomiesEnhancedPhoneMode) {
      const trimmed = rawValue.trim();
      const isExplicitInternational = trimmed.charAt(0) === '+';
      const selectedCountry = rojomiesCountrySelect?.value || null;

      const parsed = rojoParseWithLibphonenumber(trimmed, isExplicitInternational ? undefined : selectedCountry);

      if (parsed && typeof parsed.isPossible === 'function' && parsed.isPossible() && parsed.number) {
        // Optional sync only — never required for a successful submission.
        if (isExplicitInternational && parsed.country && rojomiesCountrySelect && rojomiesCountryOptionCodes.includes(parsed.country)) {
          rojomiesCountrySelect.value = parsed.country;
        }
        return parsed.number;
      }
    }

    return rojoNormalizePhoneToE164(rawValue);
  }

  const ROJO_ROJOMIES_WORKER_URL = 'https://rojo-os-rojomies-signup.tdomclothing.workers.dev';
  const ROJO_ROJOMIES_SUBMIT_TIMEOUT_MS = 12000;
  let rojomiesSubmitInFlight = false;

  // Every Worker error code maps to one of 3 customer-facing messages —
  // the customer never needs to know which specific internal thing failed
  // (never displays Omnisend/Worker details), only whether to fix their
  // input or just try again. classifyRojomiesWorkerError()'s own default
  // below means any code not explicitly recognized here — including a
  // genuinely new one added to the Worker later — safely falls through to
  // the generic "network" message rather than ever showing nothing.
  // TEMPORARY CAMPAIGN (2026-09) — titles/labels reworded for the promo's
  // "GET EARLY ACCESS" action; classifyRojomiesWorkerError() below (which
  // selects which of these to show) and every validation/submission rule
  // that feeds it are completely unchanged from the current ROJOMIES CLUB
  // implementation.
  const ROJO_ROJOMIES_ERROR_MESSAGES = {
    validation: {
      title: 'ACCESS REQUEST NOT SENT',
      text: 'ENTER A VALID PHONE NUMBER AND CONFIRM CONSENT, THEN TRY AGAIN.'
    },
    rateLimited: {
      title: 'ACCESS REQUEST NOT SENT',
      text: 'TOO MANY ATTEMPTS. PLEASE WAIT A MOMENT AND TRY AGAIN.'
    },
    network: {
      title: 'ACCESS REQUEST NOT SENT',
      text: "WE COULDN'T CONNECT. PLEASE CHECK YOUR CONNECTION AND TRY AGAIN."
    }
  };

  function classifyRojomiesWorkerError(errorCode) {
    if (errorCode === 'rate_limited') return 'rateLimited';
    if (errorCode === 'invalid_phone' || errorCode === 'consent_required') return 'validation';
    // invalid_submission, origin_not_allowed, service_unavailable,
    // upstream_unreachable, upstream_error, unexpected_error, a malformed/
    // unparseable response (errorCode is null), and anything unrecognized
    // all share the generic message — none are actionable by the customer
    // beyond "try again."
    return 'network';
  }

  function setRojomiesErrorMessage(kind) {
    const message = ROJO_ROJOMIES_ERROR_MESSAGES[kind] || ROJO_ROJOMIES_ERROR_MESSAGES.network;
    const titleEl = rojomiesErrorBlock ? rojomiesErrorBlock.querySelector('.rojo-rojomies-error__title') : null;
    const textEl = rojomiesErrorBlock ? rojomiesErrorBlock.querySelector('.rojo-rojomies-error__text') : null;
    if (titleEl) titleEl.textContent = message.title;
    if (textEl) textEl.textContent = message.text;
  }

  // TEMPORARY CAMPAIGN (2026-09, round 9) — COMPACT VALIDATION, NO LAYOUT
  // SHIFT. The large .rojo-rojomies-error card (populated by
  // setRojomiesErrorMessage() above) is permanently hidden for this promo
  // build (see rojo-os.css) because unhiding it pushes the phone/consent/
  // CTA down, sometimes past the visible viewport. Every error path that
  // used to rely on that card is mapped here to one of two existing,
  // fixed-size elements instead: the phone field's own label (text swap +
  // color/glow only — same font-size/line-height/margin) or the consent
  // row (outline only — outline never participates in box layout, so it
  // can never add height). setRojomiesErrorMessage()/setRojomiesFormState()
  // above/below are left completely unchanged and still run at every
  // call site — this is purely an additional presentation layer.
  const ROJO_PROMO_PHONE_LABEL_DEFAULT = 'PHONE NUMBER + COUNTRY CODE';
  const ROJO_PROMO_COMPACT_ERROR_LABELS = {
    phone: 'ENTER A VALID PHONE NUMBER',
    // Server-side validation failure (invalid_phone/consent_required from
    // the Worker) — client-side validation already normally catches this
    // before a request is even sent, so this is a rare fallback; same
    // message as a client-side invalid phone is the closest accurate
    // equivalent.
    validation: 'ENTER A VALID PHONE NUMBER',
    rateLimited: 'TOO MANY ATTEMPTS — TRY LATER',
    network: 'PLEASE TRY AGAIN'
  };

  function setRojomiesConsentError() {
    rojomiesConsentRow?.classList.add('is-error');
  }

  function clearRojomiesConsentError() {
    rojomiesConsentRow?.classList.remove('is-error');
  }

  // includeConsent is only ever passed true for the client-side "both
  // phone and consent invalid" case — a backend/network error (which only
  // ever fires after client-side validation already passed) never touches
  // consent. Any kind not in the map above (should never happen, but
  // never silently swallowed either) falls back to PLEASE TRY AGAIN.
  function setRojomiesPhoneCompactError(kind, includeConsent) {
    if (rojomiesPhoneLabel) {
      rojomiesPhoneLabel.textContent = ROJO_PROMO_COMPACT_ERROR_LABELS[kind] || 'PLEASE TRY AGAIN';
      rojomiesPhoneLabel.classList.add('is-error');
    }
    if (includeConsent) setRojomiesConsentError();
  }

  function clearRojomiesPhoneCompactError() {
    if (rojomiesPhoneLabel) {
      rojomiesPhoneLabel.textContent = ROJO_PROMO_PHONE_LABEL_DEFAULT;
      rojomiesPhoneLabel.classList.remove('is-error');
    }
  }

  function setRojomiesFormState(state) {
    if (rojomiesSubmitButton) rojomiesSubmitButton.disabled = state === 'submitting';
    // TEMPORARY CAMPAIGN (2026-09) — promo CTA copy; disabled/error logic
    // above and below is unchanged from the current ROJOMIES CLUB flow.
    if (rojomiesSubmitLabel) rojomiesSubmitLabel.textContent = state === 'submitting' ? 'TRANSMITTING…' : 'GET EARLY ACCESS →';
    if (rojomiesErrorBlock) rojomiesErrorBlock.hidden = state !== 'error';
    root.dispatchEvent(new CustomEvent('rojo:sms-state', { detail: { state } }));
  }

  // Phase 2C (2026-07-29): the Worker now distinguishes a brand-new signup
  // from a phone number that was already on the list, via contactStatus
  // ('created' or 'existing') on every success response. Reuses the exact
  // same title/text elements as before — only their text content changes,
  // via the same querySelector-on-existing-classes technique already
  // proven for setRojomiesErrorMessage() above, so no Liquid/CSS change is
  // needed. submitRojomiesForm() below only ever calls this with an
  // already-validated 'created'/'existing' value; the fallback to
  // .created here is defensive only, never expected to actually trigger.
  // TEMPORARY CAMPAIGN (2026-09) — promo wording only; contactStatus
  // ('created' vs 'existing') still comes straight from the Worker/
  // Omnisend response, completely unchanged. Neither message claims a
  // text has already been sent — the access code is scheduled for
  // September 29 by the owner, not sent automatically by this build.
  const ROJO_ROJOMIES_SUCCESS_MESSAGES = {
    created: {
      title: "YOU’RE IN.",
      text: 'YOUR EARLY-ACCESS PASSWORD\nARRIVES BY TEXT SEPTEMBER 29.'
    },
    existing: {
      title: "YOU'RE ALREADY ON THE LIST",
      text: 'YOUR EARLY-ACCESS PASSWORD\nARRIVES BY TEXT SEPTEMBER 29.'
    }
  };

  function showRojomiesSuccess(contactStatus) {
    const message = ROJO_ROJOMIES_SUCCESS_MESSAGES[contactStatus] || ROJO_ROJOMIES_SUCCESS_MESSAGES.created;
    const titleEl = rojomiesSuccessView ? rojomiesSuccessView.querySelector('.rojo-rojomies-success__title') : null;
    const textEl = rojomiesSuccessView ? rojomiesSuccessView.querySelector('.rojo-rojomies-success__text') : null;
    if (titleEl) { titleEl.textContent = message.title; titleEl.dataset.ghost = message.title; }
    if (textEl) textEl.textContent = message.text;
    if (rojomiesFormView && rojomiesSuccessView) rojomiesSuccessView.style.minHeight = Math.ceil(rojomiesFormView.getBoundingClientRect().height) + 'px';
    if (rojomiesFormView) rojomiesFormView.hidden = true;
    if (rojomiesSuccessView) rojomiesSuccessView.hidden = false;
    root.dispatchEvent(new CustomEvent('rojo:sms-success', { detail: { contactStatus } }));
  }

  // Called on every fresh open of the ROJOMIES CLUB panel, and again after
  // "TRY AGAIN" — same reset rule as every other ROJO OS app returning to
  // a clean starting state. Never calls .focus() on anything.
  function resetRojomiesForm() {
    rojomiesForm?.reset();
    // Defensive: guarantees US even if a browser's native form.reset()
    // country-select restoration ever behaves differently than expected.
    // Never fires while the form is just sitting open with a user-made
    // selection — form.reset() itself is the only thing that runs this.
    if (rojomiesEnhancedPhoneMode && rojomiesCountrySelect && rojomiesCountryOptionCodes.includes('US')) {
      rojomiesCountrySelect.value = 'US';
      // form.reset() clears the input VALUE but never touches the
      // placeholder attribute — without this it would stay stuck on
      // whatever country was selected before closing.
      updateRojomiesPhonePlaceholder();
    }
    setRojomiesFormState('idle');
    // TEMPORARY CAMPAIGN (2026-09, round 9) — defensive: guarantees a
    // truly clean state even if compact-error clearing was somehow missed
    // elsewhere (e.g. a stale error from a previous number before ADD
    // ANOTHER NUMBER is tapped).
    clearRojomiesPhoneCompactError();
    clearRojomiesConsentError();
    if (rojomiesFormView) rojomiesFormView.hidden = false;
    if (rojomiesSuccessView) rojomiesSuccessView.hidden = true;
  }

  async function submitRojomiesForm(event) {
    event.preventDefault();
    if (Date.now() >= ROJO_PROMO_TARGET_MS) { rojoPromoExpired = true; rojoPromoShowClosedState(); return; }
    // Disabling the submit button inside setRojomiesFormState('submitting')
    // below happens synchronously, before any async work — same guard
    // reasoning as submitContactForm() below. rojomiesSubmitInFlight is a
    // second, explicit guard on top of that against duplicate submissions.
    if (!rojomiesForm || rojomiesSubmitButton?.disabled || rojomiesSubmitInFlight) return;

    // Honeypot filled -> treat as an invalid submission, same generic
    // error path as any other failed check, and never call the Worker.
    if (rojomiesHoneypot && rojomiesHoneypot.value) {
      setRojomiesErrorMessage('validation');
      setRojomiesFormState('error');
      setRojomiesPhoneCompactError('validation', false);
      return;
    }

    const normalizedPhone = rojoResolveRojomiesPhoneE164();
    const consentChecked = rojomiesConsentCheckbox?.checked === true;

    // TEMPORARY CAMPAIGN (2026-09, round 9) — phone-invalid and consent-
    // missing now get distinct compact presentations instead of one
    // combined error: phone-invalid always swaps the phone label (and
    // also flags consent if BOTH are wrong); consent-missing-only never
    // touches the phone label, only the consent row.
    if (!normalizedPhone || !consentChecked) {
      setRojomiesErrorMessage('validation');
      setRojomiesFormState('error');
      if (!normalizedPhone) {
        setRojomiesPhoneCompactError('phone', !consentChecked);
      } else {
        setRojomiesConsentError();
      }
      return;
    }

    // Clears any compact error left over from a previous failed attempt
    // now that both checks have passed.
    clearRojomiesPhoneCompactError();
    clearRojomiesConsentError();

    rojomiesSubmitInFlight = true;
    setRojomiesFormState('submitting');

    const controller = new AbortController();
    const timeoutId = window.setTimeout(() => controller.abort(), ROJO_ROJOMIES_SUBMIT_TIMEOUT_MS);

    try {
      const response = await fetch(ROJO_ROJOMIES_WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'omit',
        signal: controller.signal,
        body: JSON.stringify({
          phone: normalizedPhone,
          consent: rojomiesConsentCheckbox?.checked === true,
          honeypot: rojomiesHoneypot?.value || ''
        })
      });

      let result = null;
      try {
        result = await response.json();
      } catch (parseErr) {
        result = null;
      }

      // Phase 2C: a valid success now also requires a recognized
      // contactStatus. Missing/malformed/unrecognized falls through to the
      // generic failure path below instead of ever defaulting to a welcome
      // message — the Worker's ok:true alone is no longer sufficient.
      const contactStatus = result && (result.contactStatus === 'created' || result.contactStatus === 'existing')
        ? result.contactStatus
        : null;

      if (!root.isConnected) return;
      if (Date.now() >= ROJO_PROMO_TARGET_MS) { rojoPromoExpired = true; rojoPromoShowClosedState(); return; }
      if (response.status === 200 && result && result.ok === true && contactStatus) {
        setRojomiesFormState('idle');
        showRojomiesSuccess(contactStatus);
        return;
      }

      const errorCode = result && typeof result.error === 'string' ? result.error : null;
      const workerErrorKind = classifyRojomiesWorkerError(errorCode);
      setRojomiesErrorMessage(workerErrorKind);
      setRojomiesFormState('error');
      setRojomiesPhoneCompactError(workerErrorKind, false);
    } catch (fetchErr) {
      if (!root.isConnected) return;
      if (Date.now() >= ROJO_PROMO_TARGET_MS) { rojoPromoExpired = true; rojoPromoShowClosedState(); return; }
      // Covers both a genuine network failure and the AbortController
      // timeout above — both surface as a rejected fetch() promise and
      // are handled identically; the customer doesn't need to know which.
      setRojomiesErrorMessage('network');
      setRojomiesFormState('error');
      setRojomiesPhoneCompactError('network', false);
    } finally {
      rojomiesSubmitInFlight = false;
      window.clearTimeout(timeoutId);
    }
  }

  rojomiesForm?.addEventListener('submit', submitRojomiesForm);
  rojomiesTryAgainButton?.addEventListener('click', resetRojomiesForm);

  // TEMPORARY CAMPAIGN (2026-09, round 9) — clears the compact phone
  // error the moment the customer starts correcting the number; does not
  // touch a legitimate consent error, which is only cleared by actually
  // checking the box (see the consent listener below).
  rojomiesPhoneInput?.addEventListener('input', () => {
    clearRojomiesPhoneCompactError();
  });

  rojomiesConsentCheckbox?.addEventListener('change', () => {
    if (rojomiesConsentCheckbox.checked) clearRojomiesConsentError();
  });

  // TEMPORARY CAMPAIGN (2026-09) — BLACK TEE SMS EARLY-ACCESS COUNTDOWN.
  // Fixed instant with an explicit Pacific offset baked into the ISO
  // string itself (never new Date(2026,8,3,16,0), which would be parsed
  // in the visitor's own local timezone) — every visitor's Date.now()
  // comparison resolves against the identical real-world moment
  // regardless of where they are.
  const ROJO_PROMO_TARGET_MS = new Date('2026-09-29T15:00:00-07:00').getTime();
  let rojoPromoExpired = false;

  // Once the deadline passes, immediately stop presenting early access as
  // available — disables the submit action and swaps to the fail-safe
  // closed state. Idempotent (safe to call every tick); never touches
  // subtotal/backend semantics, never redirects, never auto-publishes
  // another theme.
  function rojoPromoShowClosedState() {
    root.setAttribute('data-rojo-halloween-closed', '');
    root.dispatchEvent(new CustomEvent('rojo:sms-closed'));
    if (rojomiesSubmitButton) rojomiesSubmitButton.disabled = true;
    if (promoCountdown) promoCountdown.hidden = true;
    if (promoDropInfo) promoDropInfo.hidden = true;
    if (rojomiesFormView) rojomiesFormView.hidden = true;
    if (rojomiesSuccessView) rojomiesSuccessView.hidden = true;
    if (promoClosedState) promoClosedState.hidden = false;
  }

  function rojoPromoUpdateCountdown() {
    const remainingMs = Math.max(0, ROJO_PROMO_TARGET_MS - Date.now());

    if (remainingMs <= 0) {
      if (!rojoPromoExpired) {
        rojoPromoExpired = true;
        rojoPromoShowClosedState();
      }
      return;
    }

    const totalSeconds = Math.floor(remainingMs / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const pad = (value) => String(value).padStart(2, '0');

    if (promoDaysEl) promoDaysEl.textContent = pad(days);
    if (promoHoursEl) promoHoursEl.textContent = pad(hours);
    if (promoMinutesEl) promoMinutesEl.textContent = pad(minutes);
    if (promoSecondsEl) promoSecondsEl.textContent = pad(seconds);
  }

  function startRojoPromoCountdown() {
    if (!promoCountdown) return;

    // Clears whatever the previous initRojoOS() call's interval was
    // (see the module-level rojoPromoCountdownInterval declaration at
    // the top of this file) before starting a fresh one — guarantees
    // exactly one live interval per page, even across repeated Shopify
    // theme-editor section reloads.
    if (rojoPromoCountdownInterval) window.clearInterval(rojoPromoCountdownInterval);

    rojoPromoUpdateCountdown();
    rojoPromoCountdownInterval = window.setInterval(rojoPromoUpdateCountdown, 1000);
  }

  startRojoPromoCountdown();

  // ROJO OS — CONTACT US application (2026-07-27). Same two-beat open
  // choreography as openShop()/openConcept() above, no changes to that
  // shared pattern. resetContactForm() (defined below, alongside the rest
  // of the contact-form submission logic) is called on every open so a
  // stale success/error state from a previous visit never lingers — the
  // panel always starts fresh.
  function openContact() {
    if (
      appTransitionLocked ||
      !root.classList.contains('is-home') ||
      root.classList.contains('is-app') ||
      !apps ||
      !contactApp
    ) return;

    window.clearTimeout(appTransitionTimer);
    appTransitionLocked = true;
    const myTransitionToken = ++appTransitionToken;

    deactivateAllApps();
    resetContactForm();

    // Two-beat open — see openShop() for the full explanation.
    root.classList.add('is-app-transition');
    menu.setAttribute('aria-hidden', 'true');

    appTransitionTimer = window.setTimeout(() => {
      if (myTransitionToken !== appTransitionToken) return;
      root.classList.add('is-app');
      apps.hidden = false;
      contactApp.setAttribute('aria-hidden', 'false');

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          if (myTransitionToken !== appTransitionToken) return;
          contactApp.classList.add('is-active');
          appTransitionTimer = window.setTimeout(() => {
            if (myTransitionToken !== appTransitionToken) return;
            finishAppTransition();
          }, 260);
        });
      });
    }, 260);
  }

  // ROJO OS — CONTACT US Basin submission (2026-07-27). Endpoint provided
  // by the owner for the "TDOM Customer Support" Basin form specifically —
  // used only for this form, nowhere else. AJAX submission (fetch, same
  // async/await + try/catch pattern already used for /cart/add.js etc.
  // elsewhere in this file) so the customer never leaves the ROJO OS shell,
  // matching how every other action in this app already behaves. No API
  // key involved or needed — Basin's public form endpoints accept plain
  // POSTs, nothing secret lives in this file.
  const ROJO_CONTACT_BASIN_ENDPOINT = 'https://usebasin.com/f/1ca4f2a439f6';

  function setContactFormState(state) {
    if (contactSubmitButton) contactSubmitButton.disabled = state === 'submitting';
    if (contactSubmitLabel) contactSubmitLabel.textContent = state === 'submitting' ? 'SENDING...' : 'SUBMIT REQUEST';
    if (contactErrorBlock) contactErrorBlock.hidden = state !== 'error';
  }

  function showContactSuccess() {
    if (contactFormView) contactFormView.hidden = true;
    if (contactSuccessView) contactSuccessView.hidden = false;
  }

  // Called on every fresh open of the CONTACT US panel, and again after the
  // owner-requested "SEND ANOTHER REQUEST" action — same reset, same rule
  // as every other ROJO OS app returning to a clean starting state.
  function resetContactForm() {
    contactForm?.reset();
    setContactFormState('idle');
    if (contactFormView) contactFormView.hidden = false;
    if (contactSuccessView) contactSuccessView.hidden = true;
  }

  async function submitContactForm(event) {
    event.preventDefault();
    // Disabling the submit button inside setContactFormState('submitting')
    // below happens synchronously, before any `await` — JS is single-
    // threaded, so a second click physically cannot reach this handler
    // again until that disable has already taken effect (disabled buttons
    // don't fire click/submit at all). This guard is a cheap, explicit
    // backstop on top of that, not the only thing preventing a double-send.
    if (!contactForm || contactSubmitButton?.disabled) return;

    setContactFormState('submitting');

    try {
      const response = await fetch(ROJO_CONTACT_BASIN_ENDPOINT, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(contactForm)
      });

      if (!response.ok) throw new Error('Basin submission failed');

      // Fields are only ever cleared on confirmed success (via
      // showContactSuccess() hiding the form, then resetContactForm()
      // clearing it later if the customer chooses "send another") — never
      // on error, so a failed attempt never loses what the customer typed.
      setContactFormState('idle');
      showContactSuccess();
    } catch (err) {
      setContactFormState('error');
    }
  }

  contactForm?.addEventListener('submit', submitContactForm);
  contactSendAnotherButton?.addEventListener('click', resetContactForm);

  function openConceptPreview(conceptHandle) {
    if (!conceptHandle) return;
    resetConceptViews();
    const preview = conceptPreviews.find((item) => item.dataset.rojoConceptPreview === conceptHandle);
    if (!preview) return;
    conceptShell?.classList.add('is-preview-open');
    preview.hidden = false;
    preview.setAttribute('aria-hidden', 'false');
    preview.querySelector('[data-rojo-concept-preview-close]')?.focus({ preventScroll: true });
  }

  function openConceptFull(conceptHandle) {
    if (!conceptHandle) return;
    resetConceptViews();
    const fullView = conceptFullViews.find((item) => item.dataset.rojoConceptFull === conceptHandle);
    if (!fullView) return;
    fullView.hidden = false;
    fullView.setAttribute('aria-hidden', 'false');
    fullView.querySelector('[data-rojo-concept-full-close]')?.focus({ preventScroll: true });
  }

  function closeConceptOverlay() {
    resetConceptViews();
  }

  // ROJO RUN — Phase 1 shell state machine (launch -> rotate prompt -> landscape pre-start). No gameplay yet.
  const rojoRunLandscapeQuery = window.matchMedia('(orientation: landscape)');
  const rojoRunCoarsePointerQuery = window.matchMedia('(pointer: coarse)');
  const rojoRunShortHeightQuery = window.matchMedia('(max-height: 500px)');

  function addRojoRunMediaListener(mediaQuery, handler) {
    if (!mediaQuery) return;
    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', handler);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(handler);
    }
  }

  function removeRojoRunMediaListener(mediaQuery, handler) {
    if (!mediaQuery) return;
    if (typeof mediaQuery.removeEventListener === 'function') {
      mediaQuery.removeEventListener('change', handler);
    } else if (typeof mediaQuery.removeListener === 'function') {
      mediaQuery.removeListener(handler);
    }
  }

  function rojoRunHasCoarsePointer() {
    return rojoRunCoarsePointerQuery.matches;
  }

  function rojoRunIsLandscape() {
    return rojoRunLandscapeQuery.matches;
  }

  // Desktop/mouse users have nothing to physically rotate, so they skip the rotate prompt entirely.
  function rojoRunNeedsRotate() {
    return rojoRunHasCoarsePointer() && !rojoRunIsLandscape();
  }

  function rojoRunNeedsCompactHud() {
    return rojoRunHasCoarsePointer() && rojoRunIsLandscape() && rojoRunShortHeightQuery.matches;
  }

  // Reverts the radio and globe to their normal CSS-controlled layout (Homepage, desktop,
  // portrait, launch/rotate states, and every other app rely on these rules being untouched).
  function clearRojoRunCompactHud() {
    if (tdomRadioWrap) {
      tdomRadioWrap.style.removeProperty('position');
      tdomRadioWrap.style.removeProperty('top');
      tdomRadioWrap.style.removeProperty('left');
      tdomRadioWrap.style.removeProperty('right');
      tdomRadioWrap.style.removeProperty('width');
    }

    if (worldButton) {
      worldButton.style.removeProperty('position');
      worldButton.style.removeProperty('top');
      worldButton.style.removeProperty('left');
      worldButton.style.removeProperty('right');
      worldButton.style.removeProperty('width');
      worldButton.style.removeProperty('transform');
    }
  }

  // Anchors the radio and globe to the ROJO RUN shell's actual measured rectangle (not the
  // viewport), so they sit inside the game box itself with a guaranteed minimum gap.
  function applyRojoRunCompactHud() {
    if (!rojoRunShell || !tdomRadioWrap || !worldButton) return;

    const rect = rojoRunShell.getBoundingClientRect();
    const inset = 10;
    const gap = 16;
    const globeSize = Math.max(44, Math.min(56, rect.height - inset * 2));
    const availableForRadio = rect.width - inset * 2 - gap - globeSize;
    const radioWidth = Math.min(300, Math.max(120, availableForRadio));

    tdomRadioWrap.style.position = 'fixed';
    tdomRadioWrap.style.top = `${rect.top + inset}px`;
    tdomRadioWrap.style.left = `${rect.left + inset}px`;
    tdomRadioWrap.style.right = 'auto';
    tdomRadioWrap.style.width = `${radioWidth}px`;

    worldButton.style.position = 'fixed';
    worldButton.style.top = `${rect.top + inset}px`;
    worldButton.style.left = `${rect.right - inset - globeSize}px`;
    worldButton.style.right = 'auto';
    worldButton.style.width = `${globeSize}px`;
    worldButton.style.transform = 'none';
  }

  function updateRojoRunCompactHud(state) {
    if (rojoRunActive && (state === 'landscape' || state === 'intro' || state === 'playing') && rojoRunNeedsCompactHud()) {
      applyRojoRunCompactHud();
    } else {
      clearRojoRunCompactHud();
    }
  }

  function setRojoRunState(state) {
    if (!rojoRunShell) return;

    rojoRunShell.dataset.rojoRunState = state;

    if (rojoRunLaunch) {
      rojoRunLaunch.setAttribute('aria-hidden', state === 'launch' ? 'false' : 'true');
    }

    if (rojoRunRotate) {
      rojoRunRotate.setAttribute('aria-hidden', state === 'rotate' ? 'false' : 'true');
    }

    if (rojoRunLandscape) {
      rojoRunLandscape.setAttribute('aria-hidden', state === 'landscape' ? 'false' : 'true');
    }

    if (rojoRunIntro) {
      rojoRunIntro.setAttribute('aria-hidden', state === 'intro' ? 'false' : 'true');
    }

    if (rojoRunPlaying) {
      rojoRunPlaying.setAttribute('aria-hidden', state === 'playing' ? 'false' : 'true');
    }

    updateRojoRunCompactHud(state);
  }

  // Corrects the ROJO RUN shell height against the actually-visible landscape viewport on
  // real iPhone Safari, where the 100svh-based layout chain can render taller than what the
  // browser's toolbar currently leaves visible. Scoped strictly to coarse-pointer, landscape,
  // short-height ROJO RUN — cleared for every other state so no stale value can linger.
  function updateRojoRunVisibleHeight() {
    if (!rojoRunShell) return;

    if (!rojoRunActive || !rojoRunHasCoarsePointer() || !rojoRunIsLandscape() || !rojoRunShortHeightQuery.matches) {
      rojoRunShell.style.removeProperty('--rojo-run-visible-height');
      return;
    }

    const viewportHeight = window.visualViewport?.height || window.innerHeight;
    const appStyle = rojoRunApp ? window.getComputedStyle(rojoRunApp) : null;
    const paddingTop = appStyle ? parseFloat(appStyle.paddingTop) || 0 : 0;
    const paddingBottom = appStyle ? parseFloat(appStyle.paddingBottom) || 0 : 0;
    const available = viewportHeight - paddingTop - paddingBottom;

    if (Number.isFinite(available) && available > 0) {
      rojoRunShell.style.setProperty('--rojo-run-visible-height', `${available}px`);
    } else {
      rojoRunShell.style.removeProperty('--rojo-run-visible-height');
    }
  }

  function updateRojoRunOrientation() {
    if (!rojoRunActive || !rojoRunShell) return;

    updateRojoRunVisibleHeight();

    if (rojoRunShell.dataset.rojoRunState === 'launch') return;

    // ROJO RUN — Phase 6B: mobile Safari fires resize events constantly
    // (e.g. address-bar collapse) even with no real orientation change —
    // without this explicit no-op branch, the catch-all line at the
    // bottom of this function would silently bounce the player out of
    // this screen on every such event. Only an actual rotate-away
    // changes anything here; a spurious resize while still landscape is
    // a no-op, same treatment 'playing' below gives a spurious resize.
    if (rojoRunShell.dataset.rojoRunState === 'intro') {
      if (rojoRunNeedsRotate()) {
        setRojoRunState('rotate');
      }
      return;
    }

    if (rojoRunShell.dataset.rojoRunState === 'playing') {
      if (rojoRunNeedsRotate()) {
        // ROJO RUN — Phase 6B/6C: this branch also fires if a rotate-away
        // happens during the frozen countdown or a manual pause (state is
        // 'playing' for both, by design). Cancel/close both first so
        // neither can act later against a stopped loop.
        rojoRunCancelCountdown();
        rojoRunClosePauseOverlay();
        stopRojoRunLoop();
        resetRojoRunInput();
        resetRojoRunArenaFit();
        resetRojoRunPlayer();
        setRojoRunState('rotate');
      } else {
        rojoRunDebouncedUpdateArenaFit();
      }
      return;
    }

    setRojoRunState(rojoRunNeedsRotate() ? 'rotate' : 'landscape');
  }

  function startRojoRunLaunch() {
    window.clearTimeout(rojoRunLaunchTimer);
    setRojoRunState('launch');

    if (rojoRunLaunchFill) {
      rojoRunLaunchFill.style.width = '0%';
      window.requestAnimationFrame(() => {
        rojoRunLaunchFill.style.width = '100%';
      });
    }

    rojoRunLaunchTimer = window.setTimeout(() => {
      setRojoRunState(rojoRunNeedsRotate() ? 'rotate' : 'landscape');
    }, 900);
  }

  function stopRojoRun() {
    // ROJO OS — bug fix (2026-07-26, owner: "tap a page and go back to the
    // homepage back and forth really fast. the site crashes"). This function
    // is called unconditionally by deactivateAllApps() on EVERY single app
    // open/close (Shop, Concepts, ROJO RUN, Home — all of them). Round 1 of
    // this fix moved the `if (!rojoRunActive) return;` guard earlier so
    // Shop/Concepts (which never touch rojoRunActive) skip all of the work
    // below entirely — confirmed by the owner as fully fixed for those two.
    //
    // Round 2 of this fix (still 2026-07-26): the owner then reported ROJO
    // RUN itself still crashes after "a few" rapid open/close cycles, even
    // without ever tapping past the title screen. Root cause: openRojoRun()
    // sets rojoRunActive = true the instant its panel opens (well before the
    // player ever reaches character-select/START), so every close was still
    // running resetRojoRunPlayer() below — which cascades into
    // resetRojoRunPlayerPhysics(), unconditionally tearing down and
    // REBUILDING the entire mobile 71-canvas tile-world compositor plus
    // restarting every parallax/container/health-pickup/checkpoint/finish-
    // marker/Signal-Fracture/Pulse-Zone WAAPI animation — on every single
    // close, regardless of whether the player ever did anything beyond
    // opening the app. That's real, heavy work, repeated as fast as the
    // player could tap — a severe memory/GPU spike, not a slow leak.
    //
    // This call turns out to be redundant: rojoRunArmCountdown() (the one
    // and only choke point every real path into gameplay funnels through —
    // fresh run, replay, and restart all route back through character-select
    // first, per the owner's own Phase 7 directive) already calls
    // resetRojoRunPlayer() itself, unconditionally, right before arming the
    // countdown. So a fresh, correct reset is still guaranteed immediately
    // before the player can ever reach 'playing' state again — it just no
    // longer also happens redundantly on every mere close. Removed the call
    // here entirely. Everything else below (resetRojoRunInput/
    // resetRojoRunArenaFit — both cheap variable/style resets, not the cost
    // driver — and the WAAPI animation-pause calls) still runs exactly as
    // before whenever ROJO RUN genuinely was active, so nothing is ever left
    // running against hidden elements after a real play session.
    rojoRunCancelCountdown();
    rojoRunClosePauseOverlay();
    stopRojoRunLoop();
    rojoRunShell?.style.removeProperty('--rojo-run-visible-height');
    rojoRunSuspended = false;
    rojoRunSuspendedState = null;

    if (!rojoRunActive) return;

    resetRojoRunInput();
    resetRojoRunArenaFit();
    // ROJO OS — bug fix (2026-07-26): stopRojoRunLoop() sets
    // rojoRunLoopRunning = false, which means pauseRojoRunLoop() (its own
    // guard is `if (!rojoRunLoopRunning...) return;`) can never be reused
    // here to pause the long-lived WAAPI animations — it would just bail
    // immediately. Previously, leaving ROJO RUN via the main nav (unlike
    // backgrounding or the in-game pause button, both of which do reach
    // pauseRojoRunLoop()) left the parallax/container-track/Pulse-Zone-glow
    // animations running indefinitely against now-hidden elements. Paused
    // directly and unconditionally here instead, mirroring the exact same
    // pause calls pauseRojoRunLoop() already uses.
    if (rojoRunHasCoarsePointer()) {
      rojoRunTileAnimations.forEach((anim) => { if (anim) anim.pause(); });
    }
    rojoRunParallaxAnimations.forEach((anim) => { if (anim) anim.pause(); });
    if (rojoRunContainerLayerAnimation) rojoRunContainerLayerAnimation.pause();
    if (rojoRunWorldObjectLayerAnimation) rojoRunWorldObjectLayerAnimation.pause();
    rojoRunPulseZoneGlowAnimations.forEach((anim) => { if (anim) anim.pause(); });

    rojoRunActive = false;
    window.clearTimeout(rojoRunLaunchTimer);
    setRojoRunState('rotate');
  }

  // ROJO RUN — Phase 3A: graybox movement foundation (temporary geometric
  // Tavo, gravity, tap/hold jump, flat-ground collision). No hazards,
  // collectibles, health, scoring, camera effects, final art, or audio yet.
  function rojoRunGetTerrainAt(worldX) {
    if (worldX < ROJO_RUN_LEVEL1_TERRAIN[0].startX) return ROJO_RUN_LEVEL1_TERRAIN[0];
    for (const segment of ROJO_RUN_LEVEL1_TERRAIN) {
      if (worldX >= segment.startX && worldX < segment.endX) return segment;
    }
    return ROJO_RUN_LEVEL1_TERRAIN[ROJO_RUN_LEVEL1_TERRAIN.length - 1];
  }

  function rojoRunGroundYAt(worldX) {
    const segment = rojoRunGetTerrainAt(worldX);
    if (segment.groundY === null && !segment.isSlope) return null;
    if (segment.isSlope) {
      const t = (worldX - segment.startX) / (segment.endX - segment.startX);
      return segment.slopeFrom + (segment.slopeTo - segment.slopeFrom) * t;
    }
    return segment.groundY;
  }

  function rojoRunWorldToScreenX(worldX) {
    return ROJO_RUN_PLAYER_PROBE_SCREEN_X + (worldX - rojoRunPlayerWorldDistance);
  }

  // ROJO OS — bug fix (2026-08-06): identical to rojoRunWorldToScreenX,
  // except it reads the render-interpolated distance instead of the raw
  // stepped one — used only at terrain/Terrain-Swell screen-position call
  // sites, to smooth out the fixed-timestep jitter described above the
  // rojoRunPlayerWorldDistanceAtLastStep declaration. No other call site
  // uses this — collision/physics/hazard timing all still read
  // rojoRunWorldToScreenX (unchanged) and the authoritative
  // rojoRunPlayerWorldDistance directly.
  function rojoRunWorldToScreenXRender(worldX) {
    return ROJO_RUN_PLAYER_PROBE_SCREEN_X + (worldX - rojoRunPlayerWorldDistanceRender);
  }

  // ROJO RUN — Phase 4A: simple AABB contact check against the player's foot
  // center. Contact-collection only, idempotent via the Set (no double
  // collection), no scoring/magnetism/HUD — those belong to later phases.
  function rojoRunCheckContainerCollisions() {
    const playerCenterY = rojoRunPlayerFootY - ROJO_RUN_PLAYER_HEIGHT / 2;
    ROJO_RUN_ALL_CONTAINERS.forEach((container) => {
      if (rojoRunCollectedContainers.has(container.id)) return;
      const groundY = rojoRunGroundYAt(container.worldX);
      if (groundY === null) return;
      const containerCenterY = groundY - container.heightAboveGround - ROJO_RUN_CONTAINER_RADIUS;
      const withinX = Math.abs(rojoRunPlayerWorldDistance - container.worldX) < (ROJO_RUN_PLAYER_WIDTH / 2 + ROJO_RUN_CONTAINER_RADIUS + ROJO_RUN_CONTAINER_PICKUP_REACH_X_BONUS);
      const withinY = Math.abs(playerCenterY - containerCenterY) < (ROJO_RUN_PLAYER_HEIGHT / 2 + ROJO_RUN_CONTAINER_RADIUS + ROJO_RUN_CONTAINER_PICKUP_REACH_Y_BONUS);
      if (withinX && withinY) {
        rojoRunCollectedContainers.add(container.id);
        rojoRunScore += 50;
        rojoRunUpdateContainerCounterHud();
        // ROJO RUN — Phase 8B (2026-07-23): one small step toward the ROJO
        // palette per container, deterministic and proportional to progress
        // — not tied to the Phase 5E position milestones below anymore.
        // ROJO RUN — round (2026-07-25): reverted the front-loaded Math.pow
        // pacing from the previous round — owner: "i dont like how quickly
        // you sped up the red shift... nice and gradually. like how we had
        // it before." Back to plain linear progress, matching the exact
        // pacing already tuned/approved for the ground earlier this session
        // (the 5-point keyframe table itself, confirmed via real matrix
        // math to reach "powerful red" by 60 and "undeniably red" by 80 —
        // unchanged, only this round's speedup is reverted).
        rojoRunSetWorldTintIndex((rojoRunCollectedContainers.size / ROJO_RUN_ALL_CONTAINERS.length) * 4);
        // ROJO RUN — Phase 9 round 9: hide this container's DOM element,
        // once, on collection — the same "erase once, not every frame"
        // philosophy the original pre-Phase-9 mobile tile-bake approach
        // used, now applied to a plain DOM element instead of a canvas.
        const collectedEl = rojoRunContainerElements[container.id];
        if (collectedEl) collectedEl.style.display = 'none';
      }
    });
  }

  // ROJO RUN — Phase 4B: health/damage system core functions. See
  // ROJO_RUN_MAX_HEALTH's own comment block for the owner-confirmed rules
  // this implements.
  function rojoRunSetHealth(value) {
    rojoRunPlayerHealth = Math.max(0, Math.min(ROJO_RUN_MAX_HEALTH, value));
    if (rojoRunHealthHud.length) {
      rojoRunHealthHud.forEach((el, index) => {
        el.classList.toggle('is-filled', index < rojoRunPlayerHealth);
      });
    }
  }

  // ROJO RUN — Phase 4E: temporary graybox course-progress bar/percent,
  // called once per rendered frame (not per simulation step) since it's a
  // cheap DOM write and only needs to match visual frame rate, not physics
  // rate.
  function rojoRunUpdateProgressHud() {
    if (!rojoRunProgressFill && !rojoRunProgressPercent) return;
    const rawPercent = (rojoRunPlayerWorldDistance / ROJO_RUN_FINISH_X) * 100;
    const clampedPercent = Math.max(0, Math.min(100, rawPercent));
    const displayPercent = Math.floor(clampedPercent);
    if (rojoRunProgressFill) rojoRunProgressFill.style.width = `${clampedPercent}%`;
    if (rojoRunProgressPercent) rojoRunProgressPercent.textContent = `${displayPercent}%`;
  }

  // ROJO RUN — Phase 6A: score readout and paint meter, same per-frame
  // pattern as rojoRunUpdateProgressHud() above and called from the exact
  // same two places (render loop, resetRojoRunPlayer()). Score is read
  // directly from rojoRunScore rather than updated at each of its 7 award
  // sites — simpler and can't miss one. Paint meter reflects container
  // collection progress only (0-80); the real world-transformation visuals
  // (green-to-red environment) are Phase 8 scope.
  function rojoRunUpdateScoreAndPaintHud() {
    if (rojoRunScoreValue) rojoRunScoreValue.textContent = rojoRunScore;
    if (rojoRunPaintFill) {
      const paintPercent = (rojoRunCollectedContainers.size / ROJO_RUN_ALL_CONTAINERS.length) * 100;
      rojoRunPaintFill.style.width = `${paintPercent}%`;
    }
  }

  // ROJO RUN — Phase 4E: temporary graybox paint-container counter.
  // Event-driven (called from rojoRunCheckContainerCollisions() right after
  // a container is added to the Set) rather than per-frame, since it only
  // changes on an actual collection event.
  function rojoRunUpdateContainerCounterHud() {
    if (!rojoRunContainerCounter) return;
    rojoRunContainerCounter.textContent = `${rojoRunCollectedContainers.size}/80`;
  }

  // ROJO RUN — Phase 4E: temporary graybox CHECKPOINT REACHED flash message.
  // Shown briefly on each checkpoint crossing (called from the same
  // once-per-checkpoint guarded block that already updates
  // rojoRunLatestCheckpointX, so this naturally never re-fires for a
  // checkpoint already passed). Final polished presentation is Phase 6 scope.
  function rojoRunShowCheckpointMessage() {
    if (!rojoRunCheckpointMessage) return;
    rojoRunCheckpointMessage.classList.add('is-visible');
    if (rojoRunCheckpointMessageHideTimer) clearTimeout(rojoRunCheckpointMessageHideTimer);
    rojoRunCheckpointMessageHideTimer = setTimeout(() => {
      rojoRunCheckpointMessage.classList.remove('is-visible');
      rojoRunCheckpointMessageHideTimer = null;
    }, 2200);
  }

  // ROJO RUN — Phase 5B: guarded so a Game Over can never be re-triggered
  // (e.g. a fracture fall arriving the same frame as an already-zero
  // health) and so nothing downstream needs its own zero-health check.
  function rojoRunTriggerGameOver() {
    if (rojoRunGameOver) return;
    rojoRunGameOver = true;
    // ROJO RUN — Phase 6D: real Game Over screen (RESTART/EXIT), replacing
    // the Phase 5B graybox text stand-in. Stays visible until the player
    // acts — cleared only in resetRojoRunPlayer() (called by both the
    // Game Over screen's own RESTART and a genuine fresh run).
    if (rojoRunGameOverMessage) rojoRunGameOverMessage.classList.add('is-visible');
  }

  // ROJO RUN — RESTART goes straight back into a fresh countdown (reverted
  // 2026-07-30 from the Phase 7 "always route through character-select"
  // behavior — that existed only so a newly-unlocked ROJO Tavo had a
  // screen to be picked on; moot now that he's the only character).
  function rojoRunRestartFromGameOver() {
    if (!rojoRunGameOver) return;
    stopRojoRunLoop();
    setRojoRunState('playing');
    rojoRunArmCountdown();
  }

  function rojoRunExitFromGameOver() {
    if (!rojoRunGameOver) return;
    showHome();
  }

  // ROJO RUN — REPLAY goes straight back into a fresh countdown, same
  // reasoning/reversion as rojoRunRestartFromGameOver() above.
  function rojoRunReplayFromResults() {
    if (!rojoRunLevelComplete) return;
    stopRojoRunLoop();
    setRojoRunState('playing');
    rojoRunArmCountdown();
  }

  function rojoRunExitFromResults() {
    if (!rojoRunLevelComplete) return;
    showHome();
  }

  // ROJO RUN — Phase 6E: populates the real results screen from the
  // authoritative snapshot built in rojoRunTriggerLevelComplete() below.
  // Point values are computed here from the same fixed multipliers used
  // at each scoring site (container +50, checkpoint +250, health pickup
  // +500, clean section +500, no-damage +1500, all-containers +1000) —
  // these aren't stored per-category in rojoRunFinalResults itself (only
  // counts/booleans), so deriving them here keeps the results object
  // itself simple.
  function rojoRunPopulateResultsScreen(results) {
    const containersPoints = results.containersCollected * 50;
    const checkpointsPoints = results.checkpointsReached * 250;
    const pickupsPoints = results.healthPickupsCollected * 500;
    const sectionsPoints = results.cleanSectionsCount * 500;
    const noDamagePoints = results.noDamageRun ? 1500 : 0;
    const allContainersPoints = results.allContainersCollected ? 1000 : 0;

    if (rojoRunResultsContainersCount) rojoRunResultsContainersCount.textContent = `${results.containersCollected}/${results.containersTotal}`;
    if (rojoRunResultsContainersPoints) rojoRunResultsContainersPoints.textContent = `+${containersPoints}`;
    if (rojoRunResultsCheckpointsCount) rojoRunResultsCheckpointsCount.textContent = `${results.checkpointsReached}/${results.checkpointsTotal}`;
    if (rojoRunResultsCheckpointsPoints) rojoRunResultsCheckpointsPoints.textContent = `+${checkpointsPoints}`;
    if (rojoRunResultsPickupsCount) rojoRunResultsPickupsCount.textContent = `${results.healthPickupsCollected}/${results.healthPickupsTotal}`;
    if (rojoRunResultsPickupsPoints) rojoRunResultsPickupsPoints.textContent = `+${pickupsPoints}`;
    if (rojoRunResultsSectionsCount) rojoRunResultsSectionsCount.textContent = `${results.cleanSectionsCount}/${results.cleanSectionsTotal}`;
    if (rojoRunResultsSectionsPoints) rojoRunResultsSectionsPoints.textContent = `+${sectionsPoints}`;
    if (rojoRunResultsNoDamageCount) rojoRunResultsNoDamageCount.textContent = results.noDamageRun ? 'YES' : 'NO';
    if (rojoRunResultsNoDamagePoints) rojoRunResultsNoDamagePoints.textContent = `+${noDamagePoints}`;
    if (rojoRunResultsAllContainersCount) rojoRunResultsAllContainersCount.textContent = results.allContainersCollected ? 'YES' : 'NO';
    if (rojoRunResultsAllContainersPoints) rojoRunResultsAllContainersPoints.textContent = `+${allContainersPoints}`;
    if (rojoRunResultsTotal) rojoRunResultsTotal.textContent = results.score;

    // Secret reward trigger — shown only when this run was completed as
    // ROJO Tavo. Every qualifying run shows it again (not a one-time
    // reveal), so replaying always gives another way back to the item.
    if (rojoRunResultsSecretTrigger) rojoRunResultsSecretTrigger.hidden = results.character !== 'rojo';
  }

  // ROJO RUN — Phase 5F: guarded exactly like rojoRunTriggerGameOver above,
  // so crossing the finish line can never award its bonuses twice. Builds
  // the authoritative results snapshot, now consumed by the real Phase 6E
  // results screen via rojoRunPopulateResultsScreen() above.
  function rojoRunTriggerLevelComplete() {
    if (rojoRunLevelComplete) return;
    rojoRunLevelComplete = true;
    rojoRunScore += 2000;
    const allContainersCollected = rojoRunCollectedContainers.size === ROJO_RUN_ALL_CONTAINERS.length;
    if (allContainersCollected) {
      rojoRunScore += 1000;
    }
    const checkpointsReached = ROJO_RUN_CHECKPOINTS.filter((checkpoint) => checkpoint.worldX <= rojoRunLatestCheckpointX).length;
    const cleanSectionsCount = rojoRunSectionDamaged.filter((damaged) => !damaged).length;
    rojoRunFinalResults = {
      score: rojoRunScore,
      containersCollected: rojoRunCollectedContainers.size,
      containersTotal: ROJO_RUN_ALL_CONTAINERS.length,
      allContainersCollected,
      checkpointsReached,
      checkpointsTotal: ROJO_RUN_CHECKPOINTS.length,
      healthPickupsCollected: (rojoRunHealthPickup2Collected ? 1 : 0) + (rojoRunHealthPickup3Collected ? 1 : 0),
      healthPickupsTotal: 2,
      cleanSectionsCount,
      cleanSectionsTotal: ROJO_RUN_SECTION_BOUNDARIES.length,
      noDamageRun: rojoRunNoDamageThisRun,
      completed: true,
      // Which character finished this specific run — always 'rojo' now
      // that the game is ROJO-Tavo-only, so the secret reward reveal
      // (results.character === 'rojo') simply shows on every completion.
      character: rojoRunSelectedCharacter
    };
    rojoRunUpdateSaveOnCompletion(rojoRunFinalResults);
    rojoRunPopulateResultsScreen(rojoRunFinalResults);
    if (rojoRunLevelCompleteMessage) rojoRunLevelCompleteMessage.classList.add('is-visible');
  }

  // ROJO RUN — Phase 6D: shared damage-feedback flash, called from both
  // damage functions below regardless of whether the hit is fatal — a
  // brief red pulse across the screen. Also doubles as the checkpoint-
  // respawn presentation for a pit-fall, since that's the same instant
  // the player's position snaps back.
  function rojoRunShowDamageFlash() {
    if (!rojoRunDamageFlash) return;
    rojoRunDamageFlash.classList.remove('is-flashing');
    void rojoRunDamageFlash.offsetWidth;
    rojoRunDamageFlash.classList.add('is-flashing');
  }

  function rojoRunApplyPulseDamage() {
    rojoRunSetHealth(rojoRunPlayerHealth - 1);
    rojoRunShowDamageFlash();
    rojoRunDamageTakenThisRun += 1;
    rojoRunNoDamageThisRun = false;
    rojoRunSectionDamaged[rojoRunSectionIndexAt(rojoRunPlayerWorldDistance)] = true;
    if (rojoRunPlayerHealth <= 0) {
      // Phase 5B: zero health now stops gameplay for real instead of the
      // old free-full-heal-and-respawn. No checkpoint-respawn at zero
      // health — Game Over freezes the run in place. Pulse Zone damage
      // only ever lands while grounded (see the collision guard), so the
      // player is already standing on visible ground here — no
      // repositioning needed, unlike the pit-fall case below.
      rojoRunTriggerGameOver();
      return;
    }
    rojoRunInvincibleRemaining = ROJO_RUN_INVINCIBILITY_SECONDS;
    rojoRunHitReactionRemaining = ROJO_RUN_HIT_REACTION_SECONDS;
  }

  function rojoRunApplyPitFallDamage() {
    // The fall itself is still unconditional — ignores invincibility
    // entirely, since a physical fall is categorically different from a
    // standing hit (spec Section 5.3). What's new in Phase 5B: at zero
    // health this now triggers Game Over instead of respawning-and-healing.
    // respawnRojoRunPlayerAtCheckpoint() is still called even at zero
    // health (repositioning only, no health change) — a fatal fall leaves
    // the player below the death plane, off-screen; without this the frozen
    // Game Over scene would show an invisible player instead of one
    // standing at the checkpoint. On a non-fatal fall, this also grants
    // brief post-respawn invincibility so an unrelated nearby hazard can't
    // hit the player again in the same instant they land — genuinely
    // needed now given how dense the hazard layout got this session.
    rojoRunSetHealth(rojoRunPlayerHealth - 1);
    rojoRunShowDamageFlash();
    rojoRunDamageTakenThisRun += 1;
    rojoRunNoDamageThisRun = false;
    rojoRunSectionDamaged[rojoRunSectionIndexAt(rojoRunPlayerWorldDistance)] = true;
    respawnRojoRunPlayerAtCheckpoint();
    if (rojoRunPlayerHealth <= 0) {
      rojoRunTriggerGameOver();
      return;
    }
    rojoRunInvincibleRemaining = ROJO_RUN_INVINCIBILITY_SECONDS;
  }

  function rojoRunCheckHealthPickupCollisions() {
    if (!rojoRunHealthPickup2Collected) {
      const groundY = rojoRunGroundYAt(ROJO_RUN_HEALTH_PICKUP_2_X);
      if (groundY !== null) {
        const pickupCenterY = groundY - 12;
        const playerCenterY = rojoRunPlayerFootY - ROJO_RUN_PLAYER_HEIGHT / 2;
        const withinX = Math.abs(rojoRunPlayerWorldDistance - ROJO_RUN_HEALTH_PICKUP_2_X) < (ROJO_RUN_PLAYER_WIDTH / 2 + 12);
        const withinY = Math.abs(playerCenterY - pickupCenterY) < (ROJO_RUN_PLAYER_HEIGHT / 2 + 12);
        if (withinX && withinY) {
          rojoRunHealthPickup2Collected = true;
          rojoRunScore += 500;
          rojoRunSetHealth(rojoRunPlayerHealth + 1);
          // ROJO RUN — Phase 9: hide this pickup's DOM sprite on collection,
          // same one-time "erase once" pattern as the paint containers.
          const pickup2El = rojoRunHealthPickupElements[2];
          if (pickup2El) pickup2El.style.display = 'none';
        }
      }
    }
    // ROJO RUN — Phase 4C: Health Pickup 3, same pattern as Pickup 2 above.
    if (!rojoRunHealthPickup3Collected) {
      const groundY = rojoRunGroundYAt(ROJO_RUN_HEALTH_PICKUP_3_X);
      if (groundY !== null) {
        const pickupCenterY = groundY - 12;
        const playerCenterY = rojoRunPlayerFootY - ROJO_RUN_PLAYER_HEIGHT / 2;
        const withinX = Math.abs(rojoRunPlayerWorldDistance - ROJO_RUN_HEALTH_PICKUP_3_X) < (ROJO_RUN_PLAYER_WIDTH / 2 + 12);
        const withinY = Math.abs(playerCenterY - pickupCenterY) < (ROJO_RUN_PLAYER_HEIGHT / 2 + 12);
        if (withinX && withinY) {
          rojoRunHealthPickup3Collected = true;
          rojoRunScore += 500;
          rojoRunSetHealth(rojoRunPlayerHealth + 1);
          const pickup3El = rojoRunHealthPickupElements[3];
          if (pickup3El) pickup3El.style.display = 'none';
        }
      }
    }
  }

  // ROJO RUN — Phase 9 item 5 (2026-07-24): the graybox Signal Fracture void
  // draw (rojoRunDrawSignalFractureVoid) is removed entirely — replaced by
  // the static DOM-sprite texture art, see rojoRunBuildSignalFractureSprites()
  // below. Fall/pit collision is untouched by this — it was never driven by
  // this function, only by ROJO_RUN_LEVEL1_TERRAIN's groundY:null segments,
  // which are completely unaffected by this purely-visual change.

  // ROJO RUN — Phase 4B: ROJO Pulse Zone collision. Stateless cycle-phase
  // math — see ROJO_RUN_PULSE_ZONES' own comment for why no accumulator is
  // needed and for the owner's "mostly dangerous" balance decision. Only
  // triggers while grounded (airborne = safe, matching the spec's "must
  // have time to jump" framing) and while not already invincible (prevents
  // the active window — now well over a second under the new balance —
  // from draining multiple health crosses in a single pass-through).
  function rojoRunCheckPulseZoneCollisions() {
    if (rojoRunInvincibleRemaining > 0) return;
    if (!rojoRunPlayerGrounded) return;
    const worldTimeSeconds = rojoRunPlayerWorldDistance / ROJO_RUN_BASE_SPEED;
    ROJO_RUN_PULSE_ZONES.forEach((zone) => {
      const withinX = Math.abs(rojoRunPlayerWorldDistance - zone.worldX) < zone.halfWidth;
      if (!withinX) return;
      const cyclePos = worldTimeSeconds % zone.cycleSeconds;
      if (cyclePos >= zone.telegraphSeconds && cyclePos < zone.telegraphSeconds + zone.activeSeconds) {
        rojoRunApplyPulseDamage();
      }
    });
  }

  // ROJO RUN — Phase 9 item 6 follow-up 2 (2026-07-25): Pulse Zone rendering
  // (structure + danger glow) moved entirely off this canvas — the
  // always-visible-structure redesign made the per-frame draw run every
  // frame instead of ~40-60% of the time, reintroducing the exact shake
  // already fixed for containers/checkpoints/finish-marker. Now a static
  // DOM sprite (structure) plus a WAAPI-animated glow overlay, both built
  // once — see rojoRunBuildPulseZoneSprites()/
  // rojoRunStartPulseZoneGlowAnimations(). rojoRunCheckPulseZoneCollisions()
  // (damage) is unaffected — separate function, never touched.

  // ROJO RUN — Phase 4C: Terrain Swell rendering, extracted out of the
  // desktop-only branch of rojoRunRenderFrame and called unconditionally
  // instead. Previously this only ever ran on desktop; the mobile tile
  // compositor has no way to
  // show it (tiles are static, baked once, never redrawn — fundamentally
  // incompatible with a continuously-animated shape), so on mobile the
  // swell was invisible while its collision was still fully active
  // underneath. Drawing logic itself is unchanged from the original
  // Phase 3C implementation — same authoritative rojoRunGetSwellSurfaceY()
  // sampling, same colors, same warning-lead timing — only where it's
  // called from has changed.
  function rojoRunRenderTerrainSwell(ctx) {
    // ROJO RUN — Phase 4D: loops over every footprint instead of a single
    // start/end pair — see ROJO_RUN_SWELL_FOOTPRINTS' own comment. Each
    // footprint gets its own beginPath/fill (rather than one shared path
    // across both) so two disconnected swells never visually interfere.
    const swellSampleCount = 40;

    // ROJO RUN — bug fix (2026-07-26, owner: "id rather just get rid of the
    // terrain swells flashing appearence. i dont mind it going up and down.
    // but id rather it not flash on and off"). Previously this function also
    // computed a swellIsWarning flag (true for ~0.9s of every 2.4s cycle) and
    // painted a translucent red overlay on top whenever it was true — an
    // abrupt on/off flash with no fade. Removed entirely. The physical rise/
    // fall motion (rojoRunGetSwellTemporalAmplitude/rojoRunGetSwellSurfaceY)
    // and the separate drop-away gameplay mechanic
    // (rojoRunSwellDropTriggeredThisCycle, in rojoRunSimulationStep) are
    // untouched — that logic never depended on this color flag at all.
    //
    // Owner also asked for the swell to "match it with the terrains red
    // transition." It already did on desktop (same multiply-blend tinting
    // rojoRunGetTintedTerrainPattern() gives the main desktop terrain fill),
    // but not correctly on mobile.
    //
    // ROJO OS — bug fix, round 2 (2026-07-26, owner screenshot #1: "the
    // terrain swell is black. its suppose to blend in with the terrain but
    // it looks black"). Root cause, confirmed via code read: mobile's
    // REGULAR ground is tinted by a real CSS `filter: hue-rotate()/
    // saturate()` on the whole .rojo-run-tile-world-viewport (see
    // rojoRunApplyWorldTintFilter()) — true hue rotation, which roughly
    // preserves the original pixel's brightness. The swell can't use that
    // same CSS filter (it lives on a separate, untinted overlay canvas so
    // it can animate every frame, unlike the once-baked mobile tiles), so
    // it was instead reusing rojoRunGetTintedTerrainPattern() — a MULTIPLY
    // blend of a computed tint color onto the texture, inherently darkening
    // versus true hue rotation, reading as noticeably darker/muddier than
    // its surroundings on mobile. Desktop never showed this: its own main
    // terrain fill already uses this exact multiply-blend technique
    // (deliberately, never ctx.filter — see rojoRunGetTerrainTintColor()'s
    // own comment for the real freeze that caused that decision), so
    // desktop's swell already matched desktop's own ground.
    //
    // Round-2 fix attempt: set ctx.filter (a canvas-2D-CONTEXT property,
    // scoped per draw call) around just the swell's fill, reusing
    // rojoRunGetWorldTintFilter(). Owner screenshot #2 showed this made it
    // WORSE — the swell rendered fully untinted (plain green against an
    // already-red world), not just mismatched. ctx.filter apparently does
    // not reliably apply on this device/Safari version when the fillStyle
    // is a CanvasPattern (a known rough edge for Canvas 2D filter+pattern
    // combinations) — a real reliability gap in the technique itself, not a
    // math error.
    //
    // Round-3 fix (this one): stop relying on ctx.filter entirely. Instead,
    // reuse the one CSS-filter-on-an-ELEMENT technique already proven
    // reliable for every other tinted layer this whole session (tile
    // viewport, parallax sky/layers) — see .rojo-run-swell-canvas in
    // assets/rojo-os.css. On mobile, this function now draws the swell onto
    // that DEDICATED canvas (raw, untinted texture pattern — identical to
    // how the tiles themselves bake it) instead of the shared ctx, and lets
    // rojoRunApplyWorldTintFilter() tint the whole element via real CSS
    // filter, at the exact same call site and timing as the tile viewport —
    // guaranteed identical, not just similar. Desktop is completely
    // unchanged, still drawing on the shared ctx with the multiply-blend
    // path that already matches its own ground.
    const rojoRunSwellIsCoarsePointer = rojoRunHasCoarsePointer();
    let swellCtx = ctx;
    let swellFillStyle = '#356B30';

    if (rojoRunSwellIsCoarsePointer) {
      if (!rojoRunSwellCanvas) return;
      rojoRunSwellCanvasContext = rojoRunSwellCanvasContext || rojoRunSwellCanvas.getContext('2d');
      if (!rojoRunSwellCanvasContext) return;
      swellCtx = rojoRunSwellCanvasContext;
      // Nothing else is ever drawn on this dedicated canvas, so last
      // frame's shape (which may have been a different height) has to be
      // cleared before this frame's is drawn — the shared ctx doesn't need
      // this since rojoRunRenderFrame() already clears it wholesale.
      swellCtx.clearRect(0, 0, ROJO_RUN_VIRTUAL_WIDTH, ROJO_RUN_VIRTUAL_HEIGHT);

      if (rojoRunTerrainTextureReady) {
        try {
          const swellPattern = swellCtx.createPattern(rojoRunTerrainTextureImage, 'repeat');
          const swellScale = ROJO_RUN_TERRAIN_TEXTURE_WORLD_SIZE / rojoRunTerrainTextureImage.naturalWidth;
          const swellWorldOriginScreenX = rojoRunWorldToScreenX(0);
          swellPattern.setTransform(new DOMMatrix([swellScale, 0, 0, swellScale, swellWorldOriginScreenX, 0]));
          swellFillStyle = swellPattern;
        } catch (err) { /* fall through to the flat fallback color, still tinted by the element's own CSS filter */ }
      }
    } else {
      const swellTintColor = rojoRunGetTerrainTintColor(rojoRunWorldTintCurrentIndex);
      swellFillStyle = swellTintColor;
      if (rojoRunTerrainTextureReady) {
        try {
          const swellPattern = rojoRunGetTintedTerrainPattern(ctx, swellTintColor);
          const swellScale = ROJO_RUN_TERRAIN_TEXTURE_WORLD_SIZE / rojoRunTerrainTextureImage.naturalWidth;
          // ROJO OS — bug fix (2026-08-06): pixel-snap + render-
          // interpolated, desktop-only — same shake/gap fix as the main
          // terrain fill below. Mobile's own swellWorldOriginScreenX a few
          // lines up is left unrounded/on the raw stepped value, untouched,
          // since this branch is desktop-only.
          const swellWorldOriginScreenX = Math.round(rojoRunWorldToScreenXRender(0));
          swellPattern.setTransform(new DOMMatrix([swellScale, 0, 0, swellScale, swellWorldOriginScreenX, 0]));
          swellFillStyle = swellPattern;
        } catch (err) { /* fall through to the solid-color fallback already assigned above */ }
      }
    }

    ROJO_RUN_SWELL_FOOTPRINTS.forEach((footprint) => {
      const swellStep = (footprint.endX - footprint.startX) / swellSampleCount;

      swellCtx.fillStyle = swellFillStyle;
      swellCtx.beginPath();
      for (let i = 0; i <= swellSampleCount; i++) {
        const worldX = footprint.startX + swellStep * i;
        const surfaceY = rojoRunGetSwellSurfaceY(worldX, rojoRunSwellElapsedSeconds);
        // ROJO OS — bug fix (2026-08-06): pixel-snapped + render-
        // interpolated, same shake/gap fix as the main terrain fill. This
        // loop is shared by both mobile and desktop swellCtx — using the
        // render-interpolated value is harmless on mobile too (its own
        // rojoRunPlayerWorldDistance is already continuous, so the two
        // values converge to essentially the same thing there).
        const screenX = Math.round(rojoRunWorldToScreenXRender(worldX));
        if (i === 0) swellCtx.moveTo(screenX, surfaceY); else swellCtx.lineTo(screenX, surfaceY);
      }
      swellCtx.lineTo(Math.round(rojoRunWorldToScreenXRender(footprint.endX)), ROJO_RUN_VIRTUAL_HEIGHT);
      swellCtx.lineTo(Math.round(rojoRunWorldToScreenXRender(footprint.startX)), ROJO_RUN_VIRTUAL_HEIGHT);
      swellCtx.closePath();
      swellCtx.fill();
    });
  }

  // ROJO RUN — Phase 3C: graybox Terrain Swell. A single authoritative
  // spatial/temporal surface function shared by collision and rendering — the
  // swell reconnects continuously to ROJO_RUN_GROUND_Y at both footprint
  // edges at every point in its cycle (spatialProfile is exactly 0 there),
  // and the rise/drop/wrap cycle is continuous (both sides of every boundary
  // evaluate to the same amplitude). Outside the footprint, falls back to the
  // existing static terrain lookup unchanged.
  function rojoRunGetSwellTemporalAmplitude(elapsedSeconds) {
    const cyclePosition = elapsedSeconds % ROJO_RUN_SWELL_CYCLE_SECONDS;
    if (cyclePosition < ROJO_RUN_SWELL_TELEGRAPH_SECONDS) {
      const progress = cyclePosition / ROJO_RUN_SWELL_TELEGRAPH_SECONDS;
      const eased = progress * progress * (3 - 2 * progress);
      return ROJO_RUN_SWELL_RISE_HEIGHT * eased;
    }
    const dropDuration = ROJO_RUN_SWELL_CYCLE_SECONDS - ROJO_RUN_SWELL_TELEGRAPH_SECONDS;
    const dropProgress = (cyclePosition - ROJO_RUN_SWELL_TELEGRAPH_SECONDS) / dropDuration;
    const eased = dropProgress * dropProgress * (3 - 2 * dropProgress);
    return ROJO_RUN_SWELL_RISE_HEIGHT * (1 - eased);
  }

  function rojoRunGetSwellSurfaceY(worldX, elapsedSeconds) {
    const footprint = ROJO_RUN_SWELL_FOOTPRINTS.find((f) => worldX >= f.startX && worldX < f.endX);
    if (!footprint) {
      return rojoRunGroundYAt(worldX);
    }
    const u = (worldX - footprint.startX) / (footprint.endX - footprint.startX);
    const spatialProfile = Math.sin(Math.PI * u) ** 2;
    return ROJO_RUN_GROUND_Y - spatialProfile * rojoRunGetSwellTemporalAmplitude(elapsedSeconds);
  }

  // ROJO RUN — Phase 4A iOS fix, canvas-tile compositor: exact linear
  // interpolation of a slope segment's ground Y at an arbitrary world-X
  // within its span — used to compute the correct polygon Y values at a
  // tile boundary, which will generally fall inside the segment rather than
  // at its authored start/end. Identical math to rojoRunGroundYAt's own
  // slope branch, just callable at an arbitrary point instead of only the
  // player's current position.
  function rojoRunTileSlopeYAt(segment, worldX) {
    const progress = (worldX - segment.startX) / (segment.endX - segment.startX);
    return segment.slopeFrom + (segment.slopeTo - segment.slopeFrom) * progress;
  }

  // ROJO RUN — Phase 4A iOS fix, canvas-tile compositor: builds 16 fixed
  // 2048x1080 <canvas> tiles covering world-X -2048 to 30720, and draws
  // terrain/containers/checkpoint/milestone/health marker onto each tile's
  // own 2D context exactly once, using the same authoritative arrays and
  // drawing technique the desktop canvas path already uses. Never redrawn
  // after this — only moved via per-tile CSS transforms. No authoritative
  // world coordinate is altered anywhere in this function — only the
  // tile-local `x`/`y` passed to each draw call differs from the world
  // coordinate by a per-tile constant offset (tileStartX).
  function rojoRunBuildTileWorld() {
    if (rojoRunTilesBuilt || !rojoRunTileWorldScaler) return;

    const fragment = document.createDocumentFragment();
    rojoRunTileCanvasElements = [];

    for (let i = 0; i < ROJO_RUN_TILE_COUNT; i++) {
      const tileStartX = ROJO_RUN_TILE_WORLD_MIN_X + i * ROJO_RUN_TILE_LOGICAL_WIDTH;
      const tileEndX = tileStartX + ROJO_RUN_TILE_LOGICAL_WIDTH;

      const tileCanvas = document.createElement('canvas');
      tileCanvas.className = 'rojo-run-world-terrain-tile';
      // ROJO RUN — Phase 4A iOS fix, memory-safety correction: backing store
      // is a quarter the pixel count of the tile's CSS/world-space footprint
      // (set in .rojo-run-world-terrain-tile). ctx.setTransform(0.5, ...)
      // below means every draw call in this loop still uses the original
      // logical 2048x1080 coordinates unmodified — nothing past this point
      // was rewritten to "manually" halve a coordinate.
      tileCanvas.width = ROJO_RUN_TILE_BACKING_WIDTH;
      tileCanvas.height = ROJO_RUN_TILE_BACKING_HEIGHT;
      const ctx = tileCanvas.getContext('2d', { alpha: true, desynchronized: true });
      ctx.setTransform(0.5, 0, 0, 0.5, 0, 0);
      ctx.imageSmoothingEnabled = false;
      ctx.clearRect(0, 0, ROJO_RUN_TILE_LOGICAL_WIDTH, ROJO_RUN_TILE_LOGICAL_HEIGHT);

      // ROJO RUN — Environmental Art Phase B (2026-07-26): built once per
      // tile (not per segment — every segment in this tile shares the same
      // fill). Mobile's world-tint CSS filter (on .rojo-run-tile-world-
      // viewport) already tints whatever's baked here for free, exactly as
      // it already did for the flat color — no per-frame/per-tint work
      // needed on this platform at all. The pattern's transform anchors it
      // to tileStartX (this tile's own world-X origin) so the texture
      // reads continuously across all 71 tiles instead of restarting at
      // each tile boundary — same "seam" class of problem already solved
      // for the mountains this session, solved here at the source instead.
      let terrainFillStyle = '#356B30';
      if (rojoRunTerrainTextureReady) {
        try {
          const terrainPattern = ctx.createPattern(rojoRunTerrainTextureImage, 'repeat');
          const scale = ROJO_RUN_TERRAIN_TEXTURE_WORLD_SIZE / rojoRunTerrainTextureImage.naturalWidth;
          terrainPattern.setTransform(new DOMMatrix([scale, 0, 0, scale, -tileStartX, 0]));
          terrainFillStyle = terrainPattern;
        } catch (err) { /* fall through to the solid-color fallback below */ }
      }

      ROJO_RUN_LEVEL1_TERRAIN.forEach((segment, index) => {
        // The first terrain segment still extends 2000px to the left of
        // world-X 0 so ground exists behind the player at the start of a
        // fresh run — the only deviation from the segment's own authored
        // startX/endX anywhere in this function.
        const isFirst = index === 0;
        const segmentStartX = isFirst ? segment.startX - 2000 : segment.startX;
        const segmentEndX = segment.endX;

        const overlapStart = Math.max(segmentStartX, tileStartX);
        const overlapEnd = Math.min(segmentEndX, tileEndX);
        if (overlapEnd <= overlapStart) return;

        const localStartX = overlapStart - tileStartX;
        const localEndX = overlapEnd - tileStartX;

        // ROJO RUN — Phase 9 item 5 (2026-07-24): pit segments (Signal
        // Fractures) are skipped here entirely now — the texture art is a
        // static DOM sprite on the untinted shared track instead (see
        // rojoRunBuildSignalFractureSprites()), same reasoning as every
        // other Phase 9 art item: no per-frame redraw/lookup, no risk of
        // inheriting this tile canvas's mobile world-tint filter.
        if (segment.groundY === null && !segment.isSlope) {
          return;
        }

        ctx.fillStyle = terrainFillStyle;

        if (segment.isSlope) {
          const startY = rojoRunTileSlopeYAt(segment, overlapStart);
          const endY = rojoRunTileSlopeYAt(segment, overlapEnd);
          ctx.beginPath();
          ctx.moveTo(localStartX, startY);
          ctx.lineTo(localEndX, endY);
          ctx.lineTo(localEndX, ROJO_RUN_TILE_LOGICAL_HEIGHT);
          ctx.lineTo(localStartX, ROJO_RUN_TILE_LOGICAL_HEIGHT);
          ctx.closePath();
          ctx.fill();
        } else {
          ctx.fillRect(localStartX, segment.groundY, localEndX - localStartX, ROJO_RUN_TILE_LOGICAL_HEIGHT - segment.groundY);
        }
      });

      // ROJO RUN — Phase 9 (2026-07-23): containers are no longer baked onto
      // this tile canvas — this canvas is wrapped by the world-tint filter
      // (rojoRunTileWorldViewport), which containers must NOT inherit. They
      // are now drawn live every frame on the untinted overlay canvas
      // instead — see rojoRunRenderFrame's unconditional section, same
      // pattern already proven for Pulse Zones.

      // ROJO OS — bug fix (2026-08-06, owner: thin bright vertical lines
      // visible in gameplay near checkpoint/section areas). This was a
      // Phase 4D graybox milestone marker — a 4px-wide #FFEDE7 stripe baked
      // onto the tile at each of the 4 milestone world-X positions
      // (25/50/75/100% progress), left over from early prototyping and
      // never replaced with real milestone art. Removed as pure visual
      // dead weight: milestone detection (rojoRunMilestone25Reached etc.,
      // which drives the actual world green->red transformation) reads
      // rojoRunPlayerWorldDistance directly and never depended on this
      // stripe being drawn — completely unaffected by its removal.

      // ROJO RUN — Phase 9: health pickups no longer baked onto this tile
      // canvas — they're DOM <img> sprites now (see
      // rojoRunBuildHealthPickupSprites()), same reasoning as the paint
      // containers before them.

      // ROJO OS — bug fix (2026-08-06, owner: thin vertical checkpoint/
      // section boundary lines visible during gameplay on both platforms).
      // Same graybox checkpoint-boundary stripe as the matching fix in
      // rojoRunRenderFrame (desktop) — a #274F29 line at each checkpoint's
      // world-X, predating the real pillar artwork and never cleaned up.
      // Removed; checkpoint trigger/respawn/scoring is untouched and
      // unaffected (reads ROJO_RUN_CHECKPOINTS/rojoRunPlayerWorldDistance
      // directly, never this stripe).

      // ROJO RUN — Phase 4D: white TDOM finish marker — position-only, same
      // inert treatment as every checkpoint/milestone so far. No completion
      // logic triggers off this; that's explicitly later-phase scope.
      if (ROJO_RUN_FINISH_X >= tileStartX && ROJO_RUN_FINISH_X < tileEndX) {
        const localX = ROJO_RUN_FINISH_X - tileStartX;
        ctx.fillStyle = '#F5F2EC';
        ctx.fillRect(localX - 3, 0, 6, ROJO_RUN_TILE_LOGICAL_HEIGHT);
      }

      fragment.appendChild(tileCanvas);
      rojoRunTileCanvasElements.push(tileCanvas);
    }

    rojoRunTileWorldScaler.appendChild(fragment);
    rojoRunTilesBuilt = true;
  }

  // ROJO RUN — Phase 9 round 9 (2026-07-23): paint containers built exactly
  // once, ever — unlike the tile canvases above, these are plain <img>
  // elements with static position/size, so a genuine fresh run/replay only
  // needs to re-show them (see resetRojoRunPlayer()), never rebuild them.
  // groundY/heightAboveGround are computed here, once, since terrain never
  // changes shape at runtime — no per-frame recomputation needed at all.
  function rojoRunBuildContainerLayer() {
    if (rojoRunContainerLayerBuilt || !rojoRunContainerTrack) return;

    const fragment = document.createDocumentFragment();
    const containerSrc = rojoRunShell?.dataset.rojoRunContainerSrc || '';

    ROJO_RUN_ALL_CONTAINERS.forEach((container) => {
      const groundY = rojoRunGroundYAt(container.worldX);
      if (groundY === null) return;
      const centerY = groundY - container.heightAboveGround - ROJO_RUN_CONTAINER_RADIUS;

      const img = document.createElement('img');
      img.className = 'rojo-run-container-sprite';
      img.src = containerSrc;
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      img.style.left = `${container.worldX - ROJO_RUN_CONTAINER_VISUAL_SIZE / 2}px`;
      img.style.top = `${centerY - ROJO_RUN_CONTAINER_VISUAL_SIZE / 2}px`;
      img.style.width = `${ROJO_RUN_CONTAINER_VISUAL_SIZE}px`;
      img.style.height = `${ROJO_RUN_CONTAINER_VISUAL_SIZE}px`;

      fragment.appendChild(img);
      rojoRunContainerElements[container.id] = img;
    });

    rojoRunContainerTrack.replaceChildren(fragment);
    rojoRunContainerLayerBuilt = true;
  }

  // ROJO RUN — Phase 9 (2026-07-23): health pickups, same technique as
  // rojoRunBuildContainerLayer() immediately above — static position
  // computed once, appended to the SAME rojoRunContainerTrack (already
  // correctly scrolling in lockstep with the world on both platforms, no
  // separate track/animation needed for just 2 items). Visual size (48) is
  // intentionally larger than the locked 24x24 collision footprint —
  // matching the readability lesson already learned from the paint
  // container, which also needed a visual size well beyond its raw
  // collision box. Collision detection (rojoRunCheckHealthPickupCollisions)
  // is untouched, still keyed to the original 24-unit box.
  const ROJO_RUN_HEALTH_PICKUP_VISUAL_SIZE = 125;
  let rojoRunHealthPickupSpritesBuilt = false;
  function rojoRunBuildHealthPickupSprites() {
    if (rojoRunHealthPickupSpritesBuilt || !rojoRunContainerTrack) return;

    const healthPickupSrc = rojoRunShell?.dataset.rojoRunHealthPickupSrc || '';
    const fragment = document.createDocumentFragment();

    [
      { id: 2, worldX: ROJO_RUN_HEALTH_PICKUP_2_X },
      { id: 3, worldX: ROJO_RUN_HEALTH_PICKUP_3_X }
    ].forEach((pickup) => {
      const groundY = rojoRunGroundYAt(pickup.worldX);
      if (groundY === null) return;

      const img = document.createElement('img');
      img.className = 'rojo-run-health-pickup-sprite';
      img.src = healthPickupSrc;
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      img.style.left = `${pickup.worldX - ROJO_RUN_HEALTH_PICKUP_VISUAL_SIZE / 2}px`;
      img.style.top = `${groundY - ROJO_RUN_HEALTH_PICKUP_VISUAL_SIZE}px`;
      img.style.width = `${ROJO_RUN_HEALTH_PICKUP_VISUAL_SIZE}px`;
      img.style.height = `${ROJO_RUN_HEALTH_PICKUP_VISUAL_SIZE}px`;

      fragment.appendChild(img);
      rojoRunHealthPickupElements[pickup.id] = img;
    });

    rojoRunContainerTrack.appendChild(fragment);
    rojoRunHealthPickupSpritesBuilt = true;
  }

  // ROJO RUN — Phase 9 item 3 round 2 (2026-07-24): checkpoint pillars,
  // same technique as rojoRunBuildHealthPickupSprites() immediately above —
  // static position computed once, appended to rojoRunWorldObjectTrack
  // (moved off the shared container track 2026-08-06 so it stays behind
  // Tavo — see that fix's comment near rojoRunWorldObjectTrack's declaration).
  // Replaces the round-1 "lightweight canvas sprite" approach, which still
  // redrew via ctx.drawImage() + a rojoRunGroundYAt() lookup every frame —
  // the same category of per-frame cost already root-caused and fixed for
  // containers (round 9 of that investigation), just at a smaller scale (3
  // items, not 80). ROJO_RUN_CHECKPOINTS' worldX (the gameplay-authoritative
  // trigger/respawn position) and the existing stripe are both untouched.
  let rojoRunCheckpointPillarSpritesBuilt = false;
  function rojoRunBuildCheckpointPillarSprites() {
    if (rojoRunCheckpointPillarSpritesBuilt || !rojoRunWorldObjectTrack) return;

    const pillarSrc = rojoRunShell?.dataset.rojoRunCheckpointPillarSrc || '';
    const fragment = document.createDocumentFragment();

    ROJO_RUN_CHECKPOINTS.forEach((checkpoint) => {
      const groundY = rojoRunGroundYAt(checkpoint.worldX);
      if (groundY === null) return;
      const top = groundY
        - ROJO_RUN_CHECKPOINT_PILLAR_CONTENT_BOTTOM_FRACTION * ROJO_RUN_CHECKPOINT_PILLAR_DRAW_HEIGHT
        + ROJO_RUN_CHECKPOINT_PILLAR_GROUND_EMBED;

      const img = document.createElement('img');
      img.className = 'rojo-run-checkpoint-pillar-sprite';
      img.src = pillarSrc;
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      img.style.left = `${checkpoint.worldX - ROJO_RUN_CHECKPOINT_PILLAR_DRAW_WIDTH / 2}px`;
      img.style.top = `${top}px`;
      img.style.width = `${ROJO_RUN_CHECKPOINT_PILLAR_DRAW_WIDTH}px`;
      img.style.height = `${ROJO_RUN_CHECKPOINT_PILLAR_DRAW_HEIGHT}px`;

      fragment.appendChild(img);
    });

    rojoRunWorldObjectTrack.appendChild(fragment);
    rojoRunCheckpointPillarSpritesBuilt = true;
  }

  // ROJO RUN — Phase 9 item 4 (2026-07-24): finish gateway, same technique
  // as rojoRunBuildCheckpointPillarSprites() immediately above — static
  // position computed once, appended to rojoRunWorldObjectTrack (see that
  // function's 2026-08-06 comment for why it's not the shared container track).
  // Built with this architecture from the start (unlike the checkpoint
  // pillar, which needed a round 2 to get here) — only one sprite needed,
  // since there's exactly one finish line. ROJO_RUN_FINISH_X (the gameplay-
  // authoritative finish-line trigger) and the existing stripe are untouched.
  let rojoRunFinishMarkerSpriteBuilt = false;
  function rojoRunBuildFinishMarkerSprite() {
    if (rojoRunFinishMarkerSpriteBuilt || !rojoRunWorldObjectTrack) return;

    const groundY = rojoRunGroundYAt(ROJO_RUN_FINISH_X);
    if (groundY === null) return;
    const top = groundY
      - ROJO_RUN_FINISH_MARKER_CONTENT_BOTTOM_FRACTION * ROJO_RUN_FINISH_MARKER_DRAW_HEIGHT
      + ROJO_RUN_FINISH_MARKER_GROUND_EMBED;

    const img = document.createElement('img');
    img.className = 'rojo-run-finish-marker-sprite';
    img.src = rojoRunShell?.dataset.rojoRunFinishMarkerSrc || '';
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    img.style.left = `${ROJO_RUN_FINISH_X - ROJO_RUN_FINISH_MARKER_DRAW_WIDTH / 2}px`;
    img.style.top = `${top}px`;
    img.style.width = `${ROJO_RUN_FINISH_MARKER_DRAW_WIDTH}px`;
    img.style.height = `${ROJO_RUN_FINISH_MARKER_DRAW_HEIGHT}px`;

    rojoRunWorldObjectTrack.appendChild(img);
    rojoRunFinishMarkerSpriteBuilt = true;
  }

  // ROJO RUN — Phase 9 item 5 (2026-07-24): Signal Fracture texture art,
  // same DOM-sprite-on-the-shared-track architecture as every other Phase 9
  // art item — built this way from the start (no per-frame canvas redraw,
  // no risk of inheriting the mobile tile canvas's world-tint filter).
  // Unlike ground-standing sprites (containers, pickups, checkpoint pillar,
  // finish gateway), a fracture is a full-height void, not ground-anchored —
  // top is always 0, height is always the full arena height, no
  // rojoRunGroundYAt() lookup needed (a fracture's whole definition is
  // "groundY === null" — there is no ground Y to look up here). Reuses
  // ROJO_RUN_LEVEL1_TERRAIN directly as the source of truth for fracture
  // positions/widths (the exact same filter the removed canvas-draw call
  // sites used) rather than duplicating that data into a new array. Each
  // fracture is stretched independently to its own segment's exact width —
  // widths vary 225-425 units across the 33 fractures on the course, and
  // the source art has a single continuous top-glow arc (not a small
  // repeatable tile), so per-fracture stretching keeps that arc intact
  // rather than tiling it into multiple repeated arcs. Pit/fall collision
  // is untouched — driven entirely by ROJO_RUN_LEVEL1_TERRAIN's groundY:null
  // segments, never by this purely-visual layer.
  let rojoRunSignalFractureSpritesBuilt = false;
  function rojoRunBuildSignalFractureSprites() {
    if (rojoRunSignalFractureSpritesBuilt || !rojoRunWorldObjectTrack) return;

    const fractureSrc = rojoRunShell?.dataset.rojoRunFractureTextureSrc || '';
    const fragment = document.createDocumentFragment();

    ROJO_RUN_LEVEL1_TERRAIN.forEach((segment) => {
      if (segment.groundY !== null || segment.isSlope) return;
      const width = segment.endX - segment.startX;
      if (width <= 0) return;

      // ROJO RUN — Phase 9 item 5 follow-up round 2 (2026-07-24): wrapper +
      // 2 children, replacing the single-<img> approach. Owner reported the
      // round-1 whole-sprite opacity flicker made the (fully opaque) art
      // look translucent, faintly revealing the background — any opacity
      // under 1.0 is inherently see-through, no amount of range-tuning
      // fixes that. Owner's actual ask: only the middle crack should glow/
      // pulse red, nothing should ever look transparent. Fix: the texture
      // <img> stays permanently opaque (never animated); a separate glow
      // div is layered on top, confined near the horizontal center via its
      // own gradient, with ONLY the glow div's opacity animating — since
      // it's pure additive light on top of already-solid art, it can never
      // expose anything behind the sprite.
      const wrap = document.createElement('div');
      wrap.className = 'rojo-run-signal-fracture-sprite';
      wrap.style.left = `${segment.startX}px`;
      wrap.style.top = '0px';
      wrap.style.width = `${width}px`;
      wrap.style.height = `${ROJO_RUN_VIRTUAL_HEIGHT}px`;

      const img = document.createElement('img');
      img.className = 'rojo-run-signal-fracture-texture';
      img.src = fractureSrc;
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');

      const glow = document.createElement('div');
      glow.className = 'rojo-run-signal-fracture-glow';
      glow.setAttribute('aria-hidden', 'true');
      // Randomized negative animation-delay, set once here (never per
      // frame), so the 33 fractures' glow pulses don't all sync visibly.
      glow.style.animationDelay = `-${(Math.random() * 2.4).toFixed(2)}s`;
      // ROJO RUN — Dawn base.css has `div:empty { display:none; }`, which
      // already silently broke the Phase 8B parallax layers once (an empty
      // div with only a CSS background is still ":empty" — background
      // doesn't count as content). This glow div has no children of its
      // own, so it needs the same inert-span workaround already proven
      // there: a zero-footprint child is enough to make it no longer match
      // :empty, with no visual effect of its own.
      const glowInert = document.createElement('span');
      glowInert.setAttribute('aria-hidden', 'true');
      glow.appendChild(glowInert);

      wrap.appendChild(img);
      wrap.appendChild(glow);
      fragment.appendChild(wrap);
    });

    rojoRunWorldObjectTrack.appendChild(fragment);
    rojoRunSignalFractureSpritesBuilt = true;
  }

  // ROJO RUN — Phase 9 item 6 follow-up 2 (2026-07-25): Pulse Zone
  // structure, same DOM-sprite-on-the-shared-track technique as everything
  // above — static position computed once via rojoRunGroundYAt() (never per
  // frame). Unlike the other items, each sprite also gets a second child
  // (the glow overlay, see rojoRunStartPulseZoneGlowAnimations()) whose
  // opacity is WAAPI-animated to carry the actual danger-cycle signal —
  // that part is inherently time-varying and can't be baked into a static
  // value, but "time-varying" no longer means "per-frame JS/canvas cost"
  // once it's a WAAPI animation the browser's own compositor drives.
  const rojoRunPulseZoneGlowElements = [];
  let rojoRunPulseZoneSpritesBuilt = false;
  function rojoRunBuildPulseZoneSprites() {
    if (rojoRunPulseZoneSpritesBuilt || !rojoRunWorldObjectTrack) return;

    const pulseZoneSrc = rojoRunShell?.dataset.rojoRunPulseZoneSrc || '';
    const fragment = document.createDocumentFragment();

    ROJO_RUN_PULSE_ZONES.forEach((zone) => {
      const groundY = rojoRunGroundYAt(zone.worldX);
      if (groundY === null) return;
      const zoneVisualHeight = 120;
      const width = zone.halfWidth * 2;

      const wrap = document.createElement('div');
      wrap.className = 'rojo-run-pulse-zone-sprite';
      wrap.style.left = `${zone.worldX - zone.halfWidth}px`;
      wrap.style.top = `${groundY - zoneVisualHeight}px`;
      wrap.style.width = `${width}px`;
      wrap.style.height = `${zoneVisualHeight}px`;

      const img = document.createElement('img');
      img.className = 'rojo-run-pulse-zone-texture';
      img.src = pulseZoneSrc;
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');

      const glow = document.createElement('div');
      glow.className = 'rojo-run-pulse-zone-glow';
      glow.setAttribute('aria-hidden', 'true');
      // ROJO RUN — same Dawn `div:empty { display:none; }` trap already hit
      // twice this phase (parallax, Signal Fracture glow) — inert span so
      // this glow div is never silently hidden.
      const glowInert = document.createElement('span');
      glowInert.setAttribute('aria-hidden', 'true');
      glow.appendChild(glowInert);

      wrap.appendChild(img);
      wrap.appendChild(glow);
      fragment.appendChild(wrap);
      rojoRunPulseZoneGlowElements.push(glow);
    });

    rojoRunWorldObjectTrack.appendChild(fragment);
    rojoRunPulseZoneSpritesBuilt = true;
  }

  // ROJO RUN — Phase 9 item 6 follow-up 2 (2026-07-25): the Pulse Zone
  // danger-cycle glow, expressed as one WAAPI animation per zone instead of
  // per-frame JS/canvas math. worldTimeSeconds (= world distance / speed)
  // is mathematically just elapsed simulation seconds — the same quantity
  // a WAAPI animation's own currentTime represents while playing — so as
  // long as this animation is phase-aligned here and paused/resumed in
  // lockstep with the sim loop (see pauseRojoRunLoop()/resumeRojoRunLoop()),
  // the visual glow can never drift out of sync with the real danger window
  // rojoRunCheckPulseZoneCollisions() uses for actual damage. Duration
  // (cycleSeconds) is independent of ROJO_RUN_BASE_SPEED — unlike the
  // container/parallax tracks, this never needs cancel+recreate for a
  // character speed change, only a re-seek.
  let rojoRunPulseZoneGlowAnimations = [];
  function rojoRunStartPulseZoneGlowAnimations(targetWorldX) {
    if (!rojoRunPulseZoneGlowElements.length) return;
    const targetWorldTimeSeconds = targetWorldX / ROJO_RUN_BASE_SPEED;
    ROJO_RUN_PULSE_ZONES.forEach((zone, index) => {
      const glowEl = rojoRunPulseZoneGlowElements[index];
      if (!glowEl) return;
      const phaseMs = (targetWorldTimeSeconds % zone.cycleSeconds) * 1000;
      let anim = rojoRunPulseZoneGlowAnimations[index];
      if (!anim) {
        const telegraphFrac = zone.telegraphSeconds / zone.cycleSeconds;
        const activeEndFrac = (zone.telegraphSeconds + zone.activeSeconds) / zone.cycleSeconds;
        // Same original ramp values (0.30 -> 0.65 telegraph, 0.85 active,
        // back to 0.30 idle) — duplicate offsets create the instant jump/
        // drop at the telegraph->active and active->idle boundaries.
        anim = glowEl.animate([
          { offset: 0, opacity: 0.30 },
          { offset: telegraphFrac, opacity: 0.65 },
          { offset: telegraphFrac, opacity: 0.85 },
          { offset: activeEndFrac, opacity: 0.85 },
          { offset: activeEndFrac, opacity: 0.30 },
          { offset: 1, opacity: 0.30 }
        ], { duration: zone.cycleSeconds * 1000, iterations: Infinity, easing: 'linear' });
        rojoRunPulseZoneGlowAnimations[index] = anim;
      }
      anim.currentTime = phaseMs;
    });
  }

  // ROJO RUN — Phase 4A iOS fix, canvas-tile compositor: static verification
  // that this transform reproduces rojoRunWorldToScreenX() exactly, and
  // continuously (not only at t=0) — identical proof shape to the earlier
  // single-track/chunked-DOM attempts, now applied to a canvas tile.
  //
  //   Canonical canvas formula:
  //     screenX(worldX) = PROBE_SCREEN_X + (worldX - rojoRunPlayerWorldDistance(t))
  //
  //   Per-tile formula (a tile pixel's own screen position is its fixed
  //   CSS `left:0` plus its own tile-local X, plus the tile's current
  //   translateX — and a pixel drawn at tile-local X corresponds to
  //   worldX = tileStartX + localX):
  //     screenX(worldX) = 0 + localX + tileTranslateX(t)
  //   where this function sets, per tile:
  //     tileTranslateX(t) = tileStartX + PROBE_SCREEN_X - rojoRunPlayerWorldDistance(t)
  //
  //   Substituting (worldX = tileStartX + localX, so localX = worldX - tileStartX):
  //     screenX(worldX) = (worldX - tileStartX) + tileStartX + PROBE_SCREEN_X - rojoRunPlayerWorldDistance(t)
  //                      = PROBE_SCREEN_X + (worldX - rojoRunPlayerWorldDistance(t))
  //   ...identical to the canonical formula, for every t, for every tile —
  //   the tileStartX terms cancel, so all 16 tiles move at the identical
  //   rate over the identical duration, just spatially offset by their own
  //   tileStartX (baked into their own pre-rendered pixel content instead
  //   of into a `left` CSS value this time).
  //
  //   Static check at worldX === rojoRunPlayerWorldDistance: screenX =
  //   PROBE_SCREEN_X + (worldX - worldX) = PROBE_SCREEN_X exactly.
  function rojoRunStartTileAnimations(startWorldX) {
    if (!rojoRunHasCoarsePointer() || rojoRunTileCanvasElements.length === 0) return;

    // ROJO RUN — crash-bug fix (2026-07-31): mirrors the exact fix already
    // proven for rojoRunStartParallaxAnimations() and
    // rojoRunStartContainerLayerAnimation() above. This function used to
    // unconditionally cancel() all ROJO_RUN_TILE_COUNT (71) tile animations
    // and rebuild every one from scratch on every call — and it's called on
    // every reset path, including checkpoint respawn, which fires whenever
    // the player takes fatal damage. Cancelling and recreating 71 WAAPI
    // animations in quick succession, repeated across several deaths in a
    // row, is real, heavy compositor churn that iOS Safari can respond to
    // with a memory-pressure page reload — matching the owner's report
    // exactly (crash only on iPhone, only during ROJO RUN, a full clean
    // playthrough didn't crash but deliberately dying several times did).
    //
    // Fix: build each tile's keyframes once, spanning the FULL world range
    // (world position 0 -> ROJO_RUN_TILE_WORLD_MAX_X) instead of from this
    // call's own startWorldX. Seeking a full-range animation to the
    // proportional point for any startWorldX produces the exact same
    // instantaneous translateX AND the exact same remaining time-to-finish
    // as rebuilding fresh keyframes anchored at that startWorldX (verified
    // algebraically — both the position and playback-rate math are
    // identical, not just visually close). Only cancel+recreate when the
    // configured duration would actually need to change (ROJO_RUN_BASE_SPEED
    // genuinely differs, e.g. a real new run) — a checkpoint respawn never
    // changes speed mid-run, so every already-playing tile animation is
    // simply re-seeked instead, with no gap where its effect is removed.
    const fullDurationMs = (ROJO_RUN_TILE_WORLD_MAX_X / ROJO_RUN_BASE_SPEED) * 1000;
    const canReuseExisting =
      rojoRunTileAnimations.length === rojoRunTileCanvasElements.length &&
      rojoRunTileAnimations.every((anim) => anim && anim.effect.getTiming().duration === fullDurationMs);

    if (canReuseExisting) {
      rojoRunTileAnimations.forEach((anim) => {
        anim.currentTime = (startWorldX / ROJO_RUN_TILE_WORLD_MAX_X) * fullDurationMs;
      });
      return;
    }

    rojoRunTileAnimations.forEach((anim) => { if (anim) anim.cancel(); });

    rojoRunTileAnimations = rojoRunTileCanvasElements.map((tileCanvas, i) => {
      const tileStartX = ROJO_RUN_TILE_WORLD_MIN_X + i * ROJO_RUN_TILE_LOGICAL_WIDTH;

      const startTranslateX =
        tileStartX +
        ROJO_RUN_PLAYER_PROBE_SCREEN_X -
        0;

      const endTranslateX =
        tileStartX +
        ROJO_RUN_PLAYER_PROBE_SCREEN_X -
        ROJO_RUN_TILE_WORLD_MAX_X;

      const animation = tileCanvas.animate(
        [
          { transform: `translate3d(${startTranslateX}px, 0, 0)` },
          { transform: `translate3d(${endTranslateX}px, 0, 0)` }
        ],
        {
          duration: fullDurationMs,
          easing: 'linear',
          fill: 'forwards'
        }
      );
      animation.pause();
      animation.currentTime = (startWorldX / ROJO_RUN_TILE_WORLD_MAX_X) * fullDurationMs;
      return animation;
    });

    window.requestAnimationFrame(() => {
      rojoRunTileAnimations.forEach((anim) => { if (anim) anim.play(); });
    });
  }

  // ROJO RUN — Phase 8B bug fix (2026-07-23, round 5): bakes each parallax
  // canvas's pixels exactly once, using ordinary ctx.beginPath/lineTo/fill
  // calls — the identical drawing technique already proven stable for the
  // Phase 4A terrain tiles (see rojoRunBuildTileWorld). Replaces 4 earlier
  // DOM/CSS-only rendering attempts (repeating background, discrete
  // non-repeating divs, CSS clip-path) that all still flickered on real
  // device. Static placeholder art, unrelated to any game state, so this
  // runs exactly once at script setup — never rebuilt per run, unlike the
  // terrain tiles (which must rebuild because collected containers change).
  const ROJO_RUN_PARALLAX_SHAPES = {
    // ROJO RUN — bug fix (2026-07-23): recolored from #445A3D (a near-gray
    // desaturated green) to a genuinely saturated green. hue-rotate can
    // only visibly shift colors that HAVE real saturation — on a
    // near-neutral/gray color it produces almost no visible change
    // regardless of angle, which is why mountains stayed muted brownish-
    // gray instead of turning red alongside everything else. Depth
    // ordering (darker than hills) is preserved via lower lightness, not
    // lower saturation.
    mountains: {
      fill: '#2C5424',
      points: [[0, 55], [50, 29], [100, 51], [150, 20], [200, 46], [250, 24], [300, 53], [350, 33], [400, 55], [400, 200], [0, 200]]
    },
    // ROJO RUN — round 4 (2026-07-25): removed entirely, same technique
    // already proven for clouds (empty points array -> beginPath/forEach-
    // over-nothing/closePath/fill all become safe no-ops, nothing drawn).
    // Owner: "i think i just want to get rid of the other hill thats just
    // a plane green form with no texture" — now that mountains has real
    // illustrated art and is positioned lower (round 4's 35% vertical
    // offset), the flat untextured procedural hills shape sitting right
    // next to it read as an obvious mismatched placeholder. Fully
    // reversible: restore the points array (see git history/this plan
    // file's prior round-3 entry) to bring hills back later if wanted.
    hills: {
      fill: '#2E6329',
      points: []
    },
    // ROJO RUN — bug fix (2026-07-23): shifted down 18 units from the
    // original 140-175 range. ROJO_RUN_GROUND_Y is 70% of the virtual
    // canvas height — the same 70% mark this shape's tallest points (140,
    // i.e. exactly 70% of 200) used to reach. On ordinary flat terrain
    // ROJO RUN — removed (2026-07-26): owner "get rid of the midground" —
    // same technique already proven for hills and clouds (empty points
    // array -> beginPath/forEach-over-nothing/closePath/fill all become
    // safe no-ops, nothing drawn). Fully reversible: restore the points
    // array below (kept here for reference) to bring it back later.
    // Old points: [[0, 189], [40, 170], [80, 193], [120, 177], [160, 162],
    // [200, 191], [240, 174], [280, 158], [320, 187], [360, 170],
    // [380, 162], [390, 174], [400, 189], [400, 200], [0, 200]]
    midground: {
      fill: '#13330F',
      points: []
    },
    // ROJO RUN — Environmental Art (2026-07-25): clouds removed at the
    // owner's explicit direction — the illustrated-art attempt never
    // rendered on real device for a cause never conclusively identified,
    // and rather than leave the old placeholder circles showing (now
    // stylistically mismatched next to mountains' real art, "the clouds
    // look out of place"), an empty cluster list is kept here so the
    // rest of the parallax system (the DOM track, WAAPI scroll animation,
    // canvas elements, tint filter inheritance) stays completely
    // untouched and unchanged — this canvas simply has nothing drawn onto
    // it, same clearRect()-then-nothing outcome as any other empty
    // shape.clusters would produce. Trivially reversible later if clouds
    // are revisited (restore cluster data here, nothing else to touch).
    clouds: {
      type: 'circles',
      fill: 'rgba(240,255,200,.85)',
      clusters: []
    }
  };

  function rojoRunBakeParallaxCanvases() {
    rojoRunParallaxCanvasElements.forEach((canvas) => {
      const shape = ROJO_RUN_PARALLAX_SHAPES[canvas.dataset.rojoRunParallaxCanvas];
      if (!shape) return;
      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      // ROJO RUN — Environmental Art, Background Layer 2 (2026-07-25): the
      // mountains canvas draws the final illustrated artwork once it's
      // ready. Deliberately only returns early on SUCCESS — if the image
      // isn't ready yet (or ctx.drawImage() throws on a broken image),
      // execution falls through to the existing procedural polygon fill
      // below, which is left completely untouched. This guarantees
      // mountains can never render nothing, unlike clouds' all-or-nothing
      // approach that had no such fallback.
      // ROJO RUN — round 4 (2026-07-25, owner: "can we lower the image down
      // by 35%?"): the destination rect is shifted down by 35% of the
      // canvas height (not compressed/rescaled — same image scale as
      // before, just repositioned), so the top 35% of the mountains canvas
      // is left blank/transparent, letting the sky layer behind it show
      // through. The image's own bottom portion simply clips at the
      // canvas edge, same as any drawImage() extending past its target.
      if (canvas.dataset.rojoRunParallaxCanvas === 'mountains' && rojoRunMountainsImageReady) {
        try {
          ctx.drawImage(rojoRunMountainsImage, 0, canvas.height * ROJO_RUN_MOUNTAINS_VERTICAL_OFFSET_FRACTION, canvas.width, canvas.height);
          return;
        } catch (err) { /* fall through to the procedural fallback below */ }
      }
      ctx.fillStyle = shape.fill;
      // ROJO RUN — clouds added (2026-07-23): soft overlapping-circle
      // clusters instead of a hard-edged polygon, for a fluffy look.
      if (shape.type === 'circles') {
        shape.clusters.forEach((circles) => {
          circles.forEach(([x, y, r]) => {
            ctx.beginPath();
            ctx.arc(x, y, r, 0, Math.PI * 2);
            ctx.fill();
          });
        });
        return;
      }
      ctx.beginPath();
      shape.points.forEach(([x, y], i) => {
        if (i === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
      });
      ctx.closePath();
      ctx.fill();
    });
  }

  // ROJO RUN — Phase 8B: parallax background layers. Same create-paused →
  // deferred-play structure as rojoRunStartTileAnimations() above (so both
  // land in the same animation frame, correctly caught by the countdown
  // freeze's own nested requestAnimationFrame — see rojoRunArmCountdown()),
  // but looping infinitely (this is repeating decorative art, not unique
  // baked content) and running unconditionally on both platforms — no
  // rojoRunHasCoarsePointer() gate, unlike the terrain tiles. Each track is
  // phase-aligned to targetWorldX so a checkpoint respawn or restart doesn't
  // visibly snap the parallax back to a start position, mirroring the
  // Terrain Swell phase-alignment technique above in this same function.
  function rojoRunStartParallaxAnimations(targetWorldX) {
    if (rojoRunParallaxTrackElements.length === 0) return;

    // ROJO RUN — bug fix (2026-07-23): this function used to unconditionally
    // cancel() every animation and build fresh ones on every call — but it's
    // called on EVERY reset path, including checkpoint respawn, which fires
    // unpredictably whenever the player takes damage. cancel() synchronously
    // removes the animation's effect (the element briefly renders with no
    // transform at all) before the replacement's paused, phase-aligned
    // state is guaranteed to be reflected in the next paint — a real gap
    // that mobile Safari can render as a visible flash. This is what the
    // owner reported as a random flicker on the background layers,
    // reproducible whenever a checkpoint respawn happens to occur.
    //
    // Fix: only cancel+recreate when the animation's own configured
    // duration would actually need to change (i.e., a genuine new run,
    // where ROJO_RUN_BASE_SPEED may differ for ROJO Tavo vs Normal Tavo).
    // A checkpoint respawn never changes ROJO_RUN_BASE_SPEED mid-run, so in
    // that case every already-playing animation is simply re-seeked to the
    // new world position via currentTime — an atomic operation with no gap
    // where the animation's effect is ever removed.
    const canReuseExisting =
      rojoRunParallaxAnimations.length === rojoRunParallaxTrackElements.length &&
      rojoRunParallaxAnimations.every((anim, i) => {
        if (!anim) return false;
        const loopUnits = ROJO_RUN_PARALLAX_LOOP_UNITS[rojoRunParallaxTrackElements[i].dataset.rojoRunParallaxTrack];
        if (!loopUnits) return false;
        const expectedDurationMs = (loopUnits / ROJO_RUN_BASE_SPEED) * 1000;
        return anim.effect.getTiming().duration === expectedDurationMs;
      });

    if (canReuseExisting) {
      rojoRunParallaxTrackElements.forEach((track, i) => {
        const loopUnits = ROJO_RUN_PARALLAX_LOOP_UNITS[track.dataset.rojoRunParallaxTrack];
        const durationMs = (loopUnits / ROJO_RUN_BASE_SPEED) * 1000;
        rojoRunParallaxAnimations[i].currentTime = ((targetWorldX % loopUnits) / loopUnits) * durationMs;
      });
      return;
    }

    rojoRunParallaxAnimations.forEach((anim) => { if (anim) anim.cancel(); });

    rojoRunParallaxAnimations = rojoRunParallaxTrackElements.map((track) => {
      const loopUnits = ROJO_RUN_PARALLAX_LOOP_UNITS[track.dataset.rojoRunParallaxTrack];
      if (!loopUnits) return null;

      const durationMs = (loopUnits / ROJO_RUN_BASE_SPEED) * 1000;
      const animation = track.animate(
        [
          { transform: 'translate3d(0%, 0, 0)' },
          { transform: 'translate3d(-50%, 0, 0)' }
        ],
        {
          duration: durationMs,
          easing: 'linear',
          iterations: Infinity
        }
      );
      animation.pause();
      animation.currentTime = ((targetWorldX % loopUnits) / loopUnits) * durationMs;
      return animation;
    });

    window.requestAnimationFrame(() => {
      rojoRunParallaxAnimations.forEach((anim) => { if (anim) anim.play(); });
    });
  }

  // ROJO RUN — Phase 9 round 9 (2026-07-23): single non-looping scroll
  // animation for the whole container track, always anchored 0 -> world end
  // (never re-scoped to a respawn's position) so a checkpoint respawn can
  // just re-seek currentTime — same anti-flicker reuse-vs-recreate pattern
  // proven for rojoRunStartParallaxAnimations() above, adapted for a single
  // linear pass (matching rojoRunStartTileAnimations()'s own start/end math)
  // instead of an infinite loop. Reused only when ROJO_RUN_BASE_SPEED hasn't
  // changed (same duration) — a genuine new run with a different character
  // still needs a fresh animation, exactly like parallax.
  // ROJO OS — bug fix (2026-08-06): desktop-only. A WAAPI-seeked track (even
  // paused, even re-seeked every frame) still has its transform applied by
  // the browser's own animation/compositor pipeline, not synchronously by
  // this script — so it can render up to one frame's-worth of world
  // movement behind the terrain canvas, which paints synchronously on the
  // main thread the instant ctx.fillRect runs. Root cause of the remaining
  // multi-pixel edge mismatch (see the diagnosis this fixes: ~12.5 virtual
  // units/frame at the current run speed, several real CSS px at desktop's
  // arena scale — matches the reported gap far better than sub-pixel
  // rounding did). Fix: desktop never creates/uses the WAAPI animation for
  // this track at all — rojoRunSetDesktopContainerTrackX() (below) writes
  // its transform directly, every frame, from the exact same
  // rojoRunPlayerWorldDistanceRender value terrain uses, in the same
  // synchronous main-thread turn — see the rojoRunLoopTick() call site.
  // Mobile is completely untouched: this early return only fires when
  // rojoRunHasCoarsePointer() is false, so every line below it — the WAAPI
  // animate()/currentTime/play() logic mobile already relies on — still
  // runs exactly as before for mobile.
  function rojoRunSetDesktopContainerTrackX(worldX) {
    const translateX = ROJO_RUN_PLAYER_PROBE_SCREEN_X - worldX;
    if (rojoRunContainerTrack) {
      rojoRunContainerTrack.style.transform = `translate3d(${translateX}px, 0, 0)`;
    }
    // ROJO OS — bug fix (2026-08-06): drives rojoRunWorldObjectTrack
    // (checkpoint pillars/Signal Fractures/Pulse Zones/finish marker) from
    // the identical translateX, in the same call, so both world-anchored
    // layers move in perfect lockstep — same reasoning as this function's
    // own declaration comment above, just applied to the second track too.
    if (rojoRunWorldObjectTrack) {
      rojoRunWorldObjectTrack.style.transform = `translate3d(${translateX}px, 0, 0)`;
    }
  }

  function rojoRunStartContainerLayerAnimation(targetWorldX) {
    if (!rojoRunContainerTrack) return;

    if (!rojoRunHasCoarsePointer()) {
      // Desktop: no WAAPI animation for this track — cancel/clear any stray
      // reference defensively (never actually created on this path under
      // normal operation) and set the initial position directly, the same
      // way every subsequent frame will.
      if (rojoRunContainerLayerAnimation) {
        rojoRunContainerLayerAnimation.cancel();
        rojoRunContainerLayerAnimation = null;
      }
      rojoRunSetDesktopContainerTrackX(targetWorldX);
      return;
    }

    const durationMs = (ROJO_RUN_TILE_WORLD_MAX_X / ROJO_RUN_BASE_SPEED) * 1000;
    const canReuseExisting =
      rojoRunContainerLayerAnimation &&
      rojoRunContainerLayerAnimation.effect.getTiming().duration === durationMs;

    if (canReuseExisting) {
      rojoRunContainerLayerAnimation.currentTime = (targetWorldX / ROJO_RUN_TILE_WORLD_MAX_X) * durationMs;
      return;
    }

    if (rojoRunContainerLayerAnimation) rojoRunContainerLayerAnimation.cancel();

    const startTranslateX = ROJO_RUN_PLAYER_PROBE_SCREEN_X;
    const endTranslateX = ROJO_RUN_PLAYER_PROBE_SCREEN_X - ROJO_RUN_TILE_WORLD_MAX_X;

    rojoRunContainerLayerAnimation = rojoRunContainerTrack.animate(
      [
        { transform: `translate3d(${startTranslateX}px, 0, 0)` },
        { transform: `translate3d(${endTranslateX}px, 0, 0)` }
      ],
      {
        duration: durationMs,
        easing: 'linear',
        fill: 'forwards'
      }
    );
    rojoRunContainerLayerAnimation.pause();
    rojoRunContainerLayerAnimation.currentTime = (targetWorldX / ROJO_RUN_TILE_WORLD_MAX_X) * durationMs;

    // ROJO OS — bug fix (2026-08-06, round 2): desktop already returned
    // early above and never reaches this point — this code (and the WAAPI
    // animation it plays) is mobile-only now. Mobile is unchanged: its
    // terrain is itself WAAPI-driven (baked tiles), so it was never subject
    // to the compositor-lag this fix targets, and keeps the original
    // free-running play() behavior.
    if (rojoRunHasCoarsePointer()) {
      window.requestAnimationFrame(() => {
        if (rojoRunContainerLayerAnimation) rojoRunContainerLayerAnimation.play();
      });
    }
  }

  // ROJO OS — bug fix (2026-08-06): checkpoint pillars/Signal Fractures/
  // Pulse Zones/finish marker's own scroll-position driver, mirroring
  // rojoRunStartContainerLayerAnimation() immediately above exactly (same
  // duration/currentTime formula, same reuse-vs-recreate anti-flicker
  // logic) but targeting rojoRunWorldObjectTrack/
  // rojoRunWorldObjectLayerAnimation, so these 4 sprite types keep scrolling
  // in perfect lockstep with paint containers on mobile. On desktop this is
  // a no-op — rojoRunSetDesktopContainerTrackX() (called from this
  // function's sibling above) already writes both tracks' transform
  // directly every frame, so there's nothing left for a WAAPI animation to
  // do here on that platform.
  function rojoRunStartWorldObjectLayerAnimation(targetWorldX) {
    if (!rojoRunWorldObjectTrack) return;
    if (!rojoRunHasCoarsePointer()) return;

    const durationMs = (ROJO_RUN_TILE_WORLD_MAX_X / ROJO_RUN_BASE_SPEED) * 1000;
    const canReuseExisting =
      rojoRunWorldObjectLayerAnimation &&
      rojoRunWorldObjectLayerAnimation.effect.getTiming().duration === durationMs;

    if (canReuseExisting) {
      rojoRunWorldObjectLayerAnimation.currentTime = (targetWorldX / ROJO_RUN_TILE_WORLD_MAX_X) * durationMs;
      return;
    }

    if (rojoRunWorldObjectLayerAnimation) rojoRunWorldObjectLayerAnimation.cancel();

    const startTranslateX = ROJO_RUN_PLAYER_PROBE_SCREEN_X;
    const endTranslateX = ROJO_RUN_PLAYER_PROBE_SCREEN_X - ROJO_RUN_TILE_WORLD_MAX_X;

    rojoRunWorldObjectLayerAnimation = rojoRunWorldObjectTrack.animate(
      [
        { transform: `translate3d(${startTranslateX}px, 0, 0)` },
        { transform: `translate3d(${endTranslateX}px, 0, 0)` }
      ],
      {
        duration: durationMs,
        easing: 'linear',
        fill: 'forwards'
      }
    );
    rojoRunWorldObjectLayerAnimation.pause();
    rojoRunWorldObjectLayerAnimation.currentTime = (targetWorldX / ROJO_RUN_TILE_WORLD_MAX_X) * durationMs;

    window.requestAnimationFrame(() => {
      if (rojoRunWorldObjectLayerAnimation) rojoRunWorldObjectLayerAnimation.play();
    });
  }

  function resetRojoRunPlayerPhysics(targetWorldX) {
    rojoRunPlayerWorldDistance = targetWorldX;
    // ROJO OS — bug fix (2026-08-06): reset the interpolation state too, in
    // lockstep with the authoritative value above — prevents a stale
    // "previous" value from blending toward a teleported new position
    // (fresh run/restart/checkpoint respawn/orientation reset) and
    // flashing/sliding for one render.
    rojoRunPlayerWorldDistanceAtLastStep = targetWorldX;
    rojoRunPlayerWorldDistanceRender = targetWorldX;
    // Phase-aligned so the swell encounter is identical after a full reset or
    // an anchor respawn, regardless of which world-X the reset started from —
    // the swell phase becomes a pure function of world position.
    rojoRunSwellElapsedSeconds = (targetWorldX / ROJO_RUN_BASE_SPEED) % ROJO_RUN_SWELL_CYCLE_SECONDS;
    rojoRunSwellDropTriggeredThisCycle = false;
    const groundY = rojoRunGetSwellSurfaceY(targetWorldX, rojoRunSwellElapsedSeconds);
    rojoRunPlayerFootY = groundY !== null ? groundY : ROJO_RUN_GROUND_Y;
    rojoRunPlayerVelocityY = 0;
    rojoRunPlayerGrounded = true;
    // ROJO RUN — ROJO Tavo sprite integration, Phase 2 (run cycle): full
    // reset of the run-animation clock on every genuine fresh start (fresh
    // run, restart, checkpoint respawn, orientation reset all funnel through
    // this one function) — the same single choke point every other per-run
    // animation/physics reset in this file already uses.
    rojoRunRunAnimationElapsedSeconds = 0;
    rojoRunJumpBufferRemaining = 0;
    rojoRunCoyoteRemaining = 0;
    rojoRunJumpHoldRemaining = 0;
    rojoRunJumpPressQueued = false;
    rojoRunJumpReleaseQueued = false;

    if (rojoRunHasCoarsePointer()) {
      // ROJO RUN — Phase 4A iOS fix: the JS mobile wall-clock and the tile
      // animations must start from the identical world position at every
      // reset path (fresh run, restart, checkpoint respawn, orientation
      // reset) — all four paths route through this one shared function, so
      // there is exactly one place this has to be kept correct.
      rojoRunBuildTileWorld();
      rojoRunMobileRunStartTimestamp = performance.now();
      rojoRunMobileWorldStartOffset = targetWorldX;
      rojoRunMobilePauseStartedAt = null;
      rojoRunMobilePausedTotalMs = 0;
      rojoRunStartTileAnimations(targetWorldX);
    }

    // ROJO RUN — Phase 8B: parallax restarts on every reset path, same as
    // the mobile tile animations above, but unconditionally (both platforms).
    rojoRunStartParallaxAnimations(targetWorldX);
    // ROJO RUN — Phase 9 round 9: paint containers built once (no-op after
    // the first call) and their scroll animation (re)started on every reset
    // path, unconditionally on both platforms — same reasoning as parallax.
    rojoRunBuildContainerLayer();
    rojoRunStartContainerLayerAnimation(targetWorldX);
    // ROJO RUN — Phase 9: health pickups built once too, same call site as
    // containers — the scroll animation started above already covers them,
    // since they're children of the same track.
    rojoRunBuildHealthPickupSprites();
    // ROJO OS — bug fix (2026-08-06): checkpoint pillars, Signal Fractures,
    // Pulse Zones, and the finish marker moved to their own
    // rojoRunWorldObjectTrack (see each build function's own comment) so
    // they stay behind Tavo on desktop — that track needs its own explicit
    // start call, same reset path/timing as the container track above.
    rojoRunStartWorldObjectLayerAnimation(targetWorldX);
    // ROJO RUN — Phase 9 item 3 round 2: checkpoint pillars, built once,
    // scrolled by rojoRunWorldObjectTrack's animation started just above.
    rojoRunBuildCheckpointPillarSprites();
    // ROJO RUN — Phase 9 item 4: finish gateway, same call site and
    // reasoning as the checkpoint pillars directly above.
    rojoRunBuildFinishMarkerSprite();
    // ROJO RUN — Phase 9 item 5: Signal Fracture texture, same call site
    // and reasoning as the finish gateway directly above.
    rojoRunBuildSignalFractureSprites();
    // ROJO RUN — Phase 9 item 6 follow-up 2: Pulse Zone structure built
    // once here too; the glow's WAAPI animation is started/re-seeked on
    // every call (not just the first), so it stays phase-aligned across
    // fresh runs, restarts, and checkpoint respawns.
    rojoRunBuildPulseZoneSprites();
    rojoRunStartPulseZoneGlowAnimations(targetWorldX);
  }

  // ROJO RUN — bug fix (2026-07-22): rojoRunBuildTileWorld() is guarded by
  // rojoRunTilesBuilt, a one-time flag from the original Phase 4A design
  // (one continuous run per page load) that's never reset anywhere else in
  // the file. Phase 6C/6D/6E's REPLAY/RESTART made that assumption false —
  // without this, a replay correctly clears rojoRunCollectedContainers (so
  // containers are collectible again) but the mobile tile canvases, which
  // draw every container unconditionally at build time and only ever get
  // individually erased on collection, are never repainted — so every
  // container erased in the previous run stays visually erased forever,
  // even though it's fully collectible ("can still collect them, just
  // can't see them"). Clearing the stale DOM tiles first prevents the
  // rebuild from appending a second overlapping set of 16 canvases
  // alongside the old ones. Scoped to this function only — never
  // respawnRojoRunPlayerAtCheckpoint(), which must keep reusing the same
  // tiles for performance and must NOT visually restore containers
  // already collected earlier in the same run. Runs identically on every
  // replay, not just the first — nothing here is consumed or one-shot.
  function resetRojoRunPlayer() {
    if (rojoRunHasCoarsePointer() && rojoRunTilesBuilt) {
      rojoRunTileWorldScaler?.replaceChildren();
      rojoRunTilesBuilt = false;
    }
    resetRojoRunPlayerPhysics(0);
    // A genuine fresh run only — never on checkpoint respawn. Matches
    // Section 20's "before first checkpoint: restart Level 01" / "previously
    // completed sections... restore from the snapshot" distinction: progress
    // survives death-respawn within a run, but not a real restart.
    rojoRunLatestCheckpointX = 0;
    rojoRunCollectedContainers.clear();
    // ROJO RUN — Phase 9 round 9: re-show every container DOM element on a
    // genuine fresh run, same rule as everything else in this function —
    // direct precedent for "un-hide previously-hidden containers on replay"
    // already solved once for the old tile-canvas approach in Phase 6E.
    Object.values(rojoRunContainerElements).forEach((el) => { el.style.display = ''; });
    // ROJO RUN — Phase 4B: health resets only on a genuine fresh run, same
    // as containers/checkpoint above — never on checkpoint respawn itself
    // (respawnRojoRunPlayerAtCheckpoint() must not auto-heal, per spec
    // Section 5.4; the 0-health full-restore is handled separately inside
    // rojoRunApplyPulseDamage()/rojoRunApplyPitFallDamage()).
    rojoRunInvincibleRemaining = 0;
    rojoRunHitReactionRemaining = 0;
    rojoRunHealthPickup2Collected = false;
    rojoRunHealthPickup3Collected = false;
    // ROJO RUN — Phase 9: re-show both health pickup sprites on a genuine
    // fresh run, same rule/precedent as the paint containers.
    Object.values(rojoRunHealthPickupElements).forEach((el) => { el.style.display = ''; });
    rojoRunDamageTakenThisRun = 0;
    rojoRunNoDamageThisRun = true;
    rojoRunGameOver = false;
    if (rojoRunGameOverMessage) rojoRunGameOverMessage.classList.remove('is-visible');
    rojoRunScore = 0;
    // ROJO RUN — Phase 5E: milestone/clean-section state resets only on a
    // genuine fresh run, same rule as everything else in this function.
    rojoRunMilestone25Reached = false;
    rojoRunMilestone50Reached = false;
    rojoRunMilestone75Reached = false;
    rojoRunMilestone100Reached = false;
    rojoRunSectionDamaged = [false, false, false, false];
    rojoRunSectionBonusEvaluated = [false, false, false, false];
    // ROJO RUN — Phase 8B: world tint snaps back to the 0% state instantly
    // (no eased transition) on a genuine fresh run, same rule as every other
    // reset in this function.
    rojoRunResetWorldTintInstant();
    // ROJO RUN — Phase 5F: completion state resets only on a genuine fresh
    // run, same rule as everything else in this function.
    rojoRunLevelComplete = false;
    rojoRunFinalResults = null;
    if (rojoRunLevelCompleteMessage) rojoRunLevelCompleteMessage.classList.remove('is-visible');
    rojoRunSetHealth(ROJO_RUN_MAX_HEALTH);
    // ROJO RUN — Phase 4E: progress/counter HUD reset only on a genuine
    // fresh run, same reasoning as health/containers/checkpoint above. The
    // progress bar would self-correct on the next rendered frame regardless
    // (it reads live position every frame), but resetting it immediately
    // here avoids a one-frame stale display.
    rojoRunUpdateContainerCounterHud();
    rojoRunUpdateProgressHud();
    rojoRunUpdateScoreAndPaintHud();
    // ROJO RUN — Phase 4E: checkpoint message reset only on a genuine fresh
    // run, same reasoning as everything else in this function — checkpoint
    // respawn mid-run must not clear rojoRunLatestCheckpointX (guarded
    // elsewhere), so this must not re-arm the message for an
    // already-passed checkpoint either.
    if (rojoRunCheckpointMessageHideTimer) {
      clearTimeout(rojoRunCheckpointMessageHideTimer);
      rojoRunCheckpointMessageHideTimer = null;
    }
    if (rojoRunCheckpointMessage) rojoRunCheckpointMessage.classList.remove('is-visible');
  }

  function respawnRojoRunPlayerAtCheckpoint() {
    resetRojoRunPlayerPhysics(rojoRunLatestCheckpointX);
  }

  function rojoRunSimulationStep(deltaSeconds) {
    // ROJO RUN — Phase 5B: Game Over freezes the run in place — every
    // physics/collision/hazard-timing update below is skipped, so the
    // player, hazards, and world all hold at exactly the state they were
    // in the instant health hit zero. rojoRunRenderFrame() still runs every
    // frame regardless (see rojoRunLoopTick), so this reads as a frozen
    // scene rather than a black screen, with no visual overlay built yet
    // (Phase 6D scope). Phase 5F: crossing the finish line freezes the run
    // the same way — no visual overlay built yet either (Phase 6E scope).
    if (rojoRunGameOver || rojoRunLevelComplete) return;
    // All three timers are simulation-time countdowns, decremented only here —
    // never wall-clock deadlines — so a paused loop (no simulation steps)
    // freezes them automatically, and resuming continues from the exact
    // remaining value with no special-case code.
    rojoRunJumpBufferRemaining = Math.max(0, rojoRunJumpBufferRemaining - deltaSeconds);
    rojoRunCoyoteRemaining = Math.max(0, rojoRunCoyoteRemaining - deltaSeconds);
    rojoRunJumpHoldRemaining = Math.max(0, rojoRunJumpHoldRemaining - deltaSeconds);
    // ROJO RUN — Phase 4B: same simulation-time-countdown pattern as the
    // three timers above.
    rojoRunInvincibleRemaining = Math.max(0, rojoRunInvincibleRemaining - deltaSeconds);
    rojoRunHitReactionRemaining = Math.max(0, rojoRunHitReactionRemaining - deltaSeconds);

    // ROJO RUN — Phase 8A: eases rojoRunWorldTintCurrentIndex toward
    // rojoRunWorldTintTargetIndex over ROJO_RUN_WORLD_TINT_TRANSITION_SECONDS
    // — desktop's per-frame redraw reads this each frame to build its
    // filter string, giving the same smooth transition mobile's CSS
    // transition already provides for free. Never touches world position,
    // scroll, or input in any way.
    if (rojoRunWorldTintCurrentIndex !== rojoRunWorldTintTargetIndex) {
      const maxStep = deltaSeconds / ROJO_RUN_WORLD_TINT_TRANSITION_SECONDS;
      if (rojoRunWorldTintCurrentIndex < rojoRunWorldTintTargetIndex) {
        rojoRunWorldTintCurrentIndex = Math.min(rojoRunWorldTintTargetIndex, rojoRunWorldTintCurrentIndex + maxStep);
      } else {
        rojoRunWorldTintCurrentIndex = Math.max(rojoRunWorldTintTargetIndex, rojoRunWorldTintCurrentIndex - maxStep);
      }
    }

    // Queue-to-state processing stays in this exact position, before gravity,
    // matching accepted Phase 3A exactly — a release always affects gravity
    // starting this same tick, never one tick late.
    if (rojoRunJumpPressQueued) {
      rojoRunJumpBufferRemaining = ROJO_RUN_JUMP_BUFFER_SECONDS;
      rojoRunJumpPressQueued = false;
    }
    if (rojoRunJumpReleaseQueued) {
      rojoRunJumpHoldRemaining = 0;
      rojoRunJumpReleaseQueued = false;
    }

    const previousPlayerWorldDistance = rojoRunPlayerWorldDistance;
    // ROJO OS — bug fix (2026-08-06): module-level copy of the same value
    // (the local const above only lives for this one call) — always holds
    // rojoRunPlayerWorldDistance as it stood immediately before the most
    // recently executed simulation step, read by rojoRunLoopTick() after
    // its while-loop closes to interpolate the render position. See the
    // declaration comment above rojoRunPlayerWorldDistanceAtLastStep.
    rojoRunPlayerWorldDistanceAtLastStep = rojoRunPlayerWorldDistance;
    const previousPlayerFootY = rojoRunPlayerFootY;
    const previousSwellElapsedSeconds = rojoRunSwellElapsedSeconds;
    if (rojoRunHasCoarsePointer()) {
      // ROJO RUN — Phase 4A iOS fix: horizontal world position on mobile is a
      // pure function of monotonic wall-clock time, not an accumulated
      // per-step delta — immune to touch-induced main-thread frame-count
      // variance. Rate of change is exactly ROJO_RUN_BASE_SPEED, matching
      // the tile animations' own rate (see the lockstep proof above
      // rojoRunStartTileAnimations), so the two stay in sync.
      const elapsedMs = performance.now() - rojoRunMobileRunStartTimestamp - rojoRunMobilePausedTotalMs;
      rojoRunPlayerWorldDistance = rojoRunMobileWorldStartOffset + (elapsedMs / 1000) * ROJO_RUN_BASE_SPEED;
    } else {
      rojoRunPlayerWorldDistance += ROJO_RUN_BASE_SPEED * deltaSeconds;
    }
    rojoRunSwellElapsedSeconds = (rojoRunSwellElapsedSeconds + deltaSeconds) % ROJO_RUN_SWELL_CYCLE_SECONDS;

    // ROJO RUN — Phase 4A: progressive checkpoint tracking. Monotonic within
    // a run — cleared only by resetRojoRunPlayer() (a genuine fresh run),
    // never by checkpoint respawn itself. No score, clean-section
    // evaluation, healing, or persistence — those belong to Phase 5.
    ROJO_RUN_CHECKPOINTS.forEach((checkpoint) => {
      if (rojoRunPlayerWorldDistance >= checkpoint.worldX && rojoRunLatestCheckpointX < checkpoint.worldX) {
        rojoRunLatestCheckpointX = checkpoint.worldX;
        rojoRunScore += 250;
        rojoRunShowCheckpointMessage();
      }
    });

    // ROJO RUN — Phase 4D: invisible safe anchors (spec Section 10.5) —
    // identical crossing-detection mechanism to checkpoints above, updating
    // the same rojoRunLatestCheckpointX with the same only-ever-advances
    // guard, just with no visual marker drawn anywhere.
    ROJO_RUN_SAFE_ANCHORS.forEach((anchor) => {
      if (rojoRunPlayerWorldDistance >= anchor.worldX && rojoRunLatestCheckpointX < anchor.worldX) {
        rojoRunLatestCheckpointX = anchor.worldX;
      }
    });

    // ROJO RUN — Phase 5E: authoritative milestone crossings. No score value
    // of their own (reserved for Phase 8's world-transformation hooks)
    // except the 100% crossing, which also gates the +1,500 no-damage bonus
    // — by this point the whole course has been traversed, so this is the
    // correct place to evaluate it (the finish-line runway ahead is
    // deliberately hazard-free, so no further damage is possible anyway).
    // ROJO RUN — Phase 8B (2026-07-23): these four flags no longer drive the
    // world-tint filter (see rojoRunCheckContainerCollisions for the new
    // continuous, per-container mechanism) — kept exactly as-is, since
    // rojoRunMilestone100Reached still gates the Phase 5E no-damage bonus
    // below, and this bookkeeping remains available for any future
    // gameplay/scoring/records use.
    if (!rojoRunMilestone25Reached && rojoRunPlayerWorldDistance >= ROJO_RUN_MILESTONE_25_X) {
      rojoRunMilestone25Reached = true;
    }
    if (!rojoRunMilestone50Reached && rojoRunPlayerWorldDistance >= ROJO_RUN_MILESTONE_50_X) {
      rojoRunMilestone50Reached = true;
    }
    if (!rojoRunMilestone75Reached && rojoRunPlayerWorldDistance >= ROJO_RUN_MILESTONE_75_X) {
      rojoRunMilestone75Reached = true;
    }
    if (!rojoRunMilestone100Reached && rojoRunPlayerWorldDistance >= ROJO_RUN_MILESTONE_100_X) {
      rojoRunMilestone100Reached = true;
      if (rojoRunNoDamageThisRun) {
        rojoRunScore += 1500;
      }
    }

    // ROJO RUN — Phase 5E: four clean-section bonuses (+500 each), evaluated
    // once per section the moment the player's world position crosses that
    // section's endX — monotonic guard via rojoRunSectionBonusEvaluated,
    // same "only ever advances" pattern as checkpoints above. Whether a
    // section stays clean is tracked continuously by rojoRunSectionDamaged,
    // set inside rojoRunApplyPulseDamage()/rojoRunApplyPitFallDamage().
    ROJO_RUN_SECTION_BOUNDARIES.forEach((section, index) => {
      if (!rojoRunSectionBonusEvaluated[index] && rojoRunPlayerWorldDistance >= section.endX) {
        rojoRunSectionBonusEvaluated[index] = true;
        if (!rojoRunSectionDamaged[index]) {
          rojoRunScore += 500;
        }
      }
    });

    // ROJO RUN — Phase 5F: authoritative finish-line detection, same
    // one-time monotonic-crossing shape used by checkpoints/milestones/
    // sections above. Section 4's bonus (just above) always evaluates
    // first in the same frame, since ROJO_RUN_FINISH_X === Section 4's
    // endX, so completion scoring never races the final section bonus.
    if (!rojoRunLevelComplete && rojoRunPlayerWorldDistance >= ROJO_RUN_FINISH_X) {
      rojoRunTriggerLevelComplete();
    }

    // Re-arm the drop-away mechanic exactly once per new swell cycle, detected
    // via the continuous modulo wrap — independent of player position.
    if (rojoRunSwellElapsedSeconds < previousSwellElapsedSeconds) {
      rojoRunSwellDropTriggeredThisCycle = false;
    }

    // Terrain support resolution — before jump-trigger consumption, so a
    // same-tick ledge-loss makes coyote time usable this very tick.
    const currentGroundY = rojoRunGetSwellSurfaceY(rojoRunPlayerWorldDistance, rojoRunSwellElapsedSeconds);
    const previousGroundY = rojoRunGetSwellSurfaceY(previousPlayerWorldDistance, previousSwellElapsedSeconds);

    // ROJO RUN — Phase 4D: checks every footprint instead of a single
    // start/end pair — see ROJO_RUN_SWELL_FOOTPRINTS' own comment.
    const wasOverSwell = ROJO_RUN_SWELL_FOOTPRINTS.some((f) => previousPlayerWorldDistance >= f.startX && previousPlayerWorldDistance < f.endX);
    const isOverSwell = ROJO_RUN_SWELL_FOOTPRINTS.some((f) => rojoRunPlayerWorldDistance >= f.startX && rojoRunPlayerWorldDistance < f.endX);
    const isInteractingWithSwell = wasOverSwell || isOverSwell;

    if (rojoRunPlayerGrounded && currentGroundY !== null) {
      // Measure the SURFACE's own movement (not the player's foot position)
      // between the two time samples — this is what "the terrain is dropping
      // fast" actually means, independent of wherever the player currently is.
      const surfaceDropThisStep = previousGroundY !== null ? currentGroundY - previousGroundY : 0;
      const allowedDropThisStep = ROJO_RUN_SWELL_MAX_ADHESION_SPEED * deltaSeconds;

      // The dynamic-swell drop-away trigger applies only while interacting
      // with the swell, only once per swell cycle (rojoRunSwellDropTriggeredThisCycle
      // guards repeated loss/landing chatter within the same fast-drop
      // window), and never against ordinary static Phase 3B terrain (flat
      // ground, both accepted slopes, the raised ledge) — those always fall
      // through to unconditional adhesion below, exactly as locked.
      const shouldTriggerDropAway =
        isInteractingWithSwell &&
        previousGroundY !== null &&
        !rojoRunSwellDropTriggeredThisCycle &&
        surfaceDropThisStep > allowedDropThisStep;

      if (shouldTriggerDropAway) {
        rojoRunPlayerGrounded = false; // do not snap the player downward — leave the foot where it is
        rojoRunCoyoteRemaining = ROJO_RUN_COYOTE_SECONDS;
        rojoRunSwellDropTriggeredThisCycle = true;
      } else {
        rojoRunPlayerFootY = currentGroundY; // normal adhesion — no float/bounce
        rojoRunPlayerVelocityY = 0;
        rojoRunCoyoteRemaining = 0; // confirmed grounded support — must not persist
      }
    } else if (rojoRunPlayerGrounded && currentGroundY === null) {
      rojoRunPlayerGrounded = false; // passive support loss — NOT from a jump (Phase 3B gap)
      rojoRunCoyoteRemaining = ROJO_RUN_COYOTE_SECONDS;
    }

    const canJump = rojoRunPlayerGrounded || rojoRunCoyoteRemaining > 0;
    const wantsJump = rojoRunJumpBufferRemaining > 0;
    if (canJump && wantsJump) {
      rojoRunPlayerVelocityY = -ROJO_RUN_JUMP_VELOCITY;
      rojoRunPlayerGrounded = false;
      rojoRunJumpHoldRemaining = ROJO_RUN_JUMP_HOLD_SECONDS;
      rojoRunJumpBufferRemaining = 0;
      rojoRunCoyoteRemaining = 0; // consumed — jumping never creates a fresh coyote window
    }

    if (!rojoRunPlayerGrounded) {
      const gravityScale = (rojoRunPlayerVelocityY < 0 && rojoRunJumpHeld && rojoRunJumpHoldRemaining > 0)
        ? ROJO_RUN_JUMP_HOLD_GRAVITY_SCALE
        : 1;
      rojoRunPlayerVelocityY += ROJO_RUN_GRAVITY * gravityScale * deltaSeconds;
      rojoRunPlayerFootY += rojoRunPlayerVelocityY * deltaSeconds;

      if (currentGroundY !== null) {
        // Reuses the previousGroundY already calculated once above.
        const comparisonPreviousGroundY = previousGroundY !== null ? previousGroundY : currentGroundY;

        const previousSeparation = previousPlayerFootY - comparisonPreviousGroundY;
        const currentSeparation = rojoRunPlayerFootY - currentGroundY;

        const wasAboveOrOnSurface = previousSeparation <= 0;
        const isOnOrBelowSurface = currentSeparation >= 0;
        const movingDownwardRelativeToSurface = currentSeparation >= previousSeparation;

        if (wasAboveOrOnSurface && isOnOrBelowSurface && movingDownwardRelativeToSurface) {
          rojoRunPlayerFootY = currentGroundY;
          rojoRunPlayerVelocityY = 0;
          rojoRunPlayerGrounded = true;
          rojoRunCoyoteRemaining = 0; // confirmed landing — must not persist
        }
      }
    }

    // ROJO RUN — ROJO Tavo sprite integration, Phase 2 (run cycle):
    // simulation-time clock, advances only while grounded, wraps at the
    // full cycle duration. Freezes automatically whenever this function
    // doesn't run at all (paused, Game Over, Level Complete — see the
    // early return at the top of this function) — same established
    // pattern as every other timer in this function.
    if (rojoRunPlayerGrounded) {
      rojoRunRunAnimationElapsedSeconds = (rojoRunRunAnimationElapsedSeconds + deltaSeconds) % ROJO_RUN_RUN_CYCLE_SECONDS;
    }

    rojoRunCheckContainerCollisions();
    // ROJO RUN — Phase 4B.
    rojoRunCheckPulseZoneCollisions();
    rojoRunCheckHealthPickupCollisions();

    if (rojoRunPlayerFootY > ROJO_RUN_DEATH_PLANE_Y) {
      // ROJO RUN — Phase 4B: falling through any pit (Signal Fracture or the
      // course boundary) now costs a health cross instead of a free
      // respawn, per spec Section 5.3. rojoRunApplyPitFallDamage() already
      // calls respawnRojoRunPlayerAtCheckpoint() itself.
      rojoRunApplyPitFallDamage();
      return;
    }
  }

  function rojoRunRenderFrame() {
    if (!rojoRunCanvas) return;
    rojoRunCanvasContext = rojoRunCanvasContext || rojoRunCanvas.getContext('2d');
    if (!rojoRunCanvasContext) return;

    // ROJO RUN — Phase 4E: course-progress HUD update, once per rendered
    // frame (matches visual frame rate, not physics rate — see
    // rojoRunUpdateProgressHud()'s own comment).
    rojoRunUpdateProgressHud();
    rojoRunUpdateScoreAndPaintHud();

    const ctx = rojoRunCanvasContext;
    ctx.clearRect(0, 0, ROJO_RUN_VIRTUAL_WIDTH, ROJO_RUN_VIRTUAL_HEIGHT);

    // ROJO RUN — Phase 4A iOS fix: on coarse-pointer (touch) devices, every
    // scrolling world visual is drawn by the pre-rendered canvas-tile
    // compositor instead (see rojoRunBuildTileWorld/rojoRunStartTileAnimations)
    // — this canvas draws only the player, transparent everywhere else, so
    // the tile layer beneath it (z-index 1 vs. this canvas's z-index 2)
    // remains visible. Desktop's canvas path is completely unchanged from
    // this point down.
    if (!rojoRunHasCoarsePointer()) {
      // ROJO RUN — Phase 9 perf fix (2026-07-24): used to set ctx.filter
      // here (hue-rotate/saturate on the whole canvas) before the terrain
      // fill — root-caused as a severe desktop freeze starting at the first
      // container collection (see rojoRunGetTerrainTintColor()'s own
      // comment for the full diagnosis). Terrain is solid-color fills only,
      // so the tint is now computed once per frame as a plain RGB color
      // and used directly as ctx.fillStyle below — no ctx.filter involved
      // for terrain at all anymore.
      const rojoRunTerrainTintColor = rojoRunGetTerrainTintColor(rojoRunWorldTintCurrentIndex);
      // ROJO RUN — Phase 8B: the flat sky-color fill that used to sit here is
      // removed — ctx.clearRect() at the top of this function already leaves
      // the canvas transparent above ground level, and the new parallax DOM
      // layers (negative z-index, behind this canvas) now show through
      // instead. Terrain fill below is unaffected.

      // ROJO RUN — Environmental Art Phase B (2026-07-26): pattern anchored
      // to world position (not screen position) every frame via
      // rojoRunWorldToScreenX(0) — the exact same offset every other
      // screen-space draw call in this function already uses — so the
      // texture stays visually attached to the scrolling ground instead of
      // sliding independently of it. Falls back to the existing plain solid
      // color (unchanged) if the texture isn't ready/failed to load.
      let terrainFillStyle = rojoRunTerrainTintColor;
      if (rojoRunTerrainTextureReady) {
        try {
          const terrainPattern = rojoRunGetTintedTerrainPattern(ctx, rojoRunTerrainTintColor);
          const scale = ROJO_RUN_TERRAIN_TEXTURE_WORLD_SIZE / rojoRunTerrainTextureImage.naturalWidth;
          // ROJO OS — bug fix (2026-08-06, owner: desktop terrain shakes/
          // has hairline gaps while running, and doesn't line up with the
          // checkpoint pillar). Math.round() pixel-snaps every desktop
          // terrain screen-space coordinate here and at the segment
          // screenStartX/screenEndX below — the same sub-pixel-jitter bug
          // class already fixed 3 times elsewhere in this file (containers,
          // checkpoint pillars, Pulse Zones). rojoRunWorldToScreenXRender
          // (instead of the raw rojoRunWorldToScreenX) additionally
          // resolves the WHOLE-pixel jitter caused by the fixed-timestep
          // simulation loop having no render interpolation — see the
          // comment above the rojoRunPlayerWorldDistanceAtLastStep
          // declaration for the full root-cause writeup. Pixel-rounding
          // alone (an earlier attempt) only fixed sub-pixel noise; it left
          // this whole-pixel jitter untouched, which is why terrain kept
          // visibly shaking even after that fix shipped.
          const worldOriginScreenX = Math.round(rojoRunWorldToScreenXRender(0));
          terrainPattern.setTransform(new DOMMatrix([scale, 0, 0, scale, worldOriginScreenX, 0]));
          terrainFillStyle = terrainPattern;
        } catch (err) { /* fall through to the solid-color fallback already assigned above */ }
      }

      const visibleWorldLeft = rojoRunPlayerWorldDistanceRender - ROJO_RUN_PLAYER_PROBE_SCREEN_X;
      const visibleWorldRight = visibleWorldLeft + ROJO_RUN_VIRTUAL_WIDTH;

      ROJO_RUN_LEVEL1_TERRAIN.forEach((segment, index) => {
        const isFirst = index === 0;
        const isLast = index === ROJO_RUN_LEVEL1_TERRAIN.length - 1;
        const drawStartX = isFirst ? Math.min(segment.startX, visibleWorldLeft) : segment.startX;
        const drawEndX = isLast ? Math.max(segment.endX, visibleWorldRight) : segment.endX;

        // ROJO OS — perf fix (2026-08-06, owner-approved): viewport culling.
        // Skips this segment's screen-space math and canvas draw call
        // entirely when it has zero overlap with the visible world window —
        // it would contribute zero visible pixels either way (the canvas
        // already clips off-screen fillRect/path calls), so this changes
        // nothing about what's drawn, only whether the work happens. Uses
        // drawStartX/drawEndX (not the raw segment.startX/endX), so the
        // isFirst/isLast viewport-edge clamping two lines above is
        // preserved automatically — those segments' clamped bounds already
        // extend to/past visibleWorldLeft/Right, so they always pass this
        // check. Strict < / > (not <=/>=) so a segment exactly touching the
        // viewport edge is kept, never dropped.
        if (drawEndX < visibleWorldLeft || drawStartX > visibleWorldRight) {
          return;
        }

        const screenStartX = Math.round(rojoRunWorldToScreenXRender(drawStartX));
        const screenEndX = Math.round(rojoRunWorldToScreenXRender(drawEndX));

        // ROJO RUN — Phase 9 item 5 (2026-07-24): pit segments (Signal
        // Fractures) are skipped here entirely now — same reasoning as the
        // matching mobile tile-bake change above.
        if (segment.groundY === null && !segment.isSlope) {
          return;
        }

        ctx.fillStyle = terrainFillStyle;

        if (segment.isSlope) {
          ctx.beginPath();
          ctx.moveTo(screenStartX, segment.slopeFrom);
          ctx.lineTo(screenEndX, segment.slopeTo);
          ctx.lineTo(screenEndX, ROJO_RUN_VIRTUAL_HEIGHT);
          ctx.lineTo(screenStartX, ROJO_RUN_VIRTUAL_HEIGHT);
          ctx.closePath();
          ctx.fill();
        } else {
          ctx.fillRect(screenStartX, segment.groundY, screenEndX - screenStartX, ROJO_RUN_VIRTUAL_HEIGHT - segment.groundY);
        }
      });

      // ROJO OS — bug fix (2026-08-06, owner: "weird vertical lines in the
      // terrain... it doesnt have that in the mobile version"). This block
      // used to stroke a faint white vertical tick mark every
      // ROJO_RUN_GROUND_TICK_SPACING (80) world units across the ground —
      // a desktop-only decorative touch (this whole branch only runs when
      // !rojoRunHasCoarsePointer()) that mobile's baked-tile terrain never
      // had. Removed entirely, along with rojoRunWorldScrollX and
      // ROJO_RUN_GROUND_TICK_SPACING (both now fully unused — confirmed via
      // grep, neither had any other purpose).

      // ROJO RUN — Phase 9 perf fix (2026-07-24): ctx.filter is no longer
      // set anywhere above (terrain tint is now a computed fillStyle, not a
      // canvas filter) — this defensive reset stays as a no-op safety net
      // in case anything else ever sets ctx.filter earlier in this block,
      // so containers/milestones/health-pickup/checkpoint/player pixels
      // below are still guaranteed to draw untinted.
      ctx.filter = 'none';

      // ROJO RUN — Phase 9 (2026-07-23): container art moved to the
      // unconditional section below (same untinted live canvas, same
      // pattern as Pulse Zones/player) so it renders identically on both
      // platforms and never inherits this block's terrain-only tint filter.

      // ROJO RUN — Phase 4A: inert graybox markers (milestone, health
      // pickup). No animation beyond the simple disappear-on-collect
      // state — final art, glow, magnetism, and HUD belong to later phases.

      // ROJO OS — bug fix (2026-08-06, owner: thin bright vertical lines
      // visible in gameplay near checkpoint/section areas). Same graybox
      // milestone-marker stripe as the matching fix in rojoRunBuildTileWorld
      // — a leftover Phase 4D placeholder, never wired to anything gameplay-
      // relevant. Removed; milestone detection below (rojoRunMilestone25Reached
      // etc.) is untouched and unaffected.

      // ROJO RUN — Phase 9: health pickups no longer drawn here — DOM <img>
      // sprites now (see rojoRunBuildHealthPickupSprites()), same reasoning
      // as the paint containers before them. Health Pickup 1 (formerly a
      // third, non-functional marker) was removed entirely in Phase 5F —
      // see ROJO_RUN_MILESTONE_25_X's comment above.

      // ROJO OS — bug fix (2026-08-06, owner: thin vertical checkpoint/
      // section boundary lines visible during gameplay on both platforms).
      // This was a Phase 4D graybox checkpoint-boundary stripe — a 4px-wide
      // #274F29 (dark terrain-green) line at each checkpoint's world-X,
      // predating the real checkpoint pillar artwork (rojoRunBuildCheckpointPillarSprites(),
      // now on rojoRunWorldObjectTrack — unaffected by this removal) and
      // never cleaned up after that art shipped. Removed; checkpoint
      // trigger/respawn/scoring below reads ROJO_RUN_CHECKPOINTS and
      // rojoRunPlayerWorldDistance directly and never depended on this
      // stripe being drawn.

      // ROJO RUN — Phase 4D: white TDOM finish marker — position-only, same
      // inert treatment as every checkpoint/milestone so far, matching the
      // equivalent tile-builder draw in rojoRunBuildTileWorld.
      ctx.fillStyle = '#F5F2EC';
      const finishScreenX = rojoRunWorldToScreenX(ROJO_RUN_FINISH_X);
      ctx.fillRect(finishScreenX - 3, 0, 6, ROJO_RUN_VIRTUAL_HEIGHT);
    }

    // ROJO RUN — Phase 9 round 9 (2026-07-23): paint containers no longer
    // drawn here at all — they're now DOM <img> elements in
    // rojoRunContainerLayer, positioned once and scrolled via their own
    // WAAPI transform (see rojoRunBuildContainerLayer()/
    // rojoRunStartContainerLayerAnimation()), never redrawn per frame.

    // ROJO RUN — Phase 4C: Terrain Swell now drawn unconditionally too, same
    // reasoning as the Pulse Zone call directly below — it was desktop-only
    // before, invisible on mobile despite its collision being fully active
    // there. Its static "at rest" shape (temporalAmplitude 0) is flat ground
    // at ROJO_RUN_GROUND_Y, which is exactly what the baked tile underneath
    // already shows in this footprint — so nothing looks doubled or wrong
    // when the swell isn't actively rising.
    rojoRunRenderTerrainSwell(ctx);

    // ROJO RUN — Phase 9 item 3 round 2 (2026-07-24): checkpoint pillar art
    // no longer drawn here at all — it's now a DOM <img> element appended to
    // rojoRunWorldObjectTrack (see rojoRunBuildCheckpointPillarSprites();
    // moved off the shared container track 2026-08-06 so it stays behind
    // Tavo), same reasoning as containers/health pickups otherwise: static
    // position computed once, scrolled for free by the track's own scroll
    // mechanism, never redrawn or re-looked-up per frame.

    // ROJO RUN — Phase 9 item 6 follow-up 2 (2026-07-25): Pulse Zones no
    // longer drawn here — DOM sprite + WAAPI glow now (see
    // rojoRunBuildPulseZoneSprites()), same reasoning as containers/
    // checkpoints/finish-marker/fracture before them.

    // ROJO RUN — ROJO Tavo sprite integration, Phase 1 (2026-07-31): static
    // Run Frame 1 replaces the graybox rectangle here. Purely a visual
    // swap — the collision box (ROJO_RUN_PLAYER_WIDTH/HEIGHT/SCREEN_X,
    // used everywhere else in the file) is completely untouched by this
    // block. Falls back to the original rectangle, unchanged, whenever
    // the sprite isn't ready or failed to load, so this can never render
    // nothing.
    if (rojoRunPlayerRunImageReady) {
      const rojoRunPlayerSpriteScale = ROJO_RUN_PLAYER_SPRITE_DRAW_SIZE / ROJO_RUN_PLAYER_SPRITE_SOURCE_SIZE;
      const rojoRunPlayerVisualCenterX = ROJO_RUN_PLAYER_SCREEN_X + ROJO_RUN_PLAYER_WIDTH / 2;
      const rojoRunPlayerSpriteDestX = rojoRunPlayerVisualCenterX - ROJO_RUN_PLAYER_SPRITE_PIVOT_X * rojoRunPlayerSpriteScale;
      const rojoRunPlayerSpriteDestY = rojoRunPlayerFootY - ROJO_RUN_RUN_FRAME_1_FOOT_Y * rojoRunPlayerSpriteScale;
      // ROJO RUN — ROJO Tavo sprite integration, Phase 2 (run cycle):
      // grounded cycles through all 16 run frames via the simulation-time
      // clock above; airborne always stays on Frame 1 (index 0) — the exact
      // static frame already calibrated and approved in Phase 1. Jump-sheet
      // frame selection is a separate, later phase, not implemented here.
      // Phase 2 follow-up: playback step (which position in the loop we're
      // at) is looked up through ROJO_RUN_RUN_PLAYBACK_FRAME_INDICES to
      // find the actual sheet frame to draw -- airborne is untouched, still
      // always sheet index 0 (Frame 1), the approved Phase 1 frame.
      const rojoRunPlayerRunPlaybackStep = rojoRunPlayerGrounded
        ? Math.floor(rojoRunRunAnimationElapsedSeconds / ROJO_RUN_RUN_FRAME_DURATION_SECONDS) % ROJO_RUN_RUN_FRAME_COUNT
        : 0;
      const rojoRunPlayerRunFrameSheetIndex = rojoRunPlayerGrounded
        ? ROJO_RUN_RUN_PLAYBACK_FRAME_INDICES[rojoRunPlayerRunPlaybackStep]
        : 0;
      const rojoRunPlayerRunFrameSourceX = (rojoRunPlayerRunFrameSheetIndex % 4) * ROJO_RUN_PLAYER_SPRITE_SOURCE_SIZE;
      const rojoRunPlayerRunFrameSourceY = Math.floor(rojoRunPlayerRunFrameSheetIndex / 4) * ROJO_RUN_PLAYER_SPRITE_SOURCE_SIZE;
      ctx.imageSmoothingEnabled = true;
      // ROJO RUN — hit reaction: the old rect swapped fillStyle to a near-
      // white color on hit; drawImage() has no fillStyle to swap, so this
      // dims the sprite briefly instead, scoped only to each draw below via
      // save()/globalAlpha/restore() — never a filter, never touching the
      // terrain or the rest of the canvas. The existing full-screen damage
      // flash (rojoRunShowDamageFlash()) stays the authoritative hit cue,
      // unchanged — this is a secondary, on-character accent only. This
      // factor multiplies into whichever blend alpha is in effect below,
      // so a hit mid-crossfade dims both layers together rather than one
      // overriding the other.
      const rojoRunPlayerHitReactionAlpha = rojoRunHitReactionRemaining > 0 ? 0.55 : 1;
      // ROJO RUN — Phase 2 follow-up 3 (2026-07-31): follow-up 2 only
      // cross-faded the 4 hardest cuts (the block-to-block front/back
      // flip, step % 4 === 3). Owner feedback afterward ("its just the
      // way the feet switch when he runs that feels off") plus a direct
      // pixel-level check of the sheet (per-frame leg-region center of
      // mass) showed the within-block frame-to-frame leg-position jumps
      // are also uneven -- some adjacent frames are near-duplicates,
      // others jump a lot -- and every one of those was still an instant
      // drawImage() swap, so any foot-switch moment outside the 4
      // block-boundary steps still popped. This generalizes the same,
      // already-proven blend to every grounded step: the outgoing
      // (current) frame and the incoming (next) frame are drawn on top of
      // each other, with the incoming frame's globalAlpha ramping 0->1
      // across how far through this frame's own duration slot the clock
      // is, so its fade-in completes exactly as the next step takes over.
      // Airborne is unaffected -- still always the single static approved
      // Frame 1, via the else branch below.
      // ROJO RUN — Phase 2 follow-up 4 (2026-07-31): the outgoing frame
      // used to draw at (1-progress)*hitAlpha (complementary to the
      // incoming frame's progress*hitAlpha). Under standard canvas
      // source-over compositing, two layers at complementary PARTIAL
      // alphas never reach full opacity for the (large) non-overlapping
      // part of a moving sprite's silhouette -- read as a constant
      // dull/transparent look while running, once follow-up 3 made this
      // blend run on every step instead of only 4/16. Fix: draw the
      // outgoing frame at FULL alpha (still dimmed by hit-reaction only)
      // and let only the incoming frame fade in on top -- the standard
      // correct cross-dissolve recipe, opaque everywhere the outgoing
      // frame has content, with only the genuinely-new incoming-only
      // pixels briefly fading in from transparent.
      // ROJO RUN — Phase 2 follow-up 5 (2026-07-31): follow-up 4's opaque
      // outgoing frame stayed correctly solid, but the blend itself was
      // still active across a frame's ENTIRE display slot -- by the
      // instant right before every cut, the incoming frame's alpha had
      // ramped almost to 1, so two different, both near-fully-opaque
      // poses were visible at once for effectively the whole time the
      // character ran, not just at the cut. Owner-reported as a
      // double-image / extra-limb "shapeshifting" look. Fix: the current
      // frame is now always drawn once, alone, at full alpha -- crisp,
      // for most of the frame's display time. The incoming frame is only
      // additionally layered on top during a short trailing tail window
      // (ROJO_RUN_RUN_BLEND_TAIL_FRACTION of the frame's duration), so
      // the cross-fade is confined to just the moment of the cut instead
      // of the frame's whole lifetime.
      if (rojoRunPlayerGrounded) {
        ctx.save();
        ctx.globalAlpha = rojoRunPlayerHitReactionAlpha;
        ctx.drawImage(
          rojoRunPlayerRunImage,
          rojoRunPlayerRunFrameSourceX, rojoRunPlayerRunFrameSourceY, ROJO_RUN_PLAYER_SPRITE_SOURCE_SIZE, ROJO_RUN_PLAYER_SPRITE_SOURCE_SIZE,
          rojoRunPlayerSpriteDestX, rojoRunPlayerSpriteDestY, ROJO_RUN_PLAYER_SPRITE_DRAW_SIZE, ROJO_RUN_PLAYER_SPRITE_DRAW_SIZE
        );
        ctx.restore();
        const rojoRunPlayerRunTimeIntoSlot = rojoRunRunAnimationElapsedSeconds % ROJO_RUN_RUN_FRAME_DURATION_SECONDS;
        const rojoRunPlayerRunBlendTailSeconds = ROJO_RUN_RUN_FRAME_DURATION_SECONDS * ROJO_RUN_RUN_BLEND_TAIL_FRACTION;
        const rojoRunPlayerRunBlendTailStart = ROJO_RUN_RUN_FRAME_DURATION_SECONDS - rojoRunPlayerRunBlendTailSeconds;
        // ROJO RUN — Phase 2 follow-up 6 (2026-07-31): the sprite sheet's 16
        // frames are 4 discrete facing-direction blocks (front/back/front/
        // back) -- the last step of each block is a flip to a visually
        // unrelated image, not a similar-pose shift, so blending it the
        // same way as every other step reads as a flicker/snap instead of
        // natural motion. Skip the blend-tail there and cut instantly;
        // every other transition is unaffected.
        // ROJO RUN — Phase 2 follow-up 7 (2026-07-31): each block is now 3
        // playback steps instead of 4 (its own first frame is skipped --
        // see ROJO_RUN_RUN_PLAYBACK_FRAME_INDICES above), so the boundary
        // check is re-derived from % 4 === 3 to % 3 === 2 to keep landing
        // on the true last step of each new, shorter block.
        const rojoRunPlayerRunIsBlockBoundaryStep = rojoRunPlayerRunPlaybackStep % 3 === 2;
        if (!rojoRunPlayerRunIsBlockBoundaryStep && rojoRunPlayerRunTimeIntoSlot >= rojoRunPlayerRunBlendTailStart) {
          const rojoRunPlayerRunBlendProgress = (rojoRunPlayerRunTimeIntoSlot - rojoRunPlayerRunBlendTailStart) / rojoRunPlayerRunBlendTailSeconds;
          const rojoRunPlayerRunNextSheetIndex = ROJO_RUN_RUN_PLAYBACK_FRAME_INDICES[(rojoRunPlayerRunPlaybackStep + 1) % ROJO_RUN_RUN_FRAME_COUNT];
          const rojoRunPlayerRunNextSourceX = (rojoRunPlayerRunNextSheetIndex % 4) * ROJO_RUN_PLAYER_SPRITE_SOURCE_SIZE;
          const rojoRunPlayerRunNextSourceY = Math.floor(rojoRunPlayerRunNextSheetIndex / 4) * ROJO_RUN_PLAYER_SPRITE_SOURCE_SIZE;
          ctx.save();
          ctx.globalAlpha = rojoRunPlayerRunBlendProgress * rojoRunPlayerHitReactionAlpha;
          ctx.drawImage(
            rojoRunPlayerRunImage,
            rojoRunPlayerRunNextSourceX, rojoRunPlayerRunNextSourceY, ROJO_RUN_PLAYER_SPRITE_SOURCE_SIZE, ROJO_RUN_PLAYER_SPRITE_SOURCE_SIZE,
            rojoRunPlayerSpriteDestX, rojoRunPlayerSpriteDestY, ROJO_RUN_PLAYER_SPRITE_DRAW_SIZE, ROJO_RUN_PLAYER_SPRITE_DRAW_SIZE
          );
          ctx.restore();
        }
      } else {
        ctx.save();
        ctx.globalAlpha = rojoRunPlayerHitReactionAlpha;
        ctx.drawImage(
          rojoRunPlayerRunImage,
          rojoRunPlayerRunFrameSourceX, rojoRunPlayerRunFrameSourceY, ROJO_RUN_PLAYER_SPRITE_SOURCE_SIZE, ROJO_RUN_PLAYER_SPRITE_SOURCE_SIZE,
          rojoRunPlayerSpriteDestX, rojoRunPlayerSpriteDestY, ROJO_RUN_PLAYER_SPRITE_DRAW_SIZE, ROJO_RUN_PLAYER_SPRITE_DRAW_SIZE
        );
        ctx.restore();
      }
    } else {
      ctx.fillStyle = rojoRunHitReactionRemaining > 0 ? '#FFEDE7' : '#C0423F';
      ctx.fillRect(
        ROJO_RUN_PLAYER_SCREEN_X,
        rojoRunPlayerFootY - ROJO_RUN_PLAYER_HEIGHT,
        ROJO_RUN_PLAYER_WIDTH,
        ROJO_RUN_PLAYER_HEIGHT
      );
    }
  }

  function rojoRunLoopTick(timestamp) {
    if (!rojoRunLoopRunning || rojoRunLoopPaused) return;

    const frameMs = rojoRunLastFrameTime ? Math.min(timestamp - rojoRunLastFrameTime, ROJO_RUN_MAX_FRAME_MS) : 0;
    rojoRunLastFrameTime = timestamp;
    rojoRunAccumulatorMs += frameMs;

    while (rojoRunAccumulatorMs >= ROJO_RUN_STEP_MS) {
      rojoRunSimulationStep(ROJO_RUN_STEP_SECONDS);
      rojoRunAccumulatorMs -= ROJO_RUN_STEP_MS;
    }

    // ROJO OS — bug fix (2026-08-06): standard fixed-timestep render
    // interpolation. rojoRunAccumulatorMs here is always < ROJO_RUN_STEP_MS
    // (the while loop above only exits once it is) — the leftover fraction
    // of a step not yet consumed. Blending the last two simulation
    // snapshots by this fraction gives terrain/swell rendering a smooth,
    // real-time-tracking position instead of the raw stepped value's
    // uneven whole-pixel jumps. Only rojoRunPlayerWorldDistanceRender is
    // affected — the authoritative rojoRunPlayerWorldDistance driving
    // physics/collision/hazards/checkpoints is untouched.
    const rojoRunStepAlpha = rojoRunAccumulatorMs / ROJO_RUN_STEP_MS;
    rojoRunPlayerWorldDistanceRender = rojoRunPlayerWorldDistanceAtLastStep + (rojoRunPlayerWorldDistance - rojoRunPlayerWorldDistanceAtLastStep) * rojoRunStepAlpha;

    // ROJO OS — bug fix (2026-08-06, round 2): desktop-only. A WAAPI
    // currentTime seek (the round-1 attempt at this fix) still leaves the
    // transform's actual application to the browser's own compositor pass,
    // which can lag the synchronous canvas paint below by up to one frame —
    // see rojoRunSetDesktopContainerTrackX()'s declaration comment for the
    // full root-cause writeup. This writes the container/Signal-Fracture/
    // checkpoint-pillar track's transform directly, synchronously, on the
    // main thread, from this exact frame's rojoRunPlayerWorldDistanceRender
    // — the identical value terrain uses two lines below in
    // rojoRunRenderFrame() — so both are committed in the same JS turn, no
    // compositor generation gap possible. Mobile is untouched: its own
    // terrain is itself WAAPI-driven (baked tiles), so it keeps using
    // rojoRunStartContainerLayerAnimation()'s original play()-based path.
    if (!rojoRunHasCoarsePointer()) {
      rojoRunSetDesktopContainerTrackX(rojoRunPlayerWorldDistanceRender);
    }

    rojoRunRenderFrame();

    rojoRunLoopId = window.requestAnimationFrame(rojoRunLoopTick);
  }

  function startRojoRunLoop() {
    if (rojoRunLoopRunning) return;
    rojoRunLoopRunning = true;
    rojoRunLoopPaused = false;
    rojoRunAccumulatorMs = 0;
    rojoRunLastFrameTime = 0;
    rojoRunLoopId = window.requestAnimationFrame(rojoRunLoopTick);
  }

  function pauseRojoRunLoop() {
    if (!rojoRunLoopRunning || rojoRunLoopPaused) return;
    rojoRunLoopPaused = true;
    window.cancelAnimationFrame(rojoRunLoopId);
    rojoRunLoopId = null;
    if (rojoRunHasCoarsePointer()) {
      // ROJO RUN — Phase 4A iOS fix: freeze the mobile wall-clock and every
      // tile animation together, so neither drifts ahead of the other while
      // paused (visibility change, backgrounding). The Web Animations API's
      // own pause() already preserves each animation's currentTime exactly —
      // no manual keyframe/duration bookkeeping needed on the tile side, only
      // on the separate JS wall-clock side below.
      rojoRunMobilePauseStartedAt = performance.now();
      rojoRunTileAnimations.forEach((anim) => { if (anim) anim.pause(); });
    }
    // ROJO RUN — Phase 8B: parallax pauses on both platforms, independent of
    // the mobile-only tile-animation block above (never merged into it).
    rojoRunParallaxAnimations.forEach((anim) => { if (anim) anim.pause(); });
    // ROJO RUN — Phase 9 round 9: container layer pauses on both platforms,
    // same reasoning as parallax above.
    if (rojoRunContainerLayerAnimation) rojoRunContainerLayerAnimation.pause();
    // ROJO OS — bug fix (2026-08-06): world-object layer (checkpoint
    // pillars/Signal Fractures/Pulse Zones/finish marker) pauses in lockstep
    // too, same reasoning as the container layer directly above — a no-op
    // on desktop, where this animation is never created/played.
    if (rojoRunWorldObjectLayerAnimation) rojoRunWorldObjectLayerAnimation.pause();
    // ROJO RUN — Phase 9 item 6 follow-up 2: Pulse Zone glow animations
    // pause in lockstep too — this is what keeps the visual glow's WAAPI
    // clock from drifting away from worldTimeSeconds (the real danger-
    // timing signal) while the sim is frozen.
    rojoRunPulseZoneGlowAnimations.forEach((anim) => { if (anim) anim.pause(); });
  }

  function resumeRojoRunLoop() {
    if (!rojoRunLoopRunning || !rojoRunLoopPaused) return;
    rojoRunLoopPaused = false;
    rojoRunLastFrameTime = 0;
    rojoRunLoopId = window.requestAnimationFrame(rojoRunLoopTick);
    if (rojoRunHasCoarsePointer()) {
      if (rojoRunMobilePauseStartedAt !== null) {
        rojoRunMobilePausedTotalMs += performance.now() - rojoRunMobilePauseStartedAt;
        rojoRunMobilePauseStartedAt = null;
      }
      rojoRunTileAnimations.forEach((anim) => { if (anim) anim.play(); });
    }
    // ROJO RUN — Phase 8B: parallax resumes on both platforms, independent
    // of the mobile-only tile-animation block above.
    rojoRunParallaxAnimations.forEach((anim) => { if (anim) anim.play(); });
    // ROJO RUN — Phase 9 round 9: container layer resumes on both platforms,
    // same reasoning as parallax above.
    if (rojoRunContainerLayerAnimation) rojoRunContainerLayerAnimation.play();
    // ROJO OS — bug fix (2026-08-06): world-object layer resumes in
    // lockstep too — see the matching pause() call above; no-op on desktop.
    if (rojoRunWorldObjectLayerAnimation) rojoRunWorldObjectLayerAnimation.play();
    // ROJO RUN — Phase 9 item 6 follow-up 2: Pulse Zone glow animations
    // resume in lockstep too — see the matching pause() call above.
    rojoRunPulseZoneGlowAnimations.forEach((anim) => { if (anim) anim.play(); });
  }

  function stopRojoRunLoop() {
    if (rojoRunLoopId !== null) window.cancelAnimationFrame(rojoRunLoopId);
    rojoRunLoopId = null;
    rojoRunLoopRunning = false;
    rojoRunLoopPaused = false;
    rojoRunAccumulatorMs = 0;
    rojoRunLastFrameTime = 0;
  }

  // ROJO RUN — Phase 8B bug fix (2026-07-23): updateRojoRunArenaFit() used to
  // unconditionally rewrite rojoRunArenaFrame's width/height and recompute +
  // rewrite the tile-scaler's transform on every single call — and mobile
  // Safari calls this constantly (see updateRojoRunOrientation()'s own
  // comment: "mobile Safari fires resize events constantly, e.g. address-bar
  // collapse, even with no real orientation change"), completely unrelated
  // to any game event. Every one of those spurious, no-op-in-substance calls
  // was still forcing Safari to re-evaluate the whole arena-frame's
  // compositing subtree — including the parallax layers behind it — which
  // is what was actually causing the "random, no pattern" flicker the owner
  // kept seeing: none of it was ever about the parallax layers' own design
  // (multiple targeted fixes there made no difference), it was this
  // ancestor being needlessly re-styled on every spurious resize. Cached
  // here so the expensive work below only runs when the fit has genuinely
  // changed.
  let rojoRunLastArenaFitWidth = null;
  let rojoRunLastArenaFitHeight = null;
  // ROJO RUN — Phase 9 fix (2026-07-23): touch/JUMP taps can trigger iOS
  // Safari's address-bar chrome to animate open/closed, firing several
  // visualViewport "resize" events in quick succession while it does. Each
  // one calls updateRojoRunArenaFit() below, which — when the size has
  // genuinely changed mid-animation, not just a repeat — synchronously
  // rewrites this frame's size and the mobile tile-scaler's transform. The
  // live gameplay canvas (containers, player, hazards) rescales separately
  // via its own browser-native CSS "cover" fit, on its own timing — so for
  // a few frames mid-animation the tile-world and the live canvas can be
  // fit to two slightly different transient sizes, read as a brief shake
  // (most visible on the small, high-contrast container sprite). Debouncing
  // just this resize-triggered path collapses a whole chrome-animation's
  // worth of events into one settled application, instead of reacting to
  // every intermediate tick.
  let rojoRunArenaFitDebounceTimer = null;

  function updateRojoRunArenaFit() {
    if (!rojoRunArenaFrame || !rojoRunPlaying) return;
    if (rojoRunShell?.dataset.rojoRunState !== 'playing') return;

    // The visible frame is reserved space, not a 16:9 box — it takes all width
    // remaining after the fixed right-side JUMP control strip and its gap, and
    // the full available height. The canvas keeps its intrinsic 1920x1080
    // aspect ratio and is presented with a CSS "cover" crop inside this wider
    // frame (see .rojo-run-canvas), so the coordinate system itself is untouched.
    const controlStripWidth = 88;
    const controlGap = 8;
    const availableWidth = rojoRunPlaying.clientWidth - controlStripWidth - controlGap;
    const availableHeight = rojoRunPlaying.clientHeight;

    if (!(availableWidth > 0) || !(availableHeight > 0)) return;

    if (availableWidth === rojoRunLastArenaFitWidth && availableHeight === rojoRunLastArenaFitHeight) {
      return;
    }
    rojoRunLastArenaFitWidth = availableWidth;
    rojoRunLastArenaFitHeight = availableHeight;

    rojoRunArenaFrame.style.width = `${availableWidth}px`;
    rojoRunArenaFrame.style.height = `${availableHeight}px`;

    if (rojoRunHasCoarsePointer()) {
      rojoRunArenaFrame.classList.add('is-tile-compositor-mode');
      if (rojoRunTileWorldScaler && rojoRunTileWorldViewport) {
        // ROJO RUN — Phase 4A iOS fix: object-fit:cover-equivalent vertical
        // centering for this non-replaced DOM layer, computed fresh from the
        // actual live viewport dimensions every time. Deliberately no
        // top:50%/translateY(-50%)/translate3d(0,-50%,0)/percentage-based
        // centering anywhere — a CSS percentage inside a transform resolves
        // against the element's own untransformed box, not the viewport, so
        // any such shortcut here would silently reproduce the exact bug this
        // was built to avoid.
        const viewportWidth = rojoRunTileWorldViewport.clientWidth;
        const viewportHeight = rojoRunTileWorldViewport.clientHeight;
        const coverScale = Math.max(viewportWidth / ROJO_RUN_VIRTUAL_WIDTH, viewportHeight / ROJO_RUN_VIRTUAL_HEIGHT);
        const scaledHeight = ROJO_RUN_VIRTUAL_HEIGHT * coverScale;
        const verticalOffset = (viewportHeight - scaledHeight) / 2;
        rojoRunTileWorldScaler.style.transformOrigin = 'left top';
        rojoRunTileWorldScaler.style.transform = `translate3d(0, ${verticalOffset}px, 0) scale(${coverScale})`;
      }
    } else {
      rojoRunArenaFrame.classList.remove('is-tile-compositor-mode');
    }

    // ROJO RUN — Phase 9 round 9: the paint-container layer needs this same
    // cover-scale/vertical-centering treatment on BOTH platforms (unlike the
    // tile-scaler block above, mobile-only) — rojoRunTileWorldViewport is
    // hidden on desktop (0 clientWidth/Height there), so this reuses
    // availableWidth/availableHeight instead, already valid on both.
    if (rojoRunContainerScaler) {
      const containerCoverScale = Math.max(availableWidth / ROJO_RUN_VIRTUAL_WIDTH, availableHeight / ROJO_RUN_VIRTUAL_HEIGHT);
      const containerScaledHeight = ROJO_RUN_VIRTUAL_HEIGHT * containerCoverScale;
      const containerVerticalOffset = (availableHeight - containerScaledHeight) / 2;
      rojoRunContainerScaler.style.transformOrigin = 'left top';
      rojoRunContainerScaler.style.transform = `translate3d(0, ${containerVerticalOffset}px, 0) scale(${containerCoverScale})`;
    }

    // ROJO OS — bug fix (2026-08-06): rojoRunWorldObjectScaler (checkpoint
    // pillars, Signal Fractures, Pulse Zones, finish marker) needs the exact
    // same cover-scale/vertical-centering treatment as rojoRunContainerScaler
    // just above — same box, same formula, just applied to the second
    // scaler too so both layers stay pixel-identical in scale/position.
    if (rojoRunWorldObjectScaler) {
      const worldObjectCoverScale = Math.max(availableWidth / ROJO_RUN_VIRTUAL_WIDTH, availableHeight / ROJO_RUN_VIRTUAL_HEIGHT);
      const worldObjectScaledHeight = ROJO_RUN_VIRTUAL_HEIGHT * worldObjectCoverScale;
      const worldObjectVerticalOffset = (availableHeight - worldObjectScaledHeight) / 2;
      rojoRunWorldObjectScaler.style.transformOrigin = 'left top';
      rojoRunWorldObjectScaler.style.transform = `translate3d(0, ${worldObjectVerticalOffset}px, 0) scale(${worldObjectCoverScale})`;
    }
  }

  // ROJO RUN — Phase 9 fix (2026-07-23): used only by the resize-event path
  // in updateRojoRunOrientation() — the run-start and backgrounding-resume
  // call sites still call updateRojoRunArenaFit() directly, unchanged, since
  // those need to apply instantly, not after a settle delay.
  function rojoRunDebouncedUpdateArenaFit() {
    window.clearTimeout(rojoRunArenaFitDebounceTimer);
    rojoRunArenaFitDebounceTimer = window.setTimeout(updateRojoRunArenaFit, 150);
  }

  function resetRojoRunArenaFit() {
    if (!rojoRunArenaFrame) return;
    window.clearTimeout(rojoRunArenaFitDebounceTimer);
    rojoRunArenaFitDebounceTimer = null;
    rojoRunArenaFrame.style.removeProperty('width');
    rojoRunArenaFrame.style.removeProperty('height');
    rojoRunArenaFrame.classList.remove('is-tile-compositor-mode');
    // ROJO RUN — Phase 8B bug fix: clear the memoized fit so the next
    // updateRojoRunArenaFit() call (e.g. after rotating back to landscape)
    // re-applies for real instead of being skipped as a false "unchanged".
    rojoRunLastArenaFitWidth = null;
    rojoRunLastArenaFitHeight = null;
  }

  function releaseRojoRunJumpPointerCapture(pointerId) {
    if (pointerId === null || pointerId === undefined || !rojoRunJumpButton) return;
    try {
      if (typeof rojoRunJumpButton.hasPointerCapture === 'function') {
        if (rojoRunJumpButton.hasPointerCapture(pointerId)) {
          rojoRunJumpButton.releasePointerCapture(pointerId);
        }
      } else if (typeof rojoRunJumpButton.releasePointerCapture === 'function') {
        rojoRunJumpButton.releasePointerCapture(pointerId);
      }
    } catch (error) {
      // Capture may already be gone (pointercancel, rotation, backgrounding, DOM
      // changes) — never let this interrupt ROJO RUN teardown.
    }
  }

  function updateRojoRunJumpVisual(isPressed) {
    if (!rojoRunJumpButton) return;
    rojoRunJumpButton.classList.toggle('is-pressed', isPressed);
    rojoRunJumpButton.setAttribute('aria-pressed', isPressed ? 'true' : 'false');
  }

  function rojoRunSyncJumpHeldState() {
    const shouldBeHeld = rojoRunActiveJumpKeys.size > 0 || rojoRunActiveJumpPointerId !== null;

    if (shouldBeHeld && !rojoRunJumpHeld) {
      rojoRunJumpHeld = true;
      rojoRunJumpPressQueued = true;
      rojoRunJumpPressStart = performance.now();
      updateRojoRunJumpVisual(true);
    } else if (!shouldBeHeld && rojoRunJumpHeld) {
      rojoRunJumpHeld = false;
      rojoRunJumpReleaseQueued = true;
      rojoRunJumpLastHoldDuration = performance.now() - rojoRunJumpPressStart;
      updateRojoRunJumpVisual(false);
    }
  }

  function rojoRunJumpKeyMatches(event) {
    return event.code === 'Space' || event.code === 'KeyW' || event.code === 'ArrowUp';
  }

  function handleRojoRunKeydown(event) {
    if (!rojoRunActive || rojoRunShell?.dataset.rojoRunState !== 'playing') return;
    // ROJO RUN — Phase 6B/6C: state is already 'playing' throughout both
    // the frozen countdown and a manual pause by design — these two flags
    // are what actually block input, since the state check above alone
    // can't distinguish "frozen countdown"/"paused" from "live gameplay".
    // The pause overlay also physically covers JUMP (see rojoRunOpenPause
    // and its CSS), but keyboard events aren't blocked by DOM coverage at
    // all, so this check is load-bearing here, not just belt-and-suspenders.
    if (rojoRunCountdownActive || rojoRunPauseActive || rojoRunGameOver || rojoRunLevelComplete) return;
    if (!rojoRunJumpKeyMatches(event)) return;
    event.preventDefault();
    if (event.repeat) return;
    rojoRunActiveJumpKeys.add(event.code);
    rojoRunSyncJumpHeldState();
  }

  function handleRojoRunKeyup(event) {
    if (!rojoRunJumpKeyMatches(event)) return;
    rojoRunActiveJumpKeys.delete(event.code);
    rojoRunSyncJumpHeldState();
  }

  function handleRojoRunJumpPointerDown(event) {
    if (rojoRunActiveJumpPointerId !== null) return;
    // ROJO RUN — Phase 6B/6C: during the frozen countdown, JUMP is fully
    // visible (by design, per the "arena already visible" spec) with
    // nothing covering it, so rojoRunCountdownActive is what blocks a tap
    // there. During a manual pause the overlay physically covers JUMP
    // (see rojoRunOpenPause's CSS) so this check is defense-in-depth for
    // that case specifically.
    if (rojoRunCountdownActive || rojoRunPauseActive || rojoRunGameOver || rojoRunLevelComplete) return;
    event.preventDefault();
    rojoRunJumpButton?.setPointerCapture?.(event.pointerId);
    rojoRunActiveJumpPointerId = event.pointerId;
    rojoRunSyncJumpHeldState();
  }

  function handleRojoRunJumpContextMenu(event) {
    event.preventDefault();
  }

  function handleRojoRunJumpPointerUp(event) {
    if (event.pointerId !== rojoRunActiveJumpPointerId) return;
    releaseRojoRunJumpPointerCapture(event.pointerId);
    rojoRunActiveJumpPointerId = null;
    rojoRunSyncJumpHeldState();
  }

  function handleRojoRunJumpLostPointerCapture(event) {
    if (event.pointerId !== rojoRunActiveJumpPointerId) return;
    rojoRunActiveJumpPointerId = null;
    rojoRunSyncJumpHeldState();
  }

  function resetRojoRunInput() {
    rojoRunActiveJumpKeys.clear();
    releaseRojoRunJumpPointerCapture(rojoRunActiveJumpPointerId);
    rojoRunActiveJumpPointerId = null;
    rojoRunJumpHeld = false;
    rojoRunJumpPressQueued = false;
    rojoRunJumpReleaseQueued = false;
    rojoRunJumpPressStart = 0;
    rojoRunJumpLastHoldDuration = 0;
    updateRojoRunJumpVisual(false);
  }

  // ROJO RUN — Phase 6B: entry point into the countdown. Guard changed
  // from the old 'landscape' check to 'select' — this now fires from the
  // character-select START button, not the title screen, and is what
  // actually arms the frozen arena. This is also what makes the guard
  // itself double as "prevent duplicate countdowns": once state flips to
  // 'playing', a second call (e.g. a double-tap on START) fails the same
  // guard and no-ops, identical to how this function already prevented
  // double-entry before Phase 6B.
  //
  // Bug fix (confirmed via code read, not guessed): resetRojoRunPlayer()
  // -> resetRojoRunPlayerPhysics() -> rojoRunStartTileAnimations() (mobile
  // only) deliberately defers actually PLAYING the 16 tile animations to
  // the *next* requestAnimationFrame after creating them (so all 16 share
  // an identical start time — that deferral itself is correct, existing,
  // pre-Phase-6B behavior). Calling pauseRojoRunLoop() synchronously, in
  // the same tick as resetRojoRunPlayer(), ran BEFORE that deferred play
  // ever fired — cancelAnimationFrame(rojoRunLoopId) only cancels this
  // loop's own rAF handle, not that separate anonymous one, so the pause
  // had zero effect on the tile animations. They started scrolling,
  // completely unsupervised, one frame later and kept going for the
  // entire countdown while rojoRunPlayerWorldDistance stayed frozen at 0
  // — the visual terrain and the logical world position permanently
  // diverged, which is what broke container collection and caused false
  // falls once gameplay actually started.
  //
  // Fix: defer OUR pause (and the countdown start) into one more
  // requestAnimationFrame, scheduled after resetRojoRunPlayer() and
  // startRojoRunLoop() above. Same-frame rAF callbacks fire in scheduling
  // order, so this guarantees our pause runs immediately after the tile
  // animations' own deferred play — same frame, before any paint, zero
  // visible drift. This does NOT introduce a stray simulation tick: the
  // one incidental rojoRunLoopTick that fires in the gap always computes
  // zero elapsed frame time on its first call (startRojoRunLoop() resets
  // rojoRunLastFrameTime to 0, and the tick's frameMs calculation treats
  // a falsy rojoRunLastFrameTime as 0 elapsed), so it does zero real
  // simulation advancement — just one harmless extra idempotent render.
  // ROJO RUN — Phase 6B/6C: shared "build a fresh arena, then freeze it
  // and run the countdown" sequence — used both for the first entry into
  // gameplay (enterRojoRunPlaying) and for a restart from the pause menu
  // (rojoRunConfirmRestart). stopRojoRunLoop() first is a safe no-op on
  // first entry (loop was never running) and is what makes a restart from
  // an already-paused state correct — without it, pauseRojoRunLoop()'s
  // own "already paused" guard would silently skip pausing the freshly
  // rebuilt tile animations.
  function rojoRunArmCountdown() {
    // ROJO RUN — reaffirms the game's one permanent speed at the top of
    // every run, purely for defensive consistency (see the declaration
    // comment above) — the value itself never actually changes.
    ROJO_RUN_BASE_SPEED = ROJO_RUN_ROJO_SPEED;
    stopRojoRunLoop();
    updateRojoRunArenaFit();
    resetRojoRunPlayer();
    rojoRunRenderFrame();
    startRojoRunLoop();
    window.requestAnimationFrame(() => {
      pauseRojoRunLoop();
      rojoRunBeginCountdown();
    });
  }

  function enterRojoRunPlaying() {
    if (!rojoRunActive || !rojoRunShell || rojoRunShell.dataset.rojoRunState !== 'intro') return;
    setRojoRunState('playing');
    rojoRunArmCountdown();
  }

  const ROJO_RUN_COUNTDOWN_NUMBER_STEPS = ['3', '2', '1'];
  const ROJO_RUN_COUNTDOWN_STEP_MS = 800;
  const ROJO_RUN_COUNTDOWN_RUN_HOLD_MS = 320;

  function rojoRunShowCountdownStep(label) {
    if (!rojoRunCountdownNumber) return;
    rojoRunCountdownNumber.textContent = label;
    rojoRunCountdownNumber.classList.remove('is-popping');
    // Force a reflow so the pop animation replays on every step, not just
    // the first — the browser won't restart a still-applied animation
    // class without this.
    void rojoRunCountdownNumber.offsetWidth;
    rojoRunCountdownNumber.classList.add('is-popping');
  }

  function rojoRunAdvanceCountdown() {
    if (rojoRunCountdownStepIndex < ROJO_RUN_COUNTDOWN_NUMBER_STEPS.length) {
      rojoRunShowCountdownStep(ROJO_RUN_COUNTDOWN_NUMBER_STEPS[rojoRunCountdownStepIndex]);
      rojoRunCountdownStepIndex += 1;
      rojoRunCountdownTimer = window.setTimeout(rojoRunAdvanceCountdown, ROJO_RUN_COUNTDOWN_STEP_MS);
      return;
    }
    rojoRunShowCountdownStep('RUN');
    rojoRunCountdownOverlay?.classList.add('is-flashing');
    rojoRunCountdownTimer = window.setTimeout(rojoRunFinishCountdown, ROJO_RUN_COUNTDOWN_RUN_HOLD_MS);
  }

  function rojoRunBeginCountdown() {
    rojoRunCountdownActive = true;
    rojoRunCountdownStepIndex = 0;
    if (rojoRunCountdownOverlay) {
      rojoRunCountdownOverlay.classList.remove('is-flashing');
      rojoRunCountdownOverlay.classList.add('is-visible');
    }
    rojoRunAdvanceCountdown();
  }

  // ROJO RUN — Phase 6B: the one moment world movement begins. Resumes
  // the JS loop and every mobile WAAPI tile animation together via the
  // exact same resumeRojoRunLoop() already proven correct for
  // backgrounding-resume (wall-clock offset bookkeeping included) — no
  // arena rebuild, no resize, just this one call.
  function rojoRunFinishCountdown() {
    rojoRunCountdownActive = false;
    if (rojoRunCountdownOverlay) {
      rojoRunCountdownOverlay.classList.remove('is-visible');
      rojoRunCountdownOverlay.classList.remove('is-flashing');
    }
    resumeRojoRunLoop();
  }

  // ROJO RUN — Phase 6B: cancels any pending countdown timer without
  // touching loop state — used by interruption paths (rotate-away,
  // teardown) that already handle stopping the loop themselves.
  function rojoRunCancelCountdown() {
    window.clearTimeout(rojoRunCountdownTimer);
    rojoRunCountdownTimer = null;
    rojoRunCountdownActive = false;
    if (rojoRunCountdownOverlay) {
      rojoRunCountdownOverlay.classList.remove('is-visible');
      rojoRunCountdownOverlay.classList.remove('is-flashing');
    }
  }

  // ROJO RUN — Phase 6B: title screen -> mission briefing.
  function enterRojoRunIntro() {
    if (!rojoRunActive || !rojoRunShell || rojoRunShell.dataset.rojoRunState !== 'landscape') return;
    setRojoRunState('intro');
  }

  // ROJO RUN — records that only ever move up (a worse run never overwrites
  // a better one). Writes to localStorage only if something actually
  // changed, avoiding a pointless write on an otherwise-unremarkable
  // completion. Character-unlock tracking removed 2026-07-30 (the game is
  // ROJO-Tavo-only now — there's nothing left to unlock).
  function rojoRunUpdateSaveOnCompletion(results) {
    let changed = false;
    if (results.score > rojoRunSave.highScore) {
      rojoRunSave.highScore = results.score;
      changed = true;
    }
    if (results.containersCollected > rojoRunSave.bestContainers) {
      rojoRunSave.bestContainers = results.containersCollected;
      changed = true;
    }
    if (results.noDamageRun && !rojoRunSave.noDamageEver) {
      rojoRunSave.noDamageEver = true;
      changed = true;
    }
    if (!changed) return;
    rojoRunWriteSave();
  }

  // ROJO RUN — Phase 6C: pause, restart, exit. Only opens from genuine
  // live gameplay — blocked during the countdown freeze (belt-and-
  // suspenders alongside the JUMP-specific guards) and against re-opening
  // an already-open menu. Reuses the exact same pauseRojoRunLoop() proven
  // correct for the countdown freeze and tab-backgrounding — a third
  // reuse of that one mechanism rather than a fourth freeze
  // implementation.
  function rojoRunOpenPause() {
    if (!rojoRunActive || rojoRunShell?.dataset.rojoRunState !== 'playing') return;
    if (rojoRunCountdownActive || rojoRunPauseActive || rojoRunGameOver || rojoRunLevelComplete) return;
    rojoRunPauseActive = true;
    pauseRojoRunLoop();
    resetRojoRunInput();
    if (rojoRunPauseOverlay) {
      rojoRunPauseOverlay.dataset.rojoRunPauseMode = 'menu';
      rojoRunPauseOverlay.classList.add('is-visible');
    }
  }

  function rojoRunClosePauseOverlay() {
    rojoRunPauseActive = false;
    if (rojoRunPauseOverlay) {
      rojoRunPauseOverlay.classList.remove('is-visible');
      rojoRunPauseOverlay.dataset.rojoRunPauseMode = 'menu';
    }
  }

  function rojoRunResumeFromPause() {
    if (!rojoRunPauseActive) return;
    rojoRunClosePauseOverlay();
    resumeRojoRunLoop();
  }

  function rojoRunRequestRestartConfirm() {
    if (!rojoRunPauseActive || !rojoRunPauseOverlay) return;
    rojoRunPauseOverlay.dataset.rojoRunPauseMode = 'confirm';
  }

  function rojoRunCancelRestartConfirm() {
    if (!rojoRunPauseActive || !rojoRunPauseOverlay) return;
    rojoRunPauseOverlay.dataset.rojoRunPauseMode = 'menu';
  }

  // ROJO RUN — confirmed restart goes straight back into a fresh countdown,
  // same reasoning/reversion as rojoRunRestartFromGameOver() above.
  function rojoRunConfirmRestart() {
    if (!rojoRunPauseActive) return;
    rojoRunClosePauseOverlay();
    stopRojoRunLoop();
    setRojoRunState('playing');
    rojoRunArmCountdown();
  }

  // ROJO RUN — Phase 6C: reuses the existing showHome() app-wide "return
  // to ROJO OS" function (same one Shop/Concepts/the globe icon already
  // use) rather than building new exit logic — TDOM Radio restoration,
  // via deactivateAllApps() -> stopRojoRun(), is already handled by it.
  function rojoRunExitToHome() {
    if (!rojoRunPauseActive) return;
    showHome();
  }

  // ROJO RUN no longer pauses/fades TDOM Radio on entry (owner-directed,
  // 2026-07-28, alongside the 7-track radio upgrade) — the radio now keeps
  // playing underneath gameplay; the existing play/pause button is still
  // the only way to stop it, at any time, including while ROJO RUN is
  // open. The whole fade/pause/restore/teardown mechanism this used to
  // route through (pauseRadioForRojoRun/restoreRadioAfterRojoRun/
  // teardownRadioForRojoRun/beginRadioFadeOut/finishRadioFadeOutImmediately,
  // plus their 8 dedicated state variables) has been removed in full —
  // grep-confirmed nothing else in the file ever referenced any part of it.

  function handleRojoRunVisibilityChange() {
    if (!rojoRunActive) return;

    if (document.hidden) {
      if (rojoRunLoopRunning && !rojoRunLoopPaused) pauseRojoRunLoop();
      resetRojoRunInput();
      // ROJO RUN — Phase 6B: only cancel the pending timer, not the
      // overlay/flag — rojoRunCountdownActive itself is what tells the
      // resume branch below a countdown needs restarting, not a normal
      // in-place resume.
      window.clearTimeout(rojoRunCountdownTimer);
      if (rojoRunSuspended) return;
      rojoRunSuspended = true;
      rojoRunSuspendedState = rojoRunShell?.dataset.rojoRunState || null;
      window.clearTimeout(rojoRunLaunchTimer);
      return;
    }

    if (!rojoRunSuspended) return;
    rojoRunSuspended = false;

    if (rojoRunSuspendedState === 'launch') {
      startRojoRunLaunch();
    } else if (rojoRunSuspendedState === 'playing' && rojoRunCountdownActive) {
      // ROJO RUN — Phase 6B: backgrounding mid-countdown restarts the
      // countdown from 3 on return rather than resuming mid-count —
      // simplest safe behavior, avoids any timing-drift guesswork on a
      // live timer that was hidden for an unknown duration.
      if (!rojoRunNeedsRotate() && rojoRunLoopRunning && rojoRunLoopPaused && rojoRunShell?.dataset.rojoRunState === 'playing') {
        rojoRunBeginCountdown();
      } else {
        rojoRunCancelCountdown();
        stopRojoRunLoop();
        resetRojoRunInput();
        resetRojoRunArenaFit();
        resetRojoRunPlayer();
        setRojoRunState(rojoRunNeedsRotate() ? 'rotate' : 'landscape');
      }
    } else if (rojoRunSuspendedState === 'playing' && rojoRunPauseActive) {
      // ROJO RUN — Phase 6C: backgrounding while the player manually
      // paused must NOT auto-resume gameplay out from under them — the
      // pause overlay was never hidden, so it's already showing exactly
      // as it was. Only re-validate orientation; if a rotate is now
      // needed, fall through to the same interruption handling 'playing'
      // already gets elsewhere (which also closes the pause overlay).
      if (rojoRunNeedsRotate()) {
        rojoRunCancelCountdown();
        rojoRunClosePauseOverlay();
        stopRojoRunLoop();
        resetRojoRunInput();
        resetRojoRunArenaFit();
        resetRojoRunPlayer();
        setRojoRunState('rotate');
      }
      // else: stay exactly as paused — nothing else to do.
    } else if (rojoRunSuspendedState === 'playing') {
      // Resume in place only if every assumption made when we backgrounded still
      // holds — an orientation/viewport event could have already stopped the
      // loop while hidden, and a stale resume must never be attempted.
      const canResumeInPlace =
        !rojoRunNeedsRotate() &&
        rojoRunLoopRunning &&
        rojoRunLoopPaused &&
        rojoRunShell?.dataset.rojoRunState === 'playing';

      if (canResumeInPlace) {
        resumeRojoRunLoop();
        updateRojoRunArenaFit();
      } else {
        stopRojoRunLoop();
        resetRojoRunInput();
        resetRojoRunArenaFit();
        resetRojoRunPlayer();
        setRojoRunState(rojoRunNeedsRotate() ? 'rotate' : 'landscape');
      }
    } else {
      updateRojoRunOrientation();
    }
    rojoRunSuspendedState = null;
  }

  function openRojoRun() {
    if (
      appTransitionLocked ||
      !root.classList.contains('is-home') ||
      root.classList.contains('is-app') ||
      !apps ||
      !rojoRunApp
    ) return;

    window.clearTimeout(appTransitionTimer);
    appTransitionLocked = true;
    const myTransitionToken = ++appTransitionToken;

    deactivateAllApps();
    resetConceptViews();

    // Two-beat open — see openShop() for the full explanation. Only this
    // opening choreography changes; startRojoRunLaunch() and everything
    // downstream in the ROJO RUN state machine (launch/rotate/landscape/
    // playing, terrain, physics, JUMP, collisions, checkpoints) is
    // untouched.
    root.classList.add('is-app-transition');
    menu.setAttribute('aria-hidden', 'true');

    appTransitionTimer = window.setTimeout(() => {
      if (myTransitionToken !== appTransitionToken) return;
      root.classList.add('is-app');
      apps.hidden = false;
      rojoRunApp.setAttribute('aria-hidden', 'false');

      rojoRunActive = true;
      updateRojoRunVisibleHeight();
      startRojoRunLaunch();

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          if (myTransitionToken !== appTransitionToken) return;
          rojoRunApp.classList.add('is-active');
          appTransitionTimer = window.setTimeout(() => {
            if (myTransitionToken !== appTransitionToken) return;
            finishAppTransition();
          }, 260);
        });
      });
    }, 260);
  }

  addRojoRunMediaListener(rojoRunLandscapeQuery, updateRojoRunOrientation);
  addRojoRunMediaListener(rojoRunCoarsePointerQuery, updateRojoRunOrientation);
  addRojoRunMediaListener(rojoRunShortHeightQuery, updateRojoRunOrientation);
  window.addEventListener('resize', updateRojoRunOrientation);
  window.visualViewport?.addEventListener('resize', updateRojoRunOrientation);
  document.addEventListener('visibilitychange', handleRojoRunVisibilityChange);
  document.addEventListener('keydown', handleRojoRunKeydown);
  document.addEventListener('keyup', handleRojoRunKeyup);
  rojoRunJumpButton?.addEventListener('pointerdown', handleRojoRunJumpPointerDown);
  rojoRunJumpButton?.addEventListener('pointerup', handleRojoRunJumpPointerUp);
  rojoRunJumpButton?.addEventListener('pointercancel', handleRojoRunJumpPointerUp);
  rojoRunJumpButton?.addEventListener('lostpointercapture', handleRojoRunJumpLostPointerCapture);
  rojoRunJumpButton?.addEventListener('contextmenu', handleRojoRunJumpContextMenu);
  rojoRunLandscapeEnter?.addEventListener('click', enterRojoRunIntro);
  rojoRunIntroEnter?.addEventListener('click', enterRojoRunPlaying);
  // ROJO RUN — Phase 8B: parallax canvas art is static placeholder content,
  // unrelated to any game/save state — baked once here at startup, same
  // "applied once" timing as the unlock-state call above, never rebuilt.
  rojoRunBakeParallaxCanvases();
  rojoRunPauseButton?.addEventListener('click', rojoRunOpenPause);
  rojoRunPauseResumeButton?.addEventListener('click', rojoRunResumeFromPause);
  rojoRunPauseRestartButton?.addEventListener('click', rojoRunRequestRestartConfirm);
  rojoRunPauseExitButton?.addEventListener('click', rojoRunExitToHome);
  rojoRunPauseConfirmYes?.addEventListener('click', rojoRunConfirmRestart);
  rojoRunPauseConfirmCancel?.addEventListener('click', rojoRunCancelRestartConfirm);
  rojoRunGameOverRestartButton?.addEventListener('click', rojoRunRestartFromGameOver);
  rojoRunGameOverExitButton?.addEventListener('click', rojoRunExitFromGameOver);
  rojoRunResultsReplayButton?.addEventListener('click', rojoRunReplayFromResults);
  rojoRunResultsExitButton?.addEventListener('click', rojoRunExitFromResults);

  enter.addEventListener('click', () => {
    if (root.classList.contains('is-entering')) return;
    root.classList.add('is-entering');
    rojoGlobeDebugEnterClickAt = performance.now();
    rojoGlobeDebugLog('ENTER click t=0ms');
    window.setTimeout(showHome, 860);
  });

  worldButton.addEventListener('click', (event) => {
    // From any ROJO OS app, the globe always returns directly to the homepage.
    if (root.classList.contains('is-app')) {
      showHome();
      return;
    }

    // Before ENTER ROJO MUNDO, the globe remains decorative.
    if (!root.classList.contains('is-home')) return;

    // Keyboard activation remains accessible. Pointer activation is accepted
    // only inside the visible globe, not the old transparent outer ring area.
    if (event.detail !== 0) {
      const rect = worldButton.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;
      const distance = Math.hypot(event.clientX - centerX, event.clientY - centerY);
      const visibleGlobeRadius = Math.min(rect.width, rect.height) * 0.46;
      if (distance > visibleGlobeRadius) return;
    }

    pulseWorld();
  });

  let productCount = productCards.length;
  let activeProductIndex = 0;
  let dragStartX = 0;
  let dragCurrentX = 0;
  let isDraggingProducts = false;
  let focusCard = null;
  let suppressProductClick = false;
  let dragPointerType = 'mouse';
  let activeCollectionHandle = collectionToggle?.dataset.defaultCollection || 'all';
  let currentCartItemCount = 0;

  function wrapProductIndex(index) {
    if (!productCount) return 0;
    return ((index % productCount) + productCount) % productCount;
  }

  function shortestProductDistance(index, activeIndex) {
    let distance = index - activeIndex;
    const half = productCount / 2;

    if (distance > half) distance -= productCount;
    if (distance < -half) distance += productCount;

    return distance;
  }

  function renderProductBrowser(dragOffset = 0) {
    if (!productCount) return;

    productCards.forEach((card, index) => {
      const slot = shortestProductDistance(index, activeProductIndex);
      const isOffstage = Math.abs(slot) > 2;

      card.classList.toggle('is-offstage', isOffstage);
      card.setAttribute('aria-hidden', slot === 0 ? 'false' : 'true');

      if (isOffstage) {
        card.dataset.slot = 'offstage';
        card.style.removeProperty('--drag-x');
        return;
      }

      card.dataset.slot = String(slot);
      card.style.setProperty('--slot', String(slot));
      card.style.setProperty('--drag-x', `${dragOffset}px`);
    });
  }

  function setCarouselLocked(locked) {
    if (productPrev) productPrev.disabled = locked || productCount < 2;
    if (productNext) productNext.disabled = locked || productCount < 2;
    productViewport?.classList.toggle('is-focus-open', locked);
  }

  function moveProductsBy(amount) {
    if (focusCard || productCount < 2 || !amount) return;
    activeProductIndex = wrapProductIndex(activeProductIndex + (amount > 0 ? 1 : -1));
    renderProductBrowser();
    syncActiveProductAngle();
  }

  function beginProductDrag(clientX, pointerType) {
    if (!productViewport || focusCard || productCount < 2) return;

    pauseProductAngleAutoplay();
    isDraggingProducts = true;
    suppressProductClick = false;
    dragPointerType = pointerType || 'mouse';
    dragStartX = clientX;
    dragCurrentX = clientX;
    productViewport.classList.add('is-dragging');
  }

  function updateProductDrag(clientX) {
    if (!isDraggingProducts || !productViewport) return;

    dragCurrentX = clientX;
    const rawOffset = dragCurrentX - dragStartX;
    const clickSuppressThreshold = dragPointerType === 'touch' ? 8 : 36;
    if (Math.abs(rawOffset) > clickSuppressThreshold) suppressProductClick = true;
    const resistance = Math.max(-100, Math.min(100, rawOffset * .56));
    renderProductBrowser(resistance);
  }

  function endProductDrag(event) {
    if (!productViewport) return;

    if (!isDraggingProducts) {
      if (!suppressProductClick && event && typeof event.clientX === 'number' && typeof event.clientY === 'number') {
        const releasedTarget = document.elementFromPoint(event.clientX, event.clientY);
        if (releasedTarget && !releasedTarget.closest('button, select, input')) {
          const releasedCard = releasedTarget.closest('[data-rojo-product-card]');
          if (releasedCard) openProductFocus(releasedCard);
        }
      }
      return;
    }

    const distance = dragCurrentX - dragStartX;
    const direction = distance < 0 ? 1 : -1;
    const shouldMove = Math.abs(distance) >= 36;

    isDraggingProducts = false;
    productViewport.classList.remove('is-dragging');

    if (shouldMove) {
      activeProductIndex = wrapProductIndex(activeProductIndex + direction);
    }

    renderProductBrowser();
    syncActiveProductAngle();

    if (!suppressProductClick && !shouldMove && event && typeof event.clientX === 'number' && typeof event.clientY === 'number') {
      const releasedTarget = document.elementFromPoint(event.clientX, event.clientY);
      if (releasedTarget && !releasedTarget.closest('button, select, input')) {
        const releasedCard = releasedTarget.closest('[data-rojo-product-card]');
        if (releasedCard) openProductFocus(releasedCard);
      }
    }

    window.setTimeout(() => {
      suppressProductClick = false;
    }, 80);
  }

  function openProductFocus(card) {
    if (!card || focusCard || card.dataset.slot !== '0' || suppressProductClick) return;
    focusCard = card;
    card.classList.add('is-flipped');
    setCarouselLocked(true);
    pauseProductAngleAutoplay();
    card.dispatchEvent(new CustomEvent('rojo:bundle-refresh'));
  }

  function closeProductFocus(card) {
    const target = card || focusCard;
    if (!target) return;
    target.classList.remove('is-flipped');
    focusCard = null;
    setCarouselLocked(false);
    resumeProductAngleAutoplay();
    target.dispatchEvent(new CustomEvent('rojo:bundle-reset'));
  }

  // PRODUCT ANGLE AUTOPLAY — crossfades a product's Shopify images (product.images,
  // owner-ordered) inside the existing media frame; only the centered/active card
  // (dataset.slot === '0') ever runs a timer, and only one timer exists at a time.
  // pauseProductAngleAutoplay() clears the timer without disturbing which angle is
  // showing (used for drags/focus, where the current angle must be preserved);
  // stopProductAngleAutoplay() additionally forgets the tracked card (used when the
  // Shop itself closes, so a stale card can never resume when it reopens).
  const ROJO_PRODUCT_ANGLE_INTERVAL_MS = 2800;
  let productAngleTimer = null;
  let productAngleTrackedCard = null;

  function getProductAngleImages(card) {
    const media = card && card.querySelector('.rojo-product-card__media');
    return media ? Array.from(media.querySelectorAll('.rojo-product-card__image')) : [];
  }

  function setProductAngle(card, index) {
    const images = getProductAngleImages(card);
    if (!images.length) return;

    const clampedIndex = ((index % images.length) + images.length) % images.length;

    images.forEach((image, imageIndex) => {
      image.classList.toggle('is-active', imageIndex === clampedIndex);
    });

    card.dataset.rojoActiveAngle = String(clampedIndex);

    const counter = card.querySelector('[data-rojo-product-angle-current]');
    if (counter) counter.textContent = String(clampedIndex + 1).padStart(2, '0');
  }

  function pauseProductAngleAutoplay() {
    window.clearTimeout(productAngleTimer);
    productAngleTimer = null;
  }

  function scheduleProductAngleAdvance(card) {
    pauseProductAngleAutoplay();

    const images = getProductAngleImages(card);
    if (images.length < 2) return;

    productAngleTimer = window.setTimeout(() => {
      const currentIndex = Number.parseInt(card.dataset.rojoActiveAngle, 10) || 0;
      setProductAngle(card, currentIndex + 1);
      scheduleProductAngleAdvance(card);
    }, ROJO_PRODUCT_ANGLE_INTERVAL_MS);
  }

  function resumeProductAngleAutoplay() {
    if (!productAngleTrackedCard || focusCard) return;
    scheduleProductAngleAdvance(productAngleTrackedCard);
  }

  function stopProductAngleAutoplay() {
    pauseProductAngleAutoplay();
    productAngleTrackedCard = null;
  }

  function syncActiveProductAngle() {
    const activeCard = productCards.find((card) => card.dataset.slot === '0') || null;

    if (activeCard !== productAngleTrackedCard) {
      productAngleTrackedCard = activeCard;
      if (activeCard) setProductAngle(activeCard, 0);
    }

    resumeProductAngleAutoplay();
  }

  function clampQuantity(value) {
    const number = Number.parseInt(value, 10);
    if (!Number.isFinite(number)) return 1;
    return Math.max(1, Math.min(99, number));
  }

  function clampQuantityBounded(value, max) {
    const number = Number.parseInt(value, 10);
    if (!Number.isFinite(number)) return 1;
    return Math.max(1, Math.min(max, number));
  }

  // TEE + RED BODY PAINT BUNDLE (2026-08-19) — owner-locked feature, scoped
  // to exactly two tee products. Shopify's own already-configured automatic
  // Buy X Get Y discount (max 3 uses/order) is the only pricing authority;
  // this module only decides what to *offer* in the UI and what to *submit*
  // to /cart/add.js — it never computes or overrides a price itself.
  const ROJO_BUNDLE_ELIGIBLE_PRODUCT_IDS = ['7920611360829', '7920611098685', '7920611622973'];
  const ROJO_BUNDLE_PAINT_VARIANT_ID = '43261961175101';
  const ROJO_BUNDLE_MAX_PAIRS_PER_ORDER = 3;

  function computeRojoBundleExistingPairs(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;

    let teeQuantity = 0;
    let paintQuantity = 0;

    cart.items.forEach((item) => {
      if (ROJO_BUNDLE_ELIGIBLE_PRODUCT_IDS.includes(String(item.product_id))) teeQuantity += item.quantity;
      if (String(item.variant_id) === ROJO_BUNDLE_PAINT_VARIANT_ID) paintQuantity += item.quantity;
    });

    return Math.min(teeQuantity, paintQuantity, ROJO_BUNDLE_MAX_PAIRS_PER_ORDER);
  }

  // Cart-drawer upsell (2026-08-25) needs the raw eligible-tee quantity on
  // its own (not min'd against paint/cap like computeRojoBundleExistingPairs
  // above) to work out how many tees still have no paired paint.
  function computeRojoBundleCartTeeQuantity(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;

    let teeQuantity = 0;
    cart.items.forEach((item) => {
      if (ROJO_BUNDLE_ELIGIBLE_PRODUCT_IDS.includes(String(item.product_id))) teeQuantity += item.quantity;
    });

    return teeQuantity;
  }

  // Fails CLOSED (0 remaining) on any fetch/parse error — the bundle offer
  // simply reports itself unavailable rather than ever advertising a
  // discount Shopify's own 3-per-order cap might not actually honor.
  async function getRojoBundleRemainingSlots() {
    try {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return 0;
      const cart = await response.json();
      return Math.max(0, ROJO_BUNDLE_MAX_PAIRS_PER_ORDER - computeRojoBundleExistingPairs(cart));
    } catch (error) {
      return 0;
    }
  }

  // Red Body Paint's own product card (rendered elsewhere in this same Shop
  // grid, under the PAINT category) carries the one paint-variant-
  // availability signal Liquid can supply at render time — see
  // rojo_bundle_paint_variant_available in the Liquid loop. If that card
  // isn't found (e.g. paint not in the first 250 shop products), the offer
  // is not blocked on this render-time signal alone; a genuinely
  // unavailable/rejected add is still caught at submit time.
  function isRojoBundlePaintAvailable() {
    const paintCard = root.querySelector('[data-rojo-bundle-paint-available]');
    if (!paintCard) return true;
    return paintCard.dataset.rojoBundlePaintAvailable === 'true';
  }

  function formatCartMoney(cents) {
    const currency = window.Shopify?.currency?.active || 'USD';

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
    }
  }

  function syncCartCount(cart) {
    currentCartItemCount = cart?.item_count || 0;
    if (cartCount) cartCount.textContent = String(currentCartItemCount);
    if (conceptCartCount) conceptCartCount.textContent = String(currentCartItemCount);
  }

  // CART shipping progress + tee/paint upsell (2026-08-25) — promotional
  // guidance only; Shopify's own configured free-shipping threshold and
  // automatic Buy X Get Y discount remain the real authority. Called from
  // renderCartDrawer() below, the single existing choke point already
  // re-run after every cart mutation (open, add, bundle add, upsell add,
  // qty +/-, remove), so this stays in sync for free.
  const ROJO_FREE_SHIPPING_THRESHOLD_CENTS = 8000;

  function renderRojoCartConversionModules(cart) {
    const itemCount = cart?.item_count || 0;

    if (!itemCount) {
      if (cartShippingProgress) cartShippingProgress.hidden = true;
      if (cartBundleUpsell) cartBundleUpsell.hidden = true;
      return;
    }

    // Shared across both modules below — the cart has exactly two
    // independent paths to free shipping (the $80+ subtotal threshold, or
    // an eligible tee already paired with Red Body Paint), and the upsell's
    // own remaining-slot math needs the same pairing count.
    const existingPairs = computeRojoBundleExistingPairs(cart);

    // Correction pass (2026-08-25) — reworked to recognize BOTH free-
    // shipping paths (qualifiesByThreshold / qualifiesByBundle), and to
    // guarantee the visible fill actually reflects the calculated percent:
    // forces a layout read (offsetHeight) between un-hiding the module and
    // writing the new width, so the write can never land on a stale/
    // not-yet-laid-out box. The track/fill CSS itself was also hardened
    // (see .rojo-cart-shipping-progress__track/__fill) so a definite,
    // non-flex, non-transformed left-to-right width is guaranteed
    // regardless of this JS.
    if (cartShippingProgress) {
      const subtotal = cart?.total_price || 0;
      const qualifiesByThreshold = subtotal >= ROJO_FREE_SHIPPING_THRESHOLD_CENTS;
      const qualifiesByBundle = existingPairs > 0;
      const qualifies = qualifiesByThreshold || qualifiesByBundle;

      cartShippingProgress.hidden = false;
      // Correction pass (2026-08-26) — four approved states (A/B/C/D). Once
      // shipping is unlocked by either path, the $80 label/progress bar/
      // endpoints must not show at all (see .is-qualified in rojo-os.css) —
      // only the UNLOCKED status line and the state-specific secondary line
      // remain. State A is the only state where the bar is visible/live.
      cartShippingProgress.classList.toggle('is-qualified', qualifies);

      if (!qualifies) {
        const progressRatio = Math.max(0, Math.min(1, subtotal / ROJO_FREE_SHIPPING_THRESHOLD_CENTS));

        if (cartShippingFill) {
          void cartShippingFill.offsetHeight;
          cartShippingFill.style.width = `${progressRatio * 100}%`;
        }

        if (cartShippingCurrent) cartShippingCurrent.textContent = formatCartMoney(subtotal);

        if (cartShippingStatus) {
          cartShippingStatus.textContent = `${formatCartMoney(ROJO_FREE_SHIPPING_THRESHOLD_CENTS - subtotal)} AWAY FROM FREE SHIPPING`;
        }

        if (cartShippingSecondary) cartShippingSecondary.textContent = '';
      } else {
        if (cartShippingStatus) cartShippingStatus.textContent = 'FREE U.S. SHIPPING UNLOCKED';

        if (cartShippingSecondary) {
          cartShippingSecondary.textContent = qualifiesByBundle && qualifiesByThreshold
            ? 'YOUR ORDER QUALIFIES'
            : qualifiesByBundle
              ? 'TEE + PAINT BUNDLE'
              : '$80+ ORDER';
        }
      }
    }

    // Only actionable when a real, currently-unpaired eligible tee exists
    // AND the 3-pair cap hasn't been reached AND the paint variant is
    // available — never advertises a pair Shopify's own automatic discount
    // wouldn't actually honor. teeQuantity/existingPairs are combination-
    // agnostic sums across all three eligible product IDs.
    if (cartBundleUpsell) {
      const teeQuantity = computeRojoBundleCartTeeQuantity(cart);
      const unmatchedTees = teeQuantity - existingPairs;
      const remainingSlots = Math.max(0, ROJO_BUNDLE_MAX_PAIRS_PER_ORDER - existingPairs);
      const actionable = unmatchedTees > 0 && remainingSlots > 0 && isRojoBundlePaintAvailable();

      cartBundleUpsell.hidden = !actionable;
      if (actionable && cartBundleUpsellButton) cartBundleUpsellButton.disabled = false;
      if (cartBundleUpsellStatus) cartBundleUpsellStatus.textContent = '';
    }
  }

  function renderCartDrawer(cart) {
    if (!cartItems || !cartSubtotal) return;

    const itemCount = cart?.item_count || 0;
    cartSubtotal.textContent = formatCartMoney(cart?.total_price || 0);
    if (cartCheckoutButton) {
      cartCheckoutButton.disabled = cartDrawerOrigin === 'concepts' && itemCount === 0;
    }

    renderRojoCartConversionModules(cart);

    if (!cart?.items?.length) {
      cartItems.innerHTML = '<p class="rojo-cart-empty">YOUR CART IS EMPTY</p>';
      return;
    }

    cartItems.innerHTML = cart.items.map((item, index) => {
      const image = item.image
        ? `<img class="rojo-cart-item__image" src="${item.image}" alt="">`
        : '<div class="rojo-cart-item__image"></div>';

      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? `<p class="rojo-cart-item__variant">${item.variant_title}</p>`
        : '';

      return `
        <article class="rojo-cart-item">
          ${image}
          <div>
            <p class="rojo-cart-item__title">${item.product_title}</p>
            ${variant}
            <div class="rojo-cart-item__qty-row">
              <div class="rojo-cart-item__qty">
                <button
                  class="rojo-cart-item__qty-btn"
                  type="button"
                  data-rojo-cart-qty-minus
                  data-line="${index + 1}"
                  data-quantity="${item.quantity}"
                  aria-label="Decrease quantity"
                  ${item.quantity <= 1 ? 'disabled' : ''}
                >−</button>
                <span class="rojo-cart-item__qty-value">${item.quantity}</span>
                <button
                  class="rojo-cart-item__qty-btn"
                  type="button"
                  data-rojo-cart-qty-plus
                  data-line="${index + 1}"
                  data-quantity="${item.quantity}"
                  aria-label="Increase quantity"
                >+</button>
              </div>
              <p class="rojo-cart-item__price">${formatCartMoney(item.final_line_price)}</p>
            </div>
          </div>
          <button
            class="rojo-cart-item__remove"
            type="button"
            data-rojo-cart-remove
            data-line="${index + 1}"
            aria-label="Remove ${item.product_title}"
          >×</button>
        </article>
      `;
    }).join('');

    cartItems.querySelectorAll('[data-rojo-cart-remove]').forEach((button) => {
      button.addEventListener('click', async () => {
        button.disabled = true;

        try {
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              line: Number(button.dataset.line),
              quantity: 0
            })
          });

          if (!response.ok) throw new Error('Unable to update cart');
          const updatedCart = await response.json();

          syncCartCount(updatedCart);
          renderCartDrawer(updatedCart);
        } catch (error) {
          button.disabled = false;
        }
      });
    });

    cartItems.querySelectorAll('[data-rojo-cart-qty-minus], [data-rojo-cart-qty-plus]').forEach((button) => {
      button.addEventListener('click', async () => {
        const currentQuantity = Number(button.dataset.quantity);
        const delta = button.hasAttribute('data-rojo-cart-qty-minus') ? -1 : 1;
        const newQuantity = currentQuantity + delta;

        if (newQuantity < 1) return;

        button.disabled = true;

        try {
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              line: Number(button.dataset.line),
              quantity: newQuantity
            })
          });

          if (!response.ok) throw new Error('Unable to update cart');
          const updatedCart = await response.json();

          syncCartCount(updatedCart);
          renderCartDrawer(updatedCart);
        } catch (error) {
          button.disabled = false;
        }
      });
    });
  }

  async function refreshCartCount() {
    try {
      const response = await fetch('/cart.js', {
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) throw new Error('Cart unavailable');

      const cart = await response.json();

      syncCartCount(cart);
      renderCartDrawer(cart);

      return cart;
    } catch (error) {
      return null;
    }
  }

  function openCartDrawer(origin = 'shop') {
    cartDrawerOrigin = origin;
    cartDrawer?.classList.add('is-open');
    cartDrawer?.setAttribute('aria-hidden', 'false');
    if (cartAddItemsButton) cartAddItemsButton.hidden = origin !== 'concepts';
    // Correction pass (2026-08-26, round 4) — refresh right at open time so
    // --rojo-visible-cart-height reflects Instagram's chrome state exactly
    // when it matters, not just whatever it was at page load/last resize.
    updateRojoVisibleCartHeight();
    refreshCartCount();
  }

  function closeCartDrawer() {
    cartDrawer?.classList.remove('is-open');
    cartDrawer?.setAttribute('aria-hidden', 'true');
  }

  async function addCardToCart(card, options = {}) {
    const { navigateToCheckout = false, triggeredBy = 'add' } = options;
    const variantSelect = card.querySelector('[data-rojo-variant-select]');
    const quantityInput = card.querySelector('[data-rojo-qty]');
    const addButton = card.querySelector('[data-rojo-add-cart]');
    const buyItNowButton = card.querySelector('[data-rojo-buy-now]');
    const status = card.querySelector('[data-rojo-add-status]');
    // Correction pass (2026-08-26) — only the sibling of whichever button
    // was actually tapped gets marked .is-standby, so it stays visually
    // normal while still disabled=true (double-submit protection intact);
    // see .is-standby:disabled in rojo-os.css.
    const standbyButton = triggeredBy === 'buyNow' ? addButton : buyItNowButton;

    if (!quantityInput || !addButton || addButton.disabled || buyItNowButton?.disabled) return;

    const variantId = Number(
      variantSelect?.value || card.dataset.selectedVariantId || 0
    );

    if (!Number.isFinite(variantId) || variantId <= 0) {
      if (status) status.textContent = 'PRODUCT OPTION UNAVAILABLE';
      return;
    }

    const quantity = clampQuantity(quantityInput.value);
    quantityInput.value = String(quantity);
    addButton.disabled = true;
    if (buyItNowButton) buyItNowButton.disabled = true;
    standbyButton?.classList.add('is-standby');

    if (status) status.textContent = navigateToCheckout ? 'PROCESSING...' : 'ADDING...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity
          }]
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.description || 'Unable to add item');
      }

      await refreshCartCount();

      if (navigateToCheckout) {
        window.location.href = '/checkout';
        return;
      }

      if (status) status.textContent = 'ADDED TO CART';

      cartButton?.classList.remove('is-updated');
      window.requestAnimationFrame(() => cartButton?.classList.add('is-updated'));
    } catch (error) {
      if (status) status.textContent = error.message || 'ADD TO CART FAILED';
    } finally {
      addButton.disabled = false;
      if (buyItNowButton) buyItNowButton.disabled = false;
      standbyButton?.classList.remove('is-standby');
    }
  }

  function applyCollection(handle, title) {
    if (focusCard) closeProductFocus(focusCard);

    activeCollectionHandle = handle || 'all';
    activeProductIndex = 0;

    const aliases = {
      paint: ['paint', 'body-paint', 'red-paint', 'makeup'],
      tees: ['tees', 'tee', 't-shirts', 't-shirt', 'shirts', 'shirt'],
      outerwear: ['outerwear', 'hoodies', 'hoodie', 'jackets', 'jacket', 'sweatshirts', 'sweatshirt'],
      hats: ['hats', 'hat', 'headwear', 'caps', 'cap', 'beanies', 'beanie'],
      accessories: ['accessories', 'accessory', 'totes', 'tote', 'bags', 'bag']
    };

    allProductCards.forEach((card) => {
      const collections = (card.dataset.productCollections || '').split(',').filter(Boolean);
      const tags = (card.dataset.productTags || '').split(',').filter(Boolean);
      const productType = card.dataset.productType || '';
      const searchableValues = [...collections, ...tags, productType];
      const categoryAliases = aliases[activeCollectionHandle] || [activeCollectionHandle];

      const matches =
        activeCollectionHandle === 'all' ||
        categoryAliases.some((alias) => searchableValues.includes(alias));

      card.classList.toggle('is-filtered-out', !matches);
      card.style.removeProperty('--drag-x');
    });

    productCards = allProductCards.filter((card) => !card.classList.contains('is-filtered-out'));
    productCount = productCards.length;

    if (collectionLabel) collectionLabel.textContent = title || 'ALL';
    if (categoryEmpty) categoryEmpty.hidden = productCount > 0;

    collectionOptions.forEach((option) => {
      option.classList.toggle('is-active', option.dataset.collectionHandle === activeCollectionHandle);
    });

    if (productPrev) productPrev.disabled = productCount < 2;
    if (productNext) productNext.disabled = productCount < 2;

    closeCollectionMenu();

    if (productCount) {
      window.requestAnimationFrame(() => {
        renderProductBrowser();
        syncActiveProductAngle();
      });
    } else {
      stopProductAngleAutoplay();
    }
  }

  function openCollectionMenu() {
    if (!collectionMenu || !collectionToggle) return;
    collectionMenu.hidden = false;
    collectionToggle.setAttribute('aria-expanded', 'true');
  }

  function closeCollectionMenu() {
    if (!collectionMenu || !collectionToggle) return;
    collectionMenu.hidden = true;
    collectionToggle.setAttribute('aria-expanded', 'false');
  }

  productPrev?.addEventListener('click', () => moveProductsBy(-1));
  productNext?.addEventListener('click', () => moveProductsBy(1));

  productViewport?.addEventListener('pointerdown', (event) => {
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    if (event.target.closest('button, select, input') || focusCard) return;
    productViewport.setPointerCapture?.(event.pointerId);
    beginProductDrag(event.clientX, event.pointerType);
  });

  productViewport?.addEventListener('pointermove', (event) => {
    updateProductDrag(event.clientX);
  });

  productViewport?.addEventListener('pointerup', endProductDrag);
  productViewport?.addEventListener('pointercancel', endProductDrag);
  productViewport?.addEventListener('lostpointercapture', endProductDrag);

  allProductCards.forEach((card) => {
    const closeButton = card.querySelector('[data-rojo-focus-close]');
    const addButton = card.querySelector('[data-rojo-add-cart]');
    const buyItNowButton = card.querySelector('[data-rojo-buy-now]');
    const minusButton = card.querySelector('[data-rojo-qty-minus]');
    const plusButton = card.querySelector('[data-rojo-qty-plus]');
    const quantityInput = card.querySelector('[data-rojo-qty]');
    const variantSelect = card.querySelector('[data-rojo-variant-select]');
    const price = card.querySelector('[data-rojo-focus-price]');
    const status = card.querySelector('[data-rojo-add-status]');
    const descriptionExpandButton = card.querySelector('[data-rojo-description-expand]');
    const descriptionFull = card.querySelector('[data-rojo-description-full]');
    const descriptionCloseButton = card.querySelector('[data-rojo-description-close]');

    // TEE + RED BODY PAINT BUNDLE (2026-08-19, updated 2026-08-25 for the
    // third eligible tee) — bundleToggle is null on every card except the
    // owner-approved eligible tees (see Liquid's rojo_bundle_eligible
    // gate), so every function/branch below that
    // checks it is a no-op on every other card and existing behavior there
    // is untouched. bundleSelected/bundleRemainingSlots are declared
    // unconditionally (cheap) so the shared minus/plus/change handlers
    // further below can call bundleMaxQuantity() without a scoping branch.
    const bundleToggle = card.querySelector('[data-rojo-bundle-toggle]');
    const bundleDetail = card.querySelector('[data-rojo-bundle-detail]');
    const bundleIcon = card.querySelector('[data-rojo-bundle-icon]');
    let bundleSelected = false;
    let bundleRemainingSlots = 0;
    let bundleSubmitInFlight = false;

    function bundleMaxQuantity() {
      return bundleSelected ? Math.max(1, bundleRemainingSlots) : 99;
    }

    // Shop conversion update (2026-08-25) — the main action button's label
    // no longer varies with bundle selection (no per-quantity dollar total
    // is shown; see rojo-bundle__headline for the one approved bundle
    // price). It stays whatever Liquid already rendered ("ADD TO CART" /
    // "SOLD OUT"), so there is nothing left for JS to resync here.
    function setBundleSelected(nextSelected) {
      bundleSelected = nextSelected;

      if (bundleToggle) bundleToggle.setAttribute('aria-pressed', bundleSelected ? 'true' : 'false');
      if (bundleToggle) bundleToggle.classList.toggle('is-selected', bundleSelected);
      if (bundleIcon) bundleIcon.textContent = bundleSelected ? '✓' : '+';

      if (quantityInput) {
        const maxAllowed = bundleMaxQuantity();
        if (clampQuantity(quantityInput.value) > maxAllowed) quantityInput.value = String(maxAllowed);
      }
    }

    // Called on every fresh open of this card (see openProductFocus()'s
    // rojo:bundle-refresh dispatch) — never on an interval, never on an
    // unrelated DOM change. Starts disabled in Liquid; only enabled here
    // once both the paint-availability and cart-limit checks pass, so
    // there's no window where an unverified bundle could be selected.
    async function refreshBundleAvailability() {
      if (!bundleToggle) return;

      if (!isRojoBundlePaintAvailable()) {
        bundleToggle.disabled = true;
        if (bundleDetail) bundleDetail.textContent = 'RED BODY PAINT — UNAVAILABLE';
        if (bundleIcon) bundleIcon.textContent = '';
        if (bundleSelected) setBundleSelected(false);
        return;
      }

      bundleRemainingSlots = await getRojoBundleRemainingSlots();

      if (bundleRemainingSlots <= 0) {
        bundleToggle.disabled = true;
        if (bundleDetail) bundleDetail.textContent = 'BUNDLE LIMIT REACHED';
        if (bundleIcon) bundleIcon.textContent = '';
        if (bundleSelected) setBundleSelected(false);
        return;
      }

      bundleToggle.disabled = false;

      if (bundleSelected) {
        if (clampQuantity(quantityInput?.value) > bundleRemainingSlots) {
          quantityInput.value = String(bundleRemainingSlots);
        }
      } else {
        if (bundleDetail) bundleDetail.textContent = 'INCLUDES RED BODY PAINT';
        if (bundleIcon) bundleIcon.textContent = '+';
      }
    }

    // Atomic two-item /cart/add.js request — the tee variant currently
    // selected at click time, plus the exact locked paint variant, in
    // matching quantities. Never two separate requests, never a fallback
    // that could add only one of the two.
    async function addBundleToCart(options = {}) {
      const { navigateToCheckout = false, triggeredBy = 'add' } = options;
      if (!addButton || bundleSubmitInFlight || buyItNowButton?.disabled) return;

      const teeVariantId = Number(variantSelect?.value || card.dataset.selectedVariantId || 0);
      if (!Number.isFinite(teeVariantId) || teeVariantId <= 0) {
        if (status) status.textContent = 'PRODUCT OPTION UNAVAILABLE';
        return;
      }

      // Correction pass (2026-08-26) — same sibling-exemption pattern as
      // addCardToCart() above; see .is-standby:disabled in rojo-os.css.
      const standbyButton = triggeredBy === 'buyNow' ? addButton : buyItNowButton;

      bundleSubmitInFlight = true;
      addButton.disabled = true;
      if (buyItNowButton) buyItNowButton.disabled = true;
      standbyButton?.classList.add('is-standby');
      if (status) status.textContent = navigateToCheckout ? 'PROCESSING...' : 'ADDING...';

      try {
        // Final authoritative cap check right before submitting — avoids a
        // stale allowance if cart state changed since this card was opened.
        const remainingSlots = await getRojoBundleRemainingSlots();
        if (remainingSlots <= 0) {
          if (status) status.textContent = 'BUNDLE LIMIT REACHED';
          setBundleSelected(false);
          return;
        }

        const quantity = Math.min(clampQuantity(quantityInput?.value), remainingSlots);
        if (quantityInput) quantityInput.value = String(quantity);

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [
              { id: teeVariantId, quantity },
              { id: Number(ROJO_BUNDLE_PAINT_VARIANT_ID), quantity }
            ]
          })
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.description || 'Unable to add bundle');
        }

        await refreshCartCount();

        if (navigateToCheckout) {
          window.location.href = '/checkout';
          return;
        }

        if (status) status.textContent = 'BUNDLE ADDED';
        setBundleSelected(false);
        openCartDrawer('shop');

        cartButton?.classList.remove('is-updated');
        window.requestAnimationFrame(() => cartButton?.classList.add('is-updated'));
      } catch (error) {
        if (status) status.textContent = error.message || 'BUNDLE ADD FAILED';
      } finally {
        bundleSubmitInFlight = false;
        addButton.disabled = false;
        if (buyItNowButton) buyItNowButton.disabled = false;
        standbyButton?.classList.remove('is-standby');
      }
    }

    if (bundleToggle) {
      bundleToggle.addEventListener('click', (event) => {
        event.stopPropagation();
        setBundleSelected(!bundleSelected);
      });

      card.addEventListener('rojo:bundle-refresh', () => {
        refreshBundleAvailability();
      });

      card.addEventListener('rojo:bundle-reset', () => {
        if (bundleSelected) setBundleSelected(false);
      });
    }

    card.addEventListener('click', (event) => {
      if (event.target.closest('button, select, input')) return;
      openProductFocus(card);
    });

    closeButton?.addEventListener('click', (event) => {
      event.stopPropagation();
      closeProductFocus(card);
    });

    // FULL DESCRIPTION overlay (2026-08-25) — a plain hidden-attribute
    // toggle only; never touches quantityInput/variantSelect/bundle state,
    // so closing always returns to exactly whatever the customer had
    // selected before opening it.
    descriptionExpandButton?.addEventListener('click', (event) => {
      event.stopPropagation();
      if (descriptionFull) descriptionFull.hidden = false;
    });

    descriptionCloseButton?.addEventListener('click', (event) => {
      event.stopPropagation();
      if (descriptionFull) descriptionFull.hidden = true;
    });

    minusButton?.addEventListener('click', (event) => {
      event.stopPropagation();
      if (!quantityInput) return;
      quantityInput.value = String(clampQuantityBounded(Number(quantityInput.value) - 1, bundleMaxQuantity()));
    });

    plusButton?.addEventListener('click', (event) => {
      event.stopPropagation();
      if (!quantityInput) return;
      quantityInput.value = String(clampQuantityBounded(Number(quantityInput.value) + 1, bundleMaxQuantity()));
    });

    quantityInput?.addEventListener('change', () => {
      quantityInput.value = String(clampQuantityBounded(quantityInput.value, bundleMaxQuantity()));
    });

    variantSelect?.addEventListener('change', () => {
      const selected = variantSelect.options[variantSelect.selectedIndex];
      if (price && selected?.dataset.price) price.textContent = selected.dataset.price;
    });

    addButton?.addEventListener('click', (event) => {
      event.stopPropagation();
      if (bundleToggle && bundleSelected) {
        addBundleToCart({ triggeredBy: 'add' });
      } else {
        addCardToCart(card, { triggeredBy: 'add' });
      }
    });

    buyItNowButton?.addEventListener('click', (event) => {
      event.stopPropagation();
      if (bundleToggle && bundleSelected) {
        addBundleToCart({ navigateToCheckout: true, triggeredBy: 'buyNow' });
      } else {
        addCardToCart(card, { navigateToCheckout: true, triggeredBy: 'buyNow' });
      }
    });
  });

  collectionToggle?.addEventListener('click', () => {
    if (collectionMenu?.hidden) {
      openCollectionMenu();
    } else {
      closeCollectionMenu();
    }
  });

  collectionOptions.forEach((option) => {
    option.addEventListener('click', () => {
      applyCollection(
        option.dataset.collectionHandle || 'all',
        option.dataset.collectionTitle || option.textContent.trim()
      );
    });
  });

  document.addEventListener('click', (event) => {
    if (!collectionMenu || collectionMenu.hidden) return;
    if (event.target.closest('[data-rojo-collection-toggle], [data-rojo-collection-menu]')) return;
    closeCollectionMenu();
  });

  cartButton?.addEventListener('click', () => openCartDrawer('shop'));
  cartCloseButton?.addEventListener('click', closeCartDrawer);

  cartAddItemsButton?.addEventListener('click', () => {
    closeCartDrawer();
    openShop({ fromApp: true });
  });

  cartCheckoutButton?.addEventListener('click', () => {
    window.location.href = '/checkout';
  });

  // Cart tee/paint upsell (2026-08-25) — one listener attached once here
  // (not inside renderCartDrawer(), which re-runs on every mutation) since
  // this button is static markup outside the innerHTML renderCartDrawer()
  // replaces, so re-attaching per render would create duplicate listeners.
  // Adds exactly the missing paint for ONE unmatched eligible tee already
  // in the cart — never another tee, never more than one paint per click.
  let cartBundleUpsellSubmitInFlight = false;

  cartBundleUpsellButton?.addEventListener('click', async () => {
    if (cartBundleUpsellButton.disabled || cartBundleUpsellSubmitInFlight) return;

    cartBundleUpsellSubmitInFlight = true;
    cartBundleUpsellButton.disabled = true;
    if (cartBundleUpsellStatus) cartBundleUpsellStatus.textContent = '';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: Number(ROJO_BUNDLE_PAINT_VARIANT_ID), quantity: 1 }]
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.description || 'Unable to add item');
      }

      await refreshCartCount();
    } catch (error) {
      if (cartBundleUpsellStatus) cartBundleUpsellStatus.textContent = "COULDN'T ADD PAINT — TRY AGAIN";
      cartBundleUpsellButton.disabled = false;
    } finally {
      cartBundleUpsellSubmitInFlight = false;
    }
  });

  applyCollection('all', 'ALL');

  refreshCartCount();

  shopButton?.addEventListener('click', openShop);
  conceptButton?.addEventListener('click', openConcept);
  rojoRunButton?.addEventListener('click', openRojoRun);
  rojomiesButton?.addEventListener('click', openRojomies);
  contactButton?.addEventListener('click', openContact);

  conceptPagePrev?.addEventListener('click', () => renderConceptPage(activeConceptPage - 1));
  conceptPageNext?.addEventListener('click', () => renderConceptPage(activeConceptPage + 1));
  renderConceptPage(0);

  conceptTiles.forEach((tile) => {
    tile.addEventListener('click', () => openConceptPreview(tile.dataset.rojoConceptTile));
  });

  conceptPreviewCloseButtons.forEach((button) => {
    button.addEventListener('click', closeConceptOverlay);
  });

  conceptOpenProjectButtons.forEach((button) => {
    button.addEventListener('click', () => openConceptFull(button.dataset.rojoConceptOpenProject));
  });

  conceptFullCloseButtons.forEach((button) => {
    button.addEventListener('click', closeConceptOverlay);
  });

  root.querySelectorAll('[data-rojo-open]:not([data-rojo-open="shop"]):not([data-rojo-open="concept"]):not([data-rojo-open="rojo-run"]):not([data-rojo-open="contact"]):not([data-rojo-open="rojomies"])').forEach((button) => {
    button.addEventListener('click', pulseWorld);
  });

  // ENTER ROJO MUNDO globe-pause diagnostic — inert unless ?globe_debug=1 is
  // in the URL. Purely observational: it never alters timing, classes, or
  // rendering, only reads/logs.
  const rojoGlobeDebugEnabled = new URLSearchParams(window.location.search).has('globe_debug');
  let rojoGlobeDebugPanel = null;
  let rojoGlobeDebugEnterClickAt = 0;
  let rojoGlobeDebugPrevRaf = 0;
  function rojoGlobeDebugLog(line) {
    if (!rojoGlobeDebugEnabled) return;
    if (!rojoGlobeDebugPanel) {
      rojoGlobeDebugPanel = document.createElement('div');
      rojoGlobeDebugPanel.style.cssText = 'position:fixed;left:8px;top:8px;z-index:99999;background:rgba(0,0,0,.82);color:#0f0;font:11px/1.4 monospace;padding:8px;max-width:92vw;max-height:60vh;overflow:auto;white-space:pre-wrap;pointer-events:none;';
      document.body.appendChild(rojoGlobeDebugPanel);
    }
    const entry = document.createElement('div');
    entry.textContent = line;
    rojoGlobeDebugPanel.appendChild(entry);
    while (rojoGlobeDebugPanel.childNodes.length > 40) rojoGlobeDebugPanel.removeChild(rojoGlobeDebugPanel.firstChild);
  }

  const gl = canvas.getContext('webgl', {
    alpha: true,
    antialias: true,
    premultipliedAlpha: true,
    powerPreference: 'high-performance'
  });

  if (!gl) {
    fallback.hidden = false;
    return;
  }

  const vertexShaderSource = `
    attribute vec3 aPosition;
    attribute vec3 aNormal;
    attribute vec2 aUv;

    uniform mat4 uProjection;
    uniform mat4 uModelView;
    uniform mat3 uNormalMatrix;

    varying vec3 vNormal;
    varying vec3 vViewPosition;
    varying vec2 vUv;

    void main() {
      vec4 viewPosition = uModelView * vec4(aPosition, 1.0);
      vViewPosition = viewPosition.xyz;
      vNormal = normalize(uNormalMatrix * aNormal);
      vUv = aUv;
      gl_Position = uProjection * viewPosition;
    }
  `;

  const fragmentShaderSource = `
    precision highp float;

    uniform sampler2D uMap;
    uniform float uTime;

    varying vec3 vNormal;
    varying vec3 vViewPosition;
    varying vec2 vUv;

    float lineGrid(float value, float count, float thickness) {
      float wave = abs(fract(value * count) - 0.5);
      return 1.0 - smoothstep(thickness, thickness + 0.012, wave);
    }

    void main() {
      vec3 normal = normalize(vNormal);
      vec3 viewDir = normalize(-vViewPosition);
      float facing = max(dot(normal, viewDir), 0.0);
      float fresnel = pow(1.0 - facing, 2.2);

      float land = texture2D(uMap, vec2(fract(vUv.x), vUv.y)).r;
      land = smoothstep(0.20, 0.72, land);

      float lon = lineGrid(vUv.x, 24.0, 0.018);
      float lat = lineGrid(vUv.y, 12.0, 0.018);
      float grid = max(lon, lat) * (0.34 + 0.66 * facing);

      float current = sin((vUv.x * 18.0) + (vUv.y * 10.0) - uTime * 0.8) * 0.5 + 0.5;
      current *= sin((vUv.x * 7.0) - (vUv.y * 16.0) + uTime * 0.5) * 0.5 + 0.5;

      vec3 ocean = vec3(0.055, 0.0, 0.006);
      vec3 landColor = vec3(0.78, 0.045, 0.065);
      vec3 gridColor = vec3(1.0, 0.18, 0.20);
      vec3 rimColor = vec3(0.92, 0.04, 0.08);

      vec3 color = mix(ocean, landColor, land);
      color += gridColor * grid * 0.52;
      color += rimColor * fresnel * 0.72;
      color += vec3(0.36, 0.0, 0.02) * current * 0.18 * (0.35 + land);

      float alpha = 0.68 + land * 0.18 + grid * 0.12 + fresnel * 0.20;
      alpha *= smoothstep(-0.06, 0.10, facing);

      gl_FragColor = vec4(color, min(alpha, 1.0));
    }
  `;

  function compileShader(type, source) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
      console.error(gl.getShaderInfoLog(shader));
      gl.deleteShader(shader);
      return null;
    }
    return shader;
  }

  const vertexShader = compileShader(gl.VERTEX_SHADER, vertexShaderSource);
  const fragmentShader = compileShader(gl.FRAGMENT_SHADER, fragmentShaderSource);
  if (!vertexShader || !fragmentShader) {
    fallback.hidden = false;
    return;
  }

  const program = gl.createProgram();
  gl.attachShader(program, vertexShader);
  gl.attachShader(program, fragmentShader);
  gl.linkProgram(program);
  if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
    console.error(gl.getProgramInfoLog(program));
    fallback.hidden = false;
    return;
  }
  gl.useProgram(program);

  function createSphere(radius, widthSegments, heightSegments) {
    const positions = [];
    const normals = [];
    const uvs = [];
    const indices = [];

    for (let y = 0; y <= heightSegments; y++) {
      const v = y / heightSegments;
      const theta = v * Math.PI;

      for (let x = 0; x <= widthSegments; x++) {
        const u = x / widthSegments;
        const phi = u * Math.PI * 2;

        const sinTheta = Math.sin(theta);
        const px = -radius * Math.cos(phi) * sinTheta;
        const py = radius * Math.cos(theta);
        const pz = radius * Math.sin(phi) * sinTheta;

        positions.push(px, py, pz);
        const length = Math.hypot(px, py, pz) || 1;
        normals.push(px / length, py / length, pz / length);
        uvs.push(u, 1 - v);
      }
    }

    for (let y = 0; y < heightSegments; y++) {
      for (let x = 0; x < widthSegments; x++) {
        const a = y * (widthSegments + 1) + x;
        const b = a + widthSegments + 1;
        const c = b + 1;
        const d = a + 1;
        indices.push(a, b, d, b, c, d);
      }
    }

    return {
      positions: new Float32Array(positions),
      normals: new Float32Array(normals),
      uvs: new Float32Array(uvs),
      indices: new Uint16Array(indices)
    };
  }

  function createBuffer(data, target = gl.ARRAY_BUFFER) {
    const buffer = gl.createBuffer();
    gl.bindBuffer(target, buffer);
    gl.bufferData(target, data, gl.STATIC_DRAW);
    return buffer;
  }

  const sphere = createSphere(1, 72, 48);
  const positionBuffer = createBuffer(sphere.positions);
  const normalBuffer = createBuffer(sphere.normals);
  const uvBuffer = createBuffer(sphere.uvs);
  const indexBuffer = createBuffer(sphere.indices, gl.ELEMENT_ARRAY_BUFFER);

  function bindAttribute(name, buffer, size) {
    const location = gl.getAttribLocation(program, name);
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.enableVertexAttribArray(location);
    gl.vertexAttribPointer(location, size, gl.FLOAT, false, 0, 0);
  }

  bindAttribute('aPosition', positionBuffer, 3);
  bindAttribute('aNormal', normalBuffer, 3);
  bindAttribute('aUv', uvBuffer, 2);
  gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);

  const uniforms = {
    projection: gl.getUniformLocation(program, 'uProjection'),
    modelView: gl.getUniformLocation(program, 'uModelView'),
    normalMatrix: gl.getUniformLocation(program, 'uNormalMatrix'),
    map: gl.getUniformLocation(program, 'uMap'),
    time: gl.getUniformLocation(program, 'uTime')
  };

  const texture = gl.createTexture();
  gl.bindTexture(gl.TEXTURE_2D, texture);
  gl.texImage2D(
    gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0,
    gl.RGBA, gl.UNSIGNED_BYTE,
    new Uint8Array([255, 255, 255, 255])
  );
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);

  const image = new Image();
  image.onload = () => {
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.LUMINANCE, gl.LUMINANCE, gl.UNSIGNED_BYTE, image);
    gl.generateMipmap(gl.TEXTURE_2D);
  };
  image.src = textureData;

  gl.activeTexture(gl.TEXTURE0);
  gl.bindTexture(gl.TEXTURE_2D, texture);
  gl.uniform1i(uniforms.map, 0);

  gl.enable(gl.BLEND);
  gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
  gl.enable(gl.DEPTH_TEST);
  gl.depthFunc(gl.LEQUAL);
  gl.clearColor(0, 0, 0, 0);

  function perspective(out, fovy, aspect, near, far) {
    const f = 1 / Math.tan(fovy / 2);
    out[0] = f / aspect; out[1] = 0; out[2] = 0; out[3] = 0;
    out[4] = 0; out[5] = f; out[6] = 0; out[7] = 0;
    out[8] = 0; out[9] = 0; out[11] = -1;
    out[12] = 0; out[13] = 0; out[15] = 0;
    if (far != null && far !== Infinity) {
      const nf = 1 / (near - far);
      out[10] = (far + near) * nf;
      out[14] = 2 * far * near * nf;
    } else {
      out[10] = -1;
      out[14] = -2 * near;
    }
    return out;
  }

  // Reused every frame instead of allocating a new Float32Array each time —
  // this render loop runs continuously (~30fps) for as long as the globe is
  // visible, so a fresh allocation per frame here and in
  // normalMatrixFromModelView() below was a constant, unbounded source of
  // garbage. The math and output values are unchanged — only the array
  // identity is now stable.
  const modelViewBuffer = new Float32Array(16);
  function modelViewMatrix(rotationY, tiltX) {
    const cy = Math.cos(rotationY);
    const sy = Math.sin(rotationY);
    const cx = Math.cos(tiltX);
    const sx = Math.sin(tiltX);

    modelViewBuffer[0] = cy;   modelViewBuffer[1] = sy * sx;  modelViewBuffer[2] = -sy * cx; modelViewBuffer[3] = 0;
    modelViewBuffer[4] = 0;    modelViewBuffer[5] = cx;       modelViewBuffer[6] = sx;       modelViewBuffer[7] = 0;
    modelViewBuffer[8] = sy;   modelViewBuffer[9] = -cy * sx; modelViewBuffer[10] = cy * cx; modelViewBuffer[11] = 0;
    modelViewBuffer[12] = 0;   modelViewBuffer[13] = 0;       modelViewBuffer[14] = -3.15;   modelViewBuffer[15] = 1;
    return modelViewBuffer;
  }

  const normalMatrixBuffer = new Float32Array(9);
  function normalMatrixFromModelView(m) {
    normalMatrixBuffer[0] = m[0]; normalMatrixBuffer[1] = m[1]; normalMatrixBuffer[2] = m[2];
    normalMatrixBuffer[3] = m[4]; normalMatrixBuffer[4] = m[5]; normalMatrixBuffer[5] = m[6];
    normalMatrixBuffer[6] = m[8]; normalMatrixBuffer[7] = m[9]; normalMatrixBuffer[8] = m[10];
    return normalMatrixBuffer;
  }

  const projection = new Float32Array(16);
  let rotation = -0.72;
  let lastTime = performance.now();
  let canvasSize = 0;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function resize() {
    // clientWidth/clientHeight are the untransformed CSS layout box, unlike
    // getBoundingClientRect() which inflates while .rojo-world's ENTER ROJO
    // MUNDO `transform: scale(4.2)` is transitioning.
    const maxDpr = root.classList.contains('is-app') ? 1.15 : 1.6;
    const dpr = Math.min(window.devicePixelRatio || 1, maxDpr);
    const width = Math.max(2, Math.floor(canvas.clientWidth * dpr));
    const height = Math.max(2, Math.floor(canvas.clientHeight * dpr));
    if (canvas.width !== width || canvas.height !== height) {
      canvas.width = width;
      canvas.height = height;
      gl.viewport(0, 0, width, height);
      perspective(projection, Math.PI / 4, width / height, 0.1, 100);
      gl.uniformMatrix4fv(uniforms.projection, false, projection);
    }
  }

  let lastDrawTime = 0;

  function render(now) {
    if (!root.isConnected) return;
    if (rojoGlobeDebugEnabled) {
      if (rojoGlobeDebugPrevRaf && (now - rojoGlobeDebugPrevRaf) > 60) {
        rojoGlobeDebugLog('STALL ' + Math.round(now - rojoGlobeDebugPrevRaf) + 'ms at t=' + Math.round(now - rojoGlobeDebugEnterClickAt) + 'ms classes=' + root.className);
      }
      rojoGlobeDebugPrevRaf = now;
    }
    if (document.hidden || now - lastDrawTime < 32) {
      requestAnimationFrame(render);
      return;
    }
    lastDrawTime = now;
    resize();

    const dt = Math.min((now - lastTime) / 1000, 0.05);
    lastTime = now;
    if (!reduceMotion) {
      rotation += dt * 0.23;
    }

    const modelView = modelViewMatrix(rotation, -0.10);
    const normalMatrix = normalMatrixFromModelView(modelView);

    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
    gl.useProgram(program);
    gl.uniformMatrix4fv(uniforms.modelView, false, modelView);
    gl.uniformMatrix3fv(uniforms.normalMatrix, false, normalMatrix);
    gl.uniform1f(uniforms.time, now * 0.001);
    gl.drawElements(gl.TRIANGLES, sphere.indices.length, gl.UNSIGNED_SHORT, 0);
    try { root._rhPaintGlitch?.(now); } catch (_) { root._rhPaintGlitch = null; }

    requestAnimationFrame(render);
  }

  requestAnimationFrame(render);
  }

  // Correction pass (2026-08-26, round 4) — CART INSTAGRAM VIEWPORT FIX.
  // 100svh alone still under-corrects inside Instagram's in-app browser:
  // its own persistent, never-collapsing chrome eats more space than any
  // static CSS viewport unit can account for. Tracks the browser's actual
  // currently-visible height via JS and exposes it as a CSS custom
  // property the mobile .rojo-cart-drawer rule reads (100svh stays as its
  // fallback for the brief window before this first runs, or if the
  // Visual Viewport API is unavailable) — see rojo-os.css.
  // visualViewport.height already reflects Instagram's real visible area
  // (shrinks to account for its chrome); innerHeight is the fallback.
  function updateRojoVisibleCartHeight() {
    const height = window.visualViewport?.height || window.innerHeight;
    if (!height) return;
    document.documentElement.style.setProperty('--rojo-visible-cart-height', `${height}px`);
  }

  updateRojoVisibleCartHeight();
  window.addEventListener('resize', updateRojoVisibleCartHeight);
  window.visualViewport?.addEventListener('resize', updateRojoVisibleCartHeight);

  // Correction pass (2026-08-26, round 5) — CART INSTAGRAM FOOTER LIFT.
  // The 100svh / --rojo-visible-cart-height work above didn't move the
  // footer meaningfully on real Instagram, so this adds a distinctly
  // larger, Instagram-only bottom reserve on top of it (see
  // .rojo-instagram-browser in rojo-os.css) rather than replacing it.
  // Detected once via user agent and exposed as a class on <html> so CSS
  // can target it directly — no resize/viewport listener needed for this
  // one, it's a static browser-identity check. classList.add is a no-op
  // if the class is already present, and this whole file only executes
  // once per real page load (see the window.__rojoOsAssetLoaded guard
  // wrapping it), so there's no risk of this running twice or stacking
  // duplicate listeners.
  const rojoIsInstagramBrowser = /Instagram/i.test(navigator.userAgent || '');
  if (rojoIsInstagramBrowser) {
    document.documentElement.classList.add('rojo-instagram-browser');
  }

  // TEMPORARY CAMPAIGN (2026-09) — BLACK TEE SMS EARLY-ACCESS PROMO
  // no-scroll viewport fix. Own separate variable/listeners from
  // updateRojoVisibleCartHeight() above (never shared/reused with the
  // cart drawer) — same proven pattern: visualViewport.height reflects
  // the browser's actual currently-visible area (already accounts for
  // Instagram's persistent, non-collapsing in-app chrome), falling back
  // to innerHeight, with 100svh as the CSS-side fallback for the brief
  // window before this first runs. Registered once at true top level
  // (outside initRojoOS, alongside the cart height listeners above), so
  // it's immune to duplicate registration across Shopify theme-editor
  // section reloads the same way that code already is.
  // Correction pass (2026-09, round 4) — NO POST-REVEAL READJUSTMENT.
  // Replaces round 3's width-delta heuristic, which couldn't be trusted
  // to hold on every in-app WebView. Before reveal, resize/visualViewport
  // .resize update the variable freely via handleRojoPromoResize()
  // (correctly absorbing early browser-chrome settling while nothing is
  // visible yet). The moment showHome() locks it (see
  // lockRojoPromoVisibleHeight(), called right before is-home is
  // applied), handleRojoPromoResize() becomes a pure no-op for the rest
  // of the page's life — generic resize and visualViewport.resize can
  // NEVER rewrite --rojo-promo-visible-height again, regardless of what
  // triggered them (Safari's address bar, Instagram's persistent WebView
  // chrome settling, anything). The ONLY thing that can still update it
  // is a genuine device orientation flip, via the dedicated
  // orientationchange event (handleRojoPromoOrientationChange) — a real
  // platform signal, not an inferred one, so there's no risk of a false
  // positive letting a chrome-settling event slip through.
  let rojoPromoHeightLocked = false;

  function updateRojoPromoVisibleHeight() {
    const height = window.visualViewport?.height || window.innerHeight;
    if (!height) return;
    document.documentElement.style.setProperty('--rojo-promo-visible-height', `${height}px`);
  }

  function handleRojoPromoResize() {
    if (rojoPromoHeightLocked) return;
    updateRojoPromoVisibleHeight();
  }

  function handleRojoPromoOrientationChange() {
    updateRojoPromoVisibleHeight();
  }

  function lockRojoPromoVisibleHeight() {
    updateRojoPromoVisibleHeight();
    rojoPromoHeightLocked = true;
  }

  updateRojoPromoVisibleHeight();
  window.addEventListener('resize', handleRojoPromoResize);
  window.visualViewport?.addEventListener('resize', handleRojoPromoResize);
  window.addEventListener('orientationchange', handleRojoPromoOrientationChange);

  function initAllRojoOS(container = document) {
    if (container.matches?.('[data-rojo-os]')) {
      initRojoOS(container);
    }

    container.querySelectorAll?.('[data-rojo-os]').forEach(initRojoOS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllRojoOS());
  } else {
    initAllRojoOS();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllRojoOS(event.target);
  });

  window.__rojoOsInitAll = initAllRojoOS;
} else {
  window.__rojoOsInitAll?.();
}
